/* eslint:disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@jimmyn/apollo-client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `AWSEmail` scalar type provided by AWS AppSync, represents an Email address string that complies with [RFC 822](https://www.ietf.org/rfc/rfc822.txt). For example, "**username@example.com**" is a valid Email address. */
  AWSEmail: any;
  /** The `AWSIPAddress` scalar type provided by AWS AppSync, represents a valid [IPv4](https://en.wikipedia.org/wiki/IPv4#Addressing) or [IPv6](https://en.wikipedia.org/wiki/IPv6_address) address string.  IP addresses with subnet masks are considered valid. However, subnet masks are not necessary. For example, "**127.0.0.1**" and "**127.0.0.1/8**" are both considered valid IP Addresses. */
  AWSIPAddress: any;
  /** The `AWSPhone` scalar type provided by AWS AppSync, represents a valid Phone Number. Phone numbers are serialized and deserialized as Strings. Segments of the phone number may be whitespace delimited or hyphenated.  The number can specify a country code at the beginning. However, United States numbers without country codes are still considered to be valid. */
  AWSPhone: any;
  /** The `AWSTimestamp` scalar type provided by AWS AppSync, represents the number of seconds that have elapsed since `1970-01-01T00:00Z`. Negative values are also accepted and these represent the number of seconds till `1970-01-01T00:00Z`.  Timestamps are serialized and deserialized as integers. The minimum supported timestamp value is **`-31557014167219200`** which corresponds to `-1000000000-01-01T00:00Z`. The maximum supported timestamp value is **`31556889864403199`** which corresponds to `1000000000-12-31T23:59:59.999999999Z`. */
  AWSTimestamp: any;
  /** Long type */
  Long: any;
};

export type Account = {
  __typename?: 'Account';
  accountExecutive?: Maybe<SalesExecutive>;
  accountInvoicePaymentMethod?: Maybe<AccountInvoicePaymentMethod>;
  acquirer?: Maybe<Acquirer>;
  activatedAt?: Maybe<Scalars['String']>;
  adminEmail?: Maybe<Scalars['String']>;
  allowCreateApiKey?: Maybe<Scalars['Boolean']>;
  allowRefunds?: Maybe<Scalars['Boolean']>;
  apiKey?: Maybe<Scalars['String']>;
  approvalRequestedAt?: Maybe<Scalars['String']>;
  approvedAt?: Maybe<Scalars['String']>;
  billingEmail?: Maybe<Scalars['String']>;
  billingPlan?: Maybe<BillingPlans>;
  billingVatPercent?: Maybe<Scalars['Int']>;
  blocked?: Maybe<Scalars['Boolean']>;
  branding?: Maybe<AccountBranding>;
  business?: Maybe<BusinessData>;
  churnNote?: Maybe<Scalars['String']>;
  churnReason?: Maybe<ChurnReason>;
  churnReasonOption?: Maybe<Scalars['String']>;
  churned?: Maybe<Scalars['Boolean']>;
  contactPerson?: Maybe<ContactPerson>;
  contract?: Maybe<AccountContract>;
  createdAt?: Maybe<Scalars['String']>;
  customAccountInvoiceNotes?: Maybe<Array<Scalars['String']>>;
  customDomain?: Maybe<Scalars['String']>;
  dataUpdatedAt?: Maybe<Scalars['String']>;
  defaultCurrency?: Maybe<Currencies>;
  defaultTransactionType?: Maybe<TransactionTypes>;
  deletedAt?: Maybe<Scalars['String']>;
  dynamicBilling?: Maybe<Scalars['Boolean']>;
  fees?: Maybe<AccountFees>;
  groupInvoicesByStore?: Maybe<Scalars['Boolean']>;
  iban?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  language?: Maybe<Scalars['String']>;
  manualApproval?: Maybe<Scalars['Boolean']>;
  masterAccountId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  notifications?: Maybe<AccountNotifications>;
  partner?: Maybe<Partner>;
  paymentMethods?: Maybe<AccountPaymentMethods>;
  payoutTerms?: Maybe<AccountPayoutTerms>;
  previewFeatures?: Maybe<Array<Scalars['String']>>;
  prodAccountId?: Maybe<Scalars['ID']>;
  promoCode?: Maybe<Scalars['String']>;
  publicBusinessDetails?: Maybe<AccountPublicBusinessDetails>;
  reason?: Maybe<Scalars['String']>;
  refAccountId?: Maybe<Scalars['ID']>;
  referralCode?: Maybe<Scalars['String']>;
  rejectedAt?: Maybe<Scalars['String']>;
  representatives?: Maybe<Array<Representative>>;
  reviewConfirmed?: Maybe<Scalars['Boolean']>;
  riskIgnoredKeywords?: Maybe<Array<Scalars['String']>>;
  riskLabels?: Maybe<Array<RiskLabel>>;
  riskProcessing?: Maybe<Scalars['Boolean']>;
  riskProfile?: Maybe<RiskProfile>;
  riskProfileNote?: Maybe<Scalars['String']>;
  riskScore?: Maybe<Scalars['Int']>;
  riskUpdatedAt?: Maybe<Scalars['String']>;
  secret?: Maybe<Scalars['String']>;
  sepblacId?: Maybe<Scalars['String']>;
  status: AccountStatus;
  statusNote?: Maybe<Scalars['String']>;
  statusReason?: Maybe<StatusReason>;
  suspendedAt?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  test?: Maybe<Scalars['Boolean']>;
  testAccountId?: Maybe<Scalars['ID']>;
  timezone?: Maybe<Scalars['String']>;
  tokenizationMethods?: Maybe<AccountTokenizationMethods>;
  updatedAt?: Maybe<Scalars['String']>;
  upsell?: Maybe<Upsell>;
  userNote?: Maybe<Scalars['String']>;
};

export type AccountActualFees = {
  __typename?: 'AccountActualFees';
  dailyExtraSeatsFee: Scalars['Int'];
  dailyPlatformFee: Scalars['Int'];
  extra?: Maybe<Array<AccountExtraFee>>;
  highRiskFee: Scalars['Float'];
  steps: Array<AccountSteps>;
  weeklyCustomDomainFee: Scalars['Int'];
};

export type AccountBalances = {
  __typename?: 'AccountBalances';
  accountId?: Maybe<Scalars['ID']>;
  clearedAmount: Scalars['Int'];
  createdAt: Scalars['String'];
  currency: Scalars['String'];
  outstandingAmount: Scalars['Int'];
  totalAmount: Scalars['Int'];
  updatedAt?: Maybe<Scalars['String']>;
};

export type AccountBalancesConnection = {
  __typename?: 'AccountBalancesConnection';
  items: Array<AccountBalances>;
};

export type AccountBranding = {
  __typename?: 'AccountBranding';
  accentColor?: Maybe<Scalars['String']>;
  bgColor?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
};

export type AccountBrandingInput = {
  accentColor?: InputMaybe<Scalars['String']>;
  bgColor?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
};

export type AccountContract = {
  __typename?: 'AccountContract';
  envelopeId: Scalars['ID'];
  path?: Maybe<Scalars['String']>;
  signedDate?: Maybe<Scalars['String']>;
  status: ContractStatus;
};

export type AccountDefaults = {
  __typename?: 'AccountDefaults';
  billingPlan?: Maybe<BillingPlans>;
  business?: Maybe<BusinessDefault>;
  fees?: Maybe<AccountFees>;
  iban?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  notifications?: Maybe<AccountNotifications>;
  payoutTerms?: Maybe<AccountPayoutTerms>;
};

export type AccountDefaultsInput = {
  billingPlan?: InputMaybe<BillingPlans>;
  business?: InputMaybe<BusinessDefaultInput>;
  fees?: InputMaybe<AccountFeesInput>;
  iban?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  notifications?: InputMaybe<AccountNotificationsInput>;
  payoutTerms?: InputMaybe<AccountPayoutTermsInput>;
};

export type AccountEvent = {
  __typename?: 'AccountEvent';
  accountId: Scalars['ID'];
  createdAt?: Maybe<Scalars['AWSTimestamp']>;
  id: Scalars['ID'];
  livemode?: Maybe<Scalars['Boolean']>;
  masterAccountId?: Maybe<Scalars['ID']>;
  object: AccountEventObject;
  objectId: Scalars['ID'];
  objectType: Scalars['String'];
  type: Scalars['String'];
};

export type AccountEventObject = {
  __typename?: 'AccountEventObject';
  accountExecutive?: Maybe<Scalars['String']>;
  acquirer?: Maybe<Acquirer>;
  activatedAt?: Maybe<Scalars['String']>;
  adminEmail?: Maybe<Scalars['String']>;
  allowCreateApiKey?: Maybe<Scalars['Boolean']>;
  allowRefunds?: Maybe<Scalars['Boolean']>;
  approvalRequestedAt?: Maybe<Scalars['String']>;
  approvedAt?: Maybe<Scalars['String']>;
  billingEmail?: Maybe<Scalars['String']>;
  billingPlan?: Maybe<BillingPlans>;
  billingVatPercent?: Maybe<Scalars['Int']>;
  blocked?: Maybe<Scalars['Boolean']>;
  branding?: Maybe<AccountBranding>;
  business?: Maybe<BusinessData>;
  churnNote?: Maybe<Scalars['String']>;
  churnReason?: Maybe<ChurnReason>;
  churnReasonOption?: Maybe<Scalars['String']>;
  churned?: Maybe<Scalars['Boolean']>;
  contract?: Maybe<AccountContract>;
  createdAt?: Maybe<Scalars['String']>;
  customDomain?: Maybe<Scalars['String']>;
  dataUpdatedAt?: Maybe<Scalars['String']>;
  defaultCurrency?: Maybe<Currencies>;
  defaultTransactionType?: Maybe<TransactionTypes>;
  deletedAt?: Maybe<Scalars['String']>;
  dynamicBilling?: Maybe<Scalars['Boolean']>;
  fees?: Maybe<AccountFees>;
  iban?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  language?: Maybe<Scalars['String']>;
  manualApproval?: Maybe<Scalars['Boolean']>;
  masterAccountId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  notifications?: Maybe<AccountNotifications>;
  partner?: Maybe<Partner>;
  paymentMethods?: Maybe<AccountPaymentMethods>;
  payoutTerms?: Maybe<AccountPayoutTerms>;
  previewFeatures?: Maybe<Array<Scalars['String']>>;
  prodAccountId?: Maybe<Scalars['ID']>;
  promoCode?: Maybe<Scalars['String']>;
  publicBusinessDetails?: Maybe<AccountPublicBusinessDetails>;
  reason?: Maybe<Scalars['String']>;
  refAccountId?: Maybe<Scalars['ID']>;
  referralCode?: Maybe<Scalars['String']>;
  rejectedAt?: Maybe<Scalars['String']>;
  representatives?: Maybe<Array<Representative>>;
  reviewConfirmed?: Maybe<Scalars['Boolean']>;
  riskIgnoredKeywords?: Maybe<Array<Scalars['String']>>;
  riskProfile?: Maybe<RiskProfile>;
  riskProfileNote?: Maybe<Scalars['String']>;
  riskScore?: Maybe<Scalars['Int']>;
  riskUpdatedAt?: Maybe<Scalars['String']>;
  sepblacId?: Maybe<Scalars['String']>;
  status: AccountStatus;
  statusNote?: Maybe<Scalars['String']>;
  statusReason?: Maybe<StatusReason>;
  suspendedAt?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  test?: Maybe<Scalars['Boolean']>;
  testAccountId?: Maybe<Scalars['ID']>;
  timezone?: Maybe<Scalars['String']>;
  tokenizationMethods?: Maybe<AccountTokenizationMethods>;
  traceDetails?: Maybe<TraceDetails>;
  updatedAt?: Maybe<Scalars['String']>;
  upsell?: Maybe<Upsell>;
  userNote?: Maybe<Scalars['String']>;
};

export type AccountEventsConnection = {
  __typename?: 'AccountEventsConnection';
  items: Array<AccountEvent>;
  total: Scalars['Int'];
};

export type AccountExtraFee = {
  __typename?: 'AccountExtraFee';
  amount: Scalars['Float'];
  masterAccountFee?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  paymentMethods?: Maybe<Array<PaymentMethods>>;
  region?: Maybe<AccountExtraFeeRegion>;
  type: AccountExtraFeeType;
};

export type AccountExtraFeeInput = {
  amount?: InputMaybe<Scalars['Float']>;
  masterAccountFee?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  paymentMethods?: InputMaybe<Array<InputMaybe<PaymentMethods>>>;
  region?: InputMaybe<AccountExtraFeeRegion>;
  type?: InputMaybe<AccountExtraFeeType>;
};

export enum AccountExtraFeeRegion {
  ALL = 'all',
  DOMESTIC = 'domestic',
  NON_DOMESTIC = 'non_domestic'
}

export enum AccountExtraFeeType {
  DAILY = 'daily',
  MONEY = 'money',
  MONTHLY = 'monthly',
  ONE_TIME = 'one_time',
  PERCENT = 'percent'
}

export type AccountFees = {
  __typename?: 'AccountFees';
  dailyExtraSeatsFee?: Maybe<Scalars['Int']>;
  dailyPlatformFee?: Maybe<Scalars['Int']>;
  extra?: Maybe<Array<AccountExtraFee>>;
  highRiskFee?: Maybe<Scalars['Float']>;
  steps?: Maybe<Array<AccountSteps>>;
  trxFee?: Maybe<Scalars['Float']>;
  trxFlatFee?: Maybe<Scalars['Int']>;
  weeklyCustomDomainFee?: Maybe<Scalars['Int']>;
};

export type AccountFeesInput = {
  dailyExtraSeatsFee?: InputMaybe<Scalars['Int']>;
  dailyPlatformFee?: InputMaybe<Scalars['Int']>;
  extra?: InputMaybe<Array<AccountExtraFeeInput>>;
  highRiskFee?: InputMaybe<Scalars['Float']>;
  steps?: InputMaybe<Array<InputMaybe<AccountStepsInput>>>;
  trxFee?: InputMaybe<Scalars['Float']>;
  trxFlatFee?: InputMaybe<Scalars['Int']>;
  weeklyCustomDomainFee?: InputMaybe<Scalars['Int']>;
};

export type AccountInvoice = {
  __typename?: 'AccountInvoice';
  accountId: Scalars['ID'];
  amount: Scalars['Int'];
  business?: Maybe<InvoiceBusinessData>;
  createdAt: Scalars['AWSTimestamp'];
  currency: Scalars['String'];
  id?: Maybe<Scalars['ID']>;
  lineItems: Array<AccountInvoiceLineItem>;
  number?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<AccountInvoicePaymentMethod>;
  period: AccountInvoicePeriod;
  status?: Maybe<AccountInvoiceStatus>;
  tax: Scalars['Int'];
  totalAmount: Scalars['Int'];
  updatedAt?: Maybe<Scalars['AWSTimestamp']>;
};

export type AccountInvoiceInput = {
  accountId: Scalars['ID'];
  from: Scalars['AWSTimestamp'];
  timezone?: InputMaybe<Scalars['String']>;
  to: Scalars['AWSTimestamp'];
};

export type AccountInvoiceLineItem = {
  __typename?: 'AccountInvoiceLineItem';
  amount: Scalars['Int'];
  currency: Scalars['String'];
  name: Scalars['String'];
  quantity: Scalars['Float'];
  unitAmount: Scalars['Float'];
  unitType: InvoiceLineItemUnitType;
};

export enum AccountInvoicePaymentMethod {
  BANK_TRANSFER = 'bank_transfer',
  DIRECT_DEBIT = 'direct_debit'
}

export type AccountInvoicePeriod = {
  __typename?: 'AccountInvoicePeriod';
  from?: Maybe<Scalars['AWSTimestamp']>;
  to?: Maybe<Scalars['AWSTimestamp']>;
};

export enum AccountInvoiceStatus {
  PAID = 'PAID',
  PAST_DUE = 'PAST_DUE',
  PENDING = 'PENDING',
  UNPAID = 'UNPAID'
}

export type AccountLevelUpdate = {
  __typename?: 'AccountLevelUpdate';
  accountId?: Maybe<Scalars['ID']>;
};

export type AccountNotifications = {
  __typename?: 'AccountNotifications';
  adminEmails?: Maybe<Array<Scalars['String']>>;
  emailAdminOnSubscription?: Maybe<Scalars['Boolean']>;
  emailAdminOnSuccess?: Maybe<Scalars['Boolean']>;
  emailCustomerOnRefund?: Maybe<Scalars['Boolean']>;
  emailCustomerOnSubscription?: Maybe<Scalars['Boolean']>;
  emailCustomerOnSuccess?: Maybe<Scalars['Boolean']>;
  emailOnAccountInvoice?: Maybe<Scalars['Boolean']>;
};

export type AccountNotificationsInput = {
  adminEmails?: InputMaybe<Array<Scalars['String']>>;
  emailAdminOnSubscription?: InputMaybe<Scalars['Boolean']>;
  emailAdminOnSuccess?: InputMaybe<Scalars['Boolean']>;
  emailCustomerOnRefund?: InputMaybe<Scalars['Boolean']>;
  emailCustomerOnSubscription?: InputMaybe<Scalars['Boolean']>;
  emailCustomerOnSuccess?: InputMaybe<Scalars['Boolean']>;
  emailOnAccountInvoice?: InputMaybe<Scalars['Boolean']>;
};

export type AccountPaymentMethods = {
  __typename?: 'AccountPaymentMethods';
  BIZUM?: Maybe<AccountPaymentMethodsBizum>;
  CREDITCARD?: Maybe<AccountPaymentMethodsCreditCard>;
};

export type AccountPaymentMethodsBizum = {
  __typename?: 'AccountPaymentMethodsBizum';
  enabled?: Maybe<Scalars['Boolean']>;
};

export type AccountPaymentMethodsBizumInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type AccountPaymentMethodsCreditCard = {
  __typename?: 'AccountPaymentMethodsCreditCard';
  allowPaymentDetails?: Maybe<Scalars['Boolean']>;
  enabled?: Maybe<Scalars['Boolean']>;
  preauthorization?: Maybe<Scalars['Boolean']>;
};

export type AccountPaymentMethodsCreditCardInput = {
  allowPaymentDetails?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  preauthorization?: InputMaybe<Scalars['Boolean']>;
};

export type AccountPaymentMethodsInput = {
  BIZUM?: InputMaybe<AccountPaymentMethodsBizumInput>;
  CREDITCARD?: InputMaybe<AccountPaymentMethodsCreditCardInput>;
};

export type AccountPayoutTerms = {
  __typename?: 'AccountPayoutTerms';
  bankTransferConceptPrefix?: Maybe<Scalars['String']>;
  firstPeriod?: Maybe<Scalars['Int']>;
  iban?: Maybe<Scalars['String']>;
  period?: Maybe<Scalars['Int']>;
  releaseReserve?: Maybe<Scalars['Boolean']>;
  reservePercent?: Maybe<Scalars['Float']>;
  settleGross?: Maybe<Scalars['Boolean']>;
  settleIndividually?: Maybe<Scalars['Boolean']>;
  settleToStores?: Maybe<Scalars['Boolean']>;
  suspended?: Maybe<Scalars['Boolean']>;
};

export type AccountPayoutTermsInput = {
  bankTransferConceptPrefix?: InputMaybe<Scalars['String']>;
  firstPeriod?: InputMaybe<Scalars['Int']>;
  iban?: InputMaybe<Scalars['String']>;
  period?: InputMaybe<Scalars['Int']>;
  releaseReserve?: InputMaybe<Scalars['Boolean']>;
  reservePercent?: InputMaybe<Scalars['Float']>;
  settleGross?: InputMaybe<Scalars['Boolean']>;
  settleToStores?: InputMaybe<Scalars['Boolean']>;
  suspended?: InputMaybe<Scalars['Boolean']>;
};

export type AccountPublicBusinessDetails = {
  __typename?: 'AccountPublicBusinessDetails';
  address?: Maybe<Address>;
  companyName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  supportEmail?: Maybe<Scalars['String']>;
  supportPhone?: Maybe<Scalars['String']>;
  supportWebsite?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type AccountPublicBusinessDetailsInput = {
  address?: InputMaybe<AddressInput>;
  companyName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  supportEmail?: InputMaybe<Scalars['String']>;
  supportPhone?: InputMaybe<Scalars['String']>;
  supportWebsite?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type AccountStats = {
  __typename?: 'AccountStats';
  accountId: Scalars['ID'];
  stats?: Maybe<Stats>;
};

export enum AccountStatus {
  ACTIVE = 'ACTIVE',
  APPROVED = 'APPROVED',
  DELETED = 'DELETED',
  NOT_CONFIGURED = 'NOT_CONFIGURED',
  PENDING_APPROVAL = 'PENDING_APPROVAL',
  PENDING_CONTRACT = 'PENDING_CONTRACT',
  PENDING_REVIEW = 'PENDING_REVIEW',
  REJECTED = 'REJECTED',
  SUSPENDED = 'SUSPENDED'
}

export type AccountSteps = {
  __typename?: 'AccountSteps';
  bizumTrxFee?: Maybe<Scalars['Float']>;
  bizumTrxFlatFee?: Maybe<Scalars['Int']>;
  from: Scalars['Float'];
  multibancoTrxFee?: Maybe<Scalars['Float']>;
  multibancoTrxFlatFee?: Maybe<Scalars['Int']>;
  trxFee: Scalars['Float'];
  trxFlatFee: Scalars['Int'];
};

export type AccountStepsInput = {
  bizumTrxFee?: InputMaybe<Scalars['Float']>;
  bizumTrxFlatFee?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['Float']>;
  multibancoTrxFee?: InputMaybe<Scalars['Float']>;
  multibancoTrxFlatFee?: InputMaybe<Scalars['Int']>;
  trxFee?: InputMaybe<Scalars['Float']>;
  trxFlatFee?: InputMaybe<Scalars['Int']>;
};

export type AccountTokenizationMethods = {
  __typename?: 'AccountTokenizationMethods';
  applePay?: Maybe<AccountTokenizationMethodsItem>;
  clickToPay?: Maybe<AccountTokenizationMethodsClickToPayItem>;
  googlePay?: Maybe<AccountTokenizationMethodsItem>;
};

export type AccountTokenizationMethodsClickToPayItem = {
  __typename?: 'AccountTokenizationMethodsClickToPayItem';
  dpaId?: Maybe<Scalars['ID']>;
  enabled?: Maybe<Scalars['Boolean']>;
};

export type AccountTokenizationMethodsItem = {
  __typename?: 'AccountTokenizationMethodsItem';
  enabled?: Maybe<Scalars['Boolean']>;
};

export type AccountsConnection = {
  __typename?: 'AccountsConnection';
  items: Array<Account>;
  total: Scalars['Int'];
};

export enum Acquirer {
  ABANCA = 'ABANCA',
  ADYEN = 'ADYEN',
  BANCAMARCH = 'BANCAMARCH',
  BANKIA = 'BANKIA',
  BANKINTER = 'BANKINTER',
  BBVA = 'BBVA',
  CAJALABORAL = 'CAJALABORAL',
  CAJAMAR = 'CAJAMAR',
  CAJARURAL = 'CAJARURAL',
  CAJASUR = 'CAJASUR',
  COFIDIS = 'COFIDIS',
  COMERCIAGLOBALPAY = 'COMERCIAGLOBALPAY',
  CREDITANDORRA = 'CREDITANDORRA',
  CUSTOM = 'CUSTOM',
  DEUTSCHE_BANK = 'DEUTSCHE_BANK',
  KUTXABANK = 'KUTXABANK',
  MONEI_X = 'MONEI_X',
  PAYCOMET = 'PAYCOMET',
  PAYPAL = 'PAYPAL',
  SABADELL = 'SABADELL',
  SANTANDER = 'SANTANDER',
  STRIPE = 'STRIPE',
  UNICAJA = 'UNICAJA'
}

export type ActivateSubscriptionInput = {
  accountId: Scalars['ID'];
  addAmount?: InputMaybe<Scalars['Int']>;
  cancelUrl?: InputMaybe<Scalars['String']>;
  completeUrl?: InputMaybe<Scalars['String']>;
  expireAt?: InputMaybe<Scalars['AWSTimestamp']>;
  failUrl?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  metadata?: InputMaybe<Array<KeyValueInput>>;
  paymentToken?: InputMaybe<Scalars['String']>;
  sequenceId?: InputMaybe<Scalars['ID']>;
  sessionId?: InputMaybe<Scalars['ID']>;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type AdminUser = {
  __typename?: 'AdminUser';
  email: Scalars['String'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type AdminUsersConnection = {
  __typename?: 'AdminUsersConnection';
  items: Array<AdminUser>;
  nextToken?: Maybe<Scalars['String']>;
};

export type Affiliate = {
  __typename?: 'Affiliate';
  address?: Maybe<AffiliateAddress>;
  affiliate_group_id?: Maybe<Scalars['String']>;
  company?: Maybe<AffiliateCompany>;
  created_at?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastname?: Maybe<Scalars['String']>;
  meta_data?: Maybe<AffiliateMetaData>;
  payout_methods?: Maybe<Array<AffiliatePayoutMethod>>;
  referral_link?: Maybe<AffiliateReferralLink>;
};

export type AffiliateAddress = {
  __typename?: 'AffiliateAddress';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<AffiliateCountry>;
  postal_code?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type AffiliateCompany = {
  __typename?: 'AffiliateCompany';
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type AffiliateConnection = {
  __typename?: 'AffiliateConnection';
  items: Array<Affiliate>;
  links?: Maybe<Scalars['String']>;
};

export type AffiliateCountry = {
  __typename?: 'AffiliateCountry';
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type AffiliateInput = {
  affiliateGroupId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  nextToken?: InputMaybe<Scalars['String']>;
};

export type AffiliateInvoice = {
  __typename?: 'AffiliateInvoice';
  amount?: Maybe<Scalars['Float']>;
  dueAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  issuedAt?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type AffiliateInvoiceConnection = {
  __typename?: 'AffiliateInvoiceConnection';
  items: Array<AffiliateInvoice>;
  total?: Maybe<Scalars['Int']>;
};

export type AffiliateMerchant = {
  __typename?: 'AffiliateMerchant';
  created_at?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  meta_data?: Maybe<AffiliateMerchantMetaData>;
  status?: Maybe<Scalars['String']>;
};

export type AffiliateMerchantConnection = {
  __typename?: 'AffiliateMerchantConnection';
  items: Array<AffiliateMerchant>;
  links?: Maybe<Scalars['String']>;
};

export type AffiliateMerchantInput = {
  affiliateId: Scalars['ID'];
  nextToken?: InputMaybe<Scalars['String']>;
};

export type AffiliateMerchantMetaData = {
  __typename?: 'AffiliateMerchantMetaData';
  account_id?: Maybe<Scalars['String']>;
  account_status?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  first_conversion_date?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type AffiliateMetaData = {
  __typename?: 'AffiliateMetaData';
  tier?: Maybe<Scalars['String']>;
};

export type AffiliatePayoutMethod = {
  __typename?: 'AffiliatePayoutMethod';
  details?: Maybe<AffiliatePayoutMethodDetails>;
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
};

export type AffiliatePayoutMethodDetails = {
  __typename?: 'AffiliatePayoutMethodDetails';
  iban?: Maybe<Scalars['String']>;
  nif?: Maybe<Scalars['String']>;
};

export type AffiliatePayoutMethodDetailsInput = {
  iban?: InputMaybe<Scalars['String']>;
  nif?: InputMaybe<Scalars['String']>;
};

export type AffiliateReferralLink = {
  __typename?: 'AffiliateReferralLink';
  link?: Maybe<Scalars['String']>;
};

export type AnalyticsChange = {
  __typename?: 'AnalyticsChange';
  all?: Maybe<Scalars['Boolean']>;
};

export enum AuthPaymentMethodKlarna {
  B2B_INVOICE = 'b2b_invoice',
  BASE_ACCOUNT = 'base_account',
  CARD = 'card',
  DEFERRED_INTEREST = 'deferred_interest',
  DIRECT_BANK_TRANSFER = 'direct_bank_transfer',
  DIRECT_DEBIT = 'direct_debit',
  FIXED_AMOUNT = 'fixed_amount',
  INVOICE = 'invoice',
  PIX = 'pix',
  SLICE_IT_BY_CARD = 'slice_it_by_card'
}

export type AuthorizedUser = {
  __typename?: 'AuthorizedUser';
  accessLevel: AuthorizedUserAccessLevel;
  accountId?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lastLoginAt?: Maybe<Scalars['String']>;
  masterAccount?: Maybe<Scalars['Boolean']>;
  status: AuthorizedUserStatus;
  storeId?: Maybe<Scalars['ID']>;
  updatedAt?: Maybe<Scalars['String']>;
  userEmail: Scalars['String'];
};

export enum AuthorizedUserAccessLevel {
  ADMIN_ACCESS = 'ADMIN_ACCESS',
  READ_ACCESS = 'READ_ACCESS',
  WRITE_ACCESS = 'WRITE_ACCESS'
}

export enum AuthorizedUserStatus {
  ARCHIVED = 'ARCHIVED',
  COMPROMISED = 'COMPROMISED',
  CONFIRMED = 'CONFIRMED',
  FORCE_CHANGE_PASSWORD = 'FORCE_CHANGE_PASSWORD',
  RESET_REQUIRED = 'RESET_REQUIRED',
  UNCONFIRMED = 'UNCONFIRMED',
  UNKNOWN = 'UNKNOWN'
}

export type AuthorizedUsersConnection = {
  __typename?: 'AuthorizedUsersConnection';
  items: Array<AuthorizedUser>;
};

export type AvailablePaymentMethod = {
  __typename?: 'AvailablePaymentMethod';
  configured?: Maybe<Scalars['Boolean']>;
  enabled?: Maybe<Scalars['Boolean']>;
  paymentMethod?: Maybe<PaymentMethods>;
};

export type AvailableProcessor = {
  __typename?: 'AvailableProcessor';
  configurable?: Maybe<Scalars['Boolean']>;
  configured?: Maybe<Scalars['Boolean']>;
  enabled?: Maybe<Scalars['Boolean']>;
  paymentMethod?: Maybe<PaymentMethods>;
  processor?: Maybe<Processor>;
};

export enum BillingCategoryKlarna {
  PAY_IN_PARTS = 'PAY_IN_PARTS',
  PAY_LATER = 'PAY_LATER',
  PAY_NOW = 'PAY_NOW',
  SLICE_IT = 'SLICE_IT',
  SLICE_IT_BY_CARD = 'SLICE_IT_BY_CARD'
}

export enum BillingPlans {
  MONEI_PLUS = 'MONEI_PLUS',
  MONEI_POS = 'MONEI_POS',
  MONEI_X = 'MONEI_X'
}

export type BlacklistItem = {
  __typename?: 'BlacklistItem';
  accountId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['String'];
  type: BlacklistItemType;
  updatedAt?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type BlacklistItemInput = {
  accountId?: InputMaybe<Scalars['ID']>;
  type: BlacklistItemType;
  value: Scalars['String'];
};

export enum BlacklistItemType {
  BIN = 'bin',
  CARD = 'card',
  EMAIL = 'email',
  FINGERPRINT = 'fingerprint',
  IP = 'ip',
  PHONE = 'phone'
}

export type BlacklistItemsConnection = {
  __typename?: 'BlacklistItemsConnection';
  items: Array<Maybe<BlacklistItem>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type BusinessData = {
  __typename?: 'BusinessData';
  address?: Maybe<Address>;
  capital?: Maybe<Scalars['Long']>;
  companyName?: Maybe<Scalars['String']>;
  confirmServicesDescription?: Maybe<Scalars['Boolean']>;
  confirmWebsite?: Maybe<Scalars['Boolean']>;
  country?: Maybe<Scalars['String']>;
  creationDate?: Maybe<Scalars['String']>;
  documentNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  industry?: Maybe<Industries>;
  lastUpdateDate?: Maybe<Scalars['String']>;
  legalAddress?: Maybe<Scalars['String']>;
  legalDescription?: Maybe<Scalars['String']>;
  legalForm?: Maybe<LegalForm>;
  legalName?: Maybe<Scalars['String']>;
  mcc?: Maybe<Scalars['String']>;
  monthlyVolume?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  pibisi?: Maybe<Pibisi>;
  positions?: Maybe<Array<BusinessPosition>>;
  previousNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  registryRecords?: Maybe<Array<RegistryRecord>>;
  servicesDescription?: Maybe<Scalars['String']>;
  startActivityDate?: Maybe<Scalars['String']>;
  status?: Maybe<BusinessStatus>;
  verificationAttempts?: Maybe<Scalars['Int']>;
  website?: Maybe<Scalars['String']>;
};

export type BusinessDataInput = {
  address?: InputMaybe<AddressInput>;
  companyName?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  creationDate?: InputMaybe<Scalars['String']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  industry?: InputMaybe<Industries>;
  legalForm?: InputMaybe<LegalForm>;
  legalName?: InputMaybe<Scalars['String']>;
  mcc?: InputMaybe<Scalars['String']>;
  monthlyVolume?: InputMaybe<Scalars['Long']>;
  phone?: InputMaybe<Scalars['String']>;
  pibisi?: InputMaybe<PibisiInput>;
  servicesDescription?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<BusinessStatus>;
  website?: InputMaybe<Scalars['String']>;
};

export type BusinessDefault = {
  __typename?: 'BusinessDefault';
  confirmServicesDescription?: Maybe<Scalars['Boolean']>;
  confirmWebsite?: Maybe<Scalars['Boolean']>;
  mcc?: Maybe<Scalars['String']>;
  servicesDescription?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type BusinessDefaultInput = {
  confirmServicesDescription?: InputMaybe<Scalars['Boolean']>;
  confirmWebsite?: InputMaybe<Scalars['Boolean']>;
  mcc?: InputMaybe<Scalars['String']>;
  servicesDescription?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type BusinessPosition = {
  __typename?: 'BusinessPosition';
  fromDate?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export enum BusinessStatus {
  ACTIVE = 'active',
  DISSOLVED = 'dissolved',
  INACTIVE = 'inactive',
  NOT_FOUND = 'not_found',
  PROCESSING = 'processing',
  RENAMED = 'renamed',
  RESUBMISSION_REQUESTED = 'resubmission_requested',
  TRANSFORMED = 'transformed',
  UNDER_REVIEW = 'under_review'
}

export type CalculateRiskScoreInput = {
  accountId: Scalars['ID'];
  ignoredKeywords?: InputMaybe<Array<Scalars['String']>>;
};

export type CallbackData = {
  __typename?: 'CallbackData';
  status: Array<CallbackStatus>;
  statusCode?: Maybe<Scalars['String']>;
  statusMessage?: Maybe<Scalars['String']>;
};

export enum CallbackStatus {
  EXECUTED = 'EXECUTED',
  FAILED = 'FAILED',
  PENDING = 'PENDING'
}

export type CancelPaymentInput = {
  accountId: Scalars['ID'];
  cancellationReason?: InputMaybe<CancellationReason>;
  paymentId: Scalars['ID'];
};

export type CancelSubscriptionInput = {
  accountId: Scalars['ID'];
  cancelAtPeriodEnd?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

export enum CancellationReason {
  DUPLICATED = 'duplicated',
  FRAUDULENT = 'fraudulent',
  ORDER_CANCELED = 'order_canceled',
  REQUESTED_BY_CUSTOMER = 'requested_by_customer'
}

export type CapturePaymentInput = {
  accountId: Scalars['ID'];
  amount?: InputMaybe<Scalars['Int']>;
  paymentId: Scalars['ID'];
};

export enum CardBrand {
  AMEX = 'amex',
  DINERS = 'diners',
  DISCOVER = 'discover',
  JCB = 'jcb',
  MASTERCARD = 'mastercard',
  UNIONPAY = 'unionpay',
  UNKNOWN = 'unknown',
  VISA = 'visa'
}

export enum CardType {
  CREDIT = 'credit',
  DEBIT = 'debit'
}

export type Charge = {
  __typename?: 'Charge';
  accountId: Scalars['ID'];
  acquirer?: Maybe<Acquirer>;
  amount?: Maybe<Scalars['Int']>;
  authorizationCode?: Maybe<Scalars['String']>;
  billingDetails?: Maybe<ContactDetails>;
  billingPlan?: Maybe<BillingPlans>;
  cancellationReason?: Maybe<CancellationReason>;
  checkoutId: Scalars['ID'];
  createdAt: Scalars['AWSTimestamp'];
  currency: Scalars['String'];
  customer?: Maybe<Customer>;
  description?: Maybe<Scalars['String']>;
  descriptor?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  issuerStatusCode?: Maybe<Scalars['String']>;
  issuerStatusMessage?: Maybe<Scalars['String']>;
  lastRefundAmount?: Maybe<Scalars['Int']>;
  lastRefundReason?: Maybe<RefundReason>;
  livemode?: Maybe<Scalars['Boolean']>;
  masterAccountId?: Maybe<Scalars['ID']>;
  metadata?: Maybe<Array<KeyValueItem>>;
  orderId?: Maybe<Scalars['ID']>;
  pageOpenedAt?: Maybe<Scalars['AWSTimestamp']>;
  paymentMethod?: Maybe<PaymentMethod>;
  pointOfSaleId?: Maybe<Scalars['ID']>;
  processor?: Maybe<Processor>;
  providerId?: Maybe<Scalars['ID']>;
  providerInternalId?: Maybe<Scalars['ID']>;
  providerReferenceId?: Maybe<Scalars['ID']>;
  providerStatusCode?: Maybe<Scalars['String']>;
  providerStatusMessage?: Maybe<Scalars['String']>;
  refundedAmount?: Maybe<Scalars['Int']>;
  sequenceId?: Maybe<Scalars['ID']>;
  sessionDetails?: Maybe<SessionDetails>;
  shippingDetails?: Maybe<ContactDetails>;
  shop?: Maybe<Shop>;
  status: ChargeStatus;
  statusCode?: Maybe<Scalars['String']>;
  statusMessage?: Maybe<Scalars['String']>;
  storeId?: Maybe<Scalars['ID']>;
  subscriptionId?: Maybe<Scalars['ID']>;
  terminalId?: Maybe<Scalars['String']>;
  traceDetails?: Maybe<TraceDetails>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']>;
};

export type ChargeEvent = {
  __typename?: 'ChargeEvent';
  accountId: Scalars['ID'];
  createdAt?: Maybe<Scalars['AWSTimestamp']>;
  id: Scalars['ID'];
  livemode?: Maybe<Scalars['Boolean']>;
  masterAccountId?: Maybe<Scalars['ID']>;
  object: ChargeEventObject;
  objectId: Scalars['ID'];
  objectType: Scalars['String'];
  type: Scalars['String'];
};

export type ChargeEventObject = {
  __typename?: 'ChargeEventObject';
  accountId: Scalars['ID'];
  amount?: Maybe<Scalars['Int']>;
  authorizationCode?: Maybe<Scalars['String']>;
  billingDetails?: Maybe<ContactDetails>;
  billingPlan?: Maybe<BillingPlans>;
  cancellationReason?: Maybe<CancellationReason>;
  checkoutId: Scalars['ID'];
  createdAt?: Maybe<Scalars['AWSTimestamp']>;
  currency: Scalars['String'];
  customer?: Maybe<Customer>;
  description?: Maybe<Scalars['String']>;
  descriptor?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  issuerStatusCode?: Maybe<Scalars['String']>;
  issuerStatusMessage?: Maybe<Scalars['String']>;
  lastRefundAmount?: Maybe<Scalars['Int']>;
  lastRefundReason?: Maybe<RefundReason>;
  livemode?: Maybe<Scalars['Boolean']>;
  masterAccountId?: Maybe<Scalars['ID']>;
  metadata?: Maybe<Array<KeyValueItem>>;
  orderId?: Maybe<Scalars['ID']>;
  pageOpenedAt?: Maybe<Scalars['AWSTimestamp']>;
  paymentMethod?: Maybe<PaymentMethod>;
  pointOfSaleId?: Maybe<Scalars['ID']>;
  providerId?: Maybe<Scalars['ID']>;
  providerInternalId?: Maybe<Scalars['ID']>;
  providerReferenceId?: Maybe<Scalars['ID']>;
  providerStatusCode?: Maybe<Scalars['String']>;
  providerStatusMessage?: Maybe<Scalars['String']>;
  refundedAmount?: Maybe<Scalars['Int']>;
  sequenceId?: Maybe<Scalars['ID']>;
  sessionDetails?: Maybe<SessionDetails>;
  shippingDetails?: Maybe<ContactDetails>;
  shop?: Maybe<Shop>;
  status: ChargeStatus;
  statusCode?: Maybe<Scalars['String']>;
  statusMessage?: Maybe<Scalars['String']>;
  storeId?: Maybe<Scalars['ID']>;
  subscriptionId?: Maybe<Scalars['ID']>;
  terminalId?: Maybe<Scalars['String']>;
  traceDetails?: Maybe<TraceDetails>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']>;
};

export type ChargeEventsConnection = {
  __typename?: 'ChargeEventsConnection';
  items: Array<ChargeEvent>;
  total: Scalars['Int'];
};

export enum ChargeStatus {
  AUTHORIZED = 'AUTHORIZED',
  CANCELED = 'CANCELED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  PAID_OUT = 'PAID_OUT',
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
  PENDING = 'PENDING',
  PENDING_PROCESSING = 'PENDING_PROCESSING',
  REFUNDED = 'REFUNDED',
  SUCCEEDED = 'SUCCEEDED'
}

export type ChargesConnection = {
  __typename?: 'ChargesConnection';
  items: Array<Charge>;
  total: Scalars['Int'];
};

export type ChargesDateRangeKpi = {
  __typename?: 'ChargesDateRangeKPI';
  currency: Currencies;
  data: Array<ChargesDateRangeKpiRow>;
  total: ChargesDateRangeKpiTotal;
};

export type ChargesDateRangeKpiRow = {
  __typename?: 'ChargesDateRangeKPIRow';
  canceledAmount: Scalars['Long'];
  canceledCount: Scalars['Long'];
  capturedAmount: Scalars['Long'];
  capturedCount: Scalars['Long'];
  cuCapturedAmount: Scalars['Long'];
  cuCapturedCount: Scalars['Long'];
  cuDirectAmount: Scalars['Long'];
  cuDirectCount: Scalars['Long'];
  cuSucceededAmount: Scalars['Long'];
  cuSucceededCount: Scalars['Long'];
  cuSucceededPayoutAmount: Scalars['Long'];
  cuSucceededPayoutCount: Scalars['Long'];
  directAmount: Scalars['Long'];
  directCount: Scalars['Long'];
  failedAmount: Scalars['Long'];
  failedCount: Scalars['Long'];
  refundedAmount: Scalars['Long'];
  refundedCount: Scalars['Long'];
  succeededAmount: Scalars['Long'];
  succeededCount: Scalars['Long'];
  succeededPayoutAmount: Scalars['Long'];
  succeededPayoutCount: Scalars['Long'];
  timestamp: Scalars['AWSTimestamp'];
};

export type ChargesDateRangeKpiTotal = {
  __typename?: 'ChargesDateRangeKPITotal';
  canceledAmount: Scalars['Long'];
  canceledCount: Scalars['Long'];
  capturedAmount: Scalars['Long'];
  capturedCount: Scalars['Long'];
  directAmount: Scalars['Long'];
  directCount: Scalars['Long'];
  failedAmount: Scalars['Long'];
  failedCount: Scalars['Long'];
  refundedAmount: Scalars['Long'];
  refundedCount: Scalars['Long'];
  succeededAmount: Scalars['Long'];
  succeededCount: Scalars['Long'];
  succeededPayoutAmount: Scalars['Long'];
  succeededPayoutCount: Scalars['Long'];
};

export type ChargesExport = {
  __typename?: 'ChargesExport';
  accountId: Scalars['ID'];
  expireAt?: Maybe<Scalars['AWSTimestamp']>;
  id: Scalars['ID'];
  status: ExportStatus;
  statusCode?: Maybe<Scalars['String']>;
  statusMessage?: Maybe<Scalars['String']>;
};

export type ChargesExportsConnection = {
  __typename?: 'ChargesExportsConnection';
  items: Array<ChargesExport>;
  nextToken?: Maybe<Scalars['String']>;
};

export enum ChurnReason {
  CLOSED_BUSINESS = 'CLOSED_BUSINESS',
  ECONOMIC_CONDITIONS = 'ECONOMIC_CONDITIONS',
  LACK_SUPPORT = 'LACK_SUPPORT',
  OTHER = 'OTHER',
  PROBLEM_WITH_PLATFORM = 'PROBLEM_WITH_PLATFORM',
  PROBLEM_WITH_WEBSITE = 'PROBLEM_WITH_WEBSITE',
  SALES_DROP = 'SALES_DROP',
  SWITCHED = 'SWITCHED'
}

export type Code = {
  __typename?: 'Code';
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  metadata?: Maybe<Array<MetadataItem>>;
  type: CodeTypes;
};

export type CodeConfig = {
  __typename?: 'CodeConfig';
  metadataConfig?: Maybe<Array<MetadataConfigItem>>;
};

export enum CodeTypes {
  POINT_OF_SALE = 'POINT_OF_SALE'
}

export type ColumnsInput = {
  amount?: InputMaybe<Scalars['String']>;
  authorizationCode?: InputMaybe<Scalars['String']>;
  commission?: InputMaybe<Scalars['String']>;
};

export type ContactDetails = {
  __typename?: 'ContactDetails';
  address?: Maybe<Address>;
  company?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
};

export type ContactDetailsInput = {
  address?: InputMaybe<AddressInput>;
  company?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
};

export type ContactPerson = {
  __typename?: 'ContactPerson';
  email: Scalars['String'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
};

export type ContactPersonInput = {
  email: Scalars['String'];
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

export enum ContractStatus {
  COMPLETED = 'completed',
  CREATED = 'created',
  DECLINED = 'declined',
  DELIVERED = 'delivered',
  SENT = 'sent',
  SIGNED = 'signed',
  VOIDED = 'voided'
}

export type Countries = {
  __typename?: 'Countries';
  currentCountry?: Maybe<Country>;
  currentCountryCode?: Maybe<Scalars['String']>;
  isSupported: Scalars['Boolean'];
  supportedCountries: Array<Country>;
};

export type Country = {
  __typename?: 'Country';
  code: Scalars['String'];
  name: Scalars['String'];
  phoneCode: Scalars['String'];
};

export type CreateAuthorizedUserInput = {
  accessLevel?: InputMaybe<AuthorizedUserAccessLevel>;
  accountId: Scalars['ID'];
  storeId?: InputMaybe<Scalars['ID']>;
  userEmail: Scalars['String'];
};

export type CreateCodeInput = {
  accountId: Scalars['ID'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Array<MetadataItemInput>>;
  type: CodeTypes;
};

export type CreateDocumentInput = {
  accountId: Scalars['ID'];
  internal?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  type: DocumentType;
};

export type CreateMasterAccountApiKeyInput = {
  apiKey?: InputMaybe<Scalars['String']>;
  livemode: Scalars['Boolean'];
  masterAccountId: Scalars['ID'];
};

export type CreateMasterAccountInput = {
  accountDefaults?: InputMaybe<AccountDefaultsInput>;
  adminEmail?: InputMaybe<Scalars['String']>;
  allowCreateApiKey?: InputMaybe<Scalars['Boolean']>;
  allowedIPs?: InputMaybe<Array<Scalars['String']>>;
  business?: InputMaybe<BusinessDataInput>;
  churnedEmails?: InputMaybe<Array<Scalars['String']>>;
  contractTemplateId?: InputMaybe<Scalars['ID']>;
  extraFees?: InputMaybe<Array<InputMaybe<AccountExtraFeeInput>>>;
  iban?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  payoutTerms?: InputMaybe<AccountPayoutTermsInput>;
  promoCode?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<AccountStatus>;
  webhookEmails?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateMasterAccountUserInput = {
  accountId: Scalars['ID'];
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type CreatePaymentInput = {
  accountId: Scalars['ID'];
  allowedPaymentMethods?: InputMaybe<Array<InputMaybe<PaymentMethods>>>;
  amount: Scalars['Int'];
  billingDetails?: InputMaybe<ContactDetailsInput>;
  callbackUrl?: InputMaybe<Scalars['String']>;
  cancelUrl?: InputMaybe<Scalars['String']>;
  completeUrl?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Currencies>;
  customer?: InputMaybe<CustomerInput>;
  description?: InputMaybe<Scalars['String']>;
  expireAt?: InputMaybe<Scalars['AWSTimestamp']>;
  failUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  metadata?: InputMaybe<Array<KeyValueInput>>;
  orderId?: InputMaybe<Scalars['ID']>;
  pointOfSaleId?: InputMaybe<Scalars['ID']>;
  shippingDetails?: InputMaybe<ContactDetailsInput>;
  storeId?: InputMaybe<Scalars['ID']>;
  transactionType?: InputMaybe<TransactionTypes>;
};

export type CreatePibisiUserInput = {
  accountId: Scalars['ID'];
  id?: InputMaybe<Scalars['Int']>;
  legalForm: LegalForm;
};

export type CreatePointOfSaleInput = {
  accountId: Scalars['ID'];
  manualAmount?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  storeId: Scalars['ID'];
};

export type CreateProviderInput = {
  accountId: Scalars['ID'];
  acquirer: Acquirer;
  enabled?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Array<MetadataItemInput>>;
  nativeHostedPayment?: InputMaybe<Scalars['Boolean']>;
  paymentMethod?: InputMaybe<PaymentMethods>;
  processor?: InputMaybe<Processor>;
  rules?: InputMaybe<ProviderRulesInput>;
  test?: InputMaybe<Scalars['Boolean']>;
};

export type CreateStoreInput = {
  accountId: Scalars['ID'];
  address?: InputMaybe<AddressInput>;
  blocked?: InputMaybe<Scalars['Boolean']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  iban?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Array<MetadataItemInput>>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type CreateSubscriptionInput = {
  accountId: Scalars['ID'];
  amount: Scalars['Int'];
  billingDetails?: InputMaybe<ContactDetailsInput>;
  callbackUrl?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Currencies>;
  customer?: InputMaybe<CustomerInput>;
  description?: InputMaybe<Scalars['String']>;
  descriptor?: InputMaybe<Scalars['String']>;
  interval?: InputMaybe<IntervalInput>;
  intervalCount?: InputMaybe<Scalars['Int']>;
  masterAccountId?: InputMaybe<Scalars['ID']>;
  metadata?: InputMaybe<Array<KeyValueInput>>;
  paymentCallbackUrl?: InputMaybe<Scalars['String']>;
  retrySchedule?: InputMaybe<Array<RetryScheduleInput>>;
  shippingDetails?: InputMaybe<ContactDetailsInput>;
  storeId?: InputMaybe<Scalars['ID']>;
  trialAmount?: InputMaybe<Scalars['Int']>;
  trialPeriodDays?: InputMaybe<Scalars['Int']>;
  trialPeriodEnd?: InputMaybe<Scalars['AWSTimestamp']>;
};

export type CreateWebhookInput = {
  accountId: Scalars['ID'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  eventTypes: Array<WebhookEventType>;
  masterAccount?: InputMaybe<Scalars['Boolean']>;
  url: Scalars['String'];
};

export enum Currencies {
  CHF = 'CHF',
  DKK = 'DKK',
  EUR = 'EUR',
  GBP = 'GBP',
  JPY = 'JPY',
  SEK = 'SEK',
  USD = 'USD'
}

export type Customer = {
  __typename?: 'Customer';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type CustomerInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type DeleteCodeInput = {
  accountId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};

export type DeleteMasterAccountApiKeyInput = {
  apiKey?: InputMaybe<Scalars['String']>;
  masterAccountId: Scalars['ID'];
};

export enum DeviceType {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
  SMARTTV = 'smartTV',
  TABLET = 'tablet'
}

export type Document = {
  __typename?: 'Document';
  accountId: Scalars['ID'];
  contentType?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  internal?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<Array<DocumentMetadataItem>>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  status: DocumentStatus;
  statusCode?: Maybe<Scalars['String']>;
  statusMessage?: Maybe<Scalars['String']>;
  traceDetails?: Maybe<TraceDetails>;
  type: DocumentType;
  updatedAt?: Maybe<Scalars['String']>;
};

export type DocumentEvent = {
  __typename?: 'DocumentEvent';
  accountId: Scalars['ID'];
  createdAt: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  object: DocumentEventObject;
  objectId: Scalars['ID'];
  objectType: Scalars['String'];
  type: Scalars['String'];
};

export type DocumentEventObject = {
  __typename?: 'DocumentEventObject';
  accountId: Scalars['ID'];
  contentType?: Maybe<Scalars['String']>;
  createdAt: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  internal?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<Array<DocumentMetadataItem>>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  status: DocumentStatus;
  statusCode?: Maybe<Scalars['String']>;
  statusMessage?: Maybe<Scalars['String']>;
  traceDetails?: Maybe<TraceDetails>;
  type: DocumentType;
  updatedAt?: Maybe<Scalars['AWSTimestamp']>;
};

export type DocumentEventsConnection = {
  __typename?: 'DocumentEventsConnection';
  items: Array<DocumentEvent>;
  total: Scalars['Int'];
};

export type DocumentMetadataItem = {
  __typename?: 'DocumentMetadataItem';
  key: Scalars['String'];
  value?: Maybe<Array<Scalars['String']>>;
};

export enum DocumentStatus {
  APPROVAL_REQUIRED = 'APPROVAL_REQUIRED',
  APPROVED = 'APPROVED',
  EXPIRED = 'EXPIRED',
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  REJECTED = 'REJECTED'
}

export enum DocumentType {
  ALAVA_CENSUS_CERT = 'ALAVA_CENSUS_CERT',
  BANK_OWNERSHIP_CERT = 'BANK_OWNERSHIP_CERT',
  BENEFICIAL_OWNERSHIP_REPORT = 'BENEFICIAL_OWNERSHIP_REPORT',
  BIZKAIA_CENSUS_CERT = 'BIZKAIA_CENSUS_CERT',
  CENSUS_CERT = 'CENSUS_CERT',
  COMPANY_TAX_ID = 'COMPANY_TAX_ID',
  CONTRACT = 'CONTRACT',
  DEED_OF_COMPANY_REPRESENTATIVE = 'DEED_OF_COMPANY_REPRESENTATIVE',
  DEED_OF_INCORPORATION = 'DEED_OF_INCORPORATION',
  DRIVERS_LICENSE = 'DRIVERS_LICENSE',
  GIPUZKOA_CENSUS_CERT = 'GIPUZKOA_CENSUS_CERT',
  ID_CARD = 'ID_CARD',
  MERCANTILE_REGISTRY_NOTE = 'MERCANTILE_REGISTRY_NOTE',
  NAVARRA_CENSUS_CERT = 'NAVARRA_CENSUS_CERT',
  OTHER = 'OTHER',
  PASSPORT = 'PASSPORT',
  PIBISI_REPORT = 'PIBISI_REPORT',
  POWER_OF_ATTORNEY = 'POWER_OF_ATTORNEY',
  RESIDENCE_PERMIT = 'RESIDENCE_PERMIT',
  VERIFF_REPORT = 'VERIFF_REPORT'
}

export type DocumentsConnection = {
  __typename?: 'DocumentsConnection';
  items: Array<Document>;
  nextToken?: Maybe<Scalars['String']>;
};

export type DownloadFile = {
  __typename?: 'DownloadFile';
  downloadUrl: Scalars['String'];
  expiresAt: Scalars['AWSTimestamp'];
};

export enum ExportStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  PENDING = 'PENDING'
}

export enum Gender {
  F = 'F',
  M = 'M'
}

export type GenerateSettlementReportInput = {
  accountId: Scalars['ID'];
  columns?: InputMaybe<ColumnsInput>;
  file: S3ObjectInput;
  timezone?: InputMaybe<Scalars['String']>;
};

export type IdDocument = {
  __typename?: 'IdDocument';
  country?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  type?: Maybe<IdDocumentType>;
  validFrom?: Maybe<Scalars['String']>;
  validUntil?: Maybe<Scalars['String']>;
};

export enum IdDocumentType {
  DRIVERS_LICENSE = 'DRIVERS_LICENSE',
  ID_CARD = 'ID_CARD',
  PASSPORT = 'PASSPORT',
  RESIDENCE_PERMIT = 'RESIDENCE_PERMIT'
}

export enum IdVerificationStatus {
  ABANDONED = 'abandoned',
  APPROVED = 'approved',
  DECLINED = 'declined',
  EXPIRED = 'expired',
  RESUBMISSION_REQUESTED = 'resubmission_requested',
  SUBMITTED = 'submitted'
}

export type ImpersonateInput = {
  accountId?: InputMaybe<Scalars['ID']>;
  adminEmail: Scalars['String'];
  userEmail: Scalars['String'];
};

export enum Industries {
  ECOMMERCE = 'ECOMMERCE'
}

export enum Interval {
  DAY = 'day',
  HOUR = 'hour',
  MINUTE = 'minute',
  MONTH = 'month',
  QUARTER = 'quarter',
  WEEK = 'week',
  YEAR = 'year'
}

export enum IntervalInput {
  DAY = 'day',
  MINUTE = 'minute',
  MONTH = 'month',
  QUARTER = 'quarter',
  WEEK = 'week',
  YEAR = 'year'
}

export enum InterventionType {
  AUT = 'AUT',
  OTR = 'OTR',
  REP = 'REP',
  TIT = 'TIT',
  TRE = 'TRE'
}

export type InvoiceBusinessData = {
  __typename?: 'InvoiceBusinessData';
  documentNumber?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  legalName?: Maybe<Scalars['String']>;
  mandateSignatureTimestamp?: Maybe<Scalars['String']>;
};

export enum InvoiceLineItemUnitType {
  MONEY = 'money',
  PERCENT = 'percent'
}

export type InvoicesConnection = {
  __typename?: 'InvoicesConnection';
  items: Array<AccountInvoice>;
  total: Scalars['Int'];
};

export type ItemLevelUpdate = {
  __typename?: 'ItemLevelUpdate';
  accountId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
};

export type KeyValueInput = {
  key: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type KeyValueItem = {
  __typename?: 'KeyValueItem';
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type LastPayment = {
  __typename?: 'LastPayment';
  id: Scalars['ID'];
  status: PaymentStatus;
  statusCode?: Maybe<Scalars['String']>;
  statusMessage?: Maybe<Scalars['String']>;
};

export enum LegalForm {
  COMPANY = 'COMPANY',
  FREELANCE = 'FREELANCE',
  INDIVIDUAL = 'INDIVIDUAL'
}

export type MasterAccount = {
  __typename?: 'MasterAccount';
  accountCallbackUrl?: Maybe<Scalars['String']>;
  accountDefaults?: Maybe<AccountDefaults>;
  adminEmail?: Maybe<Scalars['String']>;
  allowCreateApiKey?: Maybe<Scalars['Boolean']>;
  allowedDomains?: Maybe<Array<Scalars['String']>>;
  allowedIPs?: Maybe<Array<Scalars['String']>>;
  apiKey?: Maybe<Scalars['String']>;
  autoApprove?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  branding?: Maybe<AccountBranding>;
  business?: Maybe<BusinessData>;
  churnedEmails?: Maybe<Array<Scalars['String']>>;
  contractTemplateId?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  extraFees?: Maybe<Array<Maybe<AccountExtraFee>>>;
  iban?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  payoutTerms?: Maybe<AccountPayoutTerms>;
  prodAccountId?: Maybe<Scalars['ID']>;
  promoCode?: Maybe<Scalars['String']>;
  publicBusinessDetails?: Maybe<AccountPublicBusinessDetails>;
  requireExternalId?: Maybe<Scalars['Boolean']>;
  status?: Maybe<AccountStatus>;
  test?: Maybe<Scalars['Boolean']>;
  testAccountId?: Maybe<Scalars['ID']>;
  traceDetails?: Maybe<TraceDetails>;
  updatedAt?: Maybe<Scalars['String']>;
  webhookEmails?: Maybe<Array<Scalars['String']>>;
};

export type MasterAccountActualFees = {
  __typename?: 'MasterAccountActualFees';
  approvedAccountFee: Scalars['Int'];
  extra?: Maybe<Array<MasterAccountExtraFee>>;
};

export type MasterAccountExtraFee = {
  __typename?: 'MasterAccountExtraFee';
  amount: Scalars['Float'];
  masterAccountFee?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  paymentMethods?: Maybe<Array<PaymentMethods>>;
  region?: Maybe<AccountExtraFeeRegion>;
  type: AccountExtraFeeType;
};

export type MasterAccountExtraFeeInput = {
  amount?: InputMaybe<Scalars['Float']>;
  masterAccountFee?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  paymentMethods?: InputMaybe<Array<InputMaybe<PaymentMethods>>>;
  region?: InputMaybe<AccountExtraFeeRegion>;
  type?: InputMaybe<AccountExtraFeeType>;
};

export type MasterAccountFeesInput = {
  approvedAccountFee?: InputMaybe<Scalars['Int']>;
  extra?: InputMaybe<Array<MasterAccountExtraFeeInput>>;
};

export type MasterAccountInvoice = {
  __typename?: 'MasterAccountInvoice';
  amount: Scalars['Int'];
  business?: Maybe<InvoiceBusinessData>;
  createdAt: Scalars['AWSTimestamp'];
  currency: Scalars['String'];
  id?: Maybe<Scalars['ID']>;
  lineItems: Array<AccountInvoiceLineItem>;
  masterAccountId: Scalars['ID'];
  number?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<AccountInvoicePaymentMethod>;
  period: AccountInvoicePeriod;
  status?: Maybe<AccountInvoiceStatus>;
  tax: Scalars['Int'];
  totalAmount: Scalars['Int'];
  updatedAt?: Maybe<Scalars['AWSTimestamp']>;
};

export type MasterAccountInvoicesConnection = {
  __typename?: 'MasterAccountInvoicesConnection';
  items: Array<MasterAccountInvoice>;
};

export type MasterAccountsConnection = {
  __typename?: 'MasterAccountsConnection';
  items: Array<MasterAccount>;
  total: Scalars['Int'];
};

export enum MessageChannel {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  WHATSAPP = 'WHATSAPP'
}

export type MetadataConfigItem = {
  __typename?: 'MetadataConfigItem';
  default?: Maybe<Scalars['String']>;
  example?: Maybe<Scalars['String']>;
  internal?: Maybe<Scalars['Boolean']>;
  key: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  possibleValues?: Maybe<Array<Scalars['String']>>;
  regex?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  secret?: Maybe<Scalars['Boolean']>;
  type: MetadataItemType;
};

export type MetadataItem = {
  __typename?: 'MetadataItem';
  default?: Maybe<Scalars['String']>;
  example?: Maybe<Scalars['String']>;
  internal?: Maybe<Scalars['Boolean']>;
  key: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  possibleValues?: Maybe<Array<Scalars['String']>>;
  regex?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  secret?: Maybe<Scalars['Boolean']>;
  type: MetadataItemType;
  value?: Maybe<Scalars['String']>;
};

export type MetadataItemInput = {
  key: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export enum MetadataItemType {
  BOOLEAN = 'BOOLEAN',
  NUMBER = 'NUMBER',
  NUMBER_ARRAY = 'NUMBER_ARRAY',
  STRING = 'STRING',
  STRING_ARRAY = 'STRING_ARRAY'
}

export type Mutation = {
  __typename?: 'Mutation';
  activateSubscription?: Maybe<Payment>;
  addBlacklistItem?: Maybe<BlacklistItem>;
  approveAccount: Account;
  calculateRiskScore?: Maybe<Account>;
  cancelPayment?: Maybe<Payment>;
  cancelSubscription?: Maybe<Subscription>;
  capturePayment?: Maybe<Payment>;
  connectMasterAccount: Account;
  createAccountInvoice: AccountInvoice;
  createAuthorizedUser?: Maybe<AuthorizedUser>;
  createCode: Code;
  createDocument: Document;
  createMasterAccount: MasterAccount;
  createMasterAccountApiKey: MasterAccount;
  createMasterAccountUser: AuthorizedUser;
  createPayment?: Maybe<Payment>;
  createPibisiUser: Account;
  createPointOfSale: PointOfSale;
  createProvider: Provider;
  createStore: Store;
  createSubscription?: Maybe<Subscription>;
  createWebhook: Webhook;
  deleteAccount: Account;
  deleteAuthorizedUser: Scalars['Boolean'];
  deleteBlacklistItem: Scalars['Boolean'];
  deleteCode: Scalars['Boolean'];
  deleteDocument: Scalars['Boolean'];
  deleteMasterAccountApiKey: MasterAccount;
  deleteMasterAccountUser: Scalars['Boolean'];
  deletePointOfSale: Scalars['Boolean'];
  deleteProvider: Provider;
  deleteStore: Scalars['Boolean'];
  deleteWebhook: Scalars['Boolean'];
  disableAffiliateProcessing: Affiliate;
  disableTokenizationMethod: Account;
  disableUser: User;
  disconnectMasterAccount: Account;
  downloadAccountInvoice: DownloadFile;
  downloadAffiliateInvoice: DownloadFile;
  downloadContract?: Maybe<DownloadFile>;
  downloadDocument: DownloadFile;
  downloadExport: DownloadFile;
  downloadOperationsFile: DownloadFile;
  enableAffiliateProcessing: Affiliate;
  enableTokenizationMethod: Account;
  enableUser: User;
  exportCharges: DownloadFile;
  generateSettlementReport: DownloadFile;
  impersonate?: Maybe<Scalars['Boolean']>;
  pauseSubscription?: Maybe<Subscription>;
  publishUpdateAccount?: Maybe<AccountLevelUpdate>;
  /** @deprecated Use publishUpdateAnalyticsV2 instead */
  publishUpdateAnalytics?: Maybe<AnalyticsChange>;
  publishUpdateAnalyticsV2: Scalars['Boolean'];
  publishUpdateCharge?: Maybe<ItemLevelUpdate>;
  publishUpdateChargeEvents?: Maybe<ItemLevelUpdate>;
  publishUpdateCharges?: Maybe<AccountLevelUpdate>;
  publishUpdateDocuments?: Maybe<AccountLevelUpdate>;
  publishUpdateEvents?: Maybe<AccountLevelUpdate>;
  publishUpdateSubscription?: Maybe<ItemLevelUpdate>;
  publishUpdateSubscriptionEvents?: Maybe<ItemLevelUpdate>;
  publishUpdateSubscriptions?: Maybe<AccountLevelUpdate>;
  refundPayment?: Maybe<Payment>;
  registerMoneiXMerchant: SuccessResult;
  registerMoneiXPMerchant: SuccessResult;
  resetUserPassword: Scalars['String'];
  resolvePibisiAlert: Account;
  resolvePibisiMatch: Account;
  restoreAccount: Account;
  resumeSubscription?: Maybe<Subscription>;
  retrieveAffiliateHistory?: Maybe<Scalars['Boolean']>;
  sendPaymentLink?: Maybe<Payment>;
  sendPaymentReceipt?: Maybe<Payment>;
  sendPaymentRequest?: Maybe<Payment>;
  sendSubscriptionLink?: Maybe<Subscription>;
  sendSubscriptionStatus?: Maybe<Subscription>;
  startCompanyLookup: Account;
  startExportCharges: ChargesExport;
  updateAccount: Account;
  updateAccountInvoice: AccountInvoice;
  updateAffiliatePayoutMethod: Affiliate;
  updateAffiliateTier: Affiliate;
  updateAuthorizedUser?: Maybe<AuthorizedUser>;
  updateCode: Code;
  updateDocument: Document;
  updateMasterAccount: MasterAccount;
  updatePibisiStatus: Account;
  updatePointOfSale: PointOfSale;
  updateProvider: Provider;
  updateStore: Store;
  updateSubscription?: Maybe<Subscription>;
  updateUser: User;
  updateUserMasterAccount: MasterAccount;
  updateWebKeyword?: Maybe<WebKeyword>;
  updateWebhook: Webhook;
  uploadDocument: UploadFile;
  verifyId: Account;
};


export type MutationActivateSubscriptionArgs = {
  input: ActivateSubscriptionInput;
};


export type MutationAddBlacklistItemArgs = {
  input: BlacklistItemInput;
};


export type MutationApproveAccountArgs = {
  id: Scalars['ID'];
  processor?: InputMaybe<Processor>;
};


export type MutationCalculateRiskScoreArgs = {
  input: CalculateRiskScoreInput;
};


export type MutationCancelPaymentArgs = {
  input: CancelPaymentInput;
};


export type MutationCancelSubscriptionArgs = {
  input: CancelSubscriptionInput;
};


export type MutationCapturePaymentArgs = {
  input: CapturePaymentInput;
};


export type MutationConnectMasterAccountArgs = {
  accountId: Scalars['ID'];
  externalHash?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  promoCode: Scalars['String'];
};


export type MutationCreateAccountInvoiceArgs = {
  input: AccountInvoiceInput;
};


export type MutationCreateAuthorizedUserArgs = {
  input: CreateAuthorizedUserInput;
};


export type MutationCreateCodeArgs = {
  input: CreateCodeInput;
};


export type MutationCreateDocumentArgs = {
  input: CreateDocumentInput;
};


export type MutationCreateMasterAccountArgs = {
  input: CreateMasterAccountInput;
};


export type MutationCreateMasterAccountApiKeyArgs = {
  input: CreateMasterAccountApiKeyInput;
};


export type MutationCreateMasterAccountUserArgs = {
  input: CreateMasterAccountUserInput;
};


export type MutationCreatePaymentArgs = {
  input: CreatePaymentInput;
};


export type MutationCreatePibisiUserArgs = {
  input?: InputMaybe<CreatePibisiUserInput>;
};


export type MutationCreatePointOfSaleArgs = {
  input: CreatePointOfSaleInput;
};


export type MutationCreateProviderArgs = {
  input: CreateProviderInput;
};


export type MutationCreateStoreArgs = {
  input: CreateStoreInput;
};


export type MutationCreateSubscriptionArgs = {
  input: CreateSubscriptionInput;
};


export type MutationCreateWebhookArgs = {
  input: CreateWebhookInput;
};


export type MutationDeleteAccountArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAuthorizedUserArgs = {
  accountId: Scalars['ID'];
  userEmail: Scalars['String'];
};


export type MutationDeleteBlacklistItemArgs = {
  accountId?: InputMaybe<Scalars['ID']>;
  value: Scalars['String'];
};


export type MutationDeleteCodeArgs = {
  input: DeleteCodeInput;
};


export type MutationDeleteDocumentArgs = {
  accountId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDeleteMasterAccountApiKeyArgs = {
  input: DeleteMasterAccountApiKeyInput;
};


export type MutationDeleteMasterAccountUserArgs = {
  accountId: Scalars['ID'];
  userEmail: Scalars['String'];
};


export type MutationDeletePointOfSaleArgs = {
  accountId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};


export type MutationDeleteProviderArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteStoreArgs = {
  accountId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDeleteWebhookArgs = {
  accountId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDisableAffiliateProcessingArgs = {
  affiliateId: Scalars['ID'];
};


export type MutationDisableTokenizationMethodArgs = {
  accountId: Scalars['ID'];
  method: TokenizationMethods;
};


export type MutationDisableUserArgs = {
  id: Scalars['ID'];
};


export type MutationDisconnectMasterAccountArgs = {
  accountId: Scalars['ID'];
};


export type MutationDownloadAccountInvoiceArgs = {
  accountId: Scalars['ID'];
  invoiceId: Scalars['ID'];
};


export type MutationDownloadAffiliateInvoiceArgs = {
  affiliateId: Scalars['String'];
  invoiceNumber: Scalars['String'];
  year?: InputMaybe<Scalars['String']>;
};


export type MutationDownloadContractArgs = {
  accountId: Scalars['ID'];
};


export type MutationDownloadDocumentArgs = {
  accountId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDownloadExportArgs = {
  id: Scalars['ID'];
};


export type MutationDownloadOperationsFileArgs = {
  accountId: Scalars['ID'];
  settlementId: Scalars['ID'];
};


export type MutationEnableAffiliateProcessingArgs = {
  affiliateId: Scalars['ID'];
};


export type MutationEnableTokenizationMethodArgs = {
  accountId: Scalars['ID'];
  method: TokenizationMethods;
};


export type MutationEnableUserArgs = {
  id: Scalars['ID'];
};


export type MutationExportChargesArgs = {
  columns?: InputMaybe<Array<Scalars['String']>>;
  filter?: InputMaybe<SearchableChargeFilterInput>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type MutationGenerateSettlementReportArgs = {
  input: GenerateSettlementReportInput;
};


export type MutationImpersonateArgs = {
  input: ImpersonateInput;
};


export type MutationPauseSubscriptionArgs = {
  input: PauseSubscriptionInput;
};


export type MutationPublishUpdateAccountArgs = {
  accountId: Scalars['ID'];
};


export type MutationPublishUpdateAnalyticsArgs = {
  all: Scalars['Boolean'];
};


export type MutationPublishUpdateChargeArgs = {
  accountId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationPublishUpdateChargeEventsArgs = {
  accountId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationPublishUpdateChargesArgs = {
  accountId: Scalars['ID'];
};


export type MutationPublishUpdateDocumentsArgs = {
  accountId: Scalars['ID'];
};


export type MutationPublishUpdateEventsArgs = {
  accountId: Scalars['ID'];
};


export type MutationPublishUpdateSubscriptionArgs = {
  accountId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationPublishUpdateSubscriptionEventsArgs = {
  accountId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationPublishUpdateSubscriptionsArgs = {
  accountId: Scalars['ID'];
};


export type MutationRefundPaymentArgs = {
  input: RefundPaymentInput;
};


export type MutationRegisterMoneiXMerchantArgs = {
  id: Scalars['ID'];
};


export type MutationRegisterMoneiXpMerchantArgs = {
  accountId: Scalars['ID'];
  paymentMethods?: InputMaybe<Array<InputMaybe<PaymentMethods>>>;
};


export type MutationResetUserPasswordArgs = {
  temporalPassword?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
};


export type MutationResolvePibisiAlertArgs = {
  input?: InputMaybe<ResolvePibisiAlertInput>;
};


export type MutationResolvePibisiMatchArgs = {
  input?: InputMaybe<ResolvePibisiMatchInput>;
};


export type MutationRestoreAccountArgs = {
  id: Scalars['ID'];
};


export type MutationResumeSubscriptionArgs = {
  input: ResumeSubscriptionInput;
};


export type MutationRetrieveAffiliateHistoryArgs = {
  affiliateId: Scalars['ID'];
  email?: InputMaybe<Scalars['String']>;
};


export type MutationSendPaymentLinkArgs = {
  input: SendPaymentMessageInput;
};


export type MutationSendPaymentReceiptArgs = {
  input: SendPaymentMessageInput;
};


export type MutationSendPaymentRequestArgs = {
  input: SendPaymentRequestInput;
};


export type MutationSendSubscriptionLinkArgs = {
  input: SendSubscriptionMessageInput;
};


export type MutationSendSubscriptionStatusArgs = {
  input: SendSubscriptionMessageInput;
};


export type MutationStartCompanyLookupArgs = {
  accountId: Scalars['ID'];
  documentNumber: Scalars['String'];
};


export type MutationStartExportChargesArgs = {
  columns?: InputMaybe<Array<Scalars['String']>>;
  filter?: InputMaybe<SearchableChargeFilterInput>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateAccountArgs = {
  input: UpdateAccountInput;
};


export type MutationUpdateAccountInvoiceArgs = {
  input: UpdateAccountInvoiceInput;
};


export type MutationUpdateAffiliatePayoutMethodArgs = {
  input: UpdateAffiliatePayoutMethodInput;
};


export type MutationUpdateAffiliateTierArgs = {
  input: UpdateAffiliateTierInput;
};


export type MutationUpdateAuthorizedUserArgs = {
  input: UpdateAuthorizedUserInput;
};


export type MutationUpdateCodeArgs = {
  input: UpdateCodeInput;
};


export type MutationUpdateDocumentArgs = {
  input: UpdateDocumentInput;
};


export type MutationUpdateMasterAccountArgs = {
  input: UpdateMasterAccountInput;
};


export type MutationUpdatePibisiStatusArgs = {
  input?: InputMaybe<UpdatePibisiStatusInput>;
};


export type MutationUpdatePointOfSaleArgs = {
  input: UpdatePointOfSaleInput;
};


export type MutationUpdateProviderArgs = {
  input: UpdateProviderInput;
};


export type MutationUpdateStoreArgs = {
  input: UpdateStoreInput;
};


export type MutationUpdateSubscriptionArgs = {
  input: UpdateSubscriptionInput;
};


export type MutationUpdateUserArgs = {
  input: UserInput;
};


export type MutationUpdateUserMasterAccountArgs = {
  input: UpdateUserMasterAccountInput;
};


export type MutationUpdateWebKeywordArgs = {
  input: UpdateWebKeywordInput;
};


export type MutationUpdateWebhookArgs = {
  input: UpdateWebhookInput;
};


export type MutationUploadDocumentArgs = {
  accountId: Scalars['ID'];
  contentType?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type MutationVerifyIdArgs = {
  accountId: Scalars['ID'];
  id: Scalars['Int'];
};

export type NextAction = {
  __typename?: 'NextAction';
  mustRedirect?: Maybe<Scalars['Boolean']>;
  redirectUrl?: Maybe<Scalars['String']>;
  type?: Maybe<NextActionTypes>;
};

export enum NextActionTypes {
  BIZUM_CHALLENGE = 'BIZUM_CHALLENGE',
  CHALLENGE = 'CHALLENGE',
  COMPLETE = 'COMPLETE',
  CONFIRM = 'CONFIRM',
  FRICTIONLESS_CHALLENGE = 'FRICTIONLESS_CHALLENGE'
}

export enum Partner {
  ACTIVE_MERCHANT = 'ACTIVE_MERCHANT',
  SHOPIFY = 'SHOPIFY',
  V1 = 'V1'
}

export type PauseSubscriptionInput = {
  accountId: Scalars['ID'];
  id: Scalars['ID'];
  pauseAtPeriodEnd?: InputMaybe<Scalars['Boolean']>;
  pauseIntervalCount: Scalars['Int'];
};

export type Payment = {
  __typename?: 'Payment';
  accountId: Scalars['ID'];
  amount?: Maybe<Scalars['Int']>;
  authorizationCode?: Maybe<Scalars['String']>;
  billingDetails?: Maybe<ContactDetails>;
  cancellationReason?: Maybe<CancellationReason>;
  createdAt?: Maybe<Scalars['AWSTimestamp']>;
  currency: Scalars['String'];
  customer?: Maybe<Customer>;
  description?: Maybe<Scalars['String']>;
  descriptor?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastRefundAmount?: Maybe<Scalars['Int']>;
  lastRefundReason?: Maybe<RefundReason>;
  livemode?: Maybe<Scalars['Boolean']>;
  masterAccountId?: Maybe<Scalars['ID']>;
  metadata?: Maybe<Array<KeyValueItem>>;
  nextAction?: Maybe<NextAction>;
  orderId?: Maybe<Scalars['ID']>;
  pageOpenedAt?: Maybe<Scalars['AWSTimestamp']>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentToken?: Maybe<Scalars['String']>;
  pointOfSaleId?: Maybe<Scalars['ID']>;
  refundedAmount?: Maybe<Scalars['Int']>;
  sequenceId?: Maybe<Scalars['ID']>;
  sessionDetails?: Maybe<SessionDetails>;
  shippingDetails?: Maybe<ContactDetails>;
  shop?: Maybe<Shop>;
  status: PaymentStatus;
  statusCode?: Maybe<Scalars['String']>;
  statusMessage?: Maybe<Scalars['String']>;
  storeId?: Maybe<Scalars['ID']>;
  subscriptionId?: Maybe<Scalars['ID']>;
  traceDetails?: Maybe<TraceDetails>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']>;
};

export enum PaymentEmailType {
  PAYMENT_LINK = 'PAYMENT_LINK',
  RECEIPT = 'RECEIPT'
}

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  bizum?: Maybe<PaymentMethodBizum>;
  card?: Maybe<PaymentMethodCard>;
  cardPresent?: Maybe<PaymentMethodCardPresent>;
  cofidis?: Maybe<PaymentMethodCofidis>;
  cofidisLoan?: Maybe<PaymentMethodCofidisLoan>;
  klarna?: Maybe<PaymentMethodKlarna>;
  mbway?: Maybe<PaymentMethodMbWay>;
  method?: Maybe<PaymentMethods>;
  paypal?: Maybe<PaymentMethodPaypal>;
  sepa?: Maybe<PaymentMethodSepa>;
  trustly?: Maybe<PaymentMethodTrustly>;
};

export type PaymentMethodBizum = {
  __typename?: 'PaymentMethodBizum';
  integrationType?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type PaymentMethodCard = {
  __typename?: 'PaymentMethodCard';
  bank?: Maybe<Scalars['String']>;
  brand?: Maybe<CardBrand>;
  cardholderEmail?: Maybe<Scalars['String']>;
  cardholderName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  expiration?: Maybe<Scalars['Long']>;
  last4?: Maybe<Scalars['String']>;
  srcCorrelationId?: Maybe<Scalars['ID']>;
  srcDpaId?: Maybe<Scalars['ID']>;
  srciTransactionId?: Maybe<Scalars['ID']>;
  threeDSecure?: Maybe<Scalars['Boolean']>;
  threeDSecureFlow?: Maybe<ThreeDSecureFlow>;
  threeDSecureStatus?: Maybe<ThreeDsStatus>;
  threeDSecureVersion?: Maybe<Scalars['String']>;
  tokenizationMethod?: Maybe<TokenizationMethods>;
  type?: Maybe<CardType>;
};

export type PaymentMethodCardPresent = {
  __typename?: 'PaymentMethodCardPresent';
  bin?: Maybe<Scalars['String']>;
  brand?: Maybe<CardBrand>;
  cardholderEmail?: Maybe<Scalars['String']>;
  cardholderName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  expiration?: Maybe<Scalars['Long']>;
  last4?: Maybe<Scalars['String']>;
  type?: Maybe<CardType>;
};

export type PaymentMethodCofidis = {
  __typename?: 'PaymentMethodCofidis';
  orderId?: Maybe<Scalars['ID']>;
};

export type PaymentMethodCofidisLoan = {
  __typename?: 'PaymentMethodCofidisLoan';
  orderId?: Maybe<Scalars['ID']>;
};

export type PaymentMethodKlarna = {
  __typename?: 'PaymentMethodKlarna';
  authPaymentMethod?: Maybe<AuthPaymentMethodKlarna>;
  billingCategory?: Maybe<BillingCategoryKlarna>;
};

export type PaymentMethodMbWay = {
  __typename?: 'PaymentMethodMBWay';
  phoneNumber?: Maybe<Scalars['String']>;
};

export type PaymentMethodPaypal = {
  __typename?: 'PaymentMethodPaypal';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['ID']>;
  payerId?: Maybe<Scalars['ID']>;
};

export type PaymentMethodSepa = {
  __typename?: 'PaymentMethodSepa';
  accountholderAddress?: Maybe<Address>;
  accountholderEmail?: Maybe<Scalars['String']>;
  accountholderName?: Maybe<Scalars['String']>;
  bankAddress?: Maybe<Scalars['String']>;
  bankCode?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  bic?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
};

export type PaymentMethodTrustly = {
  __typename?: 'PaymentMethodTrustly';
  customerId?: Maybe<Scalars['ID']>;
};

export enum PaymentMethods {
  ALIPAY = 'alipay',
  APPLEPAY = 'applePay',
  BANCONTACT = 'bancontact',
  BIZUM = 'bizum',
  BLIK = 'blik',
  CARD = 'card',
  CARDPRESENT = 'cardPresent',
  CLICKTOPAY = 'clickToPay',
  COFIDIS = 'cofidis',
  COFIDISLOAN = 'cofidisLoan',
  EPS = 'eps',
  GIROPAY = 'giropay',
  GOOGLEPAY = 'googlePay',
  IDEAL = 'iDeal',
  KLARNA = 'klarna',
  MBWAY = 'mbway',
  MULTIBANCO = 'multibanco',
  PAYPAL = 'paypal',
  SEPA = 'sepa',
  SOFORT = 'sofort',
  SRTP = 'srtp',
  TRUSTLY = 'trustly'
}

export enum PaymentStatus {
  AUTHORIZED = 'AUTHORIZED',
  CANCELED = 'CANCELED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  PAID_OUT = 'PAID_OUT',
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
  PENDING = 'PENDING',
  PENDING_PROCESSING = 'PENDING_PROCESSING',
  REFUNDED = 'REFUNDED',
  SUCCEEDED = 'SUCCEEDED'
}

export type Pibisi = {
  __typename?: 'Pibisi';
  alerts?: Maybe<Array<Maybe<PibisiAlert>>>;
  alertsId?: Maybe<Scalars['String']>;
  alertsStatus?: Maybe<PibisiMatchStatus>;
  customerId?: Maybe<Scalars['ID']>;
  matches?: Maybe<Array<Maybe<PibisiMatch>>>;
  status?: Maybe<PibisiStatus>;
};

export enum PibisiAction {
  ACCEPT = 'accept',
  REJECT = 'reject'
}

export type PibisiAlert = {
  __typename?: 'PibisiAlert';
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  status: PibisiAlertStatus;
  type?: Maybe<PibisiAlertTypes>;
};

export type PibisiAlertInput = {
  id: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PibisiAlertStatus>;
  type?: InputMaybe<PibisiAlertTypes>;
};

export enum PibisiAlertStatus {
  ACCEPTED = 'accepted',
  MONITORED = 'monitored',
  PENDING = 'pending',
  REJECTED = 'rejected'
}

export enum PibisiAlertTypes {
  HAS_MATCHES = 'has_matches',
  HAS_MEDIA = 'has_media',
  INFO_ID_EXPIRED = 'info_id_expired',
  INFO_ID_EXPIRED_NOTICE = 'info_id_expired_notice',
  IS_HIGH_RISK = 'is_high_risk',
  IS_PEP = 'is_pep',
  IS_SANCTIONED = 'is_sanctioned',
  IS_TERRORIST = 'is_terrorist',
  POSSIBLY_INCOMPLETE_NAME = 'possibly_incomplete_name',
  WAS_HIGH_RISK = 'was_high_risk',
  WAS_PEP = 'was_pep'
}

export type PibisiContent = {
  __typename?: 'PibisiContent';
  action?: Maybe<Scalars['String']>;
  charge?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  from?: Maybe<Scalars['String']>;
  issue?: Maybe<Scalars['String']>;
  issuer?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  types?: Maybe<Array<Maybe<Scalars['String']>>>;
  url?: Maybe<Scalars['String']>;
};

export type PibisiContentInput = {
  action?: InputMaybe<Scalars['String']>;
  charge?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  issue?: InputMaybe<Scalars['String']>;
  issuer?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  url?: InputMaybe<Scalars['String']>;
};

export type PibisiFlag = {
  __typename?: 'PibisiFlag';
  content?: Maybe<PibisiContent>;
  id?: Maybe<Scalars['ID']>;
};

export type PibisiFlagInput = {
  content?: InputMaybe<PibisiContentInput>;
  id?: InputMaybe<Scalars['ID']>;
};

export type PibisiInput = {
  alerts?: InputMaybe<Array<InputMaybe<PibisiAlertInput>>>;
  alertsId?: InputMaybe<Scalars['String']>;
  alertsStatus?: InputMaybe<PibisiMatchStatus>;
  customerId?: InputMaybe<Scalars['ID']>;
  matches?: InputMaybe<Array<InputMaybe<PibisiMatchInput>>>;
  status?: InputMaybe<PibisiStatus>;
};

export type PibisiMatch = {
  __typename?: 'PibisiMatch';
  adverseInfo?: Maybe<Array<Maybe<PibisiFlag>>>;
  highRisk?: Maybe<Array<Maybe<PibisiFlag>>>;
  id: Scalars['ID'];
  matches?: Maybe<Array<Maybe<PibisiFlag>>>;
  media?: Maybe<Array<Maybe<PibisiFlag>>>;
  pep?: Maybe<Array<Maybe<PibisiFlag>>>;
  sanctioned?: Maybe<Array<Maybe<PibisiFlag>>>;
  status: PibisiMatchStatus;
  terrorist?: Maybe<Array<Maybe<PibisiFlag>>>;
};

export type PibisiMatchInput = {
  adverseInfo?: InputMaybe<Array<InputMaybe<PibisiFlagInput>>>;
  highRisk?: InputMaybe<Array<InputMaybe<PibisiFlagInput>>>;
  id: Scalars['ID'];
  matches?: InputMaybe<Array<InputMaybe<PibisiFlagInput>>>;
  media?: InputMaybe<Array<InputMaybe<PibisiFlagInput>>>;
  note?: InputMaybe<Scalars['String']>;
  pep?: InputMaybe<Array<InputMaybe<PibisiFlagInput>>>;
  sanction?: InputMaybe<Array<InputMaybe<PibisiFlagInput>>>;
  status?: InputMaybe<PibisiMatchStatus>;
  terrorist?: InputMaybe<Array<InputMaybe<PibisiFlagInput>>>;
};

export enum PibisiMatchStatus {
  ACCEPTED = 'accepted',
  PENDING = 'pending',
  REJECTED = 'rejected'
}

export enum PibisiStatus {
  PENDING_TO_VERIFY = 'PENDING_TO_VERIFY',
  REJECTED = 'REJECTED',
  UNDER_REVIEW = 'UNDER_REVIEW',
  VERIFIED = 'VERIFIED'
}

export type PointOfSale = {
  __typename?: 'PointOfSale';
  accountId: Scalars['ID'];
  currentPaymentId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  manualAmount?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  number: Scalars['Int'];
  storeId: Scalars['ID'];
};

export type PointsOfSaleConnection = {
  __typename?: 'PointsOfSaleConnection';
  items: Array<PointOfSale>;
  nextToken?: Maybe<Scalars['String']>;
};

export enum Processor {
  ADYEN = 'ADYEN',
  COFIDIS = 'COFIDIS',
  MONEIX_F = 'MONEIX_F',
  MONEIX_G = 'MONEIX_G',
  MONEIX_P = 'MONEIX_P',
  MONEIX_S = 'MONEIX_S',
  MONEI_REDSYS = 'MONEI_REDSYS',
  MONEI_X = 'MONEI_X',
  PAYPAL = 'PAYPAL',
  REDSYS = 'REDSYS',
  STRIPE = 'STRIPE',
  TEST_BIZUM = 'TEST_BIZUM',
  TEST_CARD = 'TEST_CARD'
}

export type Provider = {
  __typename?: 'Provider';
  acquirer?: Maybe<Acquirer>;
  configurable?: Maybe<Scalars['Boolean']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  metadata?: Maybe<Array<MetadataItem>>;
  nativeHostedPayment?: Maybe<Scalars['Boolean']>;
  paymentMethod?: Maybe<PaymentMethods>;
  processor?: Maybe<Processor>;
  rules?: Maybe<ProviderRules>;
  test?: Maybe<Scalars['Boolean']>;
};

export type ProviderConfig = {
  __typename?: 'ProviderConfig';
  acquirers?: Maybe<Array<Acquirer>>;
  metadataConfig?: Maybe<Array<MetadataConfigItem>>;
  paymentMethod?: Maybe<PaymentMethods>;
  processor?: Maybe<Processor>;
};

export type ProviderEvent = {
  __typename?: 'ProviderEvent';
  accountId: Scalars['ID'];
  createdAt: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  object: ProviderEventObject;
  objectId: Scalars['ID'];
  objectType: Scalars['String'];
  traceDetails?: Maybe<TraceDetails>;
  type: Scalars['String'];
};

export type ProviderEventObject = {
  __typename?: 'ProviderEventObject';
  acquirer?: Maybe<Acquirer>;
  configurable?: Maybe<Scalars['Boolean']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  internalId?: Maybe<Scalars['String']>;
  metadata?: Maybe<Array<ProviderMetadataItem>>;
  nativeHostedPayment?: Maybe<Scalars['Boolean']>;
  paymentMethod?: Maybe<PaymentMethods>;
  processor?: Maybe<Processor>;
  rules?: Maybe<ProviderRules>;
  test?: Maybe<Scalars['Boolean']>;
  traceDetails?: Maybe<TraceDetails>;
};

export type ProviderEventsConnection = {
  __typename?: 'ProviderEventsConnection';
  items: Array<ProviderEvent>;
  total: Scalars['Int'];
};

export type ProviderMetadataItem = {
  __typename?: 'ProviderMetadataItem';
  key: Scalars['String'];
  value?: Maybe<Array<Scalars['String']>>;
};

export type ProviderRules = {
  __typename?: 'ProviderRules';
  descriptionLike?: Maybe<Scalars['String']>;
  maxAmount?: Maybe<Scalars['Int']>;
  minAmount?: Maybe<Scalars['Int']>;
  shopNameLike?: Maybe<Scalars['String']>;
};

export type ProviderRulesInput = {
  descriptionLike?: InputMaybe<Scalars['String']>;
  maxAmount?: InputMaybe<Scalars['Int']>;
  minAmount?: InputMaybe<Scalars['Int']>;
  shopNameLike?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  account?: Maybe<Account>;
  accountActualFees?: Maybe<AccountActualFees>;
  accountBalances: AccountBalancesConnection;
  accountEvents: AccountEventsConnection;
  accountInvoices: InvoicesConnection;
  accountStats: AccountStats;
  accountTags: Array<Scalars['String']>;
  accounts: AccountsConnection;
  adminUsers: AdminUsersConnection;
  affiliate: Affiliate;
  affiliateInvoices: AffiliateInvoiceConnection;
  affiliateMerchants: AffiliateMerchantConnection;
  affiliatePayoutMethods: Array<AffiliatePayoutMethod>;
  affiliates: AffiliateConnection;
  authorizedUsers: AuthorizedUsersConnection;
  availablePaymentMethods?: Maybe<Array<AvailablePaymentMethod>>;
  availableProcessors?: Maybe<Array<AvailableProcessor>>;
  blacklistItem?: Maybe<BlacklistItem>;
  blacklistItems: BlacklistItemsConnection;
  charge?: Maybe<Charge>;
  chargeEvents: ChargeEventsConnection;
  chargeSources: Array<Scalars['String']>;
  charges: ChargesConnection;
  chargesDateRangeKPI: ChargesDateRangeKpi;
  chargesExport?: Maybe<ChargesExport>;
  chargesExports: ChargesExportsConnection;
  code?: Maybe<Code>;
  codeConfig?: Maybe<CodeConfig>;
  codes: Array<Code>;
  countries: Countries;
  document?: Maybe<Document>;
  documentEvents: DocumentEventsConnection;
  documents: DocumentsConnection;
  events: ChargeEventsConnection;
  masterAccount?: Maybe<MasterAccount>;
  masterAccountActualFees?: Maybe<MasterAccountActualFees>;
  masterAccountInvoices: MasterAccountInvoicesConnection;
  masterAccounts: MasterAccountsConnection;
  notificationsPortalUrl?: Maybe<Redirect>;
  pointOfSale?: Maybe<PointOfSale>;
  pointsOfSale: PointsOfSaleConnection;
  previewPaymentEmail?: Maybe<Scalars['String']>;
  previewSubscriptionEmail?: Maybe<Scalars['String']>;
  provider?: Maybe<Provider>;
  providerConfig?: Maybe<ProviderConfig>;
  providerEvents: ProviderEventsConnection;
  providers?: Maybe<Array<Provider>>;
  restrictedKeywords?: Maybe<Array<Scalars['String']>>;
  settlementEvents: SettlementEventsConnection;
  settlements: SettlementsConnection;
  store?: Maybe<Store>;
  stores: StoresConnection;
  subscription?: Maybe<Subscription>;
  subscriptionEvents: SubscriptionEventsConnection;
  subscriptions: SubscriptionsConnection;
  user?: Maybe<User>;
  userMasterAccount?: Maybe<MasterAccount>;
  users: UsersConnection;
  webKeywords: WebKeywordsConnection;
  webReport?: Maybe<WebReport>;
  webhooks: WebhooksConnection;
};


export type QueryAccountArgs = {
  id: Scalars['ID'];
};


export type QueryAccountActualFeesArgs = {
  id: Scalars['ID'];
};


export type QueryAccountBalancesArgs = {
  accountId: Scalars['ID'];
};


export type QueryAccountEventsArgs = {
  accountId: Scalars['ID'];
  from?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
};


export type QueryAccountInvoicesArgs = {
  filter?: InputMaybe<SearchableInvoiceFilterInput>;
  from?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
};


export type QueryAccountStatsArgs = {
  accountId: Scalars['ID'];
};


export type QueryAccountsArgs = {
  filter?: InputMaybe<SearchableAccountFilterInput>;
  from?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
};


export type QueryAdminUsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  token?: InputMaybe<Scalars['String']>;
};


export type QueryAffiliateArgs = {
  affiliateId: Scalars['ID'];
};


export type QueryAffiliateInvoicesArgs = {
  taxId: Scalars['String'];
};


export type QueryAffiliateMerchantsArgs = {
  input?: InputMaybe<AffiliateMerchantInput>;
};


export type QueryAffiliatePayoutMethodsArgs = {
  affiliateId: Scalars['ID'];
};


export type QueryAffiliatesArgs = {
  input?: InputMaybe<AffiliateInput>;
};


export type QueryAuthorizedUsersArgs = {
  accountId: Scalars['ID'];
};


export type QueryAvailablePaymentMethodsArgs = {
  accountId: Scalars['ID'];
};


export type QueryAvailableProcessorsArgs = {
  accountId: Scalars['ID'];
  paymentMethod: PaymentMethods;
};


export type QueryBlacklistItemArgs = {
  accountId?: InputMaybe<Scalars['ID']>;
  value: Scalars['String'];
};


export type QueryBlacklistItemsArgs = {
  accountId?: InputMaybe<Scalars['ID']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  token?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<BlacklistItemType>;
};


export type QueryChargeArgs = {
  id: Scalars['ID'];
};


export type QueryChargeEventsArgs = {
  chargeId: Scalars['ID'];
  from?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
};


export type QueryChargesArgs = {
  filter?: InputMaybe<SearchableChargeFilterInput>;
  from?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
};


export type QueryChargesDateRangeKpiArgs = {
  accountId?: InputMaybe<Scalars['ID']>;
  acquirer?: InputMaybe<Acquirer>;
  billingPlan?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Currencies>;
  end?: InputMaybe<Scalars['Int']>;
  interval?: InputMaybe<Interval>;
  masterAccountId?: InputMaybe<Scalars['ID']>;
  paymentMethod?: InputMaybe<PaymentMethods>;
  source?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Int']>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type QueryChargesExportArgs = {
  id: Scalars['ID'];
};


export type QueryChargesExportsArgs = {
  pageSize?: InputMaybe<Scalars['Int']>;
  token?: InputMaybe<Scalars['String']>;
};


export type QueryCodeArgs = {
  id: Scalars['ID'];
};


export type QueryCodeConfigArgs = {
  codeType: CodeTypes;
};


export type QueryCodesArgs = {
  accountId: Scalars['ID'];
};


export type QueryDocumentArgs = {
  accountId: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryDocumentEventsArgs = {
  documentId: Scalars['ID'];
};


export type QueryDocumentsArgs = {
  accountId: Scalars['ID'];
  pageSize?: InputMaybe<Scalars['Int']>;
  token?: InputMaybe<Scalars['String']>;
};


export type QueryEventsArgs = {
  filter?: InputMaybe<SearchableEventFilterInput>;
  from?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
};


export type QueryMasterAccountArgs = {
  id: Scalars['ID'];
};


export type QueryMasterAccountActualFeesArgs = {
  id: Scalars['ID'];
};


export type QueryMasterAccountInvoicesArgs = {
  masterAccountId: Scalars['ID'];
};


export type QueryMasterAccountsArgs = {
  filter?: InputMaybe<SearchableMasterAccountFilterInput>;
  from?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
};


export type QueryNotificationsPortalUrlArgs = {
  accountId: Scalars['ID'];
};


export type QueryPointOfSaleArgs = {
  id: Scalars['ID'];
};


export type QueryPointsOfSaleArgs = {
  accountId: Scalars['ID'];
  pageSize?: InputMaybe<Scalars['Int']>;
  storeId?: InputMaybe<Scalars['ID']>;
  token?: InputMaybe<Scalars['String']>;
};


export type QueryPreviewPaymentEmailArgs = {
  accountId: Scalars['ID'];
  emailType?: InputMaybe<PaymentEmailType>;
  language?: InputMaybe<Scalars['String']>;
  paymentId: Scalars['ID'];
};


export type QueryPreviewSubscriptionEmailArgs = {
  accountId: Scalars['ID'];
  emailType?: InputMaybe<SubscriptionEmailType>;
  language?: InputMaybe<Scalars['String']>;
  subscriptionId: Scalars['ID'];
};


export type QueryProviderArgs = {
  id: Scalars['ID'];
};


export type QueryProviderConfigArgs = {
  paymentMethod: PaymentMethods;
  processor: Processor;
};


export type QueryProviderEventsArgs = {
  accountId: Scalars['ID'];
  providerId?: InputMaybe<Scalars['ID']>;
};


export type QueryProvidersArgs = {
  accountId: Scalars['ID'];
};


export type QuerySettlementEventsArgs = {
  from?: InputMaybe<Scalars['Int']>;
  settlementId: Scalars['ID'];
  size?: InputMaybe<Scalars['Int']>;
};


export type QuerySettlementsArgs = {
  filter?: InputMaybe<SearchableSettlementFilterInput>;
  from?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
};


export type QueryStoreArgs = {
  accountId: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryStoresArgs = {
  accountId: Scalars['ID'];
  pageSize?: InputMaybe<Scalars['Int']>;
  token?: InputMaybe<Scalars['String']>;
};


export type QuerySubscriptionArgs = {
  id: Scalars['ID'];
};


export type QuerySubscriptionEventsArgs = {
  subscriptionId: Scalars['ID'];
};


export type QuerySubscriptionsArgs = {
  filter?: InputMaybe<SearchableSubscriptionFilterInput>;
  from?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUsersArgs = {
  filter?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  token?: InputMaybe<Scalars['String']>;
};


export type QueryWebKeywordsArgs = {
  baseUrl: Scalars['String'];
  pageSize?: InputMaybe<Scalars['Int']>;
  token?: InputMaybe<Scalars['String']>;
};


export type QueryWebReportArgs = {
  baseUrl: Scalars['String'];
};


export type QueryWebhooksArgs = {
  accountId: Scalars['ID'];
  pageSize?: InputMaybe<Scalars['Int']>;
  token?: InputMaybe<Scalars['String']>;
};

export type Redirect = {
  __typename?: 'Redirect';
  redirectUrl: Scalars['String'];
};

export type RefundPaymentInput = {
  accountId: Scalars['ID'];
  amount: Scalars['Int'];
  paymentId: Scalars['ID'];
  refundReason?: InputMaybe<RefundReason>;
};

export enum RefundReason {
  DUPLICATED = 'duplicated',
  FRAUDULENT = 'fraudulent',
  ORDER_CANCELED = 'order_canceled',
  REQUESTED_BY_CUSTOMER = 'requested_by_customer'
}

export type RegistryRecord = {
  __typename?: 'RegistryRecord';
  date?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Representative = {
  __typename?: 'Representative';
  address?: Maybe<Address>;
  citizenship?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  document?: Maybe<IdDocument>;
  documentNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  hasNoPublicActivity?: Maybe<Scalars['Boolean']>;
  idSession?: Maybe<Scalars['String']>;
  idSessionUrl?: Maybe<Scalars['String']>;
  interventionType?: Maybe<Array<InterventionType>>;
  lastName?: Maybe<Scalars['String']>;
  nationality?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  pibisi?: Maybe<Pibisi>;
  placeOfBirth?: Maybe<Scalars['String']>;
  registeredAt?: Maybe<Scalars['String']>;
  riskLabels?: Maybe<Array<RiskLabel>>;
  status?: Maybe<IdVerificationStatus>;
  statusCode?: Maybe<Scalars['Int']>;
  statusMessage?: Maybe<Scalars['String']>;
  stocksPercentage?: Maybe<Scalars['Float']>;
  yearOfBirth?: Maybe<Scalars['String']>;
};

export type RepresentativeInput = {
  address?: InputMaybe<AddressInput>;
  citizenship?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['String']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  interventionType?: InputMaybe<Array<InterventionType>>;
  lastName?: InputMaybe<Scalars['String']>;
  nationality?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  pibisi?: InputMaybe<PibisiInput>;
  registeredAt?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<IdVerificationStatus>;
  stocksPercentage?: InputMaybe<Scalars['Float']>;
  yearOfBirth?: InputMaybe<Scalars['String']>;
};

export type ResolvePibisiAlertInput = {
  accountId: Scalars['ID'];
  action: PibisiAction;
  alertId: Scalars['ID'];
  customerId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
};

export type ResolvePibisiMatchInput = {
  accountId: Scalars['ID'];
  action: PibisiAction;
  customerId: Scalars['ID'];
  matchId: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
};

export type ResumeSubscriptionInput = {
  accountId: Scalars['ID'];
  id: Scalars['ID'];
};

export enum RetryIntervalInput {
  DAY = 'day',
  HOUR = 'hour',
  MINUTE = 'minute',
  MONTH = 'month',
  QUARTER = 'quarter',
  WEEK = 'week',
  YEAR = 'year'
}

export type RetrySchedule = {
  __typename?: 'RetrySchedule';
  interval: Interval;
  intervalCount: Scalars['Int'];
};

export type RetryScheduleInput = {
  interval: RetryIntervalInput;
  intervalCount: Scalars['Int'];
};

export type RiskLabel = {
  __typename?: 'RiskLabel';
  category?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  riskScore?: Maybe<Scalars['Int']>;
};

export enum RiskProfile {
  HIGH_RISK = 'HIGH_RISK',
  LOW_RISK = 'LOW_RISK',
  MEDIUM_RISK = 'MEDIUM_RISK',
  PROCESSING = 'PROCESSING'
}

export type S3ObjectInput = {
  bucket: Scalars['String'];
  key?: InputMaybe<Scalars['String']>;
  region: Scalars['String'];
};

export enum SalesExecutive {
  ALEX_SAIZ = 'ALEX_SAIZ',
  BERTA_GIRBAU = 'BERTA_GIRBAU',
  CARLA_GIRBAU = 'CARLA_GIRBAU',
  GERARD_HERNANDEZ = 'GERARD_HERNANDEZ',
  JOAN_ASENSIO = 'JOAN_ASENSIO',
  SELF_SERVED = 'SELF_SERVED'
}

export type SearchableAccountFilterInput = {
  accountExecutive?: InputMaybe<SearchableStringFilterInput>;
  adminEmail?: InputMaybe<SearchableStringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<SearchableAccountFilterInput>>>;
  apiKey?: InputMaybe<SearchableStringFilterInput>;
  billingPlan?: InputMaybe<SearchableStringFilterInput>;
  blocked?: InputMaybe<SearchableBooleanFilterInput>;
  businessCompanyName?: InputMaybe<SearchableStringFilterInput>;
  businessCountry?: InputMaybe<SearchableStringFilterInput>;
  businessDocumentNumber?: InputMaybe<SearchableStringFilterInput>;
  businessEmail?: InputMaybe<SearchableStringFilterInput>;
  businessLegalName?: InputMaybe<SearchableStringFilterInput>;
  businessWebsite?: InputMaybe<SearchableStringFilterInput>;
  churned?: InputMaybe<SearchableBooleanFilterInput>;
  dynamicBilling?: InputMaybe<SearchableBooleanFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  masterAccountId?: InputMaybe<SearchableStringFilterInput>;
  name?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<SearchableAccountFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableAccountFilterInput>>>;
  payoutTermsSuspended?: InputMaybe<SearchableBooleanFilterInput>;
  promoCode?: InputMaybe<SearchableStringFilterInput>;
  referralCode?: InputMaybe<SearchableStringFilterInput>;
  representativeDocumentNumber?: InputMaybe<SearchableStringFilterInput>;
  representativeName?: InputMaybe<SearchableStringFilterInput>;
  riskProfile?: InputMaybe<SearchableStringFilterInput>;
  secret?: InputMaybe<SearchableStringFilterInput>;
  sepblacId?: InputMaybe<SearchableStringFilterInput>;
  status?: InputMaybe<SearchableStringFilterInput>;
  tags?: InputMaybe<SearchableStringFilterInput>;
};

export type SearchableBooleanFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
};

export type SearchableChargeFilterInput = {
  accountId?: InputMaybe<SearchableIdFilterInput>;
  acquirer?: InputMaybe<SearchableStringFilterInput>;
  amount?: InputMaybe<SearchableIntFilterInput>;
  and?: InputMaybe<Array<InputMaybe<SearchableChargeFilterInput>>>;
  authorizationCode?: InputMaybe<SearchableStringFilterInput>;
  billingPlan?: InputMaybe<SearchableStringFilterInput>;
  checkoutId?: InputMaybe<SearchableIdFilterInput>;
  createdAt?: InputMaybe<SearchableIntFilterInput>;
  currency?: InputMaybe<SearchableStringFilterInput>;
  customerEmail?: InputMaybe<SearchableStringFilterInput>;
  customerName?: InputMaybe<SearchableStringFilterInput>;
  customerPhone?: InputMaybe<SearchableStringFilterInput>;
  description?: InputMaybe<SearchableStringFilterInput>;
  descriptor?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  masterAccountId?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<SearchableChargeFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableChargeFilterInput>>>;
  orderId?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodBizumIntegrationType?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardBrand?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardLast4?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardThreeDSecure?: InputMaybe<SearchableBooleanFilterInput>;
  paymentMethodCardThreeDSecureFlow?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardThreeDSecureVersion?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardTokenizationMethod?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardType?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodMethod?: InputMaybe<SearchableStringFilterInput>;
  pointOfSaleId?: InputMaybe<SearchableStringFilterInput>;
  processor?: InputMaybe<SearchableStringFilterInput>;
  providerReferenceId?: InputMaybe<SearchableStringFilterInput>;
  refundedAmount?: InputMaybe<SearchableIntFilterInput>;
  sequenceId?: InputMaybe<SearchableStringFilterInput>;
  sessionCountry?: InputMaybe<SearchableStringFilterInput>;
  sessionIp?: InputMaybe<SearchableStringFilterInput>;
  shopCountry?: InputMaybe<SearchableStringFilterInput>;
  shopName?: InputMaybe<SearchableStringFilterInput>;
  status?: InputMaybe<SearchableStringFilterInput>;
  statusCode?: InputMaybe<SearchableStringFilterInput>;
  statusMessage?: InputMaybe<SearchableStringFilterInput>;
  storeId?: InputMaybe<SearchableStringFilterInput>;
  subscriptionId?: InputMaybe<SearchableStringFilterInput>;
  traceDetailsSource?: InputMaybe<SearchableStringFilterInput>;
  updatedAt?: InputMaybe<SearchableIntFilterInput>;
};

export type SearchableEventFilterInput = {
  accountId?: InputMaybe<SearchableIdFilterInput>;
  acquirer?: InputMaybe<SearchableStringFilterInput>;
  amount?: InputMaybe<SearchableIntFilterInput>;
  and?: InputMaybe<Array<InputMaybe<SearchableEventFilterInput>>>;
  authorizationCode?: InputMaybe<SearchableStringFilterInput>;
  billingPlan?: InputMaybe<SearchableStringFilterInput>;
  checkoutId?: InputMaybe<SearchableIdFilterInput>;
  createdAt?: InputMaybe<SearchableIntFilterInput>;
  currency?: InputMaybe<SearchableStringFilterInput>;
  customerEmail?: InputMaybe<SearchableStringFilterInput>;
  customerName?: InputMaybe<SearchableStringFilterInput>;
  description?: InputMaybe<SearchableStringFilterInput>;
  descriptor?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  masterAccountId?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<SearchableEventFilterInput>;
  objectId?: InputMaybe<SearchableIdFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableEventFilterInput>>>;
  orderId?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardBrand?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardLast4?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardThreeDSecure?: InputMaybe<SearchableBooleanFilterInput>;
  paymentMethodCardThreeDSecureFlow?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardThreeDSecureVersion?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardTokenizationMethod?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardType?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodMethod?: InputMaybe<SearchableStringFilterInput>;
  pointOfSaleId?: InputMaybe<SearchableStringFilterInput>;
  processor?: InputMaybe<SearchableStringFilterInput>;
  providerReferenceId?: InputMaybe<SearchableStringFilterInput>;
  refundedAmount?: InputMaybe<SearchableIntFilterInput>;
  sequenceId?: InputMaybe<SearchableStringFilterInput>;
  sessionCountry?: InputMaybe<SearchableStringFilterInput>;
  sessionIp?: InputMaybe<SearchableStringFilterInput>;
  shopCountry?: InputMaybe<SearchableStringFilterInput>;
  shopName?: InputMaybe<SearchableStringFilterInput>;
  status?: InputMaybe<SearchableStringFilterInput>;
  statusCode?: InputMaybe<SearchableStringFilterInput>;
  statusMessage?: InputMaybe<SearchableStringFilterInput>;
  storeId?: InputMaybe<SearchableStringFilterInput>;
  subscriptionId?: InputMaybe<SearchableStringFilterInput>;
  type?: InputMaybe<SearchableStringFilterInput>;
};

export type SearchableFloatFilterInput = {
  eq?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
};

export type SearchableIdFilterInput = {
  eq?: InputMaybe<Scalars['ID']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  match?: InputMaybe<Scalars['ID']>;
  matchPhrase?: InputMaybe<Scalars['ID']>;
  matchPhrasePrefix?: InputMaybe<Scalars['ID']>;
  ne?: InputMaybe<Scalars['ID']>;
  regexp?: InputMaybe<Scalars['ID']>;
  wildcard?: InputMaybe<Scalars['ID']>;
};

export type SearchableIntFilterInput = {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  ne?: InputMaybe<Scalars['Int']>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type SearchableInvoiceFilterInput = {
  accountId?: InputMaybe<SearchableIdFilterInput>;
  amount?: InputMaybe<SearchableIntFilterInput>;
  and?: InputMaybe<Array<InputMaybe<SearchableInvoiceFilterInput>>>;
  currency?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<SearchableInvoiceFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableInvoiceFilterInput>>>;
  tax?: InputMaybe<SearchableIntFilterInput>;
  totalAmount?: InputMaybe<SearchableIntFilterInput>;
};

export type SearchableMasterAccountFilterInput = {
  adminEmail?: InputMaybe<SearchableStringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<SearchableMasterAccountFilterInput>>>;
  id?: InputMaybe<SearchableIdFilterInput>;
  name?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<SearchableMasterAccountFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableMasterAccountFilterInput>>>;
  promoCode?: InputMaybe<SearchableStringFilterInput>;
};

export type SearchableSettlementFilterInput = {
  accountId?: InputMaybe<SearchableIdFilterInput>;
  acquirer?: InputMaybe<SearchableStringFilterInput>;
  acquirerFees?: InputMaybe<SearchableIntFilterInput>;
  and?: InputMaybe<Array<InputMaybe<SearchableSettlementFilterInput>>>;
  createdAt?: InputMaybe<SearchableIntFilterInput>;
  currency?: InputMaybe<SearchableStringFilterInput>;
  grossVolume?: InputMaybe<SearchableIntFilterInput>;
  iban?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  legalName?: InputMaybe<SearchableStringFilterInput>;
  masterAccountId?: InputMaybe<SearchableIdFilterInput>;
  netVolume?: InputMaybe<SearchableIntFilterInput>;
  not?: InputMaybe<SearchableSettlementFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableSettlementFilterInput>>>;
  payMethod?: InputMaybe<SearchableStringFilterInput>;
  period?: InputMaybe<SearchableIntFilterInput>;
  periodEndAt?: InputMaybe<SearchableIntFilterInput>;
  periodStartAt?: InputMaybe<SearchableIntFilterInput>;
  previousNegative?: InputMaybe<SearchableBooleanFilterInput>;
  releasedAmount?: InputMaybe<SearchableIntFilterInput>;
  reservePercent?: InputMaybe<SearchableIntFilterInput>;
  reservedAmount?: InputMaybe<SearchableIntFilterInput>;
  scheduledAt?: InputMaybe<SearchableIntFilterInput>;
  settleGross?: InputMaybe<SearchableBooleanFilterInput>;
  settleIndividually?: InputMaybe<SearchableBooleanFilterInput>;
  status?: InputMaybe<SearchableStringFilterInput>;
  storeId?: InputMaybe<SearchableStringFilterInput>;
  updatedAt?: InputMaybe<SearchableIntFilterInput>;
};

export type SearchableStringFilterInput = {
  eq?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  match?: InputMaybe<Scalars['String']>;
  matchPhrase?: InputMaybe<Scalars['String']>;
  matchPhrasePrefix?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  regexp?: InputMaybe<Scalars['String']>;
  wildcard?: InputMaybe<Scalars['String']>;
};

export type SearchableSubscriptionFilterInput = {
  accountId?: InputMaybe<SearchableIdFilterInput>;
  amount?: InputMaybe<SearchableIntFilterInput>;
  and?: InputMaybe<Array<InputMaybe<SearchableSubscriptionFilterInput>>>;
  createdAt?: InputMaybe<SearchableIntFilterInput>;
  currency?: InputMaybe<SearchableStringFilterInput>;
  customerEmail?: InputMaybe<SearchableStringFilterInput>;
  customerName?: InputMaybe<SearchableStringFilterInput>;
  customerPhone?: InputMaybe<SearchableStringFilterInput>;
  description?: InputMaybe<SearchableStringFilterInput>;
  descriptor?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  interval?: InputMaybe<SearchableStringFilterInput>;
  intervalCount?: InputMaybe<SearchableIntFilterInput>;
  lastOrderId?: InputMaybe<SearchableStringFilterInput>;
  lastPaymentId?: InputMaybe<SearchableIdFilterInput>;
  lastPaymentStatus?: InputMaybe<SearchableStringFilterInput>;
  lastPaymentStatusCode?: InputMaybe<SearchableStringFilterInput>;
  masterAccountId?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<SearchableSubscriptionFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableSubscriptionFilterInput>>>;
  paymentMethodCardBrand?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardLast4?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardThreeDSecure?: InputMaybe<SearchableBooleanFilterInput>;
  paymentMethodCardThreeDSecureFlow?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardThreeDSecureVersion?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardTokenizationMethod?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodCardType?: InputMaybe<SearchableStringFilterInput>;
  paymentMethodMethod?: InputMaybe<SearchableStringFilterInput>;
  sequenceId?: InputMaybe<SearchableStringFilterInput>;
  status?: InputMaybe<SearchableStringFilterInput>;
  storeId?: InputMaybe<SearchableStringFilterInput>;
  traceDetailsSource?: InputMaybe<SearchableStringFilterInput>;
  updatedAt?: InputMaybe<SearchableIntFilterInput>;
};

export type SendPaymentMessageInput = {
  accountId: Scalars['ID'];
  channel?: InputMaybe<MessageChannel>;
  customerEmail?: InputMaybe<Scalars['AWSEmail']>;
  customerPhone?: InputMaybe<Scalars['AWSPhone']>;
  language?: InputMaybe<Scalars['String']>;
  paymentId: Scalars['ID'];
};

export type SendPaymentRequestInput = {
  language?: InputMaybe<Scalars['String']>;
  paymentId: Scalars['ID'];
  phoneNumber: Scalars['String'];
};

export type SendSubscriptionMessageInput = {
  accountId: Scalars['ID'];
  channel?: InputMaybe<MessageChannel>;
  customerEmail?: InputMaybe<Scalars['AWSEmail']>;
  customerPhone?: InputMaybe<Scalars['AWSPhone']>;
  language?: InputMaybe<Scalars['String']>;
  subscriptionId: Scalars['ID'];
};

export type SessionDetails = {
  __typename?: 'SessionDetails';
  browser?: Maybe<Scalars['String']>;
  browserAccept?: Maybe<Scalars['String']>;
  browserColorDepth?: Maybe<Scalars['String']>;
  browserScreenHeight?: Maybe<Scalars['String']>;
  browserScreenWidth?: Maybe<Scalars['String']>;
  browserTimezoneOffset?: Maybe<Scalars['String']>;
  browserVersion?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  deviceModel?: Maybe<Scalars['String']>;
  deviceType?: Maybe<DeviceType>;
  ip?: Maybe<Scalars['AWSIPAddress']>;
  lang?: Maybe<Scalars['String']>;
  os?: Maybe<Scalars['String']>;
  osVersion?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  sourceVersion?: Maybe<Scalars['String']>;
  userAgent?: Maybe<Scalars['String']>;
};

export type Settlement = {
  __typename?: 'Settlement';
  accountId: Scalars['ID'];
  acquirer: SettlementAcquirer;
  acquirerFees: Scalars['Int'];
  createdAt: Scalars['AWSTimestamp'];
  currency?: Maybe<Scalars['String']>;
  grossVolume: Scalars['Int'];
  iban?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  legalName?: Maybe<Scalars['String']>;
  masterAccountId?: Maybe<Scalars['ID']>;
  netVolume: Scalars['Int'];
  payMethod?: Maybe<SettlementPayMethods>;
  period: Scalars['Int'];
  periodEndAt: Scalars['AWSTimestamp'];
  periodStartAt: Scalars['AWSTimestamp'];
  previousNegative?: Maybe<Scalars['Boolean']>;
  releasedAmount?: Maybe<Scalars['Int']>;
  reservePercent: Scalars['Int'];
  reservedAmount?: Maybe<Scalars['Int']>;
  scheduledAt: Scalars['AWSTimestamp'];
  settleGross?: Maybe<Scalars['Boolean']>;
  settleIndividually?: Maybe<Scalars['Boolean']>;
  status: SettlementStatus;
  storeId?: Maybe<Scalars['ID']>;
  updatedAt: Scalars['AWSTimestamp'];
};

export enum SettlementAcquirer {
  COMERCIA_GLOBAL_PAY = 'COMERCIA_GLOBAL_PAY',
  CREDORAX = 'CREDORAX'
}

export type SettlementEvent = {
  __typename?: 'SettlementEvent';
  accountId: Scalars['ID'];
  createdAt: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  object: SettlementEventObject;
  objectId: Scalars['ID'];
  objectType: Scalars['String'];
  type: Scalars['String'];
};

export type SettlementEventObject = {
  __typename?: 'SettlementEventObject';
  accountId: Scalars['ID'];
  acquirer: SettlementAcquirer;
  acquirerFees: Scalars['Int'];
  createdAt: Scalars['AWSTimestamp'];
  currency?: Maybe<Scalars['String']>;
  grossVolume: Scalars['Int'];
  iban?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  legalName?: Maybe<Scalars['String']>;
  masterAccountId?: Maybe<Scalars['ID']>;
  netVolume: Scalars['Int'];
  payMethod?: Maybe<SettlementPayMethods>;
  period: Scalars['Int'];
  periodEndAt: Scalars['AWSTimestamp'];
  periodStartAt: Scalars['AWSTimestamp'];
  previousNegative?: Maybe<Scalars['Boolean']>;
  releasedAmount?: Maybe<Scalars['Int']>;
  reservePercent: Scalars['Int'];
  reservedAmount?: Maybe<Scalars['Int']>;
  scheduledAt: Scalars['AWSTimestamp'];
  settleGross?: Maybe<Scalars['Boolean']>;
  settleIndividually?: Maybe<Scalars['Boolean']>;
  status: SettlementStatus;
  storeId?: Maybe<Scalars['ID']>;
  updatedAt: Scalars['AWSTimestamp'];
};

export type SettlementEventsConnection = {
  __typename?: 'SettlementEventsConnection';
  items: Array<SettlementEvent>;
  total: Scalars['Int'];
};

export enum SettlementPayMethods {
  BIZUM = 'bizum',
  CARD = 'card'
}

export enum SettlementStatus {
  COMPLETED = 'COMPLETED',
  PENDING = 'PENDING',
  SUSPENDED = 'SUSPENDED'
}

export type SettlementsConnection = {
  __typename?: 'SettlementsConnection';
  items: Array<Settlement>;
  total: Scalars['Int'];
};

export type Shop = {
  __typename?: 'Shop';
  country?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Stats = {
  __typename?: 'Stats';
  activeMonths?: Maybe<Scalars['Int']>;
  avgMonthlyTransactions?: Maybe<Scalars['Int']>;
  avgMonthlyVolume?: Maybe<Scalars['Float']>;
  churned?: Maybe<Scalars['Boolean']>;
  firstTransactionAt?: Maybe<Scalars['Long']>;
  lastTransactionAt?: Maybe<Scalars['Long']>;
  totalSucceededAmount?: Maybe<Scalars['Float']>;
  totalSucceededCount?: Maybe<Scalars['Int']>;
};

export enum StatusReason {
  BANK_OWNERSHIP_CERT_REQUIRED = 'BANK_OWNERSHIP_CERT_REQUIRED',
  CBD_PRODUCTS = 'CBD_PRODUCTS',
  CHARGEBACKS = 'CHARGEBACKS',
  CUSTOMER_COMPLAINTS = 'CUSTOMER_COMPLAINTS',
  HIGH_RISK_GOODS = 'HIGH_RISK_GOODS',
  ID_VERIFICATION_REQUIRED = 'ID_VERIFICATION_REQUIRED',
  INCOMPLETE_DOCS = 'INCOMPLETE_DOCS',
  JOINT_OWNERSHIP = 'JOINT_OWNERSHIP',
  NON_COMMERCIAL_COMPANY_DOCS = 'NON_COMMERCIAL_COMPANY_DOCS',
  NON_COMPLIANT_WEBSITE = 'NON_COMPLIANT_WEBSITE',
  NOT_COMPLIANT_BUSINESS = 'NOT_COMPLIANT_BUSINESS',
  OTHER = 'OTHER',
  OTHER_COMPANY_WEBSITE = 'OTHER_COMPANY_WEBSITE',
  REAL_HOLDERS_DOCS = 'REAL_HOLDERS_DOCS',
  REPEAT_ONBOARDING = 'REPEAT_ONBOARDING',
  RESTRICTED_CATEGORY = 'RESTRICTED_CATEGORY',
  SUSPICIOUS_ACTIVITY = 'SUSPICIOUS_ACTIVITY',
  UPDATE_BILLING_INFO = 'UPDATE_BILLING_INFO'
}

export type Store = {
  __typename?: 'Store';
  accountId: Scalars['ID'];
  address?: Maybe<Address>;
  blocked?: Maybe<Scalars['Boolean']>;
  documentNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  iban?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  metadata?: Maybe<Array<MetadataItem>>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type StoresConnection = {
  __typename?: 'StoresConnection';
  items: Array<Store>;
  nextToken?: Maybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  accountId: Scalars['ID'];
  amount: Scalars['Int'];
  billingDetails?: Maybe<ContactDetails>;
  callbackUrl?: Maybe<Scalars['String']>;
  cancelAtPeriodEnd?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['Int']>;
  currency?: Maybe<Currencies>;
  currentPeriodEnd?: Maybe<Scalars['Int']>;
  currentPeriodStart?: Maybe<Scalars['Int']>;
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['ID']>;
  defaultTokenId?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  descriptor?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  interval: Interval;
  intervalCount: Scalars['Int'];
  lastInvoiceId?: Maybe<Scalars['ID']>;
  lastOrderId?: Maybe<Scalars['ID']>;
  lastPayment?: Maybe<LastPayment>;
  livemode: Scalars['Boolean'];
  masterAccountId?: Maybe<Scalars['ID']>;
  metadata?: Maybe<Array<KeyValueItem>>;
  nextPaymentAt?: Maybe<Scalars['Int']>;
  pauseAtPeriodEnd?: Maybe<Scalars['Boolean']>;
  pauseIntervalCount?: Maybe<Scalars['Int']>;
  paymentCallbackUrl?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<PaymentMethod>;
  planVariantId?: Maybe<Scalars['ID']>;
  productId?: Maybe<Scalars['ID']>;
  retryCount?: Maybe<Scalars['Int']>;
  retrySchedule?: Maybe<Array<RetrySchedule>>;
  sequenceId?: Maybe<Scalars['ID']>;
  sessionDetails?: Maybe<SessionDetails>;
  shippingDetails?: Maybe<ContactDetails>;
  status: SubscriptionStatus;
  storeId?: Maybe<Scalars['ID']>;
  traceDetails?: Maybe<TraceDetails>;
  trialAmount?: Maybe<Scalars['Int']>;
  trialPeriodDays?: Maybe<Scalars['Int']>;
  trialPeriodEnd?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Int']>;
};

export enum SubscriptionEmailType {
  SUBSCRIPTION_LINK = 'SUBSCRIPTION_LINK',
  SUBSCRIPTION_STATUS = 'SUBSCRIPTION_STATUS'
}

export type SubscriptionEvent = {
  __typename?: 'SubscriptionEvent';
  accountId: Scalars['ID'];
  createdAt: Scalars['AWSTimestamp'];
  id: Scalars['ID'];
  masterAccountId?: Maybe<Scalars['ID']>;
  object: SubscriptionEventObject;
  objectId: Scalars['ID'];
  objectType: Scalars['String'];
  type: Scalars['String'];
};

export type SubscriptionEventObject = {
  __typename?: 'SubscriptionEventObject';
  accountId: Scalars['ID'];
  amount?: Maybe<Scalars['Int']>;
  billingDetails?: Maybe<ContactDetails>;
  cancelAtPeriodEnd?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['AWSTimestamp']>;
  currency: Scalars['String'];
  currentPeriodEnd?: Maybe<Scalars['Int']>;
  currentPeriodStart?: Maybe<Scalars['Int']>;
  customer?: Maybe<Customer>;
  description?: Maybe<Scalars['String']>;
  descriptor?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  interval: Interval;
  intervalCount: Scalars['Int'];
  lastInvoiceId?: Maybe<Scalars['ID']>;
  lastOrderId?: Maybe<Scalars['ID']>;
  lastPayment?: Maybe<LastPayment>;
  livemode?: Maybe<Scalars['Boolean']>;
  masterAccountId?: Maybe<Scalars['ID']>;
  metadata?: Maybe<Array<KeyValueItem>>;
  pageOpenedAt?: Maybe<Scalars['AWSTimestamp']>;
  pauseAtPeriodEnd?: Maybe<Scalars['Boolean']>;
  pauseIntervalCount?: Maybe<Scalars['Int']>;
  paymentMethod?: Maybe<PaymentMethod>;
  planVariantId?: Maybe<Scalars['ID']>;
  pointOfSaleId?: Maybe<Scalars['ID']>;
  productId?: Maybe<Scalars['ID']>;
  retryCount?: Maybe<Scalars['Int']>;
  sequenceId?: Maybe<Scalars['ID']>;
  shippingDetails?: Maybe<ContactDetails>;
  status: SubscriptionStatus;
  storeId?: Maybe<Scalars['ID']>;
  traceDetails?: Maybe<TraceDetails>;
  trialPeriodDays?: Maybe<Scalars['Int']>;
  trialPeriodEnd?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']>;
};

export type SubscriptionEventsConnection = {
  __typename?: 'SubscriptionEventsConnection';
  items: Array<SubscriptionEvent>;
  total: Scalars['Int'];
};

export enum SubscriptionStatus {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  EXPIRED = 'EXPIRED',
  PAST_DUE = 'PAST_DUE',
  PAUSED = 'PAUSED',
  PENDING = 'PENDING',
  TRIALING = 'TRIALING'
}

export type Subscriptions = {
  __typename?: 'Subscriptions';
  onUpdateAccount?: Maybe<AccountLevelUpdate>;
  /** @deprecated Use publishUpdateAnalyticsV2 instead */
  onUpdateAnalytics?: Maybe<AnalyticsChange>;
  onUpdateAnalyticsV2: Scalars['Boolean'];
  onUpdateCharge?: Maybe<ItemLevelUpdate>;
  onUpdateChargeEvents?: Maybe<ItemLevelUpdate>;
  onUpdateCharges?: Maybe<AccountLevelUpdate>;
  onUpdateDocuments?: Maybe<AccountLevelUpdate>;
  onUpdateEvents?: Maybe<AccountLevelUpdate>;
  onUpdateSubscription?: Maybe<ItemLevelUpdate>;
  onUpdateSubscriptionEvents?: Maybe<ItemLevelUpdate>;
  onUpdateSubscriptions?: Maybe<AccountLevelUpdate>;
};


export type SubscriptionsOnUpdateAccountArgs = {
  accountId: Scalars['ID'];
};


export type SubscriptionsOnUpdateAnalyticsArgs = {
  all: Scalars['Boolean'];
};


export type SubscriptionsOnUpdateChargeArgs = {
  accountId: Scalars['ID'];
  id: Scalars['ID'];
};


export type SubscriptionsOnUpdateChargeEventsArgs = {
  accountId: Scalars['ID'];
  id: Scalars['ID'];
};


export type SubscriptionsOnUpdateChargesArgs = {
  accountId: Scalars['ID'];
};


export type SubscriptionsOnUpdateDocumentsArgs = {
  accountId: Scalars['ID'];
};


export type SubscriptionsOnUpdateEventsArgs = {
  accountId: Scalars['ID'];
};


export type SubscriptionsOnUpdateSubscriptionArgs = {
  accountId: Scalars['ID'];
  id: Scalars['ID'];
};


export type SubscriptionsOnUpdateSubscriptionEventsArgs = {
  accountId: Scalars['ID'];
  id: Scalars['ID'];
};


export type SubscriptionsOnUpdateSubscriptionsArgs = {
  accountId: Scalars['ID'];
};

export type SubscriptionsConnection = {
  __typename?: 'SubscriptionsConnection';
  items: Array<Subscription>;
  total: Scalars['Int'];
};

export type SuccessResult = {
  __typename?: 'SuccessResult';
  success: Scalars['Boolean'];
};

export enum ThreeDsStatus {
  A = 'A',
  I = 'I',
  N = 'N',
  R = 'R',
  U = 'U',
  Y = 'Y'
}

export enum ThreeDSecureFlow {
  CHALLENGE = 'CHALLENGE',
  DIRECT = 'DIRECT',
  FRICTIONLESS = 'FRICTIONLESS',
  FRICTIONLESS_CHALLENGE = 'FRICTIONLESS_CHALLENGE'
}

export enum TokenizationMethods {
  APPLEPAY = 'applePay',
  CLICKTOPAY = 'clickToPay',
  GOOGLEPAY = 'googlePay'
}

export type TraceDetails = {
  __typename?: 'TraceDetails';
  apiKey?: Maybe<Scalars['String']>;
  browser?: Maybe<Scalars['String']>;
  browserAccept?: Maybe<Scalars['String']>;
  browserVersion?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  deviceModel?: Maybe<Scalars['String']>;
  deviceType?: Maybe<DeviceType>;
  ip?: Maybe<Scalars['AWSIPAddress']>;
  lang?: Maybe<Scalars['String']>;
  masterApiKey?: Maybe<Scalars['String']>;
  os?: Maybe<Scalars['String']>;
  osVersion?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  sourceVersion?: Maybe<Scalars['String']>;
  userAgent?: Maybe<Scalars['String']>;
  userEmail?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['ID']>;
  userName?: Maybe<Scalars['String']>;
};

export enum TransactionTypes {
  AUTH = 'AUTH',
  CANCEL = 'CANCEL',
  CAPTURE = 'CAPTURE',
  PAYOUT = 'PAYOUT',
  REFUND = 'REFUND',
  SALE = 'SALE',
  VERIF = 'VERIF'
}

export type UpdateAccountInput = {
  accountExecutive?: InputMaybe<Scalars['String']>;
  accountInvoicePaymentMethod?: InputMaybe<AccountInvoicePaymentMethod>;
  acquirer?: InputMaybe<Acquirer>;
  adminEmail?: InputMaybe<Scalars['String']>;
  allowCreateApiKey?: InputMaybe<Scalars['Boolean']>;
  allowRefunds?: InputMaybe<Scalars['Boolean']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingPlan?: InputMaybe<BillingPlans>;
  billingVatPercent?: InputMaybe<Scalars['Int']>;
  blocked?: InputMaybe<Scalars['Boolean']>;
  branding?: InputMaybe<AccountBrandingInput>;
  business?: InputMaybe<BusinessDataInput>;
  churnNote?: InputMaybe<Scalars['String']>;
  churnReason?: InputMaybe<ChurnReason>;
  churnReasonOption?: InputMaybe<Scalars['String']>;
  contactPerson?: InputMaybe<ContactPersonInput>;
  customAccountInvoiceNotes?: InputMaybe<Array<Scalars['String']>>;
  customDomain?: InputMaybe<Scalars['String']>;
  defaultCurrency?: InputMaybe<Currencies>;
  defaultTransactionType?: InputMaybe<TransactionTypes>;
  dynamicBilling?: InputMaybe<Scalars['Boolean']>;
  fees?: InputMaybe<AccountFeesInput>;
  groupInvoicesByStore?: InputMaybe<Scalars['Boolean']>;
  iban?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  language?: InputMaybe<Scalars['String']>;
  manualApproval?: InputMaybe<Scalars['Boolean']>;
  masterAccountId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  notifications?: InputMaybe<AccountNotificationsInput>;
  partner?: InputMaybe<Partner>;
  paymentMethods?: InputMaybe<AccountPaymentMethodsInput>;
  payoutTerms?: InputMaybe<AccountPayoutTermsInput>;
  promoCode?: InputMaybe<Scalars['String']>;
  publicBusinessDetails?: InputMaybe<AccountPublicBusinessDetailsInput>;
  reason?: InputMaybe<Scalars['String']>;
  refAccountId?: InputMaybe<Scalars['String']>;
  referralCode?: InputMaybe<Scalars['String']>;
  representatives?: InputMaybe<Array<InputMaybe<RepresentativeInput>>>;
  reviewConfirmed?: InputMaybe<Scalars['Boolean']>;
  riskIgnoredKeywords?: InputMaybe<Array<Scalars['String']>>;
  riskProfile?: InputMaybe<RiskProfile>;
  riskProfileNote?: InputMaybe<Scalars['String']>;
  riskScore?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<AccountStatus>;
  statusNote?: InputMaybe<Scalars['String']>;
  statusReason?: InputMaybe<StatusReason>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  timezone?: InputMaybe<Scalars['String']>;
  upsell?: InputMaybe<UpsellInput>;
};

export type UpdateAccountInvoiceInput = {
  accountId: Scalars['ID'];
  id: Scalars['ID'];
  status: AccountInvoiceStatus;
};

export type UpdateAffiliatePayoutMethodInput = {
  affiliateId: Scalars['ID'];
  details?: InputMaybe<AffiliatePayoutMethodDetailsInput>;
};

export type UpdateAffiliateTierInput = {
  affiliateId: Scalars['ID'];
  tier?: InputMaybe<Scalars['String']>;
};

export type UpdateAuthorizedUserInput = {
  accessLevel?: InputMaybe<AuthorizedUserAccessLevel>;
  accountId: Scalars['ID'];
  storeId?: InputMaybe<Scalars['ID']>;
  userEmail: Scalars['String'];
};

export type UpdateCodeInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  metadata?: InputMaybe<Array<MetadataItemInput>>;
};

export type UpdateDocumentInput = {
  accountId: Scalars['ID'];
  id: Scalars['ID'];
  internal?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<DocumentStatus>;
  statusCode?: InputMaybe<Scalars['String']>;
};

export type UpdateMasterAccountInput = {
  accountDefaults?: InputMaybe<AccountDefaultsInput>;
  adminEmail?: InputMaybe<Scalars['String']>;
  allowCreateApiKey?: InputMaybe<Scalars['Boolean']>;
  allowedDomains?: InputMaybe<Array<Scalars['String']>>;
  allowedIPs?: InputMaybe<Array<Scalars['String']>>;
  autoApprove?: InputMaybe<Scalars['Boolean']>;
  blocked?: InputMaybe<Scalars['Boolean']>;
  branding?: InputMaybe<AccountBrandingInput>;
  business?: InputMaybe<BusinessDataInput>;
  churnedEmails?: InputMaybe<Array<Scalars['String']>>;
  contractTemplateId?: InputMaybe<Scalars['ID']>;
  extraFees?: InputMaybe<Array<InputMaybe<AccountExtraFeeInput>>>;
  fees?: InputMaybe<MasterAccountFeesInput>;
  iban?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  payoutTerms?: InputMaybe<AccountPayoutTermsInput>;
  promoCode?: InputMaybe<Scalars['String']>;
  publicBusinessDetails?: InputMaybe<AccountPublicBusinessDetailsInput>;
  requireExternalId?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<AccountStatus>;
  webhookEmails?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdatePibisiStatusInput = {
  accountId: Scalars['ID'];
  customerId: Scalars['ID'];
  status: PibisiStatus;
};

export type UpdatePointOfSaleInput = {
  accountId: Scalars['ID'];
  id: Scalars['ID'];
  manualAmount?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateProviderInput = {
  acquirer?: InputMaybe<Acquirer>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  metadata?: InputMaybe<Array<MetadataItemInput>>;
  nativeHostedPayment?: InputMaybe<Scalars['Boolean']>;
  rules?: InputMaybe<ProviderRulesInput>;
  test?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateStoreInput = {
  accountId: Scalars['ID'];
  address?: InputMaybe<AddressInput>;
  blocked?: InputMaybe<Scalars['Boolean']>;
  documentNumber?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  iban?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  metadata?: InputMaybe<Array<MetadataItemInput>>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type UpdateSubscriptionInput = {
  accountId: Scalars['ID'];
  amount?: InputMaybe<Scalars['Int']>;
  billingDetails?: InputMaybe<ContactDetailsInput>;
  callbackUrl?: InputMaybe<Scalars['String']>;
  cancelAtPeriodEnd?: InputMaybe<Scalars['Boolean']>;
  customer?: InputMaybe<CustomerInput>;
  description?: InputMaybe<Scalars['String']>;
  descriptor?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  interval?: InputMaybe<IntervalInput>;
  intervalCount?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Array<KeyValueInput>>;
  nextPaymentAt?: InputMaybe<Scalars['AWSTimestamp']>;
  pauseAtPeriodEnd?: InputMaybe<Scalars['Boolean']>;
  pauseIntervalCount?: InputMaybe<Scalars['Int']>;
  paymentCallbackUrl?: InputMaybe<Scalars['String']>;
  retrySchedule?: InputMaybe<Array<RetryScheduleInput>>;
  shippingDetails?: InputMaybe<ContactDetailsInput>;
  trialPeriodEnd?: InputMaybe<Scalars['AWSTimestamp']>;
};

export type UpdateUserMasterAccountInput = {
  accountCallbackUrl?: InputMaybe<Scalars['String']>;
  allowedDomains?: InputMaybe<Array<Scalars['String']>>;
  allowedIPs?: InputMaybe<Array<Scalars['String']>>;
  branding?: InputMaybe<AccountBrandingInput>;
  churnedEmails?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  publicBusinessDetails?: InputMaybe<AccountPublicBusinessDetailsInput>;
  requireExternalId?: InputMaybe<Scalars['Boolean']>;
  webhookEmails?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateWebKeywordInput = {
  baseUrl: Scalars['String'];
  incorrect: Scalars['Boolean'];
  urlKeyword: Scalars['String'];
};

export type UpdateWebhookInput = {
  accountId: Scalars['ID'];
  enabled?: InputMaybe<Scalars['Boolean']>;
  eventTypes?: InputMaybe<Array<WebhookEventType>>;
  id: Scalars['ID'];
  masterAccount?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  expiresAt: Scalars['AWSTimestamp'];
  uploadUrl: Scalars['String'];
};

export type Upsell = {
  __typename?: 'Upsell';
  date: Scalars['String'];
  executive: SalesExecutive;
  note?: Maybe<Scalars['String']>;
  paymentMethods: Array<PaymentMethods>;
};

export type UpsellInput = {
  date: Scalars['String'];
  executive: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  paymentMethods: Array<PaymentMethods>;
};

export type User = {
  __typename?: 'User';
  accountId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['String'];
  email: Scalars['String'];
  emailVerified?: Maybe<Scalars['Boolean']>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  locale?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneNumberVerified?: Maybe<Scalars['Boolean']>;
  promoCode?: Maybe<Scalars['String']>;
  referralCode?: Maybe<Scalars['String']>;
  smsMfaEnabled?: Maybe<Scalars['Boolean']>;
  status: UserStatus;
  testAccountId?: Maybe<Scalars['ID']>;
};

export type UserInput = {
  id: Scalars['ID'];
  locale?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export enum UserStatus {
  ARCHIVED = 'ARCHIVED',
  COMPROMISED = 'COMPROMISED',
  CONFIRMED = 'CONFIRMED',
  EXTERNAL_PROVIDER = 'EXTERNAL_PROVIDER',
  FORCE_CHANGE_PASSWORD = 'FORCE_CHANGE_PASSWORD',
  RESET_REQUIRED = 'RESET_REQUIRED',
  UNCONFIRMED = 'UNCONFIRMED',
  UNKNOWN = 'UNKNOWN'
}

export type UsersConnection = {
  __typename?: 'UsersConnection';
  items: Array<User>;
  nextToken?: Maybe<Scalars['String']>;
};

export type WebKeyword = {
  __typename?: 'WebKeyword';
  accountId: Scalars['ID'];
  baseUrl: Scalars['String'];
  confirmed?: Maybe<Scalars['Boolean']>;
  context?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['AWSTimestamp']>;
  description?: Maybe<Scalars['String']>;
  expiresAt: Scalars['AWSTimestamp'];
  explanation?: Maybe<Scalars['String']>;
  incorrect?: Maybe<Scalars['Boolean']>;
  keyword: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']>;
  url: Scalars['String'];
  urlKeyword: Scalars['String'];
};

export type WebKeywordsConnection = {
  __typename?: 'WebKeywordsConnection';
  items: Array<WebKeyword>;
  nextToken?: Maybe<Scalars['String']>;
};

export type WebReport = {
  __typename?: 'WebReport';
  accountId: Scalars['ID'];
  baseUrl: Scalars['String'];
  confirmedKeywords: Array<Maybe<Scalars['String']>>;
  createdAt?: Maybe<Scalars['AWSTimestamp']>;
  description?: Maybe<Scalars['String']>;
  expiresAt: Scalars['AWSTimestamp'];
  failedPageCount?: Maybe<Scalars['Int']>;
  legalDetailsUrl?: Maybe<Scalars['String']>;
  pageCount?: Maybe<Scalars['Int']>;
  riskCategory?: Maybe<Scalars['String']>;
  status?: Maybe<WebReportStatus>;
  statusCode?: Maybe<Scalars['String']>;
  statusMessage?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  uncheckedPageCount?: Maybe<Scalars['Int']>;
  unconfirmedKeywords: Array<Maybe<Scalars['String']>>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']>;
};

export enum WebReportStatus {
  FAILED = 'FAILED',
  PROCESSING = 'PROCESSING',
  SUCCEEDED = 'SUCCEEDED'
}

export type Webhook = {
  __typename?: 'Webhook';
  accountId: Scalars['ID'];
  createdAt: Scalars['String'];
  enabled: Scalars['Boolean'];
  eventTypes: Array<WebhookEventType>;
  id: Scalars['ID'];
  lastResponse?: Maybe<CallbackData>;
  secret?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

export enum WebhookEventType {
  ACCOUNT_ACTIVATED = 'ACCOUNT_ACTIVATED',
  ACCOUNT_APPROVAL_REQUESTED = 'ACCOUNT_APPROVAL_REQUESTED',
  ACCOUNT_APPROVED = 'ACCOUNT_APPROVED',
  ACCOUNT_BLOCKED = 'ACCOUNT_BLOCKED',
  ACCOUNT_CHURNED = 'ACCOUNT_CHURNED',
  ACCOUNT_DATA_REQUESTED = 'ACCOUNT_DATA_REQUESTED',
  ACCOUNT_DATA_UPDATED = 'ACCOUNT_DATA_UPDATED',
  ACCOUNT_DELETED = 'ACCOUNT_DELETED',
  ACCOUNT_INVOICE_PAID = 'ACCOUNT_INVOICE_PAID',
  ACCOUNT_INVOICE_PAST_DUE = 'ACCOUNT_INVOICE_PAST_DUE',
  ACCOUNT_INVOICE_PENDING = 'ACCOUNT_INVOICE_PENDING',
  ACCOUNT_INVOICE_UNPAID = 'ACCOUNT_INVOICE_UNPAID',
  ACCOUNT_PENDING = 'ACCOUNT_PENDING',
  ACCOUNT_REACTIVATED = 'ACCOUNT_REACTIVATED',
  ACCOUNT_REJECTED = 'ACCOUNT_REJECTED',
  ACCOUNT_SUSPENDED = 'ACCOUNT_SUSPENDED',
  ACCOUNT_UNBLOCKED = 'ACCOUNT_UNBLOCKED',
  CHARGE_AUTHORIZED = 'CHARGE_AUTHORIZED',
  CHARGE_CANCELED = 'CHARGE_CANCELED',
  CHARGE_CAPTURED = 'CHARGE_CAPTURED',
  CHARGE_CHARGEBACK = 'CHARGE_CHARGEBACK',
  CHARGE_EXPIRED = 'CHARGE_EXPIRED',
  CHARGE_FAILED = 'CHARGE_FAILED',
  CHARGE_PAID_OUT = 'CHARGE_PAID_OUT',
  CHARGE_PARTIALLY_REFUNDED = 'CHARGE_PARTIALLY_REFUNDED',
  CHARGE_PENDING = 'CHARGE_PENDING',
  CHARGE_PENDING_PROCESSING = 'CHARGE_PENDING_PROCESSING',
  CHARGE_REFUNDED = 'CHARGE_REFUNDED',
  CHARGE_SUCCEEDED = 'CHARGE_SUCCEEDED',
  CHARGE_UPDATED = 'CHARGE_UPDATED',
  PROVIDER_CREATED = 'PROVIDER_CREATED',
  PROVIDER_DISABLED = 'PROVIDER_DISABLED',
  PROVIDER_ENABLED = 'PROVIDER_ENABLED',
  PROVIDER_UPDATED = 'PROVIDER_UPDATED',
  SETTLEMENT_COMPLETED = 'SETTLEMENT_COMPLETED',
  SETTLEMENT_PENDING = 'SETTLEMENT_PENDING',
  SETTLEMENT_SUSPENDED = 'SETTLEMENT_SUSPENDED',
  SUBSCRIPTION_ACTIVATED = 'SUBSCRIPTION_ACTIVATED',
  SUBSCRIPTION_CANCELED = 'SUBSCRIPTION_CANCELED',
  SUBSCRIPTION_EXPIRED = 'SUBSCRIPTION_EXPIRED',
  SUBSCRIPTION_PAST_DUE = 'SUBSCRIPTION_PAST_DUE',
  SUBSCRIPTION_PAUSED = 'SUBSCRIPTION_PAUSED',
  SUBSCRIPTION_PENDING = 'SUBSCRIPTION_PENDING',
  SUBSCRIPTION_TRIALING = 'SUBSCRIPTION_TRIALING',
  SUBSCRIPTION_UPDATED = 'SUBSCRIPTION_UPDATED'
}

export type WebhooksConnection = {
  __typename?: 'WebhooksConnection';
  items: Array<Maybe<Webhook>>;
  nextToken?: Maybe<Scalars['String']>;
};

export type AddressFieldsFragment = { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null };

export type PibisiFlagFieldsFragment = { __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null };

export type PibisiFieldsFragment = { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null };

export type SessionDetailsFieldsFragment = { __typename?: 'SessionDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, browserColorDepth?: string | null, browserScreenHeight?: string | null, browserScreenWidth?: string | null, browserTimezoneOffset?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null };

export type TraceDetailsFieldsFragment = { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null };

export type PaymentMethodFieldsFragment = { __typename?: 'PaymentMethod', method?: PaymentMethods | null, bizum?: { __typename?: 'PaymentMethodBizum', phoneNumber?: string | null, integrationType?: string | null } | null, card?: { __typename?: 'PaymentMethodCard', brand?: CardBrand | null, country?: string | null, type?: CardType | null, threeDSecure?: boolean | null, threeDSecureVersion?: string | null, threeDSecureFlow?: ThreeDSecureFlow | null, threeDSecureStatus?: ThreeDsStatus | null, last4?: string | null, cardholderName?: string | null, cardholderEmail?: string | null, expiration?: any | null, bank?: string | null, tokenizationMethod?: TokenizationMethods | null, srcCorrelationId?: string | null, srciTransactionId?: string | null, srcDpaId?: string | null } | null, cardPresent?: { __typename?: 'PaymentMethodCardPresent', bin?: string | null, brand?: CardBrand | null, cardholderEmail?: string | null, cardholderName?: string | null, country?: string | null, expiration?: any | null, last4?: string | null, type?: CardType | null } | null, mbway?: { __typename?: 'PaymentMethodMBWay', phoneNumber?: string | null } | null, paypal?: { __typename?: 'PaymentMethodPaypal', orderId?: string | null, payerId?: string | null, email?: string | null, name?: string | null } | null, sepa?: { __typename?: 'PaymentMethodSepa', accountholderEmail?: string | null, accountholderName?: string | null, countryCode?: string | null, bankAddress?: string | null, bankCode?: string | null, bankName?: string | null, bic?: string | null, last4?: string | null, accountholderAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, trustly?: { __typename?: 'PaymentMethodTrustly', customerId?: string | null } | null, klarna?: { __typename?: 'PaymentMethodKlarna', billingCategory?: BillingCategoryKlarna | null, authPaymentMethod?: AuthPaymentMethodKlarna | null } | null };

export type ProviderFieldsFragment = { __typename?: 'Provider', id: string, processor?: Processor | null, enabled?: boolean | null, test?: boolean | null, paymentMethod?: PaymentMethods | null, acquirer?: Acquirer | null, nativeHostedPayment?: boolean | null, metadata?: Array<{ __typename?: 'MetadataItem', key: string, value?: string | null, type: MetadataItemType, label?: string | null, possibleValues?: Array<string> | null, regex?: string | null, example?: string | null, secret?: boolean | null }> | null, rules?: { __typename?: 'ProviderRules', minAmount?: number | null, maxAmount?: number | null, shopNameLike?: string | null, descriptionLike?: string | null } | null };

export type ChargeFieldsFragment = { __typename?: 'Charge', id: string, accountId: string, providerId?: string | null, checkoutId: string, sequenceId?: string | null, processor?: Processor | null, subscriptionId?: string | null, pointOfSaleId?: string | null, providerReferenceId?: string | null, providerInternalId?: string | null, masterAccountId?: string | null, billingPlan?: BillingPlans | null, createdAt: any, updatedAt?: any | null, amount?: number | null, acquirer?: Acquirer | null, authorizationCode?: string | null, storeId?: string | null, currency: string, description?: string | null, descriptor?: string | null, livemode?: boolean | null, orderId?: string | null, refundedAmount?: number | null, lastRefundAmount?: number | null, lastRefundReason?: RefundReason | null, cancellationReason?: CancellationReason | null, status: ChargeStatus, statusCode?: string | null, statusMessage?: string | null, providerStatusCode?: string | null, providerStatusMessage?: string | null, issuerStatusCode?: string | null, issuerStatusMessage?: string | null, billingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, taxId?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, customer?: { __typename?: 'Customer', email?: string | null, name?: string | null, phone?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', method?: PaymentMethods | null, bizum?: { __typename?: 'PaymentMethodBizum', phoneNumber?: string | null, integrationType?: string | null } | null, card?: { __typename?: 'PaymentMethodCard', brand?: CardBrand | null, country?: string | null, type?: CardType | null, threeDSecure?: boolean | null, threeDSecureVersion?: string | null, threeDSecureFlow?: ThreeDSecureFlow | null, threeDSecureStatus?: ThreeDsStatus | null, last4?: string | null, cardholderName?: string | null, cardholderEmail?: string | null, expiration?: any | null, bank?: string | null, tokenizationMethod?: TokenizationMethods | null, srcCorrelationId?: string | null, srciTransactionId?: string | null, srcDpaId?: string | null } | null, cardPresent?: { __typename?: 'PaymentMethodCardPresent', bin?: string | null, brand?: CardBrand | null, cardholderEmail?: string | null, cardholderName?: string | null, country?: string | null, expiration?: any | null, last4?: string | null, type?: CardType | null } | null, mbway?: { __typename?: 'PaymentMethodMBWay', phoneNumber?: string | null } | null, paypal?: { __typename?: 'PaymentMethodPaypal', orderId?: string | null, payerId?: string | null, email?: string | null, name?: string | null } | null, sepa?: { __typename?: 'PaymentMethodSepa', accountholderEmail?: string | null, accountholderName?: string | null, countryCode?: string | null, bankAddress?: string | null, bankCode?: string | null, bankName?: string | null, bic?: string | null, last4?: string | null, accountholderAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, trustly?: { __typename?: 'PaymentMethodTrustly', customerId?: string | null } | null, klarna?: { __typename?: 'PaymentMethodKlarna', billingCategory?: BillingCategoryKlarna | null, authPaymentMethod?: AuthPaymentMethodKlarna | null } | null } | null, shippingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, taxId?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, shop?: { __typename?: 'Shop', name?: string | null, country?: string | null } | null, sessionDetails?: { __typename?: 'SessionDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, browserColorDepth?: string | null, browserScreenHeight?: string | null, browserScreenWidth?: string | null, browserTimezoneOffset?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null };

export type ChargeEventObjectFieldsFragment = { __typename?: 'ChargeEventObject', id: string, accountId: string, providerId?: string | null, checkoutId: string, sequenceId?: string | null, billingPlan?: BillingPlans | null, subscriptionId?: string | null, providerReferenceId?: string | null, providerInternalId?: string | null, createdAt?: any | null, updatedAt?: any | null, amount?: number | null, authorizationCode?: string | null, currency: string, description?: string | null, livemode?: boolean | null, orderId?: string | null, masterAccountId?: string | null, refundedAmount?: number | null, lastRefundAmount?: number | null, lastRefundReason?: RefundReason | null, cancellationReason?: CancellationReason | null, status: ChargeStatus, statusCode?: string | null, statusMessage?: string | null, billingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, taxId?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, customer?: { __typename?: 'Customer', email?: string | null, name?: string | null, phone?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', method?: PaymentMethods | null, bizum?: { __typename?: 'PaymentMethodBizum', phoneNumber?: string | null, integrationType?: string | null } | null, card?: { __typename?: 'PaymentMethodCard', brand?: CardBrand | null, country?: string | null, type?: CardType | null, threeDSecure?: boolean | null, threeDSecureVersion?: string | null, threeDSecureFlow?: ThreeDSecureFlow | null, threeDSecureStatus?: ThreeDsStatus | null, last4?: string | null, cardholderName?: string | null, cardholderEmail?: string | null, expiration?: any | null, bank?: string | null, tokenizationMethod?: TokenizationMethods | null, srcCorrelationId?: string | null, srciTransactionId?: string | null, srcDpaId?: string | null } | null, cardPresent?: { __typename?: 'PaymentMethodCardPresent', bin?: string | null, brand?: CardBrand | null, cardholderEmail?: string | null, cardholderName?: string | null, country?: string | null, expiration?: any | null, last4?: string | null, type?: CardType | null } | null, mbway?: { __typename?: 'PaymentMethodMBWay', phoneNumber?: string | null } | null, paypal?: { __typename?: 'PaymentMethodPaypal', orderId?: string | null, payerId?: string | null, email?: string | null, name?: string | null } | null, sepa?: { __typename?: 'PaymentMethodSepa', accountholderEmail?: string | null, accountholderName?: string | null, countryCode?: string | null, bankAddress?: string | null, bankCode?: string | null, bankName?: string | null, bic?: string | null, last4?: string | null, accountholderAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, trustly?: { __typename?: 'PaymentMethodTrustly', customerId?: string | null } | null, klarna?: { __typename?: 'PaymentMethodKlarna', billingCategory?: BillingCategoryKlarna | null, authPaymentMethod?: AuthPaymentMethodKlarna | null } | null } | null, shippingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, taxId?: string | null, phone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, shop?: { __typename?: 'Shop', name?: string | null, country?: string | null } | null, sessionDetails?: { __typename?: 'SessionDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, browserColorDepth?: string | null, browserScreenHeight?: string | null, browserScreenWidth?: string | null, browserTimezoneOffset?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null };

export type UserFieldsFragment = { __typename?: 'User', id: string, email: string, emailVerified?: boolean | null, phoneNumber?: string | null, phoneNumberVerified?: boolean | null, smsMfaEnabled?: boolean | null, status: UserStatus, enabled: boolean, accountId?: string | null, testAccountId?: string | null, referralCode?: string | null, promoCode?: string | null, createdAt: string };

export type AccountFieldsFragment = { __typename?: 'Account', id: string, refAccountId?: string | null, testAccountId?: string | null, prodAccountId?: string | null, name?: string | null, status: AccountStatus, note?: string | null, userNote?: string | null, partner?: Partner | null, acquirer?: Acquirer | null, adminEmail?: string | null, allowCreateApiKey?: boolean | null, allowRefunds?: boolean | null, defaultCurrency?: Currencies | null, defaultTransactionType?: TransactionTypes | null, referralCode?: string | null, promoCode?: string | null, language?: string | null, reviewConfirmed?: boolean | null, billingEmail?: string | null, billingPlan?: BillingPlans | null, riskScore?: number | null, riskProfile?: RiskProfile | null, riskProcessing?: boolean | null, riskProfileNote?: string | null, riskIgnoredKeywords?: Array<string> | null, riskUpdatedAt?: string | null, iban?: string | null, dynamicBilling?: boolean | null, test?: boolean | null, secret?: string | null, apiKey?: string | null, customDomain?: string | null, createdAt?: string | null, updatedAt?: string | null, deletedAt?: string | null, approvedAt?: string | null, rejectedAt?: string | null, activatedAt?: string | null, approvalRequestedAt?: string | null, suspendedAt?: string | null, dataUpdatedAt?: string | null, accountExecutive?: SalesExecutive | null, billingVatPercent?: number | null, churned?: boolean | null, blocked?: boolean | null, statusReason?: StatusReason | null, statusNote?: string | null, churnReason?: ChurnReason | null, churnReasonOption?: string | null, churnNote?: string | null, previewFeatures?: Array<string> | null, tags?: Array<string> | null, masterAccountId?: string | null, accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null, customAccountInvoiceNotes?: Array<string> | null, groupInvoicesByStore?: boolean | null, contactPerson?: { __typename?: 'ContactPerson', name: string, email: string, phone?: string | null } | null, branding?: { __typename?: 'AccountBranding', accentColor?: string | null, bgColor?: string | null, logoUrl?: string | null, iconUrl?: string | null } | null, tokenizationMethods?: { __typename?: 'AccountTokenizationMethods', googlePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, applePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, clickToPay?: { __typename?: 'AccountTokenizationMethodsClickToPayItem', enabled?: boolean | null } | null } | null, notifications?: { __typename?: 'AccountNotifications', emailCustomerOnRefund?: boolean | null, emailCustomerOnSuccess?: boolean | null, emailAdminOnSuccess?: boolean | null, emailCustomerOnSubscription?: boolean | null, emailAdminOnSubscription?: boolean | null, emailOnAccountInvoice?: boolean | null } | null, fees?: { __typename?: 'AccountFees', highRiskFee?: number | null, dailyExtraSeatsFee?: number | null, dailyPlatformFee?: number | null, weeklyCustomDomainFee?: number | null, steps?: Array<{ __typename?: 'AccountSteps', trxFee: number, bizumTrxFee?: number | null, bizumTrxFlatFee?: number | null, trxFlatFee: number, from: number }> | null, extra?: Array<{ __typename?: 'AccountExtraFee', name: string, amount: number, type: AccountExtraFeeType, masterAccountFee?: boolean | null, paymentMethods?: Array<PaymentMethods> | null }> | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null, riskScore?: number | null }> | null, business?: { __typename?: 'BusinessData', country?: string | null, legalForm?: LegalForm | null, legalName?: string | null, companyName?: string | null, mcc?: string | null, documentNumber?: string | null, status?: BusinessStatus | null, email?: string | null, phone?: string | null, website?: string | null, monthlyVolume?: number | null, confirmWebsite?: boolean | null, industry?: Industries | null, servicesDescription?: string | null, confirmServicesDescription?: boolean | null, legalAddress?: string | null, legalDescription?: string | null, creationDate?: string | null, lastUpdateDate?: string | null, startActivityDate?: string | null, capital?: any | null, previousNames?: Array<string | null> | null, verificationAttempts?: number | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, registryRecords?: Array<{ __typename?: 'RegistryRecord', name?: string | null, url?: string | null, province?: string | null, date?: string | null }> | null, positions?: Array<{ __typename?: 'BusinessPosition', fromDate?: string | null, role?: string | null, name?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null } | null, representatives?: Array<{ __typename?: 'Representative', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, documentNumber?: string | null, stocksPercentage?: number | null, gender?: Gender | null, citizenship?: string | null, dateOfBirth?: string | null, nationality?: string | null, yearOfBirth?: string | null, placeOfBirth?: string | null, idSession?: string | null, interventionType?: Array<InterventionType> | null, status?: IdVerificationStatus | null, statusCode?: number | null, hasNoPublicActivity?: boolean | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, document?: { __typename?: 'IdDocument', type?: IdDocumentType | null, number?: string | null, country?: string | null, validFrom?: string | null, validUntil?: string | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null }> | null, payoutTerms?: { __typename?: 'AccountPayoutTerms', iban?: string | null, period?: number | null, firstPeriod?: number | null, reservePercent?: number | null, suspended?: boolean | null, releaseReserve?: boolean | null, settleGross?: boolean | null, bankTransferConceptPrefix?: string | null, settleToStores?: boolean | null } | null, publicBusinessDetails?: { __typename?: 'AccountPublicBusinessDetails', companyName?: string | null, website?: string | null, phone?: string | null, supportWebsite?: string | null, supportPhone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, contract?: { __typename?: 'AccountContract', envelopeId: string, status: ContractStatus, path?: string | null, signedDate?: string | null } | null, upsell?: { __typename?: 'Upsell', executive: SalesExecutive, paymentMethods: Array<PaymentMethods>, date: string, note?: string | null } | null };

export type AuthorizedUserFieldsFragment = { __typename?: 'AuthorizedUser', id?: string | null, accountId?: string | null, userEmail: string, accessLevel: AuthorizedUserAccessLevel, storeId?: string | null, status: AuthorizedUserStatus, createdAt?: string | null, updatedAt?: string | null, lastLoginAt?: string | null };

export type AccountEventObjectFieldsFragment = { __typename?: 'AccountEventObject', id: string, refAccountId?: string | null, name?: string | null, status: AccountStatus, note?: string | null, userNote?: string | null, partner?: Partner | null, acquirer?: Acquirer | null, adminEmail?: string | null, defaultCurrency?: Currencies | null, tags?: Array<string> | null, defaultTransactionType?: TransactionTypes | null, referralCode?: string | null, promoCode?: string | null, reviewConfirmed?: boolean | null, billingPlan?: BillingPlans | null, riskScore?: number | null, iban?: string | null, dynamicBilling?: boolean | null, test?: boolean | null, customDomain?: string | null, createdAt?: string | null, updatedAt?: string | null, deletedAt?: string | null, approvedAt?: string | null, rejectedAt?: string | null, activatedAt?: string | null, approvalRequestedAt?: string | null, riskProfile?: RiskProfile | null, riskProfileNote?: string | null, riskIgnoredKeywords?: Array<string> | null, riskUpdatedAt?: string | null, suspendedAt?: string | null, dataUpdatedAt?: string | null, churnReason?: ChurnReason | null, churnReasonOption?: string | null, churnNote?: string | null, statusReason?: StatusReason | null, statusNote?: string | null, accountExecutive?: string | null, tokenizationMethods?: { __typename?: 'AccountTokenizationMethods', googlePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, applePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, clickToPay?: { __typename?: 'AccountTokenizationMethodsClickToPayItem', enabled?: boolean | null } | null } | null, notifications?: { __typename?: 'AccountNotifications', emailCustomerOnRefund?: boolean | null, emailCustomerOnSuccess?: boolean | null, emailAdminOnSuccess?: boolean | null } | null, fees?: { __typename?: 'AccountFees', highRiskFee?: number | null, dailyExtraSeatsFee?: number | null, dailyPlatformFee?: number | null, weeklyCustomDomainFee?: number | null, steps?: Array<{ __typename?: 'AccountSteps', trxFee: number, bizumTrxFee?: number | null, bizumTrxFlatFee?: number | null, trxFlatFee: number, from: number }> | null, extra?: Array<{ __typename?: 'AccountExtraFee', name: string, amount: number, type: AccountExtraFeeType, paymentMethods?: Array<PaymentMethods> | null, region?: AccountExtraFeeRegion | null }> | null } | null, business?: { __typename?: 'BusinessData', country?: string | null, legalForm?: LegalForm | null, legalName?: string | null, companyName?: string | null, mcc?: string | null, documentNumber?: string | null, status?: BusinessStatus | null, email?: string | null, phone?: string | null, website?: string | null, monthlyVolume?: number | null, confirmWebsite?: boolean | null, industry?: Industries | null, servicesDescription?: string | null, confirmServicesDescription?: boolean | null, legalAddress?: string | null, legalDescription?: string | null, creationDate?: string | null, lastUpdateDate?: string | null, startActivityDate?: string | null, capital?: any | null, previousNames?: Array<string | null> | null, verificationAttempts?: number | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, registryRecords?: Array<{ __typename?: 'RegistryRecord', name?: string | null, url?: string | null, province?: string | null, date?: string | null }> | null, positions?: Array<{ __typename?: 'BusinessPosition', fromDate?: string | null, role?: string | null, name?: string | null }> | null } | null, representatives?: Array<{ __typename?: 'Representative', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, documentNumber?: string | null, stocksPercentage?: number | null, gender?: Gender | null, citizenship?: string | null, dateOfBirth?: string | null, nationality?: string | null, yearOfBirth?: string | null, placeOfBirth?: string | null, idSession?: string | null, interventionType?: Array<InterventionType> | null, status?: IdVerificationStatus | null, statusCode?: number | null, hasNoPublicActivity?: boolean | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, document?: { __typename?: 'IdDocument', type?: IdDocumentType | null, number?: string | null, country?: string | null, validFrom?: string | null, validUntil?: string | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null }> | null }> | null, payoutTerms?: { __typename?: 'AccountPayoutTerms', iban?: string | null, period?: number | null, firstPeriod?: number | null, reservePercent?: number | null, suspended?: boolean | null, releaseReserve?: boolean | null } | null, publicBusinessDetails?: { __typename?: 'AccountPublicBusinessDetails', companyName?: string | null, website?: string | null, phone?: string | null, supportWebsite?: string | null, supportPhone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, branding?: { __typename?: 'AccountBranding', accentColor?: string | null, bgColor?: string | null, logoUrl?: string | null, iconUrl?: string | null } | null, contract?: { __typename?: 'AccountContract', envelopeId: string, status: ContractStatus, path?: string | null, signedDate?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null, upsell?: { __typename?: 'Upsell', executive: SalesExecutive, paymentMethods: Array<PaymentMethods>, date: string, note?: string | null } | null };

export type SettlementFieldsFragment = { __typename?: 'Settlement', accountId: string, acquirer: SettlementAcquirer, acquirerFees: number, grossVolume: number, iban?: string | null, id: string, payMethod?: SettlementPayMethods | null, netVolume: number, periodEndAt: any, periodStartAt: any, releasedAmount?: number | null, reservedAmount?: number | null, scheduledAt: any, status: SettlementStatus, legalName?: string | null, storeId?: string | null, settleGross?: boolean | null };

export type AccountInvoiceFieldsFragment = { __typename?: 'AccountInvoice', id?: string | null, number?: string | null, accountId: string, currency: string, amount: number, tax: number, totalAmount: number, status?: AccountInvoiceStatus | null, paymentMethod?: AccountInvoicePaymentMethod | null, period: { __typename?: 'AccountInvoicePeriod', from?: any | null, to?: any | null }, lineItems: Array<{ __typename?: 'AccountInvoiceLineItem', name: string, quantity: number, unitAmount: number, unitType: InvoiceLineItemUnitType, currency: string, amount: number }>, business?: { __typename?: 'InvoiceBusinessData', iban?: string | null } | null };

export type PaymentFieldsFragment = { __typename?: 'Payment', id: string, accountId: string, sequenceId?: string | null, subscriptionId?: string | null, pointOfSaleId?: string | null, masterAccountId?: string | null, createdAt?: any | null, updatedAt?: any | null, amount?: number | null, authorizationCode?: string | null, storeId?: string | null, currency: string, description?: string | null, descriptor?: string | null, livemode?: boolean | null, orderId?: string | null, refundedAmount?: number | null, lastRefundAmount?: number | null, lastRefundReason?: RefundReason | null, cancellationReason?: CancellationReason | null, status: PaymentStatus, statusCode?: string | null, statusMessage?: string | null, billingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, taxId?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, customer?: { __typename?: 'Customer', email?: string | null, name?: string | null, phone?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', method?: PaymentMethods | null, bizum?: { __typename?: 'PaymentMethodBizum', phoneNumber?: string | null, integrationType?: string | null } | null, card?: { __typename?: 'PaymentMethodCard', brand?: CardBrand | null, country?: string | null, type?: CardType | null, threeDSecure?: boolean | null, threeDSecureVersion?: string | null, threeDSecureFlow?: ThreeDSecureFlow | null, threeDSecureStatus?: ThreeDsStatus | null, last4?: string | null, cardholderName?: string | null, cardholderEmail?: string | null, expiration?: any | null, bank?: string | null, tokenizationMethod?: TokenizationMethods | null, srcCorrelationId?: string | null, srciTransactionId?: string | null, srcDpaId?: string | null } | null, cardPresent?: { __typename?: 'PaymentMethodCardPresent', bin?: string | null, brand?: CardBrand | null, cardholderEmail?: string | null, cardholderName?: string | null, country?: string | null, expiration?: any | null, last4?: string | null, type?: CardType | null } | null, mbway?: { __typename?: 'PaymentMethodMBWay', phoneNumber?: string | null } | null, paypal?: { __typename?: 'PaymentMethodPaypal', orderId?: string | null, payerId?: string | null, email?: string | null, name?: string | null } | null, sepa?: { __typename?: 'PaymentMethodSepa', accountholderEmail?: string | null, accountholderName?: string | null, countryCode?: string | null, bankAddress?: string | null, bankCode?: string | null, bankName?: string | null, bic?: string | null, last4?: string | null, accountholderAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, trustly?: { __typename?: 'PaymentMethodTrustly', customerId?: string | null } | null, klarna?: { __typename?: 'PaymentMethodKlarna', billingCategory?: BillingCategoryKlarna | null, authPaymentMethod?: AuthPaymentMethodKlarna | null } | null } | null, shippingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, taxId?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, shop?: { __typename?: 'Shop', name?: string | null, country?: string | null } | null, sessionDetails?: { __typename?: 'SessionDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, browserColorDepth?: string | null, browserScreenHeight?: string | null, browserScreenWidth?: string | null, browserTimezoneOffset?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null, nextAction?: { __typename?: 'NextAction', type?: NextActionTypes | null, redirectUrl?: string | null, mustRedirect?: boolean | null } | null };

export type MasterAccountFieldsFragment = { __typename?: 'MasterAccount', id: string, testAccountId?: string | null, prodAccountId?: string | null, name?: string | null, adminEmail?: string | null, iban?: string | null, apiKey?: string | null, test?: boolean | null, status?: AccountStatus | null, promoCode?: string | null, allowedIPs?: Array<string> | null, createdAt?: string | null, updatedAt?: string | null, webhookEmails?: Array<string> | null, churnedEmails?: Array<string> | null, allowedDomains?: Array<string> | null, accountCallbackUrl?: string | null, requireExternalId?: boolean | null, contractTemplateId?: string | null, autoApprove?: boolean | null, blocked?: boolean | null, allowCreateApiKey?: boolean | null, payoutTerms?: { __typename?: 'AccountPayoutTerms', iban?: string | null, firstPeriod?: number | null, period?: number | null, reservePercent?: number | null, suspended?: boolean | null, releaseReserve?: boolean | null } | null, accountDefaults?: { __typename?: 'AccountDefaults', billingPlan?: BillingPlans | null, language?: string | null, fees?: { __typename?: 'AccountFees', trxFee?: number | null, trxFlatFee?: number | null, highRiskFee?: number | null, dailyPlatformFee?: number | null, dailyExtraSeatsFee?: number | null, steps?: Array<{ __typename?: 'AccountSteps', trxFee: number, bizumTrxFee?: number | null, bizumTrxFlatFee?: number | null, trxFlatFee: number, from: number }> | null, extra?: Array<{ __typename?: 'AccountExtraFee', name: string, amount: number, type: AccountExtraFeeType, region?: AccountExtraFeeRegion | null, masterAccountFee?: boolean | null, paymentMethods?: Array<PaymentMethods> | null }> | null } | null, business?: { __typename?: 'BusinessDefault', mcc?: string | null, website?: string | null, servicesDescription?: string | null } | null } | null, business?: { __typename?: 'BusinessData', mcc?: string | null, legalName?: string | null, website?: string | null, documentNumber?: string | null, servicesDescription?: string | null } | null };

export type UserMasterAccountFieldsFragment = { __typename?: 'MasterAccount', id: string, name?: string | null, status?: AccountStatus | null, promoCode?: string | null, allowedIPs?: Array<string> | null, webhookEmails?: Array<string> | null, churnedEmails?: Array<string> | null, allowedDomains?: Array<string> | null, accountCallbackUrl?: string | null, requireExternalId?: boolean | null, apiKey?: string | null, publicBusinessDetails?: { __typename?: 'AccountPublicBusinessDetails', companyName?: string | null, website?: string | null, phone?: string | null, supportWebsite?: string | null, supportPhone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, branding?: { __typename?: 'AccountBranding', accentColor?: string | null, bgColor?: string | null, logoUrl?: string | null, iconUrl?: string | null } | null };

export type DocumentFieldsFragment = { __typename?: 'Document', id: string, accountId: string, type: DocumentType, status: DocumentStatus, statusMessage?: string | null, statusCode?: string | null, contentType?: string | null, createdAt: string, updatedAt?: string | null, name?: string | null, note?: string | null, internal?: boolean | null, metadata?: Array<{ __typename?: 'DocumentMetadataItem', key: string, value?: Array<string> | null }> | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null };

export type DocumentEventFieldsFragment = { __typename?: 'DocumentEvent', id: string, type: string, accountId: string, objectId: string, objectType: string, createdAt: any, object: { __typename?: 'DocumentEventObject', id: string, accountId: string, type: DocumentType, status: DocumentStatus, statusCode?: string | null, statusMessage?: string | null, contentType?: string | null, createdAt: any, updatedAt?: any | null, note?: string | null, name?: string | null, internal?: boolean | null, metadata?: Array<{ __typename?: 'DocumentMetadataItem', key: string, value?: Array<string> | null }> | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null } };

export type ContactFieldsFragment = { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null };

export type SubscriptionFieldsFragment = { __typename?: 'Subscription', id: string, accountId: string, livemode: boolean, amount: number, currency?: Currencies | null, description?: string | null, planVariantId?: string | null, productId?: string | null, cancelAtPeriodEnd?: boolean | null, pauseIntervalCount?: number | null, pauseAtPeriodEnd?: boolean | null, currentPeriodStart?: number | null, currentPeriodEnd?: number | null, trialPeriodDays?: number | null, trialPeriodEnd?: number | null, customerId?: string | null, defaultTokenId?: string | null, sequenceId?: string | null, lastInvoiceId?: string | null, lastOrderId?: string | null, nextPaymentAt?: number | null, createdAt?: number | null, updatedAt?: number | null, interval: Interval, intervalCount: number, retryCount?: number | null, status: SubscriptionStatus, callbackUrl?: string | null, paymentCallbackUrl?: string | null, storeId?: string | null, masterAccountId?: string | null, customer?: { __typename?: 'Customer', email?: string | null, name?: string | null, phone?: string | null } | null, billingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, shippingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, lastPayment?: { __typename?: 'LastPayment', id: string, status: PaymentStatus, statusMessage?: string | null, statusCode?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', method?: PaymentMethods | null, bizum?: { __typename?: 'PaymentMethodBizum', phoneNumber?: string | null, integrationType?: string | null } | null, card?: { __typename?: 'PaymentMethodCard', brand?: CardBrand | null, country?: string | null, type?: CardType | null, threeDSecure?: boolean | null, threeDSecureVersion?: string | null, threeDSecureFlow?: ThreeDSecureFlow | null, threeDSecureStatus?: ThreeDsStatus | null, last4?: string | null, cardholderName?: string | null, cardholderEmail?: string | null, expiration?: any | null, bank?: string | null, tokenizationMethod?: TokenizationMethods | null, srcCorrelationId?: string | null, srciTransactionId?: string | null, srcDpaId?: string | null } | null, cardPresent?: { __typename?: 'PaymentMethodCardPresent', bin?: string | null, brand?: CardBrand | null, cardholderEmail?: string | null, cardholderName?: string | null, country?: string | null, expiration?: any | null, last4?: string | null, type?: CardType | null } | null, mbway?: { __typename?: 'PaymentMethodMBWay', phoneNumber?: string | null } | null, paypal?: { __typename?: 'PaymentMethodPaypal', orderId?: string | null, payerId?: string | null, email?: string | null, name?: string | null } | null, sepa?: { __typename?: 'PaymentMethodSepa', accountholderEmail?: string | null, accountholderName?: string | null, countryCode?: string | null, bankAddress?: string | null, bankCode?: string | null, bankName?: string | null, bic?: string | null, last4?: string | null, accountholderAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, trustly?: { __typename?: 'PaymentMethodTrustly', customerId?: string | null } | null, klarna?: { __typename?: 'PaymentMethodKlarna', billingCategory?: BillingCategoryKlarna | null, authPaymentMethod?: AuthPaymentMethodKlarna | null } | null } | null, metadata?: Array<{ __typename?: 'KeyValueItem', key: string, value?: string | null }> | null, sessionDetails?: { __typename?: 'SessionDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, browserColorDepth?: string | null, browserScreenHeight?: string | null, browserScreenWidth?: string | null, browserTimezoneOffset?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null };

export type LastPaymentFieldsFragment = { __typename?: 'LastPayment', id: string, status: PaymentStatus, statusMessage?: string | null, statusCode?: string | null };

export type SubscriptionEventObjectFieldsFragment = { __typename?: 'SubscriptionEventObject', id: string, accountId: string, amount?: number | null, cancelAtPeriodEnd?: boolean | null, createdAt?: any | null, currency: string, currentPeriodEnd?: number | null, currentPeriodStart?: number | null, description?: string | null, interval: Interval, intervalCount: number, lastOrderId?: string | null, livemode?: boolean | null, pauseAtPeriodEnd?: boolean | null, pauseIntervalCount?: number | null, pointOfSaleId?: string | null, retryCount?: number | null, sequenceId?: string | null, status: SubscriptionStatus, storeId?: string | null, trialPeriodDays?: number | null, trialPeriodEnd?: number | null, updatedAt?: any | null, billingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, customer?: { __typename?: 'Customer', email?: string | null, name?: string | null, phone?: string | null } | null, lastPayment?: { __typename?: 'LastPayment', id: string, status: PaymentStatus, statusMessage?: string | null, statusCode?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', method?: PaymentMethods | null, bizum?: { __typename?: 'PaymentMethodBizum', phoneNumber?: string | null, integrationType?: string | null } | null, card?: { __typename?: 'PaymentMethodCard', brand?: CardBrand | null, country?: string | null, type?: CardType | null, threeDSecure?: boolean | null, threeDSecureVersion?: string | null, threeDSecureFlow?: ThreeDSecureFlow | null, threeDSecureStatus?: ThreeDsStatus | null, last4?: string | null, cardholderName?: string | null, cardholderEmail?: string | null, expiration?: any | null, bank?: string | null, tokenizationMethod?: TokenizationMethods | null, srcCorrelationId?: string | null, srciTransactionId?: string | null, srcDpaId?: string | null } | null, cardPresent?: { __typename?: 'PaymentMethodCardPresent', bin?: string | null, brand?: CardBrand | null, cardholderEmail?: string | null, cardholderName?: string | null, country?: string | null, expiration?: any | null, last4?: string | null, type?: CardType | null } | null, mbway?: { __typename?: 'PaymentMethodMBWay', phoneNumber?: string | null } | null, paypal?: { __typename?: 'PaymentMethodPaypal', orderId?: string | null, payerId?: string | null, email?: string | null, name?: string | null } | null, sepa?: { __typename?: 'PaymentMethodSepa', accountholderEmail?: string | null, accountholderName?: string | null, countryCode?: string | null, bankAddress?: string | null, bankCode?: string | null, bankName?: string | null, bic?: string | null, last4?: string | null, accountholderAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, trustly?: { __typename?: 'PaymentMethodTrustly', customerId?: string | null } | null, klarna?: { __typename?: 'PaymentMethodKlarna', billingCategory?: BillingCategoryKlarna | null, authPaymentMethod?: AuthPaymentMethodKlarna | null } | null } | null, shippingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null };

export type ProviderEventObjectFieldsFragment = { __typename?: 'ProviderEventObject', id: string, internalId?: string | null, processor?: Processor | null, enabled?: boolean | null, test?: boolean | null, paymentMethod?: PaymentMethods | null, acquirer?: Acquirer | null, configurable?: boolean | null, nativeHostedPayment?: boolean | null, metadata?: Array<{ __typename?: 'ProviderMetadataItem', key: string, value?: Array<string> | null }> | null, rules?: { __typename?: 'ProviderRules', minAmount?: number | null, maxAmount?: number | null, shopNameLike?: string | null, descriptionLike?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null };

export type WebhookFieldsFragment = { __typename?: 'Webhook', id: string, accountId: string, url: string, enabled: boolean, eventTypes: Array<WebhookEventType>, secret?: string | null, createdAt: string, updatedAt?: string | null };

export type StartExportChargesFieldsFragment = { __typename?: 'ChargesExport', id: string, accountId: string, status: ExportStatus };

export type StoreFieldsFragment = { __typename?: 'Store', id: string, accountId: string, name?: string | null, email?: string | null, iban?: string | null, phone?: string | null, website?: string | null, documentNumber?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null };

export type AccountBalancesFieldsFragment = { __typename?: 'AccountBalances', accountId?: string | null, currency: string, clearedAmount: number, createdAt: string, outstandingAmount: number, totalAmount: number, updatedAt?: string | null };

export type AdminUserFieldsFragment = { __typename?: 'AdminUser', id: string, email: string, name?: string | null, phoneNumber?: string | null };

export type PayoutMethodsFieldsFragment = { __typename?: 'AffiliatePayoutMethod', id?: string | null, title?: string | null, details?: { __typename?: 'AffiliatePayoutMethodDetails', iban?: string | null, nif?: string | null } | null };

export type AffiliateFieldsFragment = { __typename?: 'Affiliate', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, affiliate_group_id?: string | null, created_at?: string | null, company?: { __typename?: 'AffiliateCompany', name?: string | null, description?: string | null } | null, address?: { __typename?: 'AffiliateAddress', address?: string | null, postal_code?: string | null, city?: string | null, state?: string | null, country?: { __typename?: 'AffiliateCountry', name?: string | null, code?: string | null } | null } | null, meta_data?: { __typename?: 'AffiliateMetaData', tier?: string | null } | null, referral_link?: { __typename?: 'AffiliateReferralLink', link?: string | null } | null, payout_methods?: Array<{ __typename?: 'AffiliatePayoutMethod', id?: string | null, title?: string | null, details?: { __typename?: 'AffiliatePayoutMethodDetails', iban?: string | null, nif?: string | null } | null }> | null };

export type AffiliateMerchantFieldsFragment = { __typename?: 'AffiliateMerchant', id: string, status?: string | null, created_at?: string | null, meta_data?: { __typename?: 'AffiliateMerchantMetaData', account_id?: string | null, company_name?: string | null, website?: string | null, first_conversion_date?: string | null } | null };

export type AffiliateInvoiceFieldsFragment = { __typename?: 'AffiliateInvoice', id: string, number?: string | null, amount?: number | null, issuedAt?: string | null, status?: string | null, dueAt?: string | null };

export type ExportChargesMutationVariables = Exact<{
  filter?: InputMaybe<SearchableChargeFilterInput>;
  columns?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
}>;


export type ExportChargesMutation = { __typename?: 'Mutation', exportCharges: { __typename?: 'DownloadFile', downloadUrl: string, expiresAt: any } };

export type UpdateAccountMutationVariables = Exact<{
  input: UpdateAccountInput;
}>;


export type UpdateAccountMutation = { __typename?: 'Mutation', updateAccount: { __typename?: 'Account', id: string, refAccountId?: string | null, testAccountId?: string | null, prodAccountId?: string | null, name?: string | null, status: AccountStatus, note?: string | null, userNote?: string | null, partner?: Partner | null, acquirer?: Acquirer | null, adminEmail?: string | null, allowCreateApiKey?: boolean | null, allowRefunds?: boolean | null, defaultCurrency?: Currencies | null, defaultTransactionType?: TransactionTypes | null, referralCode?: string | null, promoCode?: string | null, language?: string | null, reviewConfirmed?: boolean | null, billingEmail?: string | null, billingPlan?: BillingPlans | null, riskScore?: number | null, riskProfile?: RiskProfile | null, riskProcessing?: boolean | null, riskProfileNote?: string | null, riskIgnoredKeywords?: Array<string> | null, riskUpdatedAt?: string | null, iban?: string | null, dynamicBilling?: boolean | null, test?: boolean | null, secret?: string | null, apiKey?: string | null, customDomain?: string | null, createdAt?: string | null, updatedAt?: string | null, deletedAt?: string | null, approvedAt?: string | null, rejectedAt?: string | null, activatedAt?: string | null, approvalRequestedAt?: string | null, suspendedAt?: string | null, dataUpdatedAt?: string | null, accountExecutive?: SalesExecutive | null, billingVatPercent?: number | null, churned?: boolean | null, blocked?: boolean | null, statusReason?: StatusReason | null, statusNote?: string | null, churnReason?: ChurnReason | null, churnReasonOption?: string | null, churnNote?: string | null, previewFeatures?: Array<string> | null, tags?: Array<string> | null, masterAccountId?: string | null, accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null, customAccountInvoiceNotes?: Array<string> | null, groupInvoicesByStore?: boolean | null, contactPerson?: { __typename?: 'ContactPerson', name: string, email: string, phone?: string | null } | null, branding?: { __typename?: 'AccountBranding', accentColor?: string | null, bgColor?: string | null, logoUrl?: string | null, iconUrl?: string | null } | null, tokenizationMethods?: { __typename?: 'AccountTokenizationMethods', googlePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, applePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, clickToPay?: { __typename?: 'AccountTokenizationMethodsClickToPayItem', enabled?: boolean | null } | null } | null, notifications?: { __typename?: 'AccountNotifications', emailCustomerOnRefund?: boolean | null, emailCustomerOnSuccess?: boolean | null, emailAdminOnSuccess?: boolean | null, emailCustomerOnSubscription?: boolean | null, emailAdminOnSubscription?: boolean | null, emailOnAccountInvoice?: boolean | null } | null, fees?: { __typename?: 'AccountFees', highRiskFee?: number | null, dailyExtraSeatsFee?: number | null, dailyPlatformFee?: number | null, weeklyCustomDomainFee?: number | null, steps?: Array<{ __typename?: 'AccountSteps', trxFee: number, bizumTrxFee?: number | null, bizumTrxFlatFee?: number | null, trxFlatFee: number, from: number }> | null, extra?: Array<{ __typename?: 'AccountExtraFee', name: string, amount: number, type: AccountExtraFeeType, masterAccountFee?: boolean | null, paymentMethods?: Array<PaymentMethods> | null }> | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null, riskScore?: number | null }> | null, business?: { __typename?: 'BusinessData', country?: string | null, legalForm?: LegalForm | null, legalName?: string | null, companyName?: string | null, mcc?: string | null, documentNumber?: string | null, status?: BusinessStatus | null, email?: string | null, phone?: string | null, website?: string | null, monthlyVolume?: number | null, confirmWebsite?: boolean | null, industry?: Industries | null, servicesDescription?: string | null, confirmServicesDescription?: boolean | null, legalAddress?: string | null, legalDescription?: string | null, creationDate?: string | null, lastUpdateDate?: string | null, startActivityDate?: string | null, capital?: any | null, previousNames?: Array<string | null> | null, verificationAttempts?: number | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, registryRecords?: Array<{ __typename?: 'RegistryRecord', name?: string | null, url?: string | null, province?: string | null, date?: string | null }> | null, positions?: Array<{ __typename?: 'BusinessPosition', fromDate?: string | null, role?: string | null, name?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null } | null, representatives?: Array<{ __typename?: 'Representative', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, documentNumber?: string | null, stocksPercentage?: number | null, gender?: Gender | null, citizenship?: string | null, dateOfBirth?: string | null, nationality?: string | null, yearOfBirth?: string | null, placeOfBirth?: string | null, idSession?: string | null, interventionType?: Array<InterventionType> | null, status?: IdVerificationStatus | null, statusCode?: number | null, hasNoPublicActivity?: boolean | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, document?: { __typename?: 'IdDocument', type?: IdDocumentType | null, number?: string | null, country?: string | null, validFrom?: string | null, validUntil?: string | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null }> | null, payoutTerms?: { __typename?: 'AccountPayoutTerms', iban?: string | null, period?: number | null, firstPeriod?: number | null, reservePercent?: number | null, suspended?: boolean | null, releaseReserve?: boolean | null, settleGross?: boolean | null, bankTransferConceptPrefix?: string | null, settleToStores?: boolean | null } | null, publicBusinessDetails?: { __typename?: 'AccountPublicBusinessDetails', companyName?: string | null, website?: string | null, phone?: string | null, supportWebsite?: string | null, supportPhone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, contract?: { __typename?: 'AccountContract', envelopeId: string, status: ContractStatus, path?: string | null, signedDate?: string | null } | null, upsell?: { __typename?: 'Upsell', executive: SalesExecutive, paymentMethods: Array<PaymentMethods>, date: string, note?: string | null } | null } };

export type UpdateMasterAccountMutationVariables = Exact<{
  input: UpdateMasterAccountInput;
}>;


export type UpdateMasterAccountMutation = { __typename?: 'Mutation', updateMasterAccount: { __typename?: 'MasterAccount', id: string, testAccountId?: string | null, prodAccountId?: string | null, name?: string | null, adminEmail?: string | null, iban?: string | null, apiKey?: string | null, test?: boolean | null, status?: AccountStatus | null, promoCode?: string | null, allowedIPs?: Array<string> | null, createdAt?: string | null, updatedAt?: string | null, webhookEmails?: Array<string> | null, churnedEmails?: Array<string> | null, allowedDomains?: Array<string> | null, accountCallbackUrl?: string | null, requireExternalId?: boolean | null, contractTemplateId?: string | null, autoApprove?: boolean | null, blocked?: boolean | null, allowCreateApiKey?: boolean | null, payoutTerms?: { __typename?: 'AccountPayoutTerms', iban?: string | null, firstPeriod?: number | null, period?: number | null, reservePercent?: number | null, suspended?: boolean | null, releaseReserve?: boolean | null } | null, accountDefaults?: { __typename?: 'AccountDefaults', billingPlan?: BillingPlans | null, language?: string | null, fees?: { __typename?: 'AccountFees', trxFee?: number | null, trxFlatFee?: number | null, highRiskFee?: number | null, dailyPlatformFee?: number | null, dailyExtraSeatsFee?: number | null, steps?: Array<{ __typename?: 'AccountSteps', trxFee: number, bizumTrxFee?: number | null, bizumTrxFlatFee?: number | null, trxFlatFee: number, from: number }> | null, extra?: Array<{ __typename?: 'AccountExtraFee', name: string, amount: number, type: AccountExtraFeeType, region?: AccountExtraFeeRegion | null, masterAccountFee?: boolean | null, paymentMethods?: Array<PaymentMethods> | null }> | null } | null, business?: { __typename?: 'BusinessDefault', mcc?: string | null, website?: string | null, servicesDescription?: string | null } | null } | null, business?: { __typename?: 'BusinessData', mcc?: string | null, legalName?: string | null, website?: string | null, documentNumber?: string | null, servicesDescription?: string | null } | null } };

export type UpdateUserMasterAccountMutationVariables = Exact<{
  input: UpdateUserMasterAccountInput;
}>;


export type UpdateUserMasterAccountMutation = { __typename?: 'Mutation', updateUserMasterAccount: { __typename?: 'MasterAccount', id: string, name?: string | null, status?: AccountStatus | null, promoCode?: string | null, allowedIPs?: Array<string> | null, webhookEmails?: Array<string> | null, churnedEmails?: Array<string> | null, allowedDomains?: Array<string> | null, accountCallbackUrl?: string | null, requireExternalId?: boolean | null, apiKey?: string | null, publicBusinessDetails?: { __typename?: 'AccountPublicBusinessDetails', companyName?: string | null, website?: string | null, phone?: string | null, supportWebsite?: string | null, supportPhone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, branding?: { __typename?: 'AccountBranding', accentColor?: string | null, bgColor?: string | null, logoUrl?: string | null, iconUrl?: string | null } | null } };

export type UpdateProviderMutationVariables = Exact<{
  input: UpdateProviderInput;
}>;


export type UpdateProviderMutation = { __typename?: 'Mutation', updateProvider: { __typename?: 'Provider', id: string, processor?: Processor | null, enabled?: boolean | null, test?: boolean | null, paymentMethod?: PaymentMethods | null, acquirer?: Acquirer | null, nativeHostedPayment?: boolean | null, metadata?: Array<{ __typename?: 'MetadataItem', key: string, value?: string | null, type: MetadataItemType, label?: string | null, possibleValues?: Array<string> | null, regex?: string | null, example?: string | null, secret?: boolean | null }> | null, rules?: { __typename?: 'ProviderRules', minAmount?: number | null, maxAmount?: number | null, shopNameLike?: string | null, descriptionLike?: string | null } | null } };

export type CreateProviderMutationVariables = Exact<{
  input: CreateProviderInput;
}>;


export type CreateProviderMutation = { __typename?: 'Mutation', createProvider: { __typename?: 'Provider', id: string, processor?: Processor | null, enabled?: boolean | null, test?: boolean | null, paymentMethod?: PaymentMethods | null, acquirer?: Acquirer | null, nativeHostedPayment?: boolean | null, metadata?: Array<{ __typename?: 'MetadataItem', key: string, value?: string | null, type: MetadataItemType, label?: string | null, possibleValues?: Array<string> | null, regex?: string | null, example?: string | null, secret?: boolean | null }> | null, rules?: { __typename?: 'ProviderRules', minAmount?: number | null, maxAmount?: number | null, shopNameLike?: string | null, descriptionLike?: string | null } | null } };

export type DeleteProviderMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProviderMutation = { __typename?: 'Mutation', deleteProvider: { __typename?: 'Provider', id: string, processor?: Processor | null, enabled?: boolean | null, test?: boolean | null, paymentMethod?: PaymentMethods | null, acquirer?: Acquirer | null, nativeHostedPayment?: boolean | null, metadata?: Array<{ __typename?: 'MetadataItem', key: string, value?: string | null, type: MetadataItemType, label?: string | null, possibleValues?: Array<string> | null, regex?: string | null, example?: string | null, secret?: boolean | null }> | null, rules?: { __typename?: 'ProviderRules', minAmount?: number | null, maxAmount?: number | null, shopNameLike?: string | null, descriptionLike?: string | null } | null } };

export type ImpersonateMutationVariables = Exact<{
  input: ImpersonateInput;
}>;


export type ImpersonateMutation = { __typename?: 'Mutation', impersonate?: boolean | null };

export type ResetUserPasswordMutationVariables = Exact<{
  userId: Scalars['ID'];
  temporalPassword?: InputMaybe<Scalars['String']>;
}>;


export type ResetUserPasswordMutation = { __typename?: 'Mutation', resetUserPassword: string };

export type DisableUserMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DisableUserMutation = { __typename?: 'Mutation', disableUser: { __typename?: 'User', id: string, email: string, emailVerified?: boolean | null, phoneNumber?: string | null, phoneNumberVerified?: boolean | null, smsMfaEnabled?: boolean | null, status: UserStatus, enabled: boolean, accountId?: string | null, testAccountId?: string | null, referralCode?: string | null, promoCode?: string | null, createdAt: string } };

export type EnableUserMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EnableUserMutation = { __typename?: 'Mutation', enableUser: { __typename?: 'User', id: string, email: string, emailVerified?: boolean | null, phoneNumber?: string | null, phoneNumberVerified?: boolean | null, smsMfaEnabled?: boolean | null, status: UserStatus, enabled: boolean, accountId?: string | null, testAccountId?: string | null, referralCode?: string | null, promoCode?: string | null, createdAt: string } };

export type DeleteAccountMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAccountMutation = { __typename?: 'Mutation', deleteAccount: { __typename?: 'Account', id: string, refAccountId?: string | null, testAccountId?: string | null, prodAccountId?: string | null, name?: string | null, status: AccountStatus, note?: string | null, userNote?: string | null, partner?: Partner | null, acquirer?: Acquirer | null, adminEmail?: string | null, allowCreateApiKey?: boolean | null, allowRefunds?: boolean | null, defaultCurrency?: Currencies | null, defaultTransactionType?: TransactionTypes | null, referralCode?: string | null, promoCode?: string | null, language?: string | null, reviewConfirmed?: boolean | null, billingEmail?: string | null, billingPlan?: BillingPlans | null, riskScore?: number | null, riskProfile?: RiskProfile | null, riskProcessing?: boolean | null, riskProfileNote?: string | null, riskIgnoredKeywords?: Array<string> | null, riskUpdatedAt?: string | null, iban?: string | null, dynamicBilling?: boolean | null, test?: boolean | null, secret?: string | null, apiKey?: string | null, customDomain?: string | null, createdAt?: string | null, updatedAt?: string | null, deletedAt?: string | null, approvedAt?: string | null, rejectedAt?: string | null, activatedAt?: string | null, approvalRequestedAt?: string | null, suspendedAt?: string | null, dataUpdatedAt?: string | null, accountExecutive?: SalesExecutive | null, billingVatPercent?: number | null, churned?: boolean | null, blocked?: boolean | null, statusReason?: StatusReason | null, statusNote?: string | null, churnReason?: ChurnReason | null, churnReasonOption?: string | null, churnNote?: string | null, previewFeatures?: Array<string> | null, tags?: Array<string> | null, masterAccountId?: string | null, accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null, customAccountInvoiceNotes?: Array<string> | null, groupInvoicesByStore?: boolean | null, contactPerson?: { __typename?: 'ContactPerson', name: string, email: string, phone?: string | null } | null, branding?: { __typename?: 'AccountBranding', accentColor?: string | null, bgColor?: string | null, logoUrl?: string | null, iconUrl?: string | null } | null, tokenizationMethods?: { __typename?: 'AccountTokenizationMethods', googlePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, applePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, clickToPay?: { __typename?: 'AccountTokenizationMethodsClickToPayItem', enabled?: boolean | null } | null } | null, notifications?: { __typename?: 'AccountNotifications', emailCustomerOnRefund?: boolean | null, emailCustomerOnSuccess?: boolean | null, emailAdminOnSuccess?: boolean | null, emailCustomerOnSubscription?: boolean | null, emailAdminOnSubscription?: boolean | null, emailOnAccountInvoice?: boolean | null } | null, fees?: { __typename?: 'AccountFees', highRiskFee?: number | null, dailyExtraSeatsFee?: number | null, dailyPlatformFee?: number | null, weeklyCustomDomainFee?: number | null, steps?: Array<{ __typename?: 'AccountSteps', trxFee: number, bizumTrxFee?: number | null, bizumTrxFlatFee?: number | null, trxFlatFee: number, from: number }> | null, extra?: Array<{ __typename?: 'AccountExtraFee', name: string, amount: number, type: AccountExtraFeeType, masterAccountFee?: boolean | null, paymentMethods?: Array<PaymentMethods> | null }> | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null, riskScore?: number | null }> | null, business?: { __typename?: 'BusinessData', country?: string | null, legalForm?: LegalForm | null, legalName?: string | null, companyName?: string | null, mcc?: string | null, documentNumber?: string | null, status?: BusinessStatus | null, email?: string | null, phone?: string | null, website?: string | null, monthlyVolume?: number | null, confirmWebsite?: boolean | null, industry?: Industries | null, servicesDescription?: string | null, confirmServicesDescription?: boolean | null, legalAddress?: string | null, legalDescription?: string | null, creationDate?: string | null, lastUpdateDate?: string | null, startActivityDate?: string | null, capital?: any | null, previousNames?: Array<string | null> | null, verificationAttempts?: number | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, registryRecords?: Array<{ __typename?: 'RegistryRecord', name?: string | null, url?: string | null, province?: string | null, date?: string | null }> | null, positions?: Array<{ __typename?: 'BusinessPosition', fromDate?: string | null, role?: string | null, name?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null } | null, representatives?: Array<{ __typename?: 'Representative', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, documentNumber?: string | null, stocksPercentage?: number | null, gender?: Gender | null, citizenship?: string | null, dateOfBirth?: string | null, nationality?: string | null, yearOfBirth?: string | null, placeOfBirth?: string | null, idSession?: string | null, interventionType?: Array<InterventionType> | null, status?: IdVerificationStatus | null, statusCode?: number | null, hasNoPublicActivity?: boolean | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, document?: { __typename?: 'IdDocument', type?: IdDocumentType | null, number?: string | null, country?: string | null, validFrom?: string | null, validUntil?: string | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null }> | null, payoutTerms?: { __typename?: 'AccountPayoutTerms', iban?: string | null, period?: number | null, firstPeriod?: number | null, reservePercent?: number | null, suspended?: boolean | null, releaseReserve?: boolean | null, settleGross?: boolean | null, bankTransferConceptPrefix?: string | null, settleToStores?: boolean | null } | null, publicBusinessDetails?: { __typename?: 'AccountPublicBusinessDetails', companyName?: string | null, website?: string | null, phone?: string | null, supportWebsite?: string | null, supportPhone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, contract?: { __typename?: 'AccountContract', envelopeId: string, status: ContractStatus, path?: string | null, signedDate?: string | null } | null, upsell?: { __typename?: 'Upsell', executive: SalesExecutive, paymentMethods: Array<PaymentMethods>, date: string, note?: string | null } | null } };

export type RestoreAccountMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RestoreAccountMutation = { __typename?: 'Mutation', restoreAccount: { __typename?: 'Account', id: string, refAccountId?: string | null, testAccountId?: string | null, prodAccountId?: string | null, name?: string | null, status: AccountStatus, note?: string | null, userNote?: string | null, partner?: Partner | null, acquirer?: Acquirer | null, adminEmail?: string | null, allowCreateApiKey?: boolean | null, allowRefunds?: boolean | null, defaultCurrency?: Currencies | null, defaultTransactionType?: TransactionTypes | null, referralCode?: string | null, promoCode?: string | null, language?: string | null, reviewConfirmed?: boolean | null, billingEmail?: string | null, billingPlan?: BillingPlans | null, riskScore?: number | null, riskProfile?: RiskProfile | null, riskProcessing?: boolean | null, riskProfileNote?: string | null, riskIgnoredKeywords?: Array<string> | null, riskUpdatedAt?: string | null, iban?: string | null, dynamicBilling?: boolean | null, test?: boolean | null, secret?: string | null, apiKey?: string | null, customDomain?: string | null, createdAt?: string | null, updatedAt?: string | null, deletedAt?: string | null, approvedAt?: string | null, rejectedAt?: string | null, activatedAt?: string | null, approvalRequestedAt?: string | null, suspendedAt?: string | null, dataUpdatedAt?: string | null, accountExecutive?: SalesExecutive | null, billingVatPercent?: number | null, churned?: boolean | null, blocked?: boolean | null, statusReason?: StatusReason | null, statusNote?: string | null, churnReason?: ChurnReason | null, churnReasonOption?: string | null, churnNote?: string | null, previewFeatures?: Array<string> | null, tags?: Array<string> | null, masterAccountId?: string | null, accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null, customAccountInvoiceNotes?: Array<string> | null, groupInvoicesByStore?: boolean | null, contactPerson?: { __typename?: 'ContactPerson', name: string, email: string, phone?: string | null } | null, branding?: { __typename?: 'AccountBranding', accentColor?: string | null, bgColor?: string | null, logoUrl?: string | null, iconUrl?: string | null } | null, tokenizationMethods?: { __typename?: 'AccountTokenizationMethods', googlePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, applePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, clickToPay?: { __typename?: 'AccountTokenizationMethodsClickToPayItem', enabled?: boolean | null } | null } | null, notifications?: { __typename?: 'AccountNotifications', emailCustomerOnRefund?: boolean | null, emailCustomerOnSuccess?: boolean | null, emailAdminOnSuccess?: boolean | null, emailCustomerOnSubscription?: boolean | null, emailAdminOnSubscription?: boolean | null, emailOnAccountInvoice?: boolean | null } | null, fees?: { __typename?: 'AccountFees', highRiskFee?: number | null, dailyExtraSeatsFee?: number | null, dailyPlatformFee?: number | null, weeklyCustomDomainFee?: number | null, steps?: Array<{ __typename?: 'AccountSteps', trxFee: number, bizumTrxFee?: number | null, bizumTrxFlatFee?: number | null, trxFlatFee: number, from: number }> | null, extra?: Array<{ __typename?: 'AccountExtraFee', name: string, amount: number, type: AccountExtraFeeType, masterAccountFee?: boolean | null, paymentMethods?: Array<PaymentMethods> | null }> | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null, riskScore?: number | null }> | null, business?: { __typename?: 'BusinessData', country?: string | null, legalForm?: LegalForm | null, legalName?: string | null, companyName?: string | null, mcc?: string | null, documentNumber?: string | null, status?: BusinessStatus | null, email?: string | null, phone?: string | null, website?: string | null, monthlyVolume?: number | null, confirmWebsite?: boolean | null, industry?: Industries | null, servicesDescription?: string | null, confirmServicesDescription?: boolean | null, legalAddress?: string | null, legalDescription?: string | null, creationDate?: string | null, lastUpdateDate?: string | null, startActivityDate?: string | null, capital?: any | null, previousNames?: Array<string | null> | null, verificationAttempts?: number | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, registryRecords?: Array<{ __typename?: 'RegistryRecord', name?: string | null, url?: string | null, province?: string | null, date?: string | null }> | null, positions?: Array<{ __typename?: 'BusinessPosition', fromDate?: string | null, role?: string | null, name?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null } | null, representatives?: Array<{ __typename?: 'Representative', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, documentNumber?: string | null, stocksPercentage?: number | null, gender?: Gender | null, citizenship?: string | null, dateOfBirth?: string | null, nationality?: string | null, yearOfBirth?: string | null, placeOfBirth?: string | null, idSession?: string | null, interventionType?: Array<InterventionType> | null, status?: IdVerificationStatus | null, statusCode?: number | null, hasNoPublicActivity?: boolean | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, document?: { __typename?: 'IdDocument', type?: IdDocumentType | null, number?: string | null, country?: string | null, validFrom?: string | null, validUntil?: string | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null }> | null, payoutTerms?: { __typename?: 'AccountPayoutTerms', iban?: string | null, period?: number | null, firstPeriod?: number | null, reservePercent?: number | null, suspended?: boolean | null, releaseReserve?: boolean | null, settleGross?: boolean | null, bankTransferConceptPrefix?: string | null, settleToStores?: boolean | null } | null, publicBusinessDetails?: { __typename?: 'AccountPublicBusinessDetails', companyName?: string | null, website?: string | null, phone?: string | null, supportWebsite?: string | null, supportPhone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, contract?: { __typename?: 'AccountContract', envelopeId: string, status: ContractStatus, path?: string | null, signedDate?: string | null } | null, upsell?: { __typename?: 'Upsell', executive: SalesExecutive, paymentMethods: Array<PaymentMethods>, date: string, note?: string | null } | null } };

export type GenerateSettlementReportMutationVariables = Exact<{
  input: GenerateSettlementReportInput;
}>;


export type GenerateSettlementReportMutation = { __typename?: 'Mutation', generateSettlementReport: { __typename?: 'DownloadFile', downloadUrl: string, expiresAt: any } };

export type CreateAccountInvoiceMutationVariables = Exact<{
  input: AccountInvoiceInput;
}>;


export type CreateAccountInvoiceMutation = { __typename?: 'Mutation', createAccountInvoice: { __typename?: 'AccountInvoice', id?: string | null, number?: string | null, accountId: string, currency: string, amount: number, tax: number, totalAmount: number, status?: AccountInvoiceStatus | null, paymentMethod?: AccountInvoicePaymentMethod | null, period: { __typename?: 'AccountInvoicePeriod', from?: any | null, to?: any | null }, lineItems: Array<{ __typename?: 'AccountInvoiceLineItem', name: string, quantity: number, unitAmount: number, unitType: InvoiceLineItemUnitType, currency: string, amount: number }>, business?: { __typename?: 'InvoiceBusinessData', iban?: string | null } | null } };

export type DisableTokenizationMethodMutationVariables = Exact<{
  accountId: Scalars['ID'];
  method: TokenizationMethods;
}>;


export type DisableTokenizationMethodMutation = { __typename?: 'Mutation', disableTokenizationMethod: { __typename?: 'Account', id: string, refAccountId?: string | null, testAccountId?: string | null, prodAccountId?: string | null, name?: string | null, status: AccountStatus, note?: string | null, userNote?: string | null, partner?: Partner | null, acquirer?: Acquirer | null, adminEmail?: string | null, allowCreateApiKey?: boolean | null, allowRefunds?: boolean | null, defaultCurrency?: Currencies | null, defaultTransactionType?: TransactionTypes | null, referralCode?: string | null, promoCode?: string | null, language?: string | null, reviewConfirmed?: boolean | null, billingEmail?: string | null, billingPlan?: BillingPlans | null, riskScore?: number | null, riskProfile?: RiskProfile | null, riskProcessing?: boolean | null, riskProfileNote?: string | null, riskIgnoredKeywords?: Array<string> | null, riskUpdatedAt?: string | null, iban?: string | null, dynamicBilling?: boolean | null, test?: boolean | null, secret?: string | null, apiKey?: string | null, customDomain?: string | null, createdAt?: string | null, updatedAt?: string | null, deletedAt?: string | null, approvedAt?: string | null, rejectedAt?: string | null, activatedAt?: string | null, approvalRequestedAt?: string | null, suspendedAt?: string | null, dataUpdatedAt?: string | null, accountExecutive?: SalesExecutive | null, billingVatPercent?: number | null, churned?: boolean | null, blocked?: boolean | null, statusReason?: StatusReason | null, statusNote?: string | null, churnReason?: ChurnReason | null, churnReasonOption?: string | null, churnNote?: string | null, previewFeatures?: Array<string> | null, tags?: Array<string> | null, masterAccountId?: string | null, accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null, customAccountInvoiceNotes?: Array<string> | null, groupInvoicesByStore?: boolean | null, contactPerson?: { __typename?: 'ContactPerson', name: string, email: string, phone?: string | null } | null, branding?: { __typename?: 'AccountBranding', accentColor?: string | null, bgColor?: string | null, logoUrl?: string | null, iconUrl?: string | null } | null, tokenizationMethods?: { __typename?: 'AccountTokenizationMethods', googlePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, applePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, clickToPay?: { __typename?: 'AccountTokenizationMethodsClickToPayItem', enabled?: boolean | null } | null } | null, notifications?: { __typename?: 'AccountNotifications', emailCustomerOnRefund?: boolean | null, emailCustomerOnSuccess?: boolean | null, emailAdminOnSuccess?: boolean | null, emailCustomerOnSubscription?: boolean | null, emailAdminOnSubscription?: boolean | null, emailOnAccountInvoice?: boolean | null } | null, fees?: { __typename?: 'AccountFees', highRiskFee?: number | null, dailyExtraSeatsFee?: number | null, dailyPlatformFee?: number | null, weeklyCustomDomainFee?: number | null, steps?: Array<{ __typename?: 'AccountSteps', trxFee: number, bizumTrxFee?: number | null, bizumTrxFlatFee?: number | null, trxFlatFee: number, from: number }> | null, extra?: Array<{ __typename?: 'AccountExtraFee', name: string, amount: number, type: AccountExtraFeeType, masterAccountFee?: boolean | null, paymentMethods?: Array<PaymentMethods> | null }> | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null, riskScore?: number | null }> | null, business?: { __typename?: 'BusinessData', country?: string | null, legalForm?: LegalForm | null, legalName?: string | null, companyName?: string | null, mcc?: string | null, documentNumber?: string | null, status?: BusinessStatus | null, email?: string | null, phone?: string | null, website?: string | null, monthlyVolume?: number | null, confirmWebsite?: boolean | null, industry?: Industries | null, servicesDescription?: string | null, confirmServicesDescription?: boolean | null, legalAddress?: string | null, legalDescription?: string | null, creationDate?: string | null, lastUpdateDate?: string | null, startActivityDate?: string | null, capital?: any | null, previousNames?: Array<string | null> | null, verificationAttempts?: number | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, registryRecords?: Array<{ __typename?: 'RegistryRecord', name?: string | null, url?: string | null, province?: string | null, date?: string | null }> | null, positions?: Array<{ __typename?: 'BusinessPosition', fromDate?: string | null, role?: string | null, name?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null } | null, representatives?: Array<{ __typename?: 'Representative', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, documentNumber?: string | null, stocksPercentage?: number | null, gender?: Gender | null, citizenship?: string | null, dateOfBirth?: string | null, nationality?: string | null, yearOfBirth?: string | null, placeOfBirth?: string | null, idSession?: string | null, interventionType?: Array<InterventionType> | null, status?: IdVerificationStatus | null, statusCode?: number | null, hasNoPublicActivity?: boolean | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, document?: { __typename?: 'IdDocument', type?: IdDocumentType | null, number?: string | null, country?: string | null, validFrom?: string | null, validUntil?: string | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null }> | null, payoutTerms?: { __typename?: 'AccountPayoutTerms', iban?: string | null, period?: number | null, firstPeriod?: number | null, reservePercent?: number | null, suspended?: boolean | null, releaseReserve?: boolean | null, settleGross?: boolean | null, bankTransferConceptPrefix?: string | null, settleToStores?: boolean | null } | null, publicBusinessDetails?: { __typename?: 'AccountPublicBusinessDetails', companyName?: string | null, website?: string | null, phone?: string | null, supportWebsite?: string | null, supportPhone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, contract?: { __typename?: 'AccountContract', envelopeId: string, status: ContractStatus, path?: string | null, signedDate?: string | null } | null, upsell?: { __typename?: 'Upsell', executive: SalesExecutive, paymentMethods: Array<PaymentMethods>, date: string, note?: string | null } | null } };

export type EnableTokenizationMethodMutationVariables = Exact<{
  accountId: Scalars['ID'];
  method: TokenizationMethods;
}>;


export type EnableTokenizationMethodMutation = { __typename?: 'Mutation', enableTokenizationMethod: { __typename?: 'Account', id: string, refAccountId?: string | null, testAccountId?: string | null, prodAccountId?: string | null, name?: string | null, status: AccountStatus, note?: string | null, userNote?: string | null, partner?: Partner | null, acquirer?: Acquirer | null, adminEmail?: string | null, allowCreateApiKey?: boolean | null, allowRefunds?: boolean | null, defaultCurrency?: Currencies | null, defaultTransactionType?: TransactionTypes | null, referralCode?: string | null, promoCode?: string | null, language?: string | null, reviewConfirmed?: boolean | null, billingEmail?: string | null, billingPlan?: BillingPlans | null, riskScore?: number | null, riskProfile?: RiskProfile | null, riskProcessing?: boolean | null, riskProfileNote?: string | null, riskIgnoredKeywords?: Array<string> | null, riskUpdatedAt?: string | null, iban?: string | null, dynamicBilling?: boolean | null, test?: boolean | null, secret?: string | null, apiKey?: string | null, customDomain?: string | null, createdAt?: string | null, updatedAt?: string | null, deletedAt?: string | null, approvedAt?: string | null, rejectedAt?: string | null, activatedAt?: string | null, approvalRequestedAt?: string | null, suspendedAt?: string | null, dataUpdatedAt?: string | null, accountExecutive?: SalesExecutive | null, billingVatPercent?: number | null, churned?: boolean | null, blocked?: boolean | null, statusReason?: StatusReason | null, statusNote?: string | null, churnReason?: ChurnReason | null, churnReasonOption?: string | null, churnNote?: string | null, previewFeatures?: Array<string> | null, tags?: Array<string> | null, masterAccountId?: string | null, accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null, customAccountInvoiceNotes?: Array<string> | null, groupInvoicesByStore?: boolean | null, contactPerson?: { __typename?: 'ContactPerson', name: string, email: string, phone?: string | null } | null, branding?: { __typename?: 'AccountBranding', accentColor?: string | null, bgColor?: string | null, logoUrl?: string | null, iconUrl?: string | null } | null, tokenizationMethods?: { __typename?: 'AccountTokenizationMethods', googlePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, applePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, clickToPay?: { __typename?: 'AccountTokenizationMethodsClickToPayItem', enabled?: boolean | null } | null } | null, notifications?: { __typename?: 'AccountNotifications', emailCustomerOnRefund?: boolean | null, emailCustomerOnSuccess?: boolean | null, emailAdminOnSuccess?: boolean | null, emailCustomerOnSubscription?: boolean | null, emailAdminOnSubscription?: boolean | null, emailOnAccountInvoice?: boolean | null } | null, fees?: { __typename?: 'AccountFees', highRiskFee?: number | null, dailyExtraSeatsFee?: number | null, dailyPlatformFee?: number | null, weeklyCustomDomainFee?: number | null, steps?: Array<{ __typename?: 'AccountSteps', trxFee: number, bizumTrxFee?: number | null, bizumTrxFlatFee?: number | null, trxFlatFee: number, from: number }> | null, extra?: Array<{ __typename?: 'AccountExtraFee', name: string, amount: number, type: AccountExtraFeeType, masterAccountFee?: boolean | null, paymentMethods?: Array<PaymentMethods> | null }> | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null, riskScore?: number | null }> | null, business?: { __typename?: 'BusinessData', country?: string | null, legalForm?: LegalForm | null, legalName?: string | null, companyName?: string | null, mcc?: string | null, documentNumber?: string | null, status?: BusinessStatus | null, email?: string | null, phone?: string | null, website?: string | null, monthlyVolume?: number | null, confirmWebsite?: boolean | null, industry?: Industries | null, servicesDescription?: string | null, confirmServicesDescription?: boolean | null, legalAddress?: string | null, legalDescription?: string | null, creationDate?: string | null, lastUpdateDate?: string | null, startActivityDate?: string | null, capital?: any | null, previousNames?: Array<string | null> | null, verificationAttempts?: number | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, registryRecords?: Array<{ __typename?: 'RegistryRecord', name?: string | null, url?: string | null, province?: string | null, date?: string | null }> | null, positions?: Array<{ __typename?: 'BusinessPosition', fromDate?: string | null, role?: string | null, name?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null } | null, representatives?: Array<{ __typename?: 'Representative', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, documentNumber?: string | null, stocksPercentage?: number | null, gender?: Gender | null, citizenship?: string | null, dateOfBirth?: string | null, nationality?: string | null, yearOfBirth?: string | null, placeOfBirth?: string | null, idSession?: string | null, interventionType?: Array<InterventionType> | null, status?: IdVerificationStatus | null, statusCode?: number | null, hasNoPublicActivity?: boolean | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, document?: { __typename?: 'IdDocument', type?: IdDocumentType | null, number?: string | null, country?: string | null, validFrom?: string | null, validUntil?: string | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null }> | null, payoutTerms?: { __typename?: 'AccountPayoutTerms', iban?: string | null, period?: number | null, firstPeriod?: number | null, reservePercent?: number | null, suspended?: boolean | null, releaseReserve?: boolean | null, settleGross?: boolean | null, bankTransferConceptPrefix?: string | null, settleToStores?: boolean | null } | null, publicBusinessDetails?: { __typename?: 'AccountPublicBusinessDetails', companyName?: string | null, website?: string | null, phone?: string | null, supportWebsite?: string | null, supportPhone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, contract?: { __typename?: 'AccountContract', envelopeId: string, status: ContractStatus, path?: string | null, signedDate?: string | null } | null, upsell?: { __typename?: 'Upsell', executive: SalesExecutive, paymentMethods: Array<PaymentMethods>, date: string, note?: string | null } | null } };

export type DownloadContractMutationVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type DownloadContractMutation = { __typename?: 'Mutation', downloadContract?: { __typename?: 'DownloadFile', downloadUrl: string, expiresAt: any } | null };

export type ApproveAccountMutationVariables = Exact<{
  id: Scalars['ID'];
  processor?: InputMaybe<Processor>;
}>;


export type ApproveAccountMutation = { __typename?: 'Mutation', approveAccount: { __typename?: 'Account', id: string, refAccountId?: string | null, testAccountId?: string | null, prodAccountId?: string | null, name?: string | null, status: AccountStatus, note?: string | null, userNote?: string | null, partner?: Partner | null, acquirer?: Acquirer | null, adminEmail?: string | null, allowCreateApiKey?: boolean | null, allowRefunds?: boolean | null, defaultCurrency?: Currencies | null, defaultTransactionType?: TransactionTypes | null, referralCode?: string | null, promoCode?: string | null, language?: string | null, reviewConfirmed?: boolean | null, billingEmail?: string | null, billingPlan?: BillingPlans | null, riskScore?: number | null, riskProfile?: RiskProfile | null, riskProcessing?: boolean | null, riskProfileNote?: string | null, riskIgnoredKeywords?: Array<string> | null, riskUpdatedAt?: string | null, iban?: string | null, dynamicBilling?: boolean | null, test?: boolean | null, secret?: string | null, apiKey?: string | null, customDomain?: string | null, createdAt?: string | null, updatedAt?: string | null, deletedAt?: string | null, approvedAt?: string | null, rejectedAt?: string | null, activatedAt?: string | null, approvalRequestedAt?: string | null, suspendedAt?: string | null, dataUpdatedAt?: string | null, accountExecutive?: SalesExecutive | null, billingVatPercent?: number | null, churned?: boolean | null, blocked?: boolean | null, statusReason?: StatusReason | null, statusNote?: string | null, churnReason?: ChurnReason | null, churnReasonOption?: string | null, churnNote?: string | null, previewFeatures?: Array<string> | null, tags?: Array<string> | null, masterAccountId?: string | null, accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null, customAccountInvoiceNotes?: Array<string> | null, groupInvoicesByStore?: boolean | null, contactPerson?: { __typename?: 'ContactPerson', name: string, email: string, phone?: string | null } | null, branding?: { __typename?: 'AccountBranding', accentColor?: string | null, bgColor?: string | null, logoUrl?: string | null, iconUrl?: string | null } | null, tokenizationMethods?: { __typename?: 'AccountTokenizationMethods', googlePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, applePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, clickToPay?: { __typename?: 'AccountTokenizationMethodsClickToPayItem', enabled?: boolean | null } | null } | null, notifications?: { __typename?: 'AccountNotifications', emailCustomerOnRefund?: boolean | null, emailCustomerOnSuccess?: boolean | null, emailAdminOnSuccess?: boolean | null, emailCustomerOnSubscription?: boolean | null, emailAdminOnSubscription?: boolean | null, emailOnAccountInvoice?: boolean | null } | null, fees?: { __typename?: 'AccountFees', highRiskFee?: number | null, dailyExtraSeatsFee?: number | null, dailyPlatformFee?: number | null, weeklyCustomDomainFee?: number | null, steps?: Array<{ __typename?: 'AccountSteps', trxFee: number, bizumTrxFee?: number | null, bizumTrxFlatFee?: number | null, trxFlatFee: number, from: number }> | null, extra?: Array<{ __typename?: 'AccountExtraFee', name: string, amount: number, type: AccountExtraFeeType, masterAccountFee?: boolean | null, paymentMethods?: Array<PaymentMethods> | null }> | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null, riskScore?: number | null }> | null, business?: { __typename?: 'BusinessData', country?: string | null, legalForm?: LegalForm | null, legalName?: string | null, companyName?: string | null, mcc?: string | null, documentNumber?: string | null, status?: BusinessStatus | null, email?: string | null, phone?: string | null, website?: string | null, monthlyVolume?: number | null, confirmWebsite?: boolean | null, industry?: Industries | null, servicesDescription?: string | null, confirmServicesDescription?: boolean | null, legalAddress?: string | null, legalDescription?: string | null, creationDate?: string | null, lastUpdateDate?: string | null, startActivityDate?: string | null, capital?: any | null, previousNames?: Array<string | null> | null, verificationAttempts?: number | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, registryRecords?: Array<{ __typename?: 'RegistryRecord', name?: string | null, url?: string | null, province?: string | null, date?: string | null }> | null, positions?: Array<{ __typename?: 'BusinessPosition', fromDate?: string | null, role?: string | null, name?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null } | null, representatives?: Array<{ __typename?: 'Representative', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, documentNumber?: string | null, stocksPercentage?: number | null, gender?: Gender | null, citizenship?: string | null, dateOfBirth?: string | null, nationality?: string | null, yearOfBirth?: string | null, placeOfBirth?: string | null, idSession?: string | null, interventionType?: Array<InterventionType> | null, status?: IdVerificationStatus | null, statusCode?: number | null, hasNoPublicActivity?: boolean | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, document?: { __typename?: 'IdDocument', type?: IdDocumentType | null, number?: string | null, country?: string | null, validFrom?: string | null, validUntil?: string | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null }> | null, payoutTerms?: { __typename?: 'AccountPayoutTerms', iban?: string | null, period?: number | null, firstPeriod?: number | null, reservePercent?: number | null, suspended?: boolean | null, releaseReserve?: boolean | null, settleGross?: boolean | null, bankTransferConceptPrefix?: string | null, settleToStores?: boolean | null } | null, publicBusinessDetails?: { __typename?: 'AccountPublicBusinessDetails', companyName?: string | null, website?: string | null, phone?: string | null, supportWebsite?: string | null, supportPhone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, contract?: { __typename?: 'AccountContract', envelopeId: string, status: ContractStatus, path?: string | null, signedDate?: string | null } | null, upsell?: { __typename?: 'Upsell', executive: SalesExecutive, paymentMethods: Array<PaymentMethods>, date: string, note?: string | null } | null } };

export type RegisterMoneiXMerchantMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RegisterMoneiXMerchantMutation = { __typename?: 'Mutation', registerMoneiXMerchant: { __typename?: 'SuccessResult', success: boolean } };

export type VerifyIdMutationVariables = Exact<{
  id: Scalars['Int'];
  accountId: Scalars['ID'];
}>;


export type VerifyIdMutation = { __typename?: 'Mutation', verifyId: { __typename?: 'Account', id: string, refAccountId?: string | null, testAccountId?: string | null, prodAccountId?: string | null, name?: string | null, status: AccountStatus, note?: string | null, userNote?: string | null, partner?: Partner | null, acquirer?: Acquirer | null, adminEmail?: string | null, allowCreateApiKey?: boolean | null, allowRefunds?: boolean | null, defaultCurrency?: Currencies | null, defaultTransactionType?: TransactionTypes | null, referralCode?: string | null, promoCode?: string | null, language?: string | null, reviewConfirmed?: boolean | null, billingEmail?: string | null, billingPlan?: BillingPlans | null, riskScore?: number | null, riskProfile?: RiskProfile | null, riskProcessing?: boolean | null, riskProfileNote?: string | null, riskIgnoredKeywords?: Array<string> | null, riskUpdatedAt?: string | null, iban?: string | null, dynamicBilling?: boolean | null, test?: boolean | null, secret?: string | null, apiKey?: string | null, customDomain?: string | null, createdAt?: string | null, updatedAt?: string | null, deletedAt?: string | null, approvedAt?: string | null, rejectedAt?: string | null, activatedAt?: string | null, approvalRequestedAt?: string | null, suspendedAt?: string | null, dataUpdatedAt?: string | null, accountExecutive?: SalesExecutive | null, billingVatPercent?: number | null, churned?: boolean | null, blocked?: boolean | null, statusReason?: StatusReason | null, statusNote?: string | null, churnReason?: ChurnReason | null, churnReasonOption?: string | null, churnNote?: string | null, previewFeatures?: Array<string> | null, tags?: Array<string> | null, masterAccountId?: string | null, accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null, customAccountInvoiceNotes?: Array<string> | null, groupInvoicesByStore?: boolean | null, contactPerson?: { __typename?: 'ContactPerson', name: string, email: string, phone?: string | null } | null, branding?: { __typename?: 'AccountBranding', accentColor?: string | null, bgColor?: string | null, logoUrl?: string | null, iconUrl?: string | null } | null, tokenizationMethods?: { __typename?: 'AccountTokenizationMethods', googlePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, applePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, clickToPay?: { __typename?: 'AccountTokenizationMethodsClickToPayItem', enabled?: boolean | null } | null } | null, notifications?: { __typename?: 'AccountNotifications', emailCustomerOnRefund?: boolean | null, emailCustomerOnSuccess?: boolean | null, emailAdminOnSuccess?: boolean | null, emailCustomerOnSubscription?: boolean | null, emailAdminOnSubscription?: boolean | null, emailOnAccountInvoice?: boolean | null } | null, fees?: { __typename?: 'AccountFees', highRiskFee?: number | null, dailyExtraSeatsFee?: number | null, dailyPlatformFee?: number | null, weeklyCustomDomainFee?: number | null, steps?: Array<{ __typename?: 'AccountSteps', trxFee: number, bizumTrxFee?: number | null, bizumTrxFlatFee?: number | null, trxFlatFee: number, from: number }> | null, extra?: Array<{ __typename?: 'AccountExtraFee', name: string, amount: number, type: AccountExtraFeeType, masterAccountFee?: boolean | null, paymentMethods?: Array<PaymentMethods> | null }> | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null, riskScore?: number | null }> | null, business?: { __typename?: 'BusinessData', country?: string | null, legalForm?: LegalForm | null, legalName?: string | null, companyName?: string | null, mcc?: string | null, documentNumber?: string | null, status?: BusinessStatus | null, email?: string | null, phone?: string | null, website?: string | null, monthlyVolume?: number | null, confirmWebsite?: boolean | null, industry?: Industries | null, servicesDescription?: string | null, confirmServicesDescription?: boolean | null, legalAddress?: string | null, legalDescription?: string | null, creationDate?: string | null, lastUpdateDate?: string | null, startActivityDate?: string | null, capital?: any | null, previousNames?: Array<string | null> | null, verificationAttempts?: number | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, registryRecords?: Array<{ __typename?: 'RegistryRecord', name?: string | null, url?: string | null, province?: string | null, date?: string | null }> | null, positions?: Array<{ __typename?: 'BusinessPosition', fromDate?: string | null, role?: string | null, name?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null } | null, representatives?: Array<{ __typename?: 'Representative', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, documentNumber?: string | null, stocksPercentage?: number | null, gender?: Gender | null, citizenship?: string | null, dateOfBirth?: string | null, nationality?: string | null, yearOfBirth?: string | null, placeOfBirth?: string | null, idSession?: string | null, interventionType?: Array<InterventionType> | null, status?: IdVerificationStatus | null, statusCode?: number | null, hasNoPublicActivity?: boolean | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, document?: { __typename?: 'IdDocument', type?: IdDocumentType | null, number?: string | null, country?: string | null, validFrom?: string | null, validUntil?: string | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null }> | null, payoutTerms?: { __typename?: 'AccountPayoutTerms', iban?: string | null, period?: number | null, firstPeriod?: number | null, reservePercent?: number | null, suspended?: boolean | null, releaseReserve?: boolean | null, settleGross?: boolean | null, bankTransferConceptPrefix?: string | null, settleToStores?: boolean | null } | null, publicBusinessDetails?: { __typename?: 'AccountPublicBusinessDetails', companyName?: string | null, website?: string | null, phone?: string | null, supportWebsite?: string | null, supportPhone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, contract?: { __typename?: 'AccountContract', envelopeId: string, status: ContractStatus, path?: string | null, signedDate?: string | null } | null, upsell?: { __typename?: 'Upsell', executive: SalesExecutive, paymentMethods: Array<PaymentMethods>, date: string, note?: string | null } | null } };

export type CreateAuthorizedUserMutationVariables = Exact<{
  input: CreateAuthorizedUserInput;
}>;


export type CreateAuthorizedUserMutation = { __typename?: 'Mutation', createAuthorizedUser?: { __typename?: 'AuthorizedUser', id?: string | null, accountId?: string | null, userEmail: string, accessLevel: AuthorizedUserAccessLevel, storeId?: string | null, status: AuthorizedUserStatus, createdAt?: string | null, updatedAt?: string | null, lastLoginAt?: string | null } | null };

export type CreateMasterAccountMutationVariables = Exact<{
  input: CreateMasterAccountInput;
}>;


export type CreateMasterAccountMutation = { __typename?: 'Mutation', createMasterAccount: { __typename?: 'MasterAccount', id: string, testAccountId?: string | null, prodAccountId?: string | null, name?: string | null, adminEmail?: string | null, iban?: string | null, apiKey?: string | null, test?: boolean | null, status?: AccountStatus | null, promoCode?: string | null, allowedIPs?: Array<string> | null, createdAt?: string | null, updatedAt?: string | null, webhookEmails?: Array<string> | null, churnedEmails?: Array<string> | null, allowedDomains?: Array<string> | null, accountCallbackUrl?: string | null, requireExternalId?: boolean | null, contractTemplateId?: string | null, autoApprove?: boolean | null, blocked?: boolean | null, allowCreateApiKey?: boolean | null, payoutTerms?: { __typename?: 'AccountPayoutTerms', iban?: string | null, firstPeriod?: number | null, period?: number | null, reservePercent?: number | null, suspended?: boolean | null, releaseReserve?: boolean | null } | null, accountDefaults?: { __typename?: 'AccountDefaults', billingPlan?: BillingPlans | null, language?: string | null, fees?: { __typename?: 'AccountFees', trxFee?: number | null, trxFlatFee?: number | null, highRiskFee?: number | null, dailyPlatformFee?: number | null, dailyExtraSeatsFee?: number | null, steps?: Array<{ __typename?: 'AccountSteps', trxFee: number, bizumTrxFee?: number | null, bizumTrxFlatFee?: number | null, trxFlatFee: number, from: number }> | null, extra?: Array<{ __typename?: 'AccountExtraFee', name: string, amount: number, type: AccountExtraFeeType, region?: AccountExtraFeeRegion | null, masterAccountFee?: boolean | null, paymentMethods?: Array<PaymentMethods> | null }> | null } | null, business?: { __typename?: 'BusinessDefault', mcc?: string | null, website?: string | null, servicesDescription?: string | null } | null } | null, business?: { __typename?: 'BusinessData', mcc?: string | null, legalName?: string | null, website?: string | null, documentNumber?: string | null, servicesDescription?: string | null } | null } };

export type CreateMasterAccountUserMutationVariables = Exact<{
  input: CreateMasterAccountUserInput;
}>;


export type CreateMasterAccountUserMutation = { __typename?: 'Mutation', createMasterAccountUser: { __typename?: 'AuthorizedUser', id?: string | null, accountId?: string | null, userEmail: string, accessLevel: AuthorizedUserAccessLevel, storeId?: string | null, status: AuthorizedUserStatus, createdAt?: string | null, updatedAt?: string | null, lastLoginAt?: string | null } };

export type DeleteMasterAccountUserMutationVariables = Exact<{
  userEmail: Scalars['String'];
  accountId: Scalars['ID'];
}>;


export type DeleteMasterAccountUserMutation = { __typename?: 'Mutation', deleteMasterAccountUser: boolean };

export type DeleteAuthorizedUserMutationVariables = Exact<{
  userEmail: Scalars['String'];
  accountId: Scalars['ID'];
}>;


export type DeleteAuthorizedUserMutation = { __typename?: 'Mutation', deleteAuthorizedUser: boolean };

export type UpdateAuthorizedUserMutationVariables = Exact<{
  input: UpdateAuthorizedUserInput;
}>;


export type UpdateAuthorizedUserMutation = { __typename?: 'Mutation', updateAuthorizedUser?: { __typename?: 'AuthorizedUser', id?: string | null, accountId?: string | null, userEmail: string, accessLevel: AuthorizedUserAccessLevel, storeId?: string | null, status: AuthorizedUserStatus, createdAt?: string | null, updatedAt?: string | null, lastLoginAt?: string | null } | null };

export type SendPaymentLinkMutationVariables = Exact<{
  input: SendPaymentMessageInput;
}>;


export type SendPaymentLinkMutation = { __typename?: 'Mutation', sendPaymentLink?: { __typename?: 'Payment', id: string, accountId: string, sequenceId?: string | null, subscriptionId?: string | null, pointOfSaleId?: string | null, masterAccountId?: string | null, createdAt?: any | null, updatedAt?: any | null, amount?: number | null, authorizationCode?: string | null, storeId?: string | null, currency: string, description?: string | null, descriptor?: string | null, livemode?: boolean | null, orderId?: string | null, refundedAmount?: number | null, lastRefundAmount?: number | null, lastRefundReason?: RefundReason | null, cancellationReason?: CancellationReason | null, status: PaymentStatus, statusCode?: string | null, statusMessage?: string | null, billingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, taxId?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, customer?: { __typename?: 'Customer', email?: string | null, name?: string | null, phone?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', method?: PaymentMethods | null, bizum?: { __typename?: 'PaymentMethodBizum', phoneNumber?: string | null, integrationType?: string | null } | null, card?: { __typename?: 'PaymentMethodCard', brand?: CardBrand | null, country?: string | null, type?: CardType | null, threeDSecure?: boolean | null, threeDSecureVersion?: string | null, threeDSecureFlow?: ThreeDSecureFlow | null, threeDSecureStatus?: ThreeDsStatus | null, last4?: string | null, cardholderName?: string | null, cardholderEmail?: string | null, expiration?: any | null, bank?: string | null, tokenizationMethod?: TokenizationMethods | null, srcCorrelationId?: string | null, srciTransactionId?: string | null, srcDpaId?: string | null } | null, cardPresent?: { __typename?: 'PaymentMethodCardPresent', bin?: string | null, brand?: CardBrand | null, cardholderEmail?: string | null, cardholderName?: string | null, country?: string | null, expiration?: any | null, last4?: string | null, type?: CardType | null } | null, mbway?: { __typename?: 'PaymentMethodMBWay', phoneNumber?: string | null } | null, paypal?: { __typename?: 'PaymentMethodPaypal', orderId?: string | null, payerId?: string | null, email?: string | null, name?: string | null } | null, sepa?: { __typename?: 'PaymentMethodSepa', accountholderEmail?: string | null, accountholderName?: string | null, countryCode?: string | null, bankAddress?: string | null, bankCode?: string | null, bankName?: string | null, bic?: string | null, last4?: string | null, accountholderAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, trustly?: { __typename?: 'PaymentMethodTrustly', customerId?: string | null } | null, klarna?: { __typename?: 'PaymentMethodKlarna', billingCategory?: BillingCategoryKlarna | null, authPaymentMethod?: AuthPaymentMethodKlarna | null } | null } | null, shippingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, taxId?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, shop?: { __typename?: 'Shop', name?: string | null, country?: string | null } | null, sessionDetails?: { __typename?: 'SessionDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, browserColorDepth?: string | null, browserScreenHeight?: string | null, browserScreenWidth?: string | null, browserTimezoneOffset?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null, nextAction?: { __typename?: 'NextAction', type?: NextActionTypes | null, redirectUrl?: string | null, mustRedirect?: boolean | null } | null } | null };

export type SendPaymentRequestMutationVariables = Exact<{
  input: SendPaymentRequestInput;
}>;


export type SendPaymentRequestMutation = { __typename?: 'Mutation', sendPaymentRequest?: { __typename?: 'Payment', id: string, accountId: string, sequenceId?: string | null, subscriptionId?: string | null, pointOfSaleId?: string | null, masterAccountId?: string | null, createdAt?: any | null, updatedAt?: any | null, amount?: number | null, authorizationCode?: string | null, storeId?: string | null, currency: string, description?: string | null, descriptor?: string | null, livemode?: boolean | null, orderId?: string | null, refundedAmount?: number | null, lastRefundAmount?: number | null, lastRefundReason?: RefundReason | null, cancellationReason?: CancellationReason | null, status: PaymentStatus, statusCode?: string | null, statusMessage?: string | null, billingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, taxId?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, customer?: { __typename?: 'Customer', email?: string | null, name?: string | null, phone?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', method?: PaymentMethods | null, bizum?: { __typename?: 'PaymentMethodBizum', phoneNumber?: string | null, integrationType?: string | null } | null, card?: { __typename?: 'PaymentMethodCard', brand?: CardBrand | null, country?: string | null, type?: CardType | null, threeDSecure?: boolean | null, threeDSecureVersion?: string | null, threeDSecureFlow?: ThreeDSecureFlow | null, threeDSecureStatus?: ThreeDsStatus | null, last4?: string | null, cardholderName?: string | null, cardholderEmail?: string | null, expiration?: any | null, bank?: string | null, tokenizationMethod?: TokenizationMethods | null, srcCorrelationId?: string | null, srciTransactionId?: string | null, srcDpaId?: string | null } | null, cardPresent?: { __typename?: 'PaymentMethodCardPresent', bin?: string | null, brand?: CardBrand | null, cardholderEmail?: string | null, cardholderName?: string | null, country?: string | null, expiration?: any | null, last4?: string | null, type?: CardType | null } | null, mbway?: { __typename?: 'PaymentMethodMBWay', phoneNumber?: string | null } | null, paypal?: { __typename?: 'PaymentMethodPaypal', orderId?: string | null, payerId?: string | null, email?: string | null, name?: string | null } | null, sepa?: { __typename?: 'PaymentMethodSepa', accountholderEmail?: string | null, accountholderName?: string | null, countryCode?: string | null, bankAddress?: string | null, bankCode?: string | null, bankName?: string | null, bic?: string | null, last4?: string | null, accountholderAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, trustly?: { __typename?: 'PaymentMethodTrustly', customerId?: string | null } | null, klarna?: { __typename?: 'PaymentMethodKlarna', billingCategory?: BillingCategoryKlarna | null, authPaymentMethod?: AuthPaymentMethodKlarna | null } | null } | null, shippingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, taxId?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, shop?: { __typename?: 'Shop', name?: string | null, country?: string | null } | null, sessionDetails?: { __typename?: 'SessionDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, browserColorDepth?: string | null, browserScreenHeight?: string | null, browserScreenWidth?: string | null, browserTimezoneOffset?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null, nextAction?: { __typename?: 'NextAction', type?: NextActionTypes | null, redirectUrl?: string | null, mustRedirect?: boolean | null } | null } | null };

export type CreatePaymentMutationVariables = Exact<{
  input: CreatePaymentInput;
}>;


export type CreatePaymentMutation = { __typename?: 'Mutation', createPayment?: { __typename?: 'Payment', id: string, accountId: string, sequenceId?: string | null, subscriptionId?: string | null, pointOfSaleId?: string | null, masterAccountId?: string | null, createdAt?: any | null, updatedAt?: any | null, amount?: number | null, authorizationCode?: string | null, storeId?: string | null, currency: string, description?: string | null, descriptor?: string | null, livemode?: boolean | null, orderId?: string | null, refundedAmount?: number | null, lastRefundAmount?: number | null, lastRefundReason?: RefundReason | null, cancellationReason?: CancellationReason | null, status: PaymentStatus, statusCode?: string | null, statusMessage?: string | null, billingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, taxId?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, customer?: { __typename?: 'Customer', email?: string | null, name?: string | null, phone?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', method?: PaymentMethods | null, bizum?: { __typename?: 'PaymentMethodBizum', phoneNumber?: string | null, integrationType?: string | null } | null, card?: { __typename?: 'PaymentMethodCard', brand?: CardBrand | null, country?: string | null, type?: CardType | null, threeDSecure?: boolean | null, threeDSecureVersion?: string | null, threeDSecureFlow?: ThreeDSecureFlow | null, threeDSecureStatus?: ThreeDsStatus | null, last4?: string | null, cardholderName?: string | null, cardholderEmail?: string | null, expiration?: any | null, bank?: string | null, tokenizationMethod?: TokenizationMethods | null, srcCorrelationId?: string | null, srciTransactionId?: string | null, srcDpaId?: string | null } | null, cardPresent?: { __typename?: 'PaymentMethodCardPresent', bin?: string | null, brand?: CardBrand | null, cardholderEmail?: string | null, cardholderName?: string | null, country?: string | null, expiration?: any | null, last4?: string | null, type?: CardType | null } | null, mbway?: { __typename?: 'PaymentMethodMBWay', phoneNumber?: string | null } | null, paypal?: { __typename?: 'PaymentMethodPaypal', orderId?: string | null, payerId?: string | null, email?: string | null, name?: string | null } | null, sepa?: { __typename?: 'PaymentMethodSepa', accountholderEmail?: string | null, accountholderName?: string | null, countryCode?: string | null, bankAddress?: string | null, bankCode?: string | null, bankName?: string | null, bic?: string | null, last4?: string | null, accountholderAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, trustly?: { __typename?: 'PaymentMethodTrustly', customerId?: string | null } | null, klarna?: { __typename?: 'PaymentMethodKlarna', billingCategory?: BillingCategoryKlarna | null, authPaymentMethod?: AuthPaymentMethodKlarna | null } | null } | null, shippingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, taxId?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, shop?: { __typename?: 'Shop', name?: string | null, country?: string | null } | null, sessionDetails?: { __typename?: 'SessionDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, browserColorDepth?: string | null, browserScreenHeight?: string | null, browserScreenWidth?: string | null, browserTimezoneOffset?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null, nextAction?: { __typename?: 'NextAction', type?: NextActionTypes | null, redirectUrl?: string | null, mustRedirect?: boolean | null } | null } | null };

export type CapturePaymentMutationVariables = Exact<{
  input: CapturePaymentInput;
}>;


export type CapturePaymentMutation = { __typename?: 'Mutation', capturePayment?: { __typename?: 'Payment', id: string, accountId: string, sequenceId?: string | null, subscriptionId?: string | null, pointOfSaleId?: string | null, masterAccountId?: string | null, createdAt?: any | null, updatedAt?: any | null, amount?: number | null, authorizationCode?: string | null, storeId?: string | null, currency: string, description?: string | null, descriptor?: string | null, livemode?: boolean | null, orderId?: string | null, refundedAmount?: number | null, lastRefundAmount?: number | null, lastRefundReason?: RefundReason | null, cancellationReason?: CancellationReason | null, status: PaymentStatus, statusCode?: string | null, statusMessage?: string | null, billingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, taxId?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, customer?: { __typename?: 'Customer', email?: string | null, name?: string | null, phone?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', method?: PaymentMethods | null, bizum?: { __typename?: 'PaymentMethodBizum', phoneNumber?: string | null, integrationType?: string | null } | null, card?: { __typename?: 'PaymentMethodCard', brand?: CardBrand | null, country?: string | null, type?: CardType | null, threeDSecure?: boolean | null, threeDSecureVersion?: string | null, threeDSecureFlow?: ThreeDSecureFlow | null, threeDSecureStatus?: ThreeDsStatus | null, last4?: string | null, cardholderName?: string | null, cardholderEmail?: string | null, expiration?: any | null, bank?: string | null, tokenizationMethod?: TokenizationMethods | null, srcCorrelationId?: string | null, srciTransactionId?: string | null, srcDpaId?: string | null } | null, cardPresent?: { __typename?: 'PaymentMethodCardPresent', bin?: string | null, brand?: CardBrand | null, cardholderEmail?: string | null, cardholderName?: string | null, country?: string | null, expiration?: any | null, last4?: string | null, type?: CardType | null } | null, mbway?: { __typename?: 'PaymentMethodMBWay', phoneNumber?: string | null } | null, paypal?: { __typename?: 'PaymentMethodPaypal', orderId?: string | null, payerId?: string | null, email?: string | null, name?: string | null } | null, sepa?: { __typename?: 'PaymentMethodSepa', accountholderEmail?: string | null, accountholderName?: string | null, countryCode?: string | null, bankAddress?: string | null, bankCode?: string | null, bankName?: string | null, bic?: string | null, last4?: string | null, accountholderAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, trustly?: { __typename?: 'PaymentMethodTrustly', customerId?: string | null } | null, klarna?: { __typename?: 'PaymentMethodKlarna', billingCategory?: BillingCategoryKlarna | null, authPaymentMethod?: AuthPaymentMethodKlarna | null } | null } | null, shippingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, taxId?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, shop?: { __typename?: 'Shop', name?: string | null, country?: string | null } | null, sessionDetails?: { __typename?: 'SessionDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, browserColorDepth?: string | null, browserScreenHeight?: string | null, browserScreenWidth?: string | null, browserTimezoneOffset?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null, nextAction?: { __typename?: 'NextAction', type?: NextActionTypes | null, redirectUrl?: string | null, mustRedirect?: boolean | null } | null } | null };

export type CancelPaymentMutationVariables = Exact<{
  input: CancelPaymentInput;
}>;


export type CancelPaymentMutation = { __typename?: 'Mutation', cancelPayment?: { __typename?: 'Payment', id: string, accountId: string, sequenceId?: string | null, subscriptionId?: string | null, pointOfSaleId?: string | null, masterAccountId?: string | null, createdAt?: any | null, updatedAt?: any | null, amount?: number | null, authorizationCode?: string | null, storeId?: string | null, currency: string, description?: string | null, descriptor?: string | null, livemode?: boolean | null, orderId?: string | null, refundedAmount?: number | null, lastRefundAmount?: number | null, lastRefundReason?: RefundReason | null, cancellationReason?: CancellationReason | null, status: PaymentStatus, statusCode?: string | null, statusMessage?: string | null, billingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, taxId?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, customer?: { __typename?: 'Customer', email?: string | null, name?: string | null, phone?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', method?: PaymentMethods | null, bizum?: { __typename?: 'PaymentMethodBizum', phoneNumber?: string | null, integrationType?: string | null } | null, card?: { __typename?: 'PaymentMethodCard', brand?: CardBrand | null, country?: string | null, type?: CardType | null, threeDSecure?: boolean | null, threeDSecureVersion?: string | null, threeDSecureFlow?: ThreeDSecureFlow | null, threeDSecureStatus?: ThreeDsStatus | null, last4?: string | null, cardholderName?: string | null, cardholderEmail?: string | null, expiration?: any | null, bank?: string | null, tokenizationMethod?: TokenizationMethods | null, srcCorrelationId?: string | null, srciTransactionId?: string | null, srcDpaId?: string | null } | null, cardPresent?: { __typename?: 'PaymentMethodCardPresent', bin?: string | null, brand?: CardBrand | null, cardholderEmail?: string | null, cardholderName?: string | null, country?: string | null, expiration?: any | null, last4?: string | null, type?: CardType | null } | null, mbway?: { __typename?: 'PaymentMethodMBWay', phoneNumber?: string | null } | null, paypal?: { __typename?: 'PaymentMethodPaypal', orderId?: string | null, payerId?: string | null, email?: string | null, name?: string | null } | null, sepa?: { __typename?: 'PaymentMethodSepa', accountholderEmail?: string | null, accountholderName?: string | null, countryCode?: string | null, bankAddress?: string | null, bankCode?: string | null, bankName?: string | null, bic?: string | null, last4?: string | null, accountholderAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, trustly?: { __typename?: 'PaymentMethodTrustly', customerId?: string | null } | null, klarna?: { __typename?: 'PaymentMethodKlarna', billingCategory?: BillingCategoryKlarna | null, authPaymentMethod?: AuthPaymentMethodKlarna | null } | null } | null, shippingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, taxId?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, shop?: { __typename?: 'Shop', name?: string | null, country?: string | null } | null, sessionDetails?: { __typename?: 'SessionDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, browserColorDepth?: string | null, browserScreenHeight?: string | null, browserScreenWidth?: string | null, browserTimezoneOffset?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null, nextAction?: { __typename?: 'NextAction', type?: NextActionTypes | null, redirectUrl?: string | null, mustRedirect?: boolean | null } | null } | null };

export type RefundPaymentMutationVariables = Exact<{
  input: RefundPaymentInput;
}>;


export type RefundPaymentMutation = { __typename?: 'Mutation', refundPayment?: { __typename?: 'Payment', id: string, accountId: string, sequenceId?: string | null, subscriptionId?: string | null, pointOfSaleId?: string | null, masterAccountId?: string | null, createdAt?: any | null, updatedAt?: any | null, amount?: number | null, authorizationCode?: string | null, storeId?: string | null, currency: string, description?: string | null, descriptor?: string | null, livemode?: boolean | null, orderId?: string | null, refundedAmount?: number | null, lastRefundAmount?: number | null, lastRefundReason?: RefundReason | null, cancellationReason?: CancellationReason | null, status: PaymentStatus, statusCode?: string | null, statusMessage?: string | null, billingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, taxId?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, customer?: { __typename?: 'Customer', email?: string | null, name?: string | null, phone?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', method?: PaymentMethods | null, bizum?: { __typename?: 'PaymentMethodBizum', phoneNumber?: string | null, integrationType?: string | null } | null, card?: { __typename?: 'PaymentMethodCard', brand?: CardBrand | null, country?: string | null, type?: CardType | null, threeDSecure?: boolean | null, threeDSecureVersion?: string | null, threeDSecureFlow?: ThreeDSecureFlow | null, threeDSecureStatus?: ThreeDsStatus | null, last4?: string | null, cardholderName?: string | null, cardholderEmail?: string | null, expiration?: any | null, bank?: string | null, tokenizationMethod?: TokenizationMethods | null, srcCorrelationId?: string | null, srciTransactionId?: string | null, srcDpaId?: string | null } | null, cardPresent?: { __typename?: 'PaymentMethodCardPresent', bin?: string | null, brand?: CardBrand | null, cardholderEmail?: string | null, cardholderName?: string | null, country?: string | null, expiration?: any | null, last4?: string | null, type?: CardType | null } | null, mbway?: { __typename?: 'PaymentMethodMBWay', phoneNumber?: string | null } | null, paypal?: { __typename?: 'PaymentMethodPaypal', orderId?: string | null, payerId?: string | null, email?: string | null, name?: string | null } | null, sepa?: { __typename?: 'PaymentMethodSepa', accountholderEmail?: string | null, accountholderName?: string | null, countryCode?: string | null, bankAddress?: string | null, bankCode?: string | null, bankName?: string | null, bic?: string | null, last4?: string | null, accountholderAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, trustly?: { __typename?: 'PaymentMethodTrustly', customerId?: string | null } | null, klarna?: { __typename?: 'PaymentMethodKlarna', billingCategory?: BillingCategoryKlarna | null, authPaymentMethod?: AuthPaymentMethodKlarna | null } | null } | null, shippingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, taxId?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, shop?: { __typename?: 'Shop', name?: string | null, country?: string | null } | null, sessionDetails?: { __typename?: 'SessionDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, browserColorDepth?: string | null, browserScreenHeight?: string | null, browserScreenWidth?: string | null, browserTimezoneOffset?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null, nextAction?: { __typename?: 'NextAction', type?: NextActionTypes | null, redirectUrl?: string | null, mustRedirect?: boolean | null } | null } | null };

export type SendPaymentReceiptMutationVariables = Exact<{
  input: SendPaymentMessageInput;
}>;


export type SendPaymentReceiptMutation = { __typename?: 'Mutation', sendPaymentReceipt?: { __typename?: 'Payment', id: string, accountId: string, sequenceId?: string | null, subscriptionId?: string | null, pointOfSaleId?: string | null, masterAccountId?: string | null, createdAt?: any | null, updatedAt?: any | null, amount?: number | null, authorizationCode?: string | null, storeId?: string | null, currency: string, description?: string | null, descriptor?: string | null, livemode?: boolean | null, orderId?: string | null, refundedAmount?: number | null, lastRefundAmount?: number | null, lastRefundReason?: RefundReason | null, cancellationReason?: CancellationReason | null, status: PaymentStatus, statusCode?: string | null, statusMessage?: string | null, billingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, taxId?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, customer?: { __typename?: 'Customer', email?: string | null, name?: string | null, phone?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', method?: PaymentMethods | null, bizum?: { __typename?: 'PaymentMethodBizum', phoneNumber?: string | null, integrationType?: string | null } | null, card?: { __typename?: 'PaymentMethodCard', brand?: CardBrand | null, country?: string | null, type?: CardType | null, threeDSecure?: boolean | null, threeDSecureVersion?: string | null, threeDSecureFlow?: ThreeDSecureFlow | null, threeDSecureStatus?: ThreeDsStatus | null, last4?: string | null, cardholderName?: string | null, cardholderEmail?: string | null, expiration?: any | null, bank?: string | null, tokenizationMethod?: TokenizationMethods | null, srcCorrelationId?: string | null, srciTransactionId?: string | null, srcDpaId?: string | null } | null, cardPresent?: { __typename?: 'PaymentMethodCardPresent', bin?: string | null, brand?: CardBrand | null, cardholderEmail?: string | null, cardholderName?: string | null, country?: string | null, expiration?: any | null, last4?: string | null, type?: CardType | null } | null, mbway?: { __typename?: 'PaymentMethodMBWay', phoneNumber?: string | null } | null, paypal?: { __typename?: 'PaymentMethodPaypal', orderId?: string | null, payerId?: string | null, email?: string | null, name?: string | null } | null, sepa?: { __typename?: 'PaymentMethodSepa', accountholderEmail?: string | null, accountholderName?: string | null, countryCode?: string | null, bankAddress?: string | null, bankCode?: string | null, bankName?: string | null, bic?: string | null, last4?: string | null, accountholderAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, trustly?: { __typename?: 'PaymentMethodTrustly', customerId?: string | null } | null, klarna?: { __typename?: 'PaymentMethodKlarna', billingCategory?: BillingCategoryKlarna | null, authPaymentMethod?: AuthPaymentMethodKlarna | null } | null } | null, shippingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, taxId?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, shop?: { __typename?: 'Shop', name?: string | null, country?: string | null } | null, sessionDetails?: { __typename?: 'SessionDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, browserColorDepth?: string | null, browserScreenHeight?: string | null, browserScreenWidth?: string | null, browserTimezoneOffset?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null, nextAction?: { __typename?: 'NextAction', type?: NextActionTypes | null, redirectUrl?: string | null, mustRedirect?: boolean | null } | null } | null };

export type DeleteDocumentMutationVariables = Exact<{
  id: Scalars['ID'];
  accountId: Scalars['ID'];
}>;


export type DeleteDocumentMutation = { __typename?: 'Mutation', deleteDocument: boolean };

export type DownloadDocumentMutationVariables = Exact<{
  id: Scalars['ID'];
  accountId: Scalars['ID'];
}>;


export type DownloadDocumentMutation = { __typename?: 'Mutation', downloadDocument: { __typename?: 'DownloadFile', downloadUrl: string, expiresAt: any } };

export type UpdateDocumentMutationVariables = Exact<{
  input: UpdateDocumentInput;
}>;


export type UpdateDocumentMutation = { __typename?: 'Mutation', updateDocument: { __typename?: 'Document', id: string, accountId: string, type: DocumentType, status: DocumentStatus, statusMessage?: string | null, statusCode?: string | null, contentType?: string | null, createdAt: string, updatedAt?: string | null, name?: string | null, note?: string | null, internal?: boolean | null, metadata?: Array<{ __typename?: 'DocumentMetadataItem', key: string, value?: Array<string> | null }> | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null } };

export type UploadDocumentMutationVariables = Exact<{
  id: Scalars['ID'];
  contentType: Scalars['String'];
  accountId: Scalars['ID'];
}>;


export type UploadDocumentMutation = { __typename?: 'Mutation', uploadDocument: { __typename?: 'UploadFile', uploadUrl: string, expiresAt: any } };

export type CreateDocumentMutationVariables = Exact<{
  input: CreateDocumentInput;
}>;


export type CreateDocumentMutation = { __typename?: 'Mutation', createDocument: { __typename?: 'Document', id: string, accountId: string, type: DocumentType, status: DocumentStatus, statusMessage?: string | null, statusCode?: string | null, contentType?: string | null, createdAt: string, updatedAt?: string | null, name?: string | null, note?: string | null, internal?: boolean | null, metadata?: Array<{ __typename?: 'DocumentMetadataItem', key: string, value?: Array<string> | null }> | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null } };

export type CancelSubscriptionMutationVariables = Exact<{
  input: CancelSubscriptionInput;
}>;


export type CancelSubscriptionMutation = { __typename?: 'Mutation', cancelSubscription?: { __typename?: 'Subscription', id: string, accountId: string, livemode: boolean, amount: number, currency?: Currencies | null, description?: string | null, planVariantId?: string | null, productId?: string | null, cancelAtPeriodEnd?: boolean | null, pauseIntervalCount?: number | null, pauseAtPeriodEnd?: boolean | null, currentPeriodStart?: number | null, currentPeriodEnd?: number | null, trialPeriodDays?: number | null, trialPeriodEnd?: number | null, customerId?: string | null, defaultTokenId?: string | null, sequenceId?: string | null, lastInvoiceId?: string | null, lastOrderId?: string | null, nextPaymentAt?: number | null, createdAt?: number | null, updatedAt?: number | null, interval: Interval, intervalCount: number, retryCount?: number | null, status: SubscriptionStatus, callbackUrl?: string | null, paymentCallbackUrl?: string | null, storeId?: string | null, masterAccountId?: string | null, customer?: { __typename?: 'Customer', email?: string | null, name?: string | null, phone?: string | null } | null, billingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, shippingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, lastPayment?: { __typename?: 'LastPayment', id: string, status: PaymentStatus, statusMessage?: string | null, statusCode?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', method?: PaymentMethods | null, bizum?: { __typename?: 'PaymentMethodBizum', phoneNumber?: string | null, integrationType?: string | null } | null, card?: { __typename?: 'PaymentMethodCard', brand?: CardBrand | null, country?: string | null, type?: CardType | null, threeDSecure?: boolean | null, threeDSecureVersion?: string | null, threeDSecureFlow?: ThreeDSecureFlow | null, threeDSecureStatus?: ThreeDsStatus | null, last4?: string | null, cardholderName?: string | null, cardholderEmail?: string | null, expiration?: any | null, bank?: string | null, tokenizationMethod?: TokenizationMethods | null, srcCorrelationId?: string | null, srciTransactionId?: string | null, srcDpaId?: string | null } | null, cardPresent?: { __typename?: 'PaymentMethodCardPresent', bin?: string | null, brand?: CardBrand | null, cardholderEmail?: string | null, cardholderName?: string | null, country?: string | null, expiration?: any | null, last4?: string | null, type?: CardType | null } | null, mbway?: { __typename?: 'PaymentMethodMBWay', phoneNumber?: string | null } | null, paypal?: { __typename?: 'PaymentMethodPaypal', orderId?: string | null, payerId?: string | null, email?: string | null, name?: string | null } | null, sepa?: { __typename?: 'PaymentMethodSepa', accountholderEmail?: string | null, accountholderName?: string | null, countryCode?: string | null, bankAddress?: string | null, bankCode?: string | null, bankName?: string | null, bic?: string | null, last4?: string | null, accountholderAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, trustly?: { __typename?: 'PaymentMethodTrustly', customerId?: string | null } | null, klarna?: { __typename?: 'PaymentMethodKlarna', billingCategory?: BillingCategoryKlarna | null, authPaymentMethod?: AuthPaymentMethodKlarna | null } | null } | null, metadata?: Array<{ __typename?: 'KeyValueItem', key: string, value?: string | null }> | null, sessionDetails?: { __typename?: 'SessionDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, browserColorDepth?: string | null, browserScreenHeight?: string | null, browserScreenWidth?: string | null, browserTimezoneOffset?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null } | null };

export type PauseSubscriptionMutationVariables = Exact<{
  input: PauseSubscriptionInput;
}>;


export type PauseSubscriptionMutation = { __typename?: 'Mutation', pauseSubscription?: { __typename?: 'Subscription', id: string, accountId: string, livemode: boolean, amount: number, currency?: Currencies | null, description?: string | null, planVariantId?: string | null, productId?: string | null, cancelAtPeriodEnd?: boolean | null, pauseIntervalCount?: number | null, pauseAtPeriodEnd?: boolean | null, currentPeriodStart?: number | null, currentPeriodEnd?: number | null, trialPeriodDays?: number | null, trialPeriodEnd?: number | null, customerId?: string | null, defaultTokenId?: string | null, sequenceId?: string | null, lastInvoiceId?: string | null, lastOrderId?: string | null, nextPaymentAt?: number | null, createdAt?: number | null, updatedAt?: number | null, interval: Interval, intervalCount: number, retryCount?: number | null, status: SubscriptionStatus, callbackUrl?: string | null, paymentCallbackUrl?: string | null, storeId?: string | null, masterAccountId?: string | null, customer?: { __typename?: 'Customer', email?: string | null, name?: string | null, phone?: string | null } | null, billingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, shippingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, lastPayment?: { __typename?: 'LastPayment', id: string, status: PaymentStatus, statusMessage?: string | null, statusCode?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', method?: PaymentMethods | null, bizum?: { __typename?: 'PaymentMethodBizum', phoneNumber?: string | null, integrationType?: string | null } | null, card?: { __typename?: 'PaymentMethodCard', brand?: CardBrand | null, country?: string | null, type?: CardType | null, threeDSecure?: boolean | null, threeDSecureVersion?: string | null, threeDSecureFlow?: ThreeDSecureFlow | null, threeDSecureStatus?: ThreeDsStatus | null, last4?: string | null, cardholderName?: string | null, cardholderEmail?: string | null, expiration?: any | null, bank?: string | null, tokenizationMethod?: TokenizationMethods | null, srcCorrelationId?: string | null, srciTransactionId?: string | null, srcDpaId?: string | null } | null, cardPresent?: { __typename?: 'PaymentMethodCardPresent', bin?: string | null, brand?: CardBrand | null, cardholderEmail?: string | null, cardholderName?: string | null, country?: string | null, expiration?: any | null, last4?: string | null, type?: CardType | null } | null, mbway?: { __typename?: 'PaymentMethodMBWay', phoneNumber?: string | null } | null, paypal?: { __typename?: 'PaymentMethodPaypal', orderId?: string | null, payerId?: string | null, email?: string | null, name?: string | null } | null, sepa?: { __typename?: 'PaymentMethodSepa', accountholderEmail?: string | null, accountholderName?: string | null, countryCode?: string | null, bankAddress?: string | null, bankCode?: string | null, bankName?: string | null, bic?: string | null, last4?: string | null, accountholderAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, trustly?: { __typename?: 'PaymentMethodTrustly', customerId?: string | null } | null, klarna?: { __typename?: 'PaymentMethodKlarna', billingCategory?: BillingCategoryKlarna | null, authPaymentMethod?: AuthPaymentMethodKlarna | null } | null } | null, metadata?: Array<{ __typename?: 'KeyValueItem', key: string, value?: string | null }> | null, sessionDetails?: { __typename?: 'SessionDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, browserColorDepth?: string | null, browserScreenHeight?: string | null, browserScreenWidth?: string | null, browserTimezoneOffset?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null } | null };

export type ResumeSubscriptionMutationVariables = Exact<{
  input: ResumeSubscriptionInput;
}>;


export type ResumeSubscriptionMutation = { __typename?: 'Mutation', resumeSubscription?: { __typename?: 'Subscription', id: string, accountId: string, livemode: boolean, amount: number, currency?: Currencies | null, description?: string | null, planVariantId?: string | null, productId?: string | null, cancelAtPeriodEnd?: boolean | null, pauseIntervalCount?: number | null, pauseAtPeriodEnd?: boolean | null, currentPeriodStart?: number | null, currentPeriodEnd?: number | null, trialPeriodDays?: number | null, trialPeriodEnd?: number | null, customerId?: string | null, defaultTokenId?: string | null, sequenceId?: string | null, lastInvoiceId?: string | null, lastOrderId?: string | null, nextPaymentAt?: number | null, createdAt?: number | null, updatedAt?: number | null, interval: Interval, intervalCount: number, retryCount?: number | null, status: SubscriptionStatus, callbackUrl?: string | null, paymentCallbackUrl?: string | null, storeId?: string | null, masterAccountId?: string | null, customer?: { __typename?: 'Customer', email?: string | null, name?: string | null, phone?: string | null } | null, billingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, shippingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, lastPayment?: { __typename?: 'LastPayment', id: string, status: PaymentStatus, statusMessage?: string | null, statusCode?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', method?: PaymentMethods | null, bizum?: { __typename?: 'PaymentMethodBizum', phoneNumber?: string | null, integrationType?: string | null } | null, card?: { __typename?: 'PaymentMethodCard', brand?: CardBrand | null, country?: string | null, type?: CardType | null, threeDSecure?: boolean | null, threeDSecureVersion?: string | null, threeDSecureFlow?: ThreeDSecureFlow | null, threeDSecureStatus?: ThreeDsStatus | null, last4?: string | null, cardholderName?: string | null, cardholderEmail?: string | null, expiration?: any | null, bank?: string | null, tokenizationMethod?: TokenizationMethods | null, srcCorrelationId?: string | null, srciTransactionId?: string | null, srcDpaId?: string | null } | null, cardPresent?: { __typename?: 'PaymentMethodCardPresent', bin?: string | null, brand?: CardBrand | null, cardholderEmail?: string | null, cardholderName?: string | null, country?: string | null, expiration?: any | null, last4?: string | null, type?: CardType | null } | null, mbway?: { __typename?: 'PaymentMethodMBWay', phoneNumber?: string | null } | null, paypal?: { __typename?: 'PaymentMethodPaypal', orderId?: string | null, payerId?: string | null, email?: string | null, name?: string | null } | null, sepa?: { __typename?: 'PaymentMethodSepa', accountholderEmail?: string | null, accountholderName?: string | null, countryCode?: string | null, bankAddress?: string | null, bankCode?: string | null, bankName?: string | null, bic?: string | null, last4?: string | null, accountholderAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, trustly?: { __typename?: 'PaymentMethodTrustly', customerId?: string | null } | null, klarna?: { __typename?: 'PaymentMethodKlarna', billingCategory?: BillingCategoryKlarna | null, authPaymentMethod?: AuthPaymentMethodKlarna | null } | null } | null, metadata?: Array<{ __typename?: 'KeyValueItem', key: string, value?: string | null }> | null, sessionDetails?: { __typename?: 'SessionDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, browserColorDepth?: string | null, browserScreenHeight?: string | null, browserScreenWidth?: string | null, browserTimezoneOffset?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null } | null };

export type UpdateSubscriptionMutationVariables = Exact<{
  input: UpdateSubscriptionInput;
}>;


export type UpdateSubscriptionMutation = { __typename?: 'Mutation', updateSubscription?: { __typename?: 'Subscription', id: string, accountId: string, livemode: boolean, amount: number, currency?: Currencies | null, description?: string | null, planVariantId?: string | null, productId?: string | null, cancelAtPeriodEnd?: boolean | null, pauseIntervalCount?: number | null, pauseAtPeriodEnd?: boolean | null, currentPeriodStart?: number | null, currentPeriodEnd?: number | null, trialPeriodDays?: number | null, trialPeriodEnd?: number | null, customerId?: string | null, defaultTokenId?: string | null, sequenceId?: string | null, lastInvoiceId?: string | null, lastOrderId?: string | null, nextPaymentAt?: number | null, createdAt?: number | null, updatedAt?: number | null, interval: Interval, intervalCount: number, retryCount?: number | null, status: SubscriptionStatus, callbackUrl?: string | null, paymentCallbackUrl?: string | null, storeId?: string | null, masterAccountId?: string | null, customer?: { __typename?: 'Customer', email?: string | null, name?: string | null, phone?: string | null } | null, billingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, shippingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, lastPayment?: { __typename?: 'LastPayment', id: string, status: PaymentStatus, statusMessage?: string | null, statusCode?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', method?: PaymentMethods | null, bizum?: { __typename?: 'PaymentMethodBizum', phoneNumber?: string | null, integrationType?: string | null } | null, card?: { __typename?: 'PaymentMethodCard', brand?: CardBrand | null, country?: string | null, type?: CardType | null, threeDSecure?: boolean | null, threeDSecureVersion?: string | null, threeDSecureFlow?: ThreeDSecureFlow | null, threeDSecureStatus?: ThreeDsStatus | null, last4?: string | null, cardholderName?: string | null, cardholderEmail?: string | null, expiration?: any | null, bank?: string | null, tokenizationMethod?: TokenizationMethods | null, srcCorrelationId?: string | null, srciTransactionId?: string | null, srcDpaId?: string | null } | null, cardPresent?: { __typename?: 'PaymentMethodCardPresent', bin?: string | null, brand?: CardBrand | null, cardholderEmail?: string | null, cardholderName?: string | null, country?: string | null, expiration?: any | null, last4?: string | null, type?: CardType | null } | null, mbway?: { __typename?: 'PaymentMethodMBWay', phoneNumber?: string | null } | null, paypal?: { __typename?: 'PaymentMethodPaypal', orderId?: string | null, payerId?: string | null, email?: string | null, name?: string | null } | null, sepa?: { __typename?: 'PaymentMethodSepa', accountholderEmail?: string | null, accountholderName?: string | null, countryCode?: string | null, bankAddress?: string | null, bankCode?: string | null, bankName?: string | null, bic?: string | null, last4?: string | null, accountholderAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, trustly?: { __typename?: 'PaymentMethodTrustly', customerId?: string | null } | null, klarna?: { __typename?: 'PaymentMethodKlarna', billingCategory?: BillingCategoryKlarna | null, authPaymentMethod?: AuthPaymentMethodKlarna | null } | null } | null, metadata?: Array<{ __typename?: 'KeyValueItem', key: string, value?: string | null }> | null, sessionDetails?: { __typename?: 'SessionDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, browserColorDepth?: string | null, browserScreenHeight?: string | null, browserScreenWidth?: string | null, browserTimezoneOffset?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null } | null };

export type ActivateSubscriptionMutationVariables = Exact<{
  input: ActivateSubscriptionInput;
}>;


export type ActivateSubscriptionMutation = { __typename?: 'Mutation', activateSubscription?: { __typename?: 'Payment', id: string, accountId: string, sequenceId?: string | null, subscriptionId?: string | null, pointOfSaleId?: string | null, masterAccountId?: string | null, createdAt?: any | null, updatedAt?: any | null, amount?: number | null, authorizationCode?: string | null, storeId?: string | null, currency: string, description?: string | null, descriptor?: string | null, livemode?: boolean | null, orderId?: string | null, refundedAmount?: number | null, lastRefundAmount?: number | null, lastRefundReason?: RefundReason | null, cancellationReason?: CancellationReason | null, status: PaymentStatus, statusCode?: string | null, statusMessage?: string | null, billingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, taxId?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, customer?: { __typename?: 'Customer', email?: string | null, name?: string | null, phone?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', method?: PaymentMethods | null, bizum?: { __typename?: 'PaymentMethodBizum', phoneNumber?: string | null, integrationType?: string | null } | null, card?: { __typename?: 'PaymentMethodCard', brand?: CardBrand | null, country?: string | null, type?: CardType | null, threeDSecure?: boolean | null, threeDSecureVersion?: string | null, threeDSecureFlow?: ThreeDSecureFlow | null, threeDSecureStatus?: ThreeDsStatus | null, last4?: string | null, cardholderName?: string | null, cardholderEmail?: string | null, expiration?: any | null, bank?: string | null, tokenizationMethod?: TokenizationMethods | null, srcCorrelationId?: string | null, srciTransactionId?: string | null, srcDpaId?: string | null } | null, cardPresent?: { __typename?: 'PaymentMethodCardPresent', bin?: string | null, brand?: CardBrand | null, cardholderEmail?: string | null, cardholderName?: string | null, country?: string | null, expiration?: any | null, last4?: string | null, type?: CardType | null } | null, mbway?: { __typename?: 'PaymentMethodMBWay', phoneNumber?: string | null } | null, paypal?: { __typename?: 'PaymentMethodPaypal', orderId?: string | null, payerId?: string | null, email?: string | null, name?: string | null } | null, sepa?: { __typename?: 'PaymentMethodSepa', accountholderEmail?: string | null, accountholderName?: string | null, countryCode?: string | null, bankAddress?: string | null, bankCode?: string | null, bankName?: string | null, bic?: string | null, last4?: string | null, accountholderAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, trustly?: { __typename?: 'PaymentMethodTrustly', customerId?: string | null } | null, klarna?: { __typename?: 'PaymentMethodKlarna', billingCategory?: BillingCategoryKlarna | null, authPaymentMethod?: AuthPaymentMethodKlarna | null } | null } | null, shippingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, taxId?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, shop?: { __typename?: 'Shop', name?: string | null, country?: string | null } | null, sessionDetails?: { __typename?: 'SessionDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, browserColorDepth?: string | null, browserScreenHeight?: string | null, browserScreenWidth?: string | null, browserTimezoneOffset?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null, nextAction?: { __typename?: 'NextAction', type?: NextActionTypes | null, redirectUrl?: string | null, mustRedirect?: boolean | null } | null } | null };

export type CreateSubscriptionMutationVariables = Exact<{
  input: CreateSubscriptionInput;
}>;


export type CreateSubscriptionMutation = { __typename?: 'Mutation', createSubscription?: { __typename?: 'Subscription', id: string, accountId: string, livemode: boolean, amount: number, currency?: Currencies | null, description?: string | null, planVariantId?: string | null, productId?: string | null, cancelAtPeriodEnd?: boolean | null, pauseIntervalCount?: number | null, pauseAtPeriodEnd?: boolean | null, currentPeriodStart?: number | null, currentPeriodEnd?: number | null, trialPeriodDays?: number | null, trialPeriodEnd?: number | null, customerId?: string | null, defaultTokenId?: string | null, sequenceId?: string | null, lastInvoiceId?: string | null, lastOrderId?: string | null, nextPaymentAt?: number | null, createdAt?: number | null, updatedAt?: number | null, interval: Interval, intervalCount: number, retryCount?: number | null, status: SubscriptionStatus, callbackUrl?: string | null, paymentCallbackUrl?: string | null, storeId?: string | null, masterAccountId?: string | null, customer?: { __typename?: 'Customer', email?: string | null, name?: string | null, phone?: string | null } | null, billingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, shippingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, lastPayment?: { __typename?: 'LastPayment', id: string, status: PaymentStatus, statusMessage?: string | null, statusCode?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', method?: PaymentMethods | null, bizum?: { __typename?: 'PaymentMethodBizum', phoneNumber?: string | null, integrationType?: string | null } | null, card?: { __typename?: 'PaymentMethodCard', brand?: CardBrand | null, country?: string | null, type?: CardType | null, threeDSecure?: boolean | null, threeDSecureVersion?: string | null, threeDSecureFlow?: ThreeDSecureFlow | null, threeDSecureStatus?: ThreeDsStatus | null, last4?: string | null, cardholderName?: string | null, cardholderEmail?: string | null, expiration?: any | null, bank?: string | null, tokenizationMethod?: TokenizationMethods | null, srcCorrelationId?: string | null, srciTransactionId?: string | null, srcDpaId?: string | null } | null, cardPresent?: { __typename?: 'PaymentMethodCardPresent', bin?: string | null, brand?: CardBrand | null, cardholderEmail?: string | null, cardholderName?: string | null, country?: string | null, expiration?: any | null, last4?: string | null, type?: CardType | null } | null, mbway?: { __typename?: 'PaymentMethodMBWay', phoneNumber?: string | null } | null, paypal?: { __typename?: 'PaymentMethodPaypal', orderId?: string | null, payerId?: string | null, email?: string | null, name?: string | null } | null, sepa?: { __typename?: 'PaymentMethodSepa', accountholderEmail?: string | null, accountholderName?: string | null, countryCode?: string | null, bankAddress?: string | null, bankCode?: string | null, bankName?: string | null, bic?: string | null, last4?: string | null, accountholderAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, trustly?: { __typename?: 'PaymentMethodTrustly', customerId?: string | null } | null, klarna?: { __typename?: 'PaymentMethodKlarna', billingCategory?: BillingCategoryKlarna | null, authPaymentMethod?: AuthPaymentMethodKlarna | null } | null } | null, metadata?: Array<{ __typename?: 'KeyValueItem', key: string, value?: string | null }> | null, sessionDetails?: { __typename?: 'SessionDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, browserColorDepth?: string | null, browserScreenHeight?: string | null, browserScreenWidth?: string | null, browserTimezoneOffset?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null } | null };

export type SendSubscriptionLinkMutationVariables = Exact<{
  input: SendSubscriptionMessageInput;
}>;


export type SendSubscriptionLinkMutation = { __typename?: 'Mutation', sendSubscriptionLink?: { __typename?: 'Subscription', id: string, accountId: string, livemode: boolean, amount: number, currency?: Currencies | null, description?: string | null, planVariantId?: string | null, productId?: string | null, cancelAtPeriodEnd?: boolean | null, pauseIntervalCount?: number | null, pauseAtPeriodEnd?: boolean | null, currentPeriodStart?: number | null, currentPeriodEnd?: number | null, trialPeriodDays?: number | null, trialPeriodEnd?: number | null, customerId?: string | null, defaultTokenId?: string | null, sequenceId?: string | null, lastInvoiceId?: string | null, lastOrderId?: string | null, nextPaymentAt?: number | null, createdAt?: number | null, updatedAt?: number | null, interval: Interval, intervalCount: number, retryCount?: number | null, status: SubscriptionStatus, callbackUrl?: string | null, paymentCallbackUrl?: string | null, storeId?: string | null, masterAccountId?: string | null, customer?: { __typename?: 'Customer', email?: string | null, name?: string | null, phone?: string | null } | null, billingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, shippingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, lastPayment?: { __typename?: 'LastPayment', id: string, status: PaymentStatus, statusMessage?: string | null, statusCode?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', method?: PaymentMethods | null, bizum?: { __typename?: 'PaymentMethodBizum', phoneNumber?: string | null, integrationType?: string | null } | null, card?: { __typename?: 'PaymentMethodCard', brand?: CardBrand | null, country?: string | null, type?: CardType | null, threeDSecure?: boolean | null, threeDSecureVersion?: string | null, threeDSecureFlow?: ThreeDSecureFlow | null, threeDSecureStatus?: ThreeDsStatus | null, last4?: string | null, cardholderName?: string | null, cardholderEmail?: string | null, expiration?: any | null, bank?: string | null, tokenizationMethod?: TokenizationMethods | null, srcCorrelationId?: string | null, srciTransactionId?: string | null, srcDpaId?: string | null } | null, cardPresent?: { __typename?: 'PaymentMethodCardPresent', bin?: string | null, brand?: CardBrand | null, cardholderEmail?: string | null, cardholderName?: string | null, country?: string | null, expiration?: any | null, last4?: string | null, type?: CardType | null } | null, mbway?: { __typename?: 'PaymentMethodMBWay', phoneNumber?: string | null } | null, paypal?: { __typename?: 'PaymentMethodPaypal', orderId?: string | null, payerId?: string | null, email?: string | null, name?: string | null } | null, sepa?: { __typename?: 'PaymentMethodSepa', accountholderEmail?: string | null, accountholderName?: string | null, countryCode?: string | null, bankAddress?: string | null, bankCode?: string | null, bankName?: string | null, bic?: string | null, last4?: string | null, accountholderAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, trustly?: { __typename?: 'PaymentMethodTrustly', customerId?: string | null } | null, klarna?: { __typename?: 'PaymentMethodKlarna', billingCategory?: BillingCategoryKlarna | null, authPaymentMethod?: AuthPaymentMethodKlarna | null } | null } | null, metadata?: Array<{ __typename?: 'KeyValueItem', key: string, value?: string | null }> | null, sessionDetails?: { __typename?: 'SessionDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, browserColorDepth?: string | null, browserScreenHeight?: string | null, browserScreenWidth?: string | null, browserTimezoneOffset?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null } | null };

export type SendSubscriptionStatusMutationVariables = Exact<{
  input: SendSubscriptionMessageInput;
}>;


export type SendSubscriptionStatusMutation = { __typename?: 'Mutation', sendSubscriptionStatus?: { __typename?: 'Subscription', id: string, accountId: string, livemode: boolean, amount: number, currency?: Currencies | null, description?: string | null, planVariantId?: string | null, productId?: string | null, cancelAtPeriodEnd?: boolean | null, pauseIntervalCount?: number | null, pauseAtPeriodEnd?: boolean | null, currentPeriodStart?: number | null, currentPeriodEnd?: number | null, trialPeriodDays?: number | null, trialPeriodEnd?: number | null, customerId?: string | null, defaultTokenId?: string | null, sequenceId?: string | null, lastInvoiceId?: string | null, lastOrderId?: string | null, nextPaymentAt?: number | null, createdAt?: number | null, updatedAt?: number | null, interval: Interval, intervalCount: number, retryCount?: number | null, status: SubscriptionStatus, callbackUrl?: string | null, paymentCallbackUrl?: string | null, storeId?: string | null, masterAccountId?: string | null, customer?: { __typename?: 'Customer', email?: string | null, name?: string | null, phone?: string | null } | null, billingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, shippingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, lastPayment?: { __typename?: 'LastPayment', id: string, status: PaymentStatus, statusMessage?: string | null, statusCode?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', method?: PaymentMethods | null, bizum?: { __typename?: 'PaymentMethodBizum', phoneNumber?: string | null, integrationType?: string | null } | null, card?: { __typename?: 'PaymentMethodCard', brand?: CardBrand | null, country?: string | null, type?: CardType | null, threeDSecure?: boolean | null, threeDSecureVersion?: string | null, threeDSecureFlow?: ThreeDSecureFlow | null, threeDSecureStatus?: ThreeDsStatus | null, last4?: string | null, cardholderName?: string | null, cardholderEmail?: string | null, expiration?: any | null, bank?: string | null, tokenizationMethod?: TokenizationMethods | null, srcCorrelationId?: string | null, srciTransactionId?: string | null, srcDpaId?: string | null } | null, cardPresent?: { __typename?: 'PaymentMethodCardPresent', bin?: string | null, brand?: CardBrand | null, cardholderEmail?: string | null, cardholderName?: string | null, country?: string | null, expiration?: any | null, last4?: string | null, type?: CardType | null } | null, mbway?: { __typename?: 'PaymentMethodMBWay', phoneNumber?: string | null } | null, paypal?: { __typename?: 'PaymentMethodPaypal', orderId?: string | null, payerId?: string | null, email?: string | null, name?: string | null } | null, sepa?: { __typename?: 'PaymentMethodSepa', accountholderEmail?: string | null, accountholderName?: string | null, countryCode?: string | null, bankAddress?: string | null, bankCode?: string | null, bankName?: string | null, bic?: string | null, last4?: string | null, accountholderAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, trustly?: { __typename?: 'PaymentMethodTrustly', customerId?: string | null } | null, klarna?: { __typename?: 'PaymentMethodKlarna', billingCategory?: BillingCategoryKlarna | null, authPaymentMethod?: AuthPaymentMethodKlarna | null } | null } | null, metadata?: Array<{ __typename?: 'KeyValueItem', key: string, value?: string | null }> | null, sessionDetails?: { __typename?: 'SessionDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, browserColorDepth?: string | null, browserScreenHeight?: string | null, browserScreenWidth?: string | null, browserTimezoneOffset?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null } | null };

export type StartCompanyLookupMutationVariables = Exact<{
  documentNumber: Scalars['String'];
  accountId: Scalars['ID'];
}>;


export type StartCompanyLookupMutation = { __typename?: 'Mutation', startCompanyLookup: { __typename?: 'Account', id: string, refAccountId?: string | null, testAccountId?: string | null, prodAccountId?: string | null, name?: string | null, status: AccountStatus, note?: string | null, userNote?: string | null, partner?: Partner | null, acquirer?: Acquirer | null, adminEmail?: string | null, allowCreateApiKey?: boolean | null, allowRefunds?: boolean | null, defaultCurrency?: Currencies | null, defaultTransactionType?: TransactionTypes | null, referralCode?: string | null, promoCode?: string | null, language?: string | null, reviewConfirmed?: boolean | null, billingEmail?: string | null, billingPlan?: BillingPlans | null, riskScore?: number | null, riskProfile?: RiskProfile | null, riskProcessing?: boolean | null, riskProfileNote?: string | null, riskIgnoredKeywords?: Array<string> | null, riskUpdatedAt?: string | null, iban?: string | null, dynamicBilling?: boolean | null, test?: boolean | null, secret?: string | null, apiKey?: string | null, customDomain?: string | null, createdAt?: string | null, updatedAt?: string | null, deletedAt?: string | null, approvedAt?: string | null, rejectedAt?: string | null, activatedAt?: string | null, approvalRequestedAt?: string | null, suspendedAt?: string | null, dataUpdatedAt?: string | null, accountExecutive?: SalesExecutive | null, billingVatPercent?: number | null, churned?: boolean | null, blocked?: boolean | null, statusReason?: StatusReason | null, statusNote?: string | null, churnReason?: ChurnReason | null, churnReasonOption?: string | null, churnNote?: string | null, previewFeatures?: Array<string> | null, tags?: Array<string> | null, masterAccountId?: string | null, accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null, customAccountInvoiceNotes?: Array<string> | null, groupInvoicesByStore?: boolean | null, contactPerson?: { __typename?: 'ContactPerson', name: string, email: string, phone?: string | null } | null, branding?: { __typename?: 'AccountBranding', accentColor?: string | null, bgColor?: string | null, logoUrl?: string | null, iconUrl?: string | null } | null, tokenizationMethods?: { __typename?: 'AccountTokenizationMethods', googlePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, applePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, clickToPay?: { __typename?: 'AccountTokenizationMethodsClickToPayItem', enabled?: boolean | null } | null } | null, notifications?: { __typename?: 'AccountNotifications', emailCustomerOnRefund?: boolean | null, emailCustomerOnSuccess?: boolean | null, emailAdminOnSuccess?: boolean | null, emailCustomerOnSubscription?: boolean | null, emailAdminOnSubscription?: boolean | null, emailOnAccountInvoice?: boolean | null } | null, fees?: { __typename?: 'AccountFees', highRiskFee?: number | null, dailyExtraSeatsFee?: number | null, dailyPlatformFee?: number | null, weeklyCustomDomainFee?: number | null, steps?: Array<{ __typename?: 'AccountSteps', trxFee: number, bizumTrxFee?: number | null, bizumTrxFlatFee?: number | null, trxFlatFee: number, from: number }> | null, extra?: Array<{ __typename?: 'AccountExtraFee', name: string, amount: number, type: AccountExtraFeeType, masterAccountFee?: boolean | null, paymentMethods?: Array<PaymentMethods> | null }> | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null, riskScore?: number | null }> | null, business?: { __typename?: 'BusinessData', country?: string | null, legalForm?: LegalForm | null, legalName?: string | null, companyName?: string | null, mcc?: string | null, documentNumber?: string | null, status?: BusinessStatus | null, email?: string | null, phone?: string | null, website?: string | null, monthlyVolume?: number | null, confirmWebsite?: boolean | null, industry?: Industries | null, servicesDescription?: string | null, confirmServicesDescription?: boolean | null, legalAddress?: string | null, legalDescription?: string | null, creationDate?: string | null, lastUpdateDate?: string | null, startActivityDate?: string | null, capital?: any | null, previousNames?: Array<string | null> | null, verificationAttempts?: number | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, registryRecords?: Array<{ __typename?: 'RegistryRecord', name?: string | null, url?: string | null, province?: string | null, date?: string | null }> | null, positions?: Array<{ __typename?: 'BusinessPosition', fromDate?: string | null, role?: string | null, name?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null } | null, representatives?: Array<{ __typename?: 'Representative', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, documentNumber?: string | null, stocksPercentage?: number | null, gender?: Gender | null, citizenship?: string | null, dateOfBirth?: string | null, nationality?: string | null, yearOfBirth?: string | null, placeOfBirth?: string | null, idSession?: string | null, interventionType?: Array<InterventionType> | null, status?: IdVerificationStatus | null, statusCode?: number | null, hasNoPublicActivity?: boolean | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, document?: { __typename?: 'IdDocument', type?: IdDocumentType | null, number?: string | null, country?: string | null, validFrom?: string | null, validUntil?: string | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null }> | null, payoutTerms?: { __typename?: 'AccountPayoutTerms', iban?: string | null, period?: number | null, firstPeriod?: number | null, reservePercent?: number | null, suspended?: boolean | null, releaseReserve?: boolean | null, settleGross?: boolean | null, bankTransferConceptPrefix?: string | null, settleToStores?: boolean | null } | null, publicBusinessDetails?: { __typename?: 'AccountPublicBusinessDetails', companyName?: string | null, website?: string | null, phone?: string | null, supportWebsite?: string | null, supportPhone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, contract?: { __typename?: 'AccountContract', envelopeId: string, status: ContractStatus, path?: string | null, signedDate?: string | null } | null, upsell?: { __typename?: 'Upsell', executive: SalesExecutive, paymentMethods: Array<PaymentMethods>, date: string, note?: string | null } | null } };

export type CreatePibisiUserMutationVariables = Exact<{
  input?: InputMaybe<CreatePibisiUserInput>;
}>;


export type CreatePibisiUserMutation = { __typename?: 'Mutation', createPibisiUser: { __typename?: 'Account', id: string, refAccountId?: string | null, testAccountId?: string | null, prodAccountId?: string | null, name?: string | null, status: AccountStatus, note?: string | null, userNote?: string | null, partner?: Partner | null, acquirer?: Acquirer | null, adminEmail?: string | null, allowCreateApiKey?: boolean | null, allowRefunds?: boolean | null, defaultCurrency?: Currencies | null, defaultTransactionType?: TransactionTypes | null, referralCode?: string | null, promoCode?: string | null, language?: string | null, reviewConfirmed?: boolean | null, billingEmail?: string | null, billingPlan?: BillingPlans | null, riskScore?: number | null, riskProfile?: RiskProfile | null, riskProcessing?: boolean | null, riskProfileNote?: string | null, riskIgnoredKeywords?: Array<string> | null, riskUpdatedAt?: string | null, iban?: string | null, dynamicBilling?: boolean | null, test?: boolean | null, secret?: string | null, apiKey?: string | null, customDomain?: string | null, createdAt?: string | null, updatedAt?: string | null, deletedAt?: string | null, approvedAt?: string | null, rejectedAt?: string | null, activatedAt?: string | null, approvalRequestedAt?: string | null, suspendedAt?: string | null, dataUpdatedAt?: string | null, accountExecutive?: SalesExecutive | null, billingVatPercent?: number | null, churned?: boolean | null, blocked?: boolean | null, statusReason?: StatusReason | null, statusNote?: string | null, churnReason?: ChurnReason | null, churnReasonOption?: string | null, churnNote?: string | null, previewFeatures?: Array<string> | null, tags?: Array<string> | null, masterAccountId?: string | null, accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null, customAccountInvoiceNotes?: Array<string> | null, groupInvoicesByStore?: boolean | null, contactPerson?: { __typename?: 'ContactPerson', name: string, email: string, phone?: string | null } | null, branding?: { __typename?: 'AccountBranding', accentColor?: string | null, bgColor?: string | null, logoUrl?: string | null, iconUrl?: string | null } | null, tokenizationMethods?: { __typename?: 'AccountTokenizationMethods', googlePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, applePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, clickToPay?: { __typename?: 'AccountTokenizationMethodsClickToPayItem', enabled?: boolean | null } | null } | null, notifications?: { __typename?: 'AccountNotifications', emailCustomerOnRefund?: boolean | null, emailCustomerOnSuccess?: boolean | null, emailAdminOnSuccess?: boolean | null, emailCustomerOnSubscription?: boolean | null, emailAdminOnSubscription?: boolean | null, emailOnAccountInvoice?: boolean | null } | null, fees?: { __typename?: 'AccountFees', highRiskFee?: number | null, dailyExtraSeatsFee?: number | null, dailyPlatformFee?: number | null, weeklyCustomDomainFee?: number | null, steps?: Array<{ __typename?: 'AccountSteps', trxFee: number, bizumTrxFee?: number | null, bizumTrxFlatFee?: number | null, trxFlatFee: number, from: number }> | null, extra?: Array<{ __typename?: 'AccountExtraFee', name: string, amount: number, type: AccountExtraFeeType, masterAccountFee?: boolean | null, paymentMethods?: Array<PaymentMethods> | null }> | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null, riskScore?: number | null }> | null, business?: { __typename?: 'BusinessData', country?: string | null, legalForm?: LegalForm | null, legalName?: string | null, companyName?: string | null, mcc?: string | null, documentNumber?: string | null, status?: BusinessStatus | null, email?: string | null, phone?: string | null, website?: string | null, monthlyVolume?: number | null, confirmWebsite?: boolean | null, industry?: Industries | null, servicesDescription?: string | null, confirmServicesDescription?: boolean | null, legalAddress?: string | null, legalDescription?: string | null, creationDate?: string | null, lastUpdateDate?: string | null, startActivityDate?: string | null, capital?: any | null, previousNames?: Array<string | null> | null, verificationAttempts?: number | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, registryRecords?: Array<{ __typename?: 'RegistryRecord', name?: string | null, url?: string | null, province?: string | null, date?: string | null }> | null, positions?: Array<{ __typename?: 'BusinessPosition', fromDate?: string | null, role?: string | null, name?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null } | null, representatives?: Array<{ __typename?: 'Representative', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, documentNumber?: string | null, stocksPercentage?: number | null, gender?: Gender | null, citizenship?: string | null, dateOfBirth?: string | null, nationality?: string | null, yearOfBirth?: string | null, placeOfBirth?: string | null, idSession?: string | null, interventionType?: Array<InterventionType> | null, status?: IdVerificationStatus | null, statusCode?: number | null, hasNoPublicActivity?: boolean | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, document?: { __typename?: 'IdDocument', type?: IdDocumentType | null, number?: string | null, country?: string | null, validFrom?: string | null, validUntil?: string | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null }> | null, payoutTerms?: { __typename?: 'AccountPayoutTerms', iban?: string | null, period?: number | null, firstPeriod?: number | null, reservePercent?: number | null, suspended?: boolean | null, releaseReserve?: boolean | null, settleGross?: boolean | null, bankTransferConceptPrefix?: string | null, settleToStores?: boolean | null } | null, publicBusinessDetails?: { __typename?: 'AccountPublicBusinessDetails', companyName?: string | null, website?: string | null, phone?: string | null, supportWebsite?: string | null, supportPhone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, contract?: { __typename?: 'AccountContract', envelopeId: string, status: ContractStatus, path?: string | null, signedDate?: string | null } | null, upsell?: { __typename?: 'Upsell', executive: SalesExecutive, paymentMethods: Array<PaymentMethods>, date: string, note?: string | null } | null } };

export type RegisterMoneiXpMerchantMutationVariables = Exact<{
  accountId: Scalars['ID'];
  paymentMethods?: InputMaybe<Array<InputMaybe<PaymentMethods>> | InputMaybe<PaymentMethods>>;
}>;


export type RegisterMoneiXpMerchantMutation = { __typename?: 'Mutation', registerMoneiXPMerchant: { __typename?: 'SuccessResult', success: boolean } };

export type ResolvePibisiAlertMutationVariables = Exact<{
  input?: InputMaybe<ResolvePibisiAlertInput>;
}>;


export type ResolvePibisiAlertMutation = { __typename?: 'Mutation', resolvePibisiAlert: { __typename?: 'Account', id: string, refAccountId?: string | null, testAccountId?: string | null, prodAccountId?: string | null, name?: string | null, status: AccountStatus, note?: string | null, userNote?: string | null, partner?: Partner | null, acquirer?: Acquirer | null, adminEmail?: string | null, allowCreateApiKey?: boolean | null, allowRefunds?: boolean | null, defaultCurrency?: Currencies | null, defaultTransactionType?: TransactionTypes | null, referralCode?: string | null, promoCode?: string | null, language?: string | null, reviewConfirmed?: boolean | null, billingEmail?: string | null, billingPlan?: BillingPlans | null, riskScore?: number | null, riskProfile?: RiskProfile | null, riskProcessing?: boolean | null, riskProfileNote?: string | null, riskIgnoredKeywords?: Array<string> | null, riskUpdatedAt?: string | null, iban?: string | null, dynamicBilling?: boolean | null, test?: boolean | null, secret?: string | null, apiKey?: string | null, customDomain?: string | null, createdAt?: string | null, updatedAt?: string | null, deletedAt?: string | null, approvedAt?: string | null, rejectedAt?: string | null, activatedAt?: string | null, approvalRequestedAt?: string | null, suspendedAt?: string | null, dataUpdatedAt?: string | null, accountExecutive?: SalesExecutive | null, billingVatPercent?: number | null, churned?: boolean | null, blocked?: boolean | null, statusReason?: StatusReason | null, statusNote?: string | null, churnReason?: ChurnReason | null, churnReasonOption?: string | null, churnNote?: string | null, previewFeatures?: Array<string> | null, tags?: Array<string> | null, masterAccountId?: string | null, accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null, customAccountInvoiceNotes?: Array<string> | null, groupInvoicesByStore?: boolean | null, contactPerson?: { __typename?: 'ContactPerson', name: string, email: string, phone?: string | null } | null, branding?: { __typename?: 'AccountBranding', accentColor?: string | null, bgColor?: string | null, logoUrl?: string | null, iconUrl?: string | null } | null, tokenizationMethods?: { __typename?: 'AccountTokenizationMethods', googlePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, applePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, clickToPay?: { __typename?: 'AccountTokenizationMethodsClickToPayItem', enabled?: boolean | null } | null } | null, notifications?: { __typename?: 'AccountNotifications', emailCustomerOnRefund?: boolean | null, emailCustomerOnSuccess?: boolean | null, emailAdminOnSuccess?: boolean | null, emailCustomerOnSubscription?: boolean | null, emailAdminOnSubscription?: boolean | null, emailOnAccountInvoice?: boolean | null } | null, fees?: { __typename?: 'AccountFees', highRiskFee?: number | null, dailyExtraSeatsFee?: number | null, dailyPlatformFee?: number | null, weeklyCustomDomainFee?: number | null, steps?: Array<{ __typename?: 'AccountSteps', trxFee: number, bizumTrxFee?: number | null, bizumTrxFlatFee?: number | null, trxFlatFee: number, from: number }> | null, extra?: Array<{ __typename?: 'AccountExtraFee', name: string, amount: number, type: AccountExtraFeeType, masterAccountFee?: boolean | null, paymentMethods?: Array<PaymentMethods> | null }> | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null, riskScore?: number | null }> | null, business?: { __typename?: 'BusinessData', country?: string | null, legalForm?: LegalForm | null, legalName?: string | null, companyName?: string | null, mcc?: string | null, documentNumber?: string | null, status?: BusinessStatus | null, email?: string | null, phone?: string | null, website?: string | null, monthlyVolume?: number | null, confirmWebsite?: boolean | null, industry?: Industries | null, servicesDescription?: string | null, confirmServicesDescription?: boolean | null, legalAddress?: string | null, legalDescription?: string | null, creationDate?: string | null, lastUpdateDate?: string | null, startActivityDate?: string | null, capital?: any | null, previousNames?: Array<string | null> | null, verificationAttempts?: number | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, registryRecords?: Array<{ __typename?: 'RegistryRecord', name?: string | null, url?: string | null, province?: string | null, date?: string | null }> | null, positions?: Array<{ __typename?: 'BusinessPosition', fromDate?: string | null, role?: string | null, name?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null } | null, representatives?: Array<{ __typename?: 'Representative', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, documentNumber?: string | null, stocksPercentage?: number | null, gender?: Gender | null, citizenship?: string | null, dateOfBirth?: string | null, nationality?: string | null, yearOfBirth?: string | null, placeOfBirth?: string | null, idSession?: string | null, interventionType?: Array<InterventionType> | null, status?: IdVerificationStatus | null, statusCode?: number | null, hasNoPublicActivity?: boolean | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, document?: { __typename?: 'IdDocument', type?: IdDocumentType | null, number?: string | null, country?: string | null, validFrom?: string | null, validUntil?: string | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null }> | null, payoutTerms?: { __typename?: 'AccountPayoutTerms', iban?: string | null, period?: number | null, firstPeriod?: number | null, reservePercent?: number | null, suspended?: boolean | null, releaseReserve?: boolean | null, settleGross?: boolean | null, bankTransferConceptPrefix?: string | null, settleToStores?: boolean | null } | null, publicBusinessDetails?: { __typename?: 'AccountPublicBusinessDetails', companyName?: string | null, website?: string | null, phone?: string | null, supportWebsite?: string | null, supportPhone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, contract?: { __typename?: 'AccountContract', envelopeId: string, status: ContractStatus, path?: string | null, signedDate?: string | null } | null, upsell?: { __typename?: 'Upsell', executive: SalesExecutive, paymentMethods: Array<PaymentMethods>, date: string, note?: string | null } | null } };

export type ResolvePibisiMatchMutationVariables = Exact<{
  input?: InputMaybe<ResolvePibisiMatchInput>;
}>;


export type ResolvePibisiMatchMutation = { __typename?: 'Mutation', resolvePibisiMatch: { __typename?: 'Account', id: string, refAccountId?: string | null, testAccountId?: string | null, prodAccountId?: string | null, name?: string | null, status: AccountStatus, note?: string | null, userNote?: string | null, partner?: Partner | null, acquirer?: Acquirer | null, adminEmail?: string | null, allowCreateApiKey?: boolean | null, allowRefunds?: boolean | null, defaultCurrency?: Currencies | null, defaultTransactionType?: TransactionTypes | null, referralCode?: string | null, promoCode?: string | null, language?: string | null, reviewConfirmed?: boolean | null, billingEmail?: string | null, billingPlan?: BillingPlans | null, riskScore?: number | null, riskProfile?: RiskProfile | null, riskProcessing?: boolean | null, riskProfileNote?: string | null, riskIgnoredKeywords?: Array<string> | null, riskUpdatedAt?: string | null, iban?: string | null, dynamicBilling?: boolean | null, test?: boolean | null, secret?: string | null, apiKey?: string | null, customDomain?: string | null, createdAt?: string | null, updatedAt?: string | null, deletedAt?: string | null, approvedAt?: string | null, rejectedAt?: string | null, activatedAt?: string | null, approvalRequestedAt?: string | null, suspendedAt?: string | null, dataUpdatedAt?: string | null, accountExecutive?: SalesExecutive | null, billingVatPercent?: number | null, churned?: boolean | null, blocked?: boolean | null, statusReason?: StatusReason | null, statusNote?: string | null, churnReason?: ChurnReason | null, churnReasonOption?: string | null, churnNote?: string | null, previewFeatures?: Array<string> | null, tags?: Array<string> | null, masterAccountId?: string | null, accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null, customAccountInvoiceNotes?: Array<string> | null, groupInvoicesByStore?: boolean | null, contactPerson?: { __typename?: 'ContactPerson', name: string, email: string, phone?: string | null } | null, branding?: { __typename?: 'AccountBranding', accentColor?: string | null, bgColor?: string | null, logoUrl?: string | null, iconUrl?: string | null } | null, tokenizationMethods?: { __typename?: 'AccountTokenizationMethods', googlePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, applePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, clickToPay?: { __typename?: 'AccountTokenizationMethodsClickToPayItem', enabled?: boolean | null } | null } | null, notifications?: { __typename?: 'AccountNotifications', emailCustomerOnRefund?: boolean | null, emailCustomerOnSuccess?: boolean | null, emailAdminOnSuccess?: boolean | null, emailCustomerOnSubscription?: boolean | null, emailAdminOnSubscription?: boolean | null, emailOnAccountInvoice?: boolean | null } | null, fees?: { __typename?: 'AccountFees', highRiskFee?: number | null, dailyExtraSeatsFee?: number | null, dailyPlatformFee?: number | null, weeklyCustomDomainFee?: number | null, steps?: Array<{ __typename?: 'AccountSteps', trxFee: number, bizumTrxFee?: number | null, bizumTrxFlatFee?: number | null, trxFlatFee: number, from: number }> | null, extra?: Array<{ __typename?: 'AccountExtraFee', name: string, amount: number, type: AccountExtraFeeType, masterAccountFee?: boolean | null, paymentMethods?: Array<PaymentMethods> | null }> | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null, riskScore?: number | null }> | null, business?: { __typename?: 'BusinessData', country?: string | null, legalForm?: LegalForm | null, legalName?: string | null, companyName?: string | null, mcc?: string | null, documentNumber?: string | null, status?: BusinessStatus | null, email?: string | null, phone?: string | null, website?: string | null, monthlyVolume?: number | null, confirmWebsite?: boolean | null, industry?: Industries | null, servicesDescription?: string | null, confirmServicesDescription?: boolean | null, legalAddress?: string | null, legalDescription?: string | null, creationDate?: string | null, lastUpdateDate?: string | null, startActivityDate?: string | null, capital?: any | null, previousNames?: Array<string | null> | null, verificationAttempts?: number | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, registryRecords?: Array<{ __typename?: 'RegistryRecord', name?: string | null, url?: string | null, province?: string | null, date?: string | null }> | null, positions?: Array<{ __typename?: 'BusinessPosition', fromDate?: string | null, role?: string | null, name?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null } | null, representatives?: Array<{ __typename?: 'Representative', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, documentNumber?: string | null, stocksPercentage?: number | null, gender?: Gender | null, citizenship?: string | null, dateOfBirth?: string | null, nationality?: string | null, yearOfBirth?: string | null, placeOfBirth?: string | null, idSession?: string | null, interventionType?: Array<InterventionType> | null, status?: IdVerificationStatus | null, statusCode?: number | null, hasNoPublicActivity?: boolean | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, document?: { __typename?: 'IdDocument', type?: IdDocumentType | null, number?: string | null, country?: string | null, validFrom?: string | null, validUntil?: string | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null }> | null, payoutTerms?: { __typename?: 'AccountPayoutTerms', iban?: string | null, period?: number | null, firstPeriod?: number | null, reservePercent?: number | null, suspended?: boolean | null, releaseReserve?: boolean | null, settleGross?: boolean | null, bankTransferConceptPrefix?: string | null, settleToStores?: boolean | null } | null, publicBusinessDetails?: { __typename?: 'AccountPublicBusinessDetails', companyName?: string | null, website?: string | null, phone?: string | null, supportWebsite?: string | null, supportPhone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, contract?: { __typename?: 'AccountContract', envelopeId: string, status: ContractStatus, path?: string | null, signedDate?: string | null } | null, upsell?: { __typename?: 'Upsell', executive: SalesExecutive, paymentMethods: Array<PaymentMethods>, date: string, note?: string | null } | null } };

export type UpdateAccountInvoiceMutationVariables = Exact<{
  input: UpdateAccountInvoiceInput;
}>;


export type UpdateAccountInvoiceMutation = { __typename?: 'Mutation', updateAccountInvoice: { __typename?: 'AccountInvoice', id?: string | null, number?: string | null, accountId: string, currency: string, amount: number, tax: number, totalAmount: number, status?: AccountInvoiceStatus | null, paymentMethod?: AccountInvoicePaymentMethod | null, period: { __typename?: 'AccountInvoicePeriod', from?: any | null, to?: any | null }, lineItems: Array<{ __typename?: 'AccountInvoiceLineItem', name: string, quantity: number, unitAmount: number, unitType: InvoiceLineItemUnitType, currency: string, amount: number }>, business?: { __typename?: 'InvoiceBusinessData', iban?: string | null } | null } };

export type CalculateRiskScoreMutationVariables = Exact<{
  input: CalculateRiskScoreInput;
}>;


export type CalculateRiskScoreMutation = { __typename?: 'Mutation', calculateRiskScore?: { __typename?: 'Account', id: string, refAccountId?: string | null, testAccountId?: string | null, prodAccountId?: string | null, name?: string | null, status: AccountStatus, note?: string | null, userNote?: string | null, partner?: Partner | null, acquirer?: Acquirer | null, adminEmail?: string | null, allowCreateApiKey?: boolean | null, allowRefunds?: boolean | null, defaultCurrency?: Currencies | null, defaultTransactionType?: TransactionTypes | null, referralCode?: string | null, promoCode?: string | null, language?: string | null, reviewConfirmed?: boolean | null, billingEmail?: string | null, billingPlan?: BillingPlans | null, riskScore?: number | null, riskProfile?: RiskProfile | null, riskProcessing?: boolean | null, riskProfileNote?: string | null, riskIgnoredKeywords?: Array<string> | null, riskUpdatedAt?: string | null, iban?: string | null, dynamicBilling?: boolean | null, test?: boolean | null, secret?: string | null, apiKey?: string | null, customDomain?: string | null, createdAt?: string | null, updatedAt?: string | null, deletedAt?: string | null, approvedAt?: string | null, rejectedAt?: string | null, activatedAt?: string | null, approvalRequestedAt?: string | null, suspendedAt?: string | null, dataUpdatedAt?: string | null, accountExecutive?: SalesExecutive | null, billingVatPercent?: number | null, churned?: boolean | null, blocked?: boolean | null, statusReason?: StatusReason | null, statusNote?: string | null, churnReason?: ChurnReason | null, churnReasonOption?: string | null, churnNote?: string | null, previewFeatures?: Array<string> | null, tags?: Array<string> | null, masterAccountId?: string | null, accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null, customAccountInvoiceNotes?: Array<string> | null, groupInvoicesByStore?: boolean | null, contactPerson?: { __typename?: 'ContactPerson', name: string, email: string, phone?: string | null } | null, branding?: { __typename?: 'AccountBranding', accentColor?: string | null, bgColor?: string | null, logoUrl?: string | null, iconUrl?: string | null } | null, tokenizationMethods?: { __typename?: 'AccountTokenizationMethods', googlePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, applePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, clickToPay?: { __typename?: 'AccountTokenizationMethodsClickToPayItem', enabled?: boolean | null } | null } | null, notifications?: { __typename?: 'AccountNotifications', emailCustomerOnRefund?: boolean | null, emailCustomerOnSuccess?: boolean | null, emailAdminOnSuccess?: boolean | null, emailCustomerOnSubscription?: boolean | null, emailAdminOnSubscription?: boolean | null, emailOnAccountInvoice?: boolean | null } | null, fees?: { __typename?: 'AccountFees', highRiskFee?: number | null, dailyExtraSeatsFee?: number | null, dailyPlatformFee?: number | null, weeklyCustomDomainFee?: number | null, steps?: Array<{ __typename?: 'AccountSteps', trxFee: number, bizumTrxFee?: number | null, bizumTrxFlatFee?: number | null, trxFlatFee: number, from: number }> | null, extra?: Array<{ __typename?: 'AccountExtraFee', name: string, amount: number, type: AccountExtraFeeType, masterAccountFee?: boolean | null, paymentMethods?: Array<PaymentMethods> | null }> | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null, riskScore?: number | null }> | null, business?: { __typename?: 'BusinessData', country?: string | null, legalForm?: LegalForm | null, legalName?: string | null, companyName?: string | null, mcc?: string | null, documentNumber?: string | null, status?: BusinessStatus | null, email?: string | null, phone?: string | null, website?: string | null, monthlyVolume?: number | null, confirmWebsite?: boolean | null, industry?: Industries | null, servicesDescription?: string | null, confirmServicesDescription?: boolean | null, legalAddress?: string | null, legalDescription?: string | null, creationDate?: string | null, lastUpdateDate?: string | null, startActivityDate?: string | null, capital?: any | null, previousNames?: Array<string | null> | null, verificationAttempts?: number | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, registryRecords?: Array<{ __typename?: 'RegistryRecord', name?: string | null, url?: string | null, province?: string | null, date?: string | null }> | null, positions?: Array<{ __typename?: 'BusinessPosition', fromDate?: string | null, role?: string | null, name?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null } | null, representatives?: Array<{ __typename?: 'Representative', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, documentNumber?: string | null, stocksPercentage?: number | null, gender?: Gender | null, citizenship?: string | null, dateOfBirth?: string | null, nationality?: string | null, yearOfBirth?: string | null, placeOfBirth?: string | null, idSession?: string | null, interventionType?: Array<InterventionType> | null, status?: IdVerificationStatus | null, statusCode?: number | null, hasNoPublicActivity?: boolean | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, document?: { __typename?: 'IdDocument', type?: IdDocumentType | null, number?: string | null, country?: string | null, validFrom?: string | null, validUntil?: string | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null }> | null, payoutTerms?: { __typename?: 'AccountPayoutTerms', iban?: string | null, period?: number | null, firstPeriod?: number | null, reservePercent?: number | null, suspended?: boolean | null, releaseReserve?: boolean | null, settleGross?: boolean | null, bankTransferConceptPrefix?: string | null, settleToStores?: boolean | null } | null, publicBusinessDetails?: { __typename?: 'AccountPublicBusinessDetails', companyName?: string | null, website?: string | null, phone?: string | null, supportWebsite?: string | null, supportPhone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, contract?: { __typename?: 'AccountContract', envelopeId: string, status: ContractStatus, path?: string | null, signedDate?: string | null } | null, upsell?: { __typename?: 'Upsell', executive: SalesExecutive, paymentMethods: Array<PaymentMethods>, date: string, note?: string | null } | null } | null };

export type DeleteWebhookMutationVariables = Exact<{
  id: Scalars['ID'];
  accountId: Scalars['ID'];
}>;


export type DeleteWebhookMutation = { __typename?: 'Mutation', deleteWebhook: boolean };

export type CreateWebhookMutationVariables = Exact<{
  input: CreateWebhookInput;
}>;


export type CreateWebhookMutation = { __typename?: 'Mutation', createWebhook: { __typename?: 'Webhook', id: string, accountId: string, url: string, enabled: boolean, eventTypes: Array<WebhookEventType>, secret?: string | null, createdAt: string, updatedAt?: string | null } };

export type UpdateWebhookMutationVariables = Exact<{
  input: UpdateWebhookInput;
}>;


export type UpdateWebhookMutation = { __typename?: 'Mutation', updateWebhook: { __typename?: 'Webhook', id: string, accountId: string, url: string, enabled: boolean, eventTypes: Array<WebhookEventType>, secret?: string | null, createdAt: string, updatedAt?: string | null } };

export type StartExportChargesMutationVariables = Exact<{
  filter?: InputMaybe<SearchableChargeFilterInput>;
  columns?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
}>;


export type StartExportChargesMutation = { __typename?: 'Mutation', startExportCharges: { __typename?: 'ChargesExport', id: string, accountId: string, status: ExportStatus } };

export type DownloadExportMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DownloadExportMutation = { __typename?: 'Mutation', downloadExport: { __typename?: 'DownloadFile', downloadUrl: string } };

export type CreateStoreMutationVariables = Exact<{
  input: CreateStoreInput;
}>;


export type CreateStoreMutation = { __typename?: 'Mutation', createStore: { __typename?: 'Store', id: string, accountId: string, name?: string | null, email?: string | null, iban?: string | null, phone?: string | null, website?: string | null, documentNumber?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } };

export type UpdateStoreMutationVariables = Exact<{
  input: UpdateStoreInput;
}>;


export type UpdateStoreMutation = { __typename?: 'Mutation', updateStore: { __typename?: 'Store', id: string, accountId: string, name?: string | null, email?: string | null, iban?: string | null, phone?: string | null, website?: string | null, documentNumber?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } };

export type DeleteStoreMutationVariables = Exact<{
  id: Scalars['ID'];
  accountId: Scalars['ID'];
}>;


export type DeleteStoreMutation = { __typename?: 'Mutation', deleteStore: boolean };

export type UpdateWebKeywordMutationVariables = Exact<{
  input: UpdateWebKeywordInput;
}>;


export type UpdateWebKeywordMutation = { __typename?: 'Mutation', updateWebKeyword?: { __typename?: 'WebKeyword', incorrect?: boolean | null } | null };

export type ConnectMasterAccountMutationVariables = Exact<{
  accountId: Scalars['ID'];
  promoCode: Scalars['String'];
  externalId?: InputMaybe<Scalars['String']>;
  externalHash?: InputMaybe<Scalars['String']>;
}>;


export type ConnectMasterAccountMutation = { __typename?: 'Mutation', connectMasterAccount: { __typename?: 'Account', id: string, refAccountId?: string | null, testAccountId?: string | null, prodAccountId?: string | null, name?: string | null, status: AccountStatus, note?: string | null, userNote?: string | null, partner?: Partner | null, acquirer?: Acquirer | null, adminEmail?: string | null, allowCreateApiKey?: boolean | null, allowRefunds?: boolean | null, defaultCurrency?: Currencies | null, defaultTransactionType?: TransactionTypes | null, referralCode?: string | null, promoCode?: string | null, language?: string | null, reviewConfirmed?: boolean | null, billingEmail?: string | null, billingPlan?: BillingPlans | null, riskScore?: number | null, riskProfile?: RiskProfile | null, riskProcessing?: boolean | null, riskProfileNote?: string | null, riskIgnoredKeywords?: Array<string> | null, riskUpdatedAt?: string | null, iban?: string | null, dynamicBilling?: boolean | null, test?: boolean | null, secret?: string | null, apiKey?: string | null, customDomain?: string | null, createdAt?: string | null, updatedAt?: string | null, deletedAt?: string | null, approvedAt?: string | null, rejectedAt?: string | null, activatedAt?: string | null, approvalRequestedAt?: string | null, suspendedAt?: string | null, dataUpdatedAt?: string | null, accountExecutive?: SalesExecutive | null, billingVatPercent?: number | null, churned?: boolean | null, blocked?: boolean | null, statusReason?: StatusReason | null, statusNote?: string | null, churnReason?: ChurnReason | null, churnReasonOption?: string | null, churnNote?: string | null, previewFeatures?: Array<string> | null, tags?: Array<string> | null, masterAccountId?: string | null, accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null, customAccountInvoiceNotes?: Array<string> | null, groupInvoicesByStore?: boolean | null, contactPerson?: { __typename?: 'ContactPerson', name: string, email: string, phone?: string | null } | null, branding?: { __typename?: 'AccountBranding', accentColor?: string | null, bgColor?: string | null, logoUrl?: string | null, iconUrl?: string | null } | null, tokenizationMethods?: { __typename?: 'AccountTokenizationMethods', googlePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, applePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, clickToPay?: { __typename?: 'AccountTokenizationMethodsClickToPayItem', enabled?: boolean | null } | null } | null, notifications?: { __typename?: 'AccountNotifications', emailCustomerOnRefund?: boolean | null, emailCustomerOnSuccess?: boolean | null, emailAdminOnSuccess?: boolean | null, emailCustomerOnSubscription?: boolean | null, emailAdminOnSubscription?: boolean | null, emailOnAccountInvoice?: boolean | null } | null, fees?: { __typename?: 'AccountFees', highRiskFee?: number | null, dailyExtraSeatsFee?: number | null, dailyPlatformFee?: number | null, weeklyCustomDomainFee?: number | null, steps?: Array<{ __typename?: 'AccountSteps', trxFee: number, bizumTrxFee?: number | null, bizumTrxFlatFee?: number | null, trxFlatFee: number, from: number }> | null, extra?: Array<{ __typename?: 'AccountExtraFee', name: string, amount: number, type: AccountExtraFeeType, masterAccountFee?: boolean | null, paymentMethods?: Array<PaymentMethods> | null }> | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null, riskScore?: number | null }> | null, business?: { __typename?: 'BusinessData', country?: string | null, legalForm?: LegalForm | null, legalName?: string | null, companyName?: string | null, mcc?: string | null, documentNumber?: string | null, status?: BusinessStatus | null, email?: string | null, phone?: string | null, website?: string | null, monthlyVolume?: number | null, confirmWebsite?: boolean | null, industry?: Industries | null, servicesDescription?: string | null, confirmServicesDescription?: boolean | null, legalAddress?: string | null, legalDescription?: string | null, creationDate?: string | null, lastUpdateDate?: string | null, startActivityDate?: string | null, capital?: any | null, previousNames?: Array<string | null> | null, verificationAttempts?: number | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, registryRecords?: Array<{ __typename?: 'RegistryRecord', name?: string | null, url?: string | null, province?: string | null, date?: string | null }> | null, positions?: Array<{ __typename?: 'BusinessPosition', fromDate?: string | null, role?: string | null, name?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null } | null, representatives?: Array<{ __typename?: 'Representative', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, documentNumber?: string | null, stocksPercentage?: number | null, gender?: Gender | null, citizenship?: string | null, dateOfBirth?: string | null, nationality?: string | null, yearOfBirth?: string | null, placeOfBirth?: string | null, idSession?: string | null, interventionType?: Array<InterventionType> | null, status?: IdVerificationStatus | null, statusCode?: number | null, hasNoPublicActivity?: boolean | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, document?: { __typename?: 'IdDocument', type?: IdDocumentType | null, number?: string | null, country?: string | null, validFrom?: string | null, validUntil?: string | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null }> | null, payoutTerms?: { __typename?: 'AccountPayoutTerms', iban?: string | null, period?: number | null, firstPeriod?: number | null, reservePercent?: number | null, suspended?: boolean | null, releaseReserve?: boolean | null, settleGross?: boolean | null, bankTransferConceptPrefix?: string | null, settleToStores?: boolean | null } | null, publicBusinessDetails?: { __typename?: 'AccountPublicBusinessDetails', companyName?: string | null, website?: string | null, phone?: string | null, supportWebsite?: string | null, supportPhone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, contract?: { __typename?: 'AccountContract', envelopeId: string, status: ContractStatus, path?: string | null, signedDate?: string | null } | null, upsell?: { __typename?: 'Upsell', executive: SalesExecutive, paymentMethods: Array<PaymentMethods>, date: string, note?: string | null } | null } };

export type DisconnectMasterAccountMutationVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type DisconnectMasterAccountMutation = { __typename?: 'Mutation', disconnectMasterAccount: { __typename?: 'Account', id: string, refAccountId?: string | null, testAccountId?: string | null, prodAccountId?: string | null, name?: string | null, status: AccountStatus, note?: string | null, userNote?: string | null, partner?: Partner | null, acquirer?: Acquirer | null, adminEmail?: string | null, allowCreateApiKey?: boolean | null, allowRefunds?: boolean | null, defaultCurrency?: Currencies | null, defaultTransactionType?: TransactionTypes | null, referralCode?: string | null, promoCode?: string | null, language?: string | null, reviewConfirmed?: boolean | null, billingEmail?: string | null, billingPlan?: BillingPlans | null, riskScore?: number | null, riskProfile?: RiskProfile | null, riskProcessing?: boolean | null, riskProfileNote?: string | null, riskIgnoredKeywords?: Array<string> | null, riskUpdatedAt?: string | null, iban?: string | null, dynamicBilling?: boolean | null, test?: boolean | null, secret?: string | null, apiKey?: string | null, customDomain?: string | null, createdAt?: string | null, updatedAt?: string | null, deletedAt?: string | null, approvedAt?: string | null, rejectedAt?: string | null, activatedAt?: string | null, approvalRequestedAt?: string | null, suspendedAt?: string | null, dataUpdatedAt?: string | null, accountExecutive?: SalesExecutive | null, billingVatPercent?: number | null, churned?: boolean | null, blocked?: boolean | null, statusReason?: StatusReason | null, statusNote?: string | null, churnReason?: ChurnReason | null, churnReasonOption?: string | null, churnNote?: string | null, previewFeatures?: Array<string> | null, tags?: Array<string> | null, masterAccountId?: string | null, accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null, customAccountInvoiceNotes?: Array<string> | null, groupInvoicesByStore?: boolean | null, contactPerson?: { __typename?: 'ContactPerson', name: string, email: string, phone?: string | null } | null, branding?: { __typename?: 'AccountBranding', accentColor?: string | null, bgColor?: string | null, logoUrl?: string | null, iconUrl?: string | null } | null, tokenizationMethods?: { __typename?: 'AccountTokenizationMethods', googlePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, applePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, clickToPay?: { __typename?: 'AccountTokenizationMethodsClickToPayItem', enabled?: boolean | null } | null } | null, notifications?: { __typename?: 'AccountNotifications', emailCustomerOnRefund?: boolean | null, emailCustomerOnSuccess?: boolean | null, emailAdminOnSuccess?: boolean | null, emailCustomerOnSubscription?: boolean | null, emailAdminOnSubscription?: boolean | null, emailOnAccountInvoice?: boolean | null } | null, fees?: { __typename?: 'AccountFees', highRiskFee?: number | null, dailyExtraSeatsFee?: number | null, dailyPlatformFee?: number | null, weeklyCustomDomainFee?: number | null, steps?: Array<{ __typename?: 'AccountSteps', trxFee: number, bizumTrxFee?: number | null, bizumTrxFlatFee?: number | null, trxFlatFee: number, from: number }> | null, extra?: Array<{ __typename?: 'AccountExtraFee', name: string, amount: number, type: AccountExtraFeeType, masterAccountFee?: boolean | null, paymentMethods?: Array<PaymentMethods> | null }> | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null, riskScore?: number | null }> | null, business?: { __typename?: 'BusinessData', country?: string | null, legalForm?: LegalForm | null, legalName?: string | null, companyName?: string | null, mcc?: string | null, documentNumber?: string | null, status?: BusinessStatus | null, email?: string | null, phone?: string | null, website?: string | null, monthlyVolume?: number | null, confirmWebsite?: boolean | null, industry?: Industries | null, servicesDescription?: string | null, confirmServicesDescription?: boolean | null, legalAddress?: string | null, legalDescription?: string | null, creationDate?: string | null, lastUpdateDate?: string | null, startActivityDate?: string | null, capital?: any | null, previousNames?: Array<string | null> | null, verificationAttempts?: number | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, registryRecords?: Array<{ __typename?: 'RegistryRecord', name?: string | null, url?: string | null, province?: string | null, date?: string | null }> | null, positions?: Array<{ __typename?: 'BusinessPosition', fromDate?: string | null, role?: string | null, name?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null } | null, representatives?: Array<{ __typename?: 'Representative', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, documentNumber?: string | null, stocksPercentage?: number | null, gender?: Gender | null, citizenship?: string | null, dateOfBirth?: string | null, nationality?: string | null, yearOfBirth?: string | null, placeOfBirth?: string | null, idSession?: string | null, interventionType?: Array<InterventionType> | null, status?: IdVerificationStatus | null, statusCode?: number | null, hasNoPublicActivity?: boolean | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, document?: { __typename?: 'IdDocument', type?: IdDocumentType | null, number?: string | null, country?: string | null, validFrom?: string | null, validUntil?: string | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null }> | null, payoutTerms?: { __typename?: 'AccountPayoutTerms', iban?: string | null, period?: number | null, firstPeriod?: number | null, reservePercent?: number | null, suspended?: boolean | null, releaseReserve?: boolean | null, settleGross?: boolean | null, bankTransferConceptPrefix?: string | null, settleToStores?: boolean | null } | null, publicBusinessDetails?: { __typename?: 'AccountPublicBusinessDetails', companyName?: string | null, website?: string | null, phone?: string | null, supportWebsite?: string | null, supportPhone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, contract?: { __typename?: 'AccountContract', envelopeId: string, status: ContractStatus, path?: string | null, signedDate?: string | null } | null, upsell?: { __typename?: 'Upsell', executive: SalesExecutive, paymentMethods: Array<PaymentMethods>, date: string, note?: string | null } | null } };

export type CreateMasterAccountApiKeyMutationVariables = Exact<{
  input: CreateMasterAccountApiKeyInput;
}>;


export type CreateMasterAccountApiKeyMutation = { __typename?: 'Mutation', createMasterAccountApiKey: { __typename?: 'MasterAccount', id: string, testAccountId?: string | null, prodAccountId?: string | null, name?: string | null, adminEmail?: string | null, iban?: string | null, apiKey?: string | null, test?: boolean | null, status?: AccountStatus | null, promoCode?: string | null, allowedIPs?: Array<string> | null, createdAt?: string | null, updatedAt?: string | null, webhookEmails?: Array<string> | null, churnedEmails?: Array<string> | null, allowedDomains?: Array<string> | null, accountCallbackUrl?: string | null, requireExternalId?: boolean | null, contractTemplateId?: string | null, autoApprove?: boolean | null, blocked?: boolean | null, allowCreateApiKey?: boolean | null, payoutTerms?: { __typename?: 'AccountPayoutTerms', iban?: string | null, firstPeriod?: number | null, period?: number | null, reservePercent?: number | null, suspended?: boolean | null, releaseReserve?: boolean | null } | null, accountDefaults?: { __typename?: 'AccountDefaults', billingPlan?: BillingPlans | null, language?: string | null, fees?: { __typename?: 'AccountFees', trxFee?: number | null, trxFlatFee?: number | null, highRiskFee?: number | null, dailyPlatformFee?: number | null, dailyExtraSeatsFee?: number | null, steps?: Array<{ __typename?: 'AccountSteps', trxFee: number, bizumTrxFee?: number | null, bizumTrxFlatFee?: number | null, trxFlatFee: number, from: number }> | null, extra?: Array<{ __typename?: 'AccountExtraFee', name: string, amount: number, type: AccountExtraFeeType, region?: AccountExtraFeeRegion | null, masterAccountFee?: boolean | null, paymentMethods?: Array<PaymentMethods> | null }> | null } | null, business?: { __typename?: 'BusinessDefault', mcc?: string | null, website?: string | null, servicesDescription?: string | null } | null } | null, business?: { __typename?: 'BusinessData', mcc?: string | null, legalName?: string | null, website?: string | null, documentNumber?: string | null, servicesDescription?: string | null } | null } };

export type DeleteMasterAccountApiKeyMutationVariables = Exact<{
  input: DeleteMasterAccountApiKeyInput;
}>;


export type DeleteMasterAccountApiKeyMutation = { __typename?: 'Mutation', deleteMasterAccountApiKey: { __typename?: 'MasterAccount', id: string, testAccountId?: string | null, prodAccountId?: string | null, name?: string | null, adminEmail?: string | null, iban?: string | null, apiKey?: string | null, test?: boolean | null, status?: AccountStatus | null, promoCode?: string | null, allowedIPs?: Array<string> | null, createdAt?: string | null, updatedAt?: string | null, webhookEmails?: Array<string> | null, churnedEmails?: Array<string> | null, allowedDomains?: Array<string> | null, accountCallbackUrl?: string | null, requireExternalId?: boolean | null, contractTemplateId?: string | null, autoApprove?: boolean | null, blocked?: boolean | null, allowCreateApiKey?: boolean | null, payoutTerms?: { __typename?: 'AccountPayoutTerms', iban?: string | null, firstPeriod?: number | null, period?: number | null, reservePercent?: number | null, suspended?: boolean | null, releaseReserve?: boolean | null } | null, accountDefaults?: { __typename?: 'AccountDefaults', billingPlan?: BillingPlans | null, language?: string | null, fees?: { __typename?: 'AccountFees', trxFee?: number | null, trxFlatFee?: number | null, highRiskFee?: number | null, dailyPlatformFee?: number | null, dailyExtraSeatsFee?: number | null, steps?: Array<{ __typename?: 'AccountSteps', trxFee: number, bizumTrxFee?: number | null, bizumTrxFlatFee?: number | null, trxFlatFee: number, from: number }> | null, extra?: Array<{ __typename?: 'AccountExtraFee', name: string, amount: number, type: AccountExtraFeeType, region?: AccountExtraFeeRegion | null, masterAccountFee?: boolean | null, paymentMethods?: Array<PaymentMethods> | null }> | null } | null, business?: { __typename?: 'BusinessDefault', mcc?: string | null, website?: string | null, servicesDescription?: string | null } | null } | null, business?: { __typename?: 'BusinessData', mcc?: string | null, legalName?: string | null, website?: string | null, documentNumber?: string | null, servicesDescription?: string | null } | null } };

export type UpdateUserMutationVariables = Exact<{
  input: UserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, email: string, emailVerified?: boolean | null, phoneNumber?: string | null, phoneNumberVerified?: boolean | null, smsMfaEnabled?: boolean | null, status: UserStatus, enabled: boolean, accountId?: string | null, testAccountId?: string | null, referralCode?: string | null, promoCode?: string | null, createdAt: string } };

export type UpdateAffiliateTierMutationVariables = Exact<{
  input: UpdateAffiliateTierInput;
}>;


export type UpdateAffiliateTierMutation = { __typename?: 'Mutation', updateAffiliateTier: { __typename?: 'Affiliate', id: string, meta_data?: { __typename?: 'AffiliateMetaData', tier?: string | null } | null } };

export type EnableAffiliateProcessingMutationVariables = Exact<{
  affiliateId: Scalars['ID'];
}>;


export type EnableAffiliateProcessingMutation = { __typename?: 'Mutation', enableAffiliateProcessing: { __typename?: 'Affiliate', id: string, affiliate_group_id?: string | null } };

export type DisableAffiliateProcessingMutationVariables = Exact<{
  affiliateId: Scalars['ID'];
}>;


export type DisableAffiliateProcessingMutation = { __typename?: 'Mutation', disableAffiliateProcessing: { __typename?: 'Affiliate', id: string, affiliate_group_id?: string | null } };

export type UpdateAffiliatePayoutMethodMutationVariables = Exact<{
  input: UpdateAffiliatePayoutMethodInput;
}>;


export type UpdateAffiliatePayoutMethodMutation = { __typename?: 'Mutation', updateAffiliatePayoutMethod: { __typename?: 'Affiliate', id: string, payout_methods?: Array<{ __typename?: 'AffiliatePayoutMethod', id?: string | null, title?: string | null, details?: { __typename?: 'AffiliatePayoutMethodDetails', iban?: string | null, nif?: string | null } | null }> | null } };

export type RetrieveAffiliateHistoryMutationVariables = Exact<{
  affiliateId: Scalars['ID'];
  email: Scalars['String'];
}>;


export type RetrieveAffiliateHistoryMutation = { __typename?: 'Mutation', retrieveAffiliateHistory?: boolean | null };

export type DownloadAffiliateInvoiceMutationVariables = Exact<{
  invoiceNumber: Scalars['String'];
  affiliateId: Scalars['String'];
  year: Scalars['String'];
}>;


export type DownloadAffiliateInvoiceMutation = { __typename?: 'Mutation', downloadAffiliateInvoice: { __typename?: 'DownloadFile', downloadUrl: string, expiresAt: any } };

export type AccountQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AccountQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, refAccountId?: string | null, testAccountId?: string | null, prodAccountId?: string | null, name?: string | null, status: AccountStatus, note?: string | null, userNote?: string | null, partner?: Partner | null, acquirer?: Acquirer | null, adminEmail?: string | null, allowCreateApiKey?: boolean | null, allowRefunds?: boolean | null, defaultCurrency?: Currencies | null, defaultTransactionType?: TransactionTypes | null, referralCode?: string | null, promoCode?: string | null, language?: string | null, reviewConfirmed?: boolean | null, billingEmail?: string | null, billingPlan?: BillingPlans | null, riskScore?: number | null, riskProfile?: RiskProfile | null, riskProcessing?: boolean | null, riskProfileNote?: string | null, riskIgnoredKeywords?: Array<string> | null, riskUpdatedAt?: string | null, iban?: string | null, dynamicBilling?: boolean | null, test?: boolean | null, secret?: string | null, apiKey?: string | null, customDomain?: string | null, createdAt?: string | null, updatedAt?: string | null, deletedAt?: string | null, approvedAt?: string | null, rejectedAt?: string | null, activatedAt?: string | null, approvalRequestedAt?: string | null, suspendedAt?: string | null, dataUpdatedAt?: string | null, accountExecutive?: SalesExecutive | null, billingVatPercent?: number | null, churned?: boolean | null, blocked?: boolean | null, statusReason?: StatusReason | null, statusNote?: string | null, churnReason?: ChurnReason | null, churnReasonOption?: string | null, churnNote?: string | null, previewFeatures?: Array<string> | null, tags?: Array<string> | null, masterAccountId?: string | null, accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null, customAccountInvoiceNotes?: Array<string> | null, groupInvoicesByStore?: boolean | null, contactPerson?: { __typename?: 'ContactPerson', name: string, email: string, phone?: string | null } | null, branding?: { __typename?: 'AccountBranding', accentColor?: string | null, bgColor?: string | null, logoUrl?: string | null, iconUrl?: string | null } | null, tokenizationMethods?: { __typename?: 'AccountTokenizationMethods', googlePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, applePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, clickToPay?: { __typename?: 'AccountTokenizationMethodsClickToPayItem', enabled?: boolean | null } | null } | null, notifications?: { __typename?: 'AccountNotifications', emailCustomerOnRefund?: boolean | null, emailCustomerOnSuccess?: boolean | null, emailAdminOnSuccess?: boolean | null, emailCustomerOnSubscription?: boolean | null, emailAdminOnSubscription?: boolean | null, emailOnAccountInvoice?: boolean | null } | null, fees?: { __typename?: 'AccountFees', highRiskFee?: number | null, dailyExtraSeatsFee?: number | null, dailyPlatformFee?: number | null, weeklyCustomDomainFee?: number | null, steps?: Array<{ __typename?: 'AccountSteps', trxFee: number, bizumTrxFee?: number | null, bizumTrxFlatFee?: number | null, trxFlatFee: number, from: number }> | null, extra?: Array<{ __typename?: 'AccountExtraFee', name: string, amount: number, type: AccountExtraFeeType, masterAccountFee?: boolean | null, paymentMethods?: Array<PaymentMethods> | null }> | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null, riskScore?: number | null }> | null, business?: { __typename?: 'BusinessData', country?: string | null, legalForm?: LegalForm | null, legalName?: string | null, companyName?: string | null, mcc?: string | null, documentNumber?: string | null, status?: BusinessStatus | null, email?: string | null, phone?: string | null, website?: string | null, monthlyVolume?: number | null, confirmWebsite?: boolean | null, industry?: Industries | null, servicesDescription?: string | null, confirmServicesDescription?: boolean | null, legalAddress?: string | null, legalDescription?: string | null, creationDate?: string | null, lastUpdateDate?: string | null, startActivityDate?: string | null, capital?: any | null, previousNames?: Array<string | null> | null, verificationAttempts?: number | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, registryRecords?: Array<{ __typename?: 'RegistryRecord', name?: string | null, url?: string | null, province?: string | null, date?: string | null }> | null, positions?: Array<{ __typename?: 'BusinessPosition', fromDate?: string | null, role?: string | null, name?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null } | null, representatives?: Array<{ __typename?: 'Representative', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, documentNumber?: string | null, stocksPercentage?: number | null, gender?: Gender | null, citizenship?: string | null, dateOfBirth?: string | null, nationality?: string | null, yearOfBirth?: string | null, placeOfBirth?: string | null, idSession?: string | null, interventionType?: Array<InterventionType> | null, status?: IdVerificationStatus | null, statusCode?: number | null, hasNoPublicActivity?: boolean | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, document?: { __typename?: 'IdDocument', type?: IdDocumentType | null, number?: string | null, country?: string | null, validFrom?: string | null, validUntil?: string | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null }> | null, payoutTerms?: { __typename?: 'AccountPayoutTerms', iban?: string | null, period?: number | null, firstPeriod?: number | null, reservePercent?: number | null, suspended?: boolean | null, releaseReserve?: boolean | null, settleGross?: boolean | null, bankTransferConceptPrefix?: string | null, settleToStores?: boolean | null } | null, publicBusinessDetails?: { __typename?: 'AccountPublicBusinessDetails', companyName?: string | null, website?: string | null, phone?: string | null, supportWebsite?: string | null, supportPhone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, contract?: { __typename?: 'AccountContract', envelopeId: string, status: ContractStatus, path?: string | null, signedDate?: string | null } | null, upsell?: { __typename?: 'Upsell', executive: SalesExecutive, paymentMethods: Array<PaymentMethods>, date: string, note?: string | null } | null } | null };

export type AccountsQueryVariables = Exact<{
  filter?: InputMaybe<SearchableAccountFilterInput>;
  size?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['Int']>;
}>;


export type AccountsQuery = { __typename?: 'Query', accounts: { __typename?: 'AccountsConnection', total: number, items: Array<{ __typename?: 'Account', id: string, refAccountId?: string | null, testAccountId?: string | null, prodAccountId?: string | null, name?: string | null, status: AccountStatus, note?: string | null, userNote?: string | null, partner?: Partner | null, acquirer?: Acquirer | null, adminEmail?: string | null, allowCreateApiKey?: boolean | null, allowRefunds?: boolean | null, defaultCurrency?: Currencies | null, defaultTransactionType?: TransactionTypes | null, referralCode?: string | null, promoCode?: string | null, language?: string | null, reviewConfirmed?: boolean | null, billingEmail?: string | null, billingPlan?: BillingPlans | null, riskScore?: number | null, riskProfile?: RiskProfile | null, riskProcessing?: boolean | null, riskProfileNote?: string | null, riskIgnoredKeywords?: Array<string> | null, riskUpdatedAt?: string | null, iban?: string | null, dynamicBilling?: boolean | null, test?: boolean | null, secret?: string | null, apiKey?: string | null, customDomain?: string | null, createdAt?: string | null, updatedAt?: string | null, deletedAt?: string | null, approvedAt?: string | null, rejectedAt?: string | null, activatedAt?: string | null, approvalRequestedAt?: string | null, suspendedAt?: string | null, dataUpdatedAt?: string | null, accountExecutive?: SalesExecutive | null, billingVatPercent?: number | null, churned?: boolean | null, blocked?: boolean | null, statusReason?: StatusReason | null, statusNote?: string | null, churnReason?: ChurnReason | null, churnReasonOption?: string | null, churnNote?: string | null, previewFeatures?: Array<string> | null, tags?: Array<string> | null, masterAccountId?: string | null, accountInvoicePaymentMethod?: AccountInvoicePaymentMethod | null, customAccountInvoiceNotes?: Array<string> | null, groupInvoicesByStore?: boolean | null, contactPerson?: { __typename?: 'ContactPerson', name: string, email: string, phone?: string | null } | null, branding?: { __typename?: 'AccountBranding', accentColor?: string | null, bgColor?: string | null, logoUrl?: string | null, iconUrl?: string | null } | null, tokenizationMethods?: { __typename?: 'AccountTokenizationMethods', googlePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, applePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, clickToPay?: { __typename?: 'AccountTokenizationMethodsClickToPayItem', enabled?: boolean | null } | null } | null, notifications?: { __typename?: 'AccountNotifications', emailCustomerOnRefund?: boolean | null, emailCustomerOnSuccess?: boolean | null, emailAdminOnSuccess?: boolean | null, emailCustomerOnSubscription?: boolean | null, emailAdminOnSubscription?: boolean | null, emailOnAccountInvoice?: boolean | null } | null, fees?: { __typename?: 'AccountFees', highRiskFee?: number | null, dailyExtraSeatsFee?: number | null, dailyPlatformFee?: number | null, weeklyCustomDomainFee?: number | null, steps?: Array<{ __typename?: 'AccountSteps', trxFee: number, bizumTrxFee?: number | null, bizumTrxFlatFee?: number | null, trxFlatFee: number, from: number }> | null, extra?: Array<{ __typename?: 'AccountExtraFee', name: string, amount: number, type: AccountExtraFeeType, masterAccountFee?: boolean | null, paymentMethods?: Array<PaymentMethods> | null }> | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null, riskScore?: number | null }> | null, business?: { __typename?: 'BusinessData', country?: string | null, legalForm?: LegalForm | null, legalName?: string | null, companyName?: string | null, mcc?: string | null, documentNumber?: string | null, status?: BusinessStatus | null, email?: string | null, phone?: string | null, website?: string | null, monthlyVolume?: number | null, confirmWebsite?: boolean | null, industry?: Industries | null, servicesDescription?: string | null, confirmServicesDescription?: boolean | null, legalAddress?: string | null, legalDescription?: string | null, creationDate?: string | null, lastUpdateDate?: string | null, startActivityDate?: string | null, capital?: any | null, previousNames?: Array<string | null> | null, verificationAttempts?: number | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, registryRecords?: Array<{ __typename?: 'RegistryRecord', name?: string | null, url?: string | null, province?: string | null, date?: string | null }> | null, positions?: Array<{ __typename?: 'BusinessPosition', fromDate?: string | null, role?: string | null, name?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null } | null, representatives?: Array<{ __typename?: 'Representative', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, documentNumber?: string | null, stocksPercentage?: number | null, gender?: Gender | null, citizenship?: string | null, dateOfBirth?: string | null, nationality?: string | null, yearOfBirth?: string | null, placeOfBirth?: string | null, idSession?: string | null, interventionType?: Array<InterventionType> | null, status?: IdVerificationStatus | null, statusCode?: number | null, hasNoPublicActivity?: boolean | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, document?: { __typename?: 'IdDocument', type?: IdDocumentType | null, number?: string | null, country?: string | null, validFrom?: string | null, validUntil?: string | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null }> | null, pibisi?: { __typename?: 'Pibisi', status?: PibisiStatus | null, customerId?: string | null, matches?: Array<{ __typename?: 'PibisiMatch', id: string, status: PibisiMatchStatus, adverseInfo?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, highRisk?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, pep?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, sanctioned?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, terrorist?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null, matches?: Array<{ __typename?: 'PibisiFlag', id?: string | null, content?: { __typename?: 'PibisiContent', action?: string | null, charge?: string | null, country?: string | null, from?: string | null, issue?: string | null, issuer?: string | null, organization?: string | null, reason?: string | null, scope?: string | null, to?: string | null, types?: Array<string | null> | null, url?: string | null } | null } | null> | null } | null> | null, alerts?: Array<{ __typename?: 'PibisiAlert', id: string, status: PibisiAlertStatus, type?: PibisiAlertTypes | null, note?: string | null } | null> | null } | null }> | null, payoutTerms?: { __typename?: 'AccountPayoutTerms', iban?: string | null, period?: number | null, firstPeriod?: number | null, reservePercent?: number | null, suspended?: boolean | null, releaseReserve?: boolean | null, settleGross?: boolean | null, bankTransferConceptPrefix?: string | null, settleToStores?: boolean | null } | null, publicBusinessDetails?: { __typename?: 'AccountPublicBusinessDetails', companyName?: string | null, website?: string | null, phone?: string | null, supportWebsite?: string | null, supportPhone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, contract?: { __typename?: 'AccountContract', envelopeId: string, status: ContractStatus, path?: string | null, signedDate?: string | null } | null, upsell?: { __typename?: 'Upsell', executive: SalesExecutive, paymentMethods: Array<PaymentMethods>, date: string, note?: string | null } | null }> } };

export type AuthorizedUsersQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type AuthorizedUsersQuery = { __typename?: 'Query', authorizedUsers: { __typename?: 'AuthorizedUsersConnection', items: Array<{ __typename?: 'AuthorizedUser', id?: string | null, accountId?: string | null, userEmail: string, accessLevel: AuthorizedUserAccessLevel, storeId?: string | null, status: AuthorizedUserStatus, createdAt?: string | null, updatedAt?: string | null, lastLoginAt?: string | null }> } };

export type AvailablePaymentMethodsQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type AvailablePaymentMethodsQuery = { __typename?: 'Query', availablePaymentMethods?: Array<{ __typename?: 'AvailablePaymentMethod', paymentMethod?: PaymentMethods | null, configured?: boolean | null, enabled?: boolean | null }> | null };

export type AvailableProcessorsQueryVariables = Exact<{
  accountId: Scalars['ID'];
  paymentMethod: PaymentMethods;
}>;


export type AvailableProcessorsQuery = { __typename?: 'Query', availableProcessors?: Array<{ __typename?: 'AvailableProcessor', paymentMethod?: PaymentMethods | null, processor?: Processor | null, configured?: boolean | null, enabled?: boolean | null }> | null };

export type ProviderConfigQueryVariables = Exact<{
  paymentMethod: PaymentMethods;
  processor: Processor;
}>;


export type ProviderConfigQuery = { __typename?: 'Query', providerConfig?: { __typename?: 'ProviderConfig', paymentMethod?: PaymentMethods | null, processor?: Processor | null, acquirers?: Array<Acquirer> | null, metadataConfig?: Array<{ __typename?: 'MetadataConfigItem', key: string, type: MetadataItemType, label?: string | null, possibleValues?: Array<string> | null, default?: string | null, regex?: string | null, secret?: boolean | null, example?: string | null }> | null } | null };

export type ProviderQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProviderQuery = { __typename?: 'Query', provider?: { __typename?: 'Provider', id: string, processor?: Processor | null, enabled?: boolean | null, test?: boolean | null, paymentMethod?: PaymentMethods | null, acquirer?: Acquirer | null, nativeHostedPayment?: boolean | null, metadata?: Array<{ __typename?: 'MetadataItem', key: string, value?: string | null, type: MetadataItemType, label?: string | null, possibleValues?: Array<string> | null, regex?: string | null, example?: string | null, secret?: boolean | null }> | null, rules?: { __typename?: 'ProviderRules', minAmount?: number | null, maxAmount?: number | null, shopNameLike?: string | null, descriptionLike?: string | null } | null } | null };

export type ProvidersQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type ProvidersQuery = { __typename?: 'Query', providers?: Array<{ __typename?: 'Provider', id: string, processor?: Processor | null, enabled?: boolean | null, test?: boolean | null, paymentMethod?: PaymentMethods | null, acquirer?: Acquirer | null, nativeHostedPayment?: boolean | null, metadata?: Array<{ __typename?: 'MetadataItem', key: string, value?: string | null, type: MetadataItemType, label?: string | null, possibleValues?: Array<string> | null, regex?: string | null, example?: string | null, secret?: boolean | null }> | null, rules?: { __typename?: 'ProviderRules', minAmount?: number | null, maxAmount?: number | null, shopNameLike?: string | null, descriptionLike?: string | null } | null }> | null };

export type ChargesQueryVariables = Exact<{
  filter?: InputMaybe<SearchableChargeFilterInput>;
  size?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['Int']>;
}>;


export type ChargesQuery = { __typename?: 'Query', charges: { __typename?: 'ChargesConnection', total: number, items: Array<{ __typename?: 'Charge', id: string, accountId: string, providerId?: string | null, checkoutId: string, sequenceId?: string | null, processor?: Processor | null, subscriptionId?: string | null, pointOfSaleId?: string | null, providerReferenceId?: string | null, providerInternalId?: string | null, masterAccountId?: string | null, billingPlan?: BillingPlans | null, createdAt: any, updatedAt?: any | null, amount?: number | null, acquirer?: Acquirer | null, authorizationCode?: string | null, storeId?: string | null, currency: string, description?: string | null, descriptor?: string | null, livemode?: boolean | null, orderId?: string | null, refundedAmount?: number | null, lastRefundAmount?: number | null, lastRefundReason?: RefundReason | null, cancellationReason?: CancellationReason | null, status: ChargeStatus, statusCode?: string | null, statusMessage?: string | null, providerStatusCode?: string | null, providerStatusMessage?: string | null, issuerStatusCode?: string | null, issuerStatusMessage?: string | null, billingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, taxId?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, customer?: { __typename?: 'Customer', email?: string | null, name?: string | null, phone?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', method?: PaymentMethods | null, bizum?: { __typename?: 'PaymentMethodBizum', phoneNumber?: string | null, integrationType?: string | null } | null, card?: { __typename?: 'PaymentMethodCard', brand?: CardBrand | null, country?: string | null, type?: CardType | null, threeDSecure?: boolean | null, threeDSecureVersion?: string | null, threeDSecureFlow?: ThreeDSecureFlow | null, threeDSecureStatus?: ThreeDsStatus | null, last4?: string | null, cardholderName?: string | null, cardholderEmail?: string | null, expiration?: any | null, bank?: string | null, tokenizationMethod?: TokenizationMethods | null, srcCorrelationId?: string | null, srciTransactionId?: string | null, srcDpaId?: string | null } | null, cardPresent?: { __typename?: 'PaymentMethodCardPresent', bin?: string | null, brand?: CardBrand | null, cardholderEmail?: string | null, cardholderName?: string | null, country?: string | null, expiration?: any | null, last4?: string | null, type?: CardType | null } | null, mbway?: { __typename?: 'PaymentMethodMBWay', phoneNumber?: string | null } | null, paypal?: { __typename?: 'PaymentMethodPaypal', orderId?: string | null, payerId?: string | null, email?: string | null, name?: string | null } | null, sepa?: { __typename?: 'PaymentMethodSepa', accountholderEmail?: string | null, accountholderName?: string | null, countryCode?: string | null, bankAddress?: string | null, bankCode?: string | null, bankName?: string | null, bic?: string | null, last4?: string | null, accountholderAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, trustly?: { __typename?: 'PaymentMethodTrustly', customerId?: string | null } | null, klarna?: { __typename?: 'PaymentMethodKlarna', billingCategory?: BillingCategoryKlarna | null, authPaymentMethod?: AuthPaymentMethodKlarna | null } | null } | null, shippingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, taxId?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, shop?: { __typename?: 'Shop', name?: string | null, country?: string | null } | null, sessionDetails?: { __typename?: 'SessionDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, browserColorDepth?: string | null, browserScreenHeight?: string | null, browserScreenWidth?: string | null, browserTimezoneOffset?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null }> } };

export type ChargesExportQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ChargesExportQuery = { __typename?: 'Query', chargesExport?: { __typename?: 'ChargesExport', id: string, status: ExportStatus, statusCode?: string | null, statusMessage?: string | null } | null };

export type ChargeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ChargeQuery = { __typename?: 'Query', charge?: { __typename?: 'Charge', id: string, accountId: string, providerId?: string | null, checkoutId: string, sequenceId?: string | null, processor?: Processor | null, subscriptionId?: string | null, pointOfSaleId?: string | null, providerReferenceId?: string | null, providerInternalId?: string | null, masterAccountId?: string | null, billingPlan?: BillingPlans | null, createdAt: any, updatedAt?: any | null, amount?: number | null, acquirer?: Acquirer | null, authorizationCode?: string | null, storeId?: string | null, currency: string, description?: string | null, descriptor?: string | null, livemode?: boolean | null, orderId?: string | null, refundedAmount?: number | null, lastRefundAmount?: number | null, lastRefundReason?: RefundReason | null, cancellationReason?: CancellationReason | null, status: ChargeStatus, statusCode?: string | null, statusMessage?: string | null, providerStatusCode?: string | null, providerStatusMessage?: string | null, issuerStatusCode?: string | null, issuerStatusMessage?: string | null, billingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, taxId?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, customer?: { __typename?: 'Customer', email?: string | null, name?: string | null, phone?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', method?: PaymentMethods | null, bizum?: { __typename?: 'PaymentMethodBizum', phoneNumber?: string | null, integrationType?: string | null } | null, card?: { __typename?: 'PaymentMethodCard', brand?: CardBrand | null, country?: string | null, type?: CardType | null, threeDSecure?: boolean | null, threeDSecureVersion?: string | null, threeDSecureFlow?: ThreeDSecureFlow | null, threeDSecureStatus?: ThreeDsStatus | null, last4?: string | null, cardholderName?: string | null, cardholderEmail?: string | null, expiration?: any | null, bank?: string | null, tokenizationMethod?: TokenizationMethods | null, srcCorrelationId?: string | null, srciTransactionId?: string | null, srcDpaId?: string | null } | null, cardPresent?: { __typename?: 'PaymentMethodCardPresent', bin?: string | null, brand?: CardBrand | null, cardholderEmail?: string | null, cardholderName?: string | null, country?: string | null, expiration?: any | null, last4?: string | null, type?: CardType | null } | null, mbway?: { __typename?: 'PaymentMethodMBWay', phoneNumber?: string | null } | null, paypal?: { __typename?: 'PaymentMethodPaypal', orderId?: string | null, payerId?: string | null, email?: string | null, name?: string | null } | null, sepa?: { __typename?: 'PaymentMethodSepa', accountholderEmail?: string | null, accountholderName?: string | null, countryCode?: string | null, bankAddress?: string | null, bankCode?: string | null, bankName?: string | null, bic?: string | null, last4?: string | null, accountholderAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, trustly?: { __typename?: 'PaymentMethodTrustly', customerId?: string | null } | null, klarna?: { __typename?: 'PaymentMethodKlarna', billingCategory?: BillingCategoryKlarna | null, authPaymentMethod?: AuthPaymentMethodKlarna | null } | null } | null, shippingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, taxId?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, shop?: { __typename?: 'Shop', name?: string | null, country?: string | null } | null, sessionDetails?: { __typename?: 'SessionDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, browserColorDepth?: string | null, browserScreenHeight?: string | null, browserScreenWidth?: string | null, browserTimezoneOffset?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null } | null };

export type SucceededDateRangeKpiQueryVariables = Exact<{
  start?: InputMaybe<Scalars['Int']>;
  end?: InputMaybe<Scalars['Int']>;
  interval?: InputMaybe<Interval>;
  accountId?: InputMaybe<Scalars['ID']>;
  acquirer?: InputMaybe<Acquirer>;
  masterAccountId?: InputMaybe<Scalars['ID']>;
  billingPlan?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<PaymentMethods>;
  source?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Currencies>;
}>;


export type SucceededDateRangeKpiQuery = { __typename?: 'Query', chargesDateRangeKPI: { __typename?: 'ChargesDateRangeKPI', currency: Currencies, total: { __typename?: 'ChargesDateRangeKPITotal', succeededAmount: any, succeededCount: any }, data: Array<{ __typename?: 'ChargesDateRangeKPIRow', timestamp: any, cuSucceededAmount: any, cuSucceededCount: any }> } };

export type ChargesDateRangeKpiQueryVariables = Exact<{
  start?: InputMaybe<Scalars['Int']>;
  end?: InputMaybe<Scalars['Int']>;
  interval?: InputMaybe<Interval>;
  accountId?: InputMaybe<Scalars['ID']>;
  acquirer?: InputMaybe<Acquirer>;
  masterAccountId?: InputMaybe<Scalars['ID']>;
  billingPlan?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<PaymentMethods>;
  source?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Currencies>;
}>;


export type ChargesDateRangeKpiQuery = { __typename?: 'Query', chargesDateRangeKPI: { __typename?: 'ChargesDateRangeKPI', currency: Currencies, total: { __typename?: 'ChargesDateRangeKPITotal', succeededAmount: any, succeededCount: any, refundedAmount: any, refundedCount: any, failedCount: any }, data: Array<{ __typename?: 'ChargesDateRangeKPIRow', timestamp: any, succeededAmount: any, succeededCount: any, refundedAmount: any, refundedCount: any, failedCount: any }> } };

export type ChargeEventsQueryVariables = Exact<{
  chargeId: Scalars['ID'];
  size?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['Int']>;
}>;


export type ChargeEventsQuery = { __typename?: 'Query', chargeEvents: { __typename?: 'ChargeEventsConnection', total: number, items: Array<{ __typename?: 'ChargeEvent', id: string, type: string, accountId: string, livemode?: boolean | null, objectId: string, objectType: string, createdAt?: any | null, object: { __typename?: 'ChargeEventObject', id: string, accountId: string, providerId?: string | null, checkoutId: string, sequenceId?: string | null, billingPlan?: BillingPlans | null, subscriptionId?: string | null, providerReferenceId?: string | null, providerInternalId?: string | null, createdAt?: any | null, updatedAt?: any | null, amount?: number | null, authorizationCode?: string | null, currency: string, description?: string | null, livemode?: boolean | null, orderId?: string | null, masterAccountId?: string | null, refundedAmount?: number | null, lastRefundAmount?: number | null, lastRefundReason?: RefundReason | null, cancellationReason?: CancellationReason | null, status: ChargeStatus, statusCode?: string | null, statusMessage?: string | null, billingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, taxId?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, customer?: { __typename?: 'Customer', email?: string | null, name?: string | null, phone?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', method?: PaymentMethods | null, bizum?: { __typename?: 'PaymentMethodBizum', phoneNumber?: string | null, integrationType?: string | null } | null, card?: { __typename?: 'PaymentMethodCard', brand?: CardBrand | null, country?: string | null, type?: CardType | null, threeDSecure?: boolean | null, threeDSecureVersion?: string | null, threeDSecureFlow?: ThreeDSecureFlow | null, threeDSecureStatus?: ThreeDsStatus | null, last4?: string | null, cardholderName?: string | null, cardholderEmail?: string | null, expiration?: any | null, bank?: string | null, tokenizationMethod?: TokenizationMethods | null, srcCorrelationId?: string | null, srciTransactionId?: string | null, srcDpaId?: string | null } | null, cardPresent?: { __typename?: 'PaymentMethodCardPresent', bin?: string | null, brand?: CardBrand | null, cardholderEmail?: string | null, cardholderName?: string | null, country?: string | null, expiration?: any | null, last4?: string | null, type?: CardType | null } | null, mbway?: { __typename?: 'PaymentMethodMBWay', phoneNumber?: string | null } | null, paypal?: { __typename?: 'PaymentMethodPaypal', orderId?: string | null, payerId?: string | null, email?: string | null, name?: string | null } | null, sepa?: { __typename?: 'PaymentMethodSepa', accountholderEmail?: string | null, accountholderName?: string | null, countryCode?: string | null, bankAddress?: string | null, bankCode?: string | null, bankName?: string | null, bic?: string | null, last4?: string | null, accountholderAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, trustly?: { __typename?: 'PaymentMethodTrustly', customerId?: string | null } | null, klarna?: { __typename?: 'PaymentMethodKlarna', billingCategory?: BillingCategoryKlarna | null, authPaymentMethod?: AuthPaymentMethodKlarna | null } | null } | null, shippingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, taxId?: string | null, phone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, shop?: { __typename?: 'Shop', name?: string | null, country?: string | null } | null, sessionDetails?: { __typename?: 'SessionDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, browserColorDepth?: string | null, browserScreenHeight?: string | null, browserScreenWidth?: string | null, browserTimezoneOffset?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null } }> } };

export type EventsQueryVariables = Exact<{
  filter?: InputMaybe<SearchableEventFilterInput>;
  size?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['Int']>;
}>;


export type EventsQuery = { __typename?: 'Query', events: { __typename?: 'ChargeEventsConnection', total: number, items: Array<{ __typename?: 'ChargeEvent', id: string, type: string, accountId: string, livemode?: boolean | null, objectId: string, objectType: string, createdAt?: any | null, object: { __typename?: 'ChargeEventObject', id: string, accountId: string, providerId?: string | null, checkoutId: string, sequenceId?: string | null, billingPlan?: BillingPlans | null, subscriptionId?: string | null, providerReferenceId?: string | null, providerInternalId?: string | null, createdAt?: any | null, updatedAt?: any | null, amount?: number | null, authorizationCode?: string | null, currency: string, description?: string | null, livemode?: boolean | null, orderId?: string | null, masterAccountId?: string | null, refundedAmount?: number | null, lastRefundAmount?: number | null, lastRefundReason?: RefundReason | null, cancellationReason?: CancellationReason | null, status: ChargeStatus, statusCode?: string | null, statusMessage?: string | null, billingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, taxId?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, customer?: { __typename?: 'Customer', email?: string | null, name?: string | null, phone?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', method?: PaymentMethods | null, bizum?: { __typename?: 'PaymentMethodBizum', phoneNumber?: string | null, integrationType?: string | null } | null, card?: { __typename?: 'PaymentMethodCard', brand?: CardBrand | null, country?: string | null, type?: CardType | null, threeDSecure?: boolean | null, threeDSecureVersion?: string | null, threeDSecureFlow?: ThreeDSecureFlow | null, threeDSecureStatus?: ThreeDsStatus | null, last4?: string | null, cardholderName?: string | null, cardholderEmail?: string | null, expiration?: any | null, bank?: string | null, tokenizationMethod?: TokenizationMethods | null, srcCorrelationId?: string | null, srciTransactionId?: string | null, srcDpaId?: string | null } | null, cardPresent?: { __typename?: 'PaymentMethodCardPresent', bin?: string | null, brand?: CardBrand | null, cardholderEmail?: string | null, cardholderName?: string | null, country?: string | null, expiration?: any | null, last4?: string | null, type?: CardType | null } | null, mbway?: { __typename?: 'PaymentMethodMBWay', phoneNumber?: string | null } | null, paypal?: { __typename?: 'PaymentMethodPaypal', orderId?: string | null, payerId?: string | null, email?: string | null, name?: string | null } | null, sepa?: { __typename?: 'PaymentMethodSepa', accountholderEmail?: string | null, accountholderName?: string | null, countryCode?: string | null, bankAddress?: string | null, bankCode?: string | null, bankName?: string | null, bic?: string | null, last4?: string | null, accountholderAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, trustly?: { __typename?: 'PaymentMethodTrustly', customerId?: string | null } | null, klarna?: { __typename?: 'PaymentMethodKlarna', billingCategory?: BillingCategoryKlarna | null, authPaymentMethod?: AuthPaymentMethodKlarna | null } | null } | null, shippingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, taxId?: string | null, phone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, shop?: { __typename?: 'Shop', name?: string | null, country?: string | null } | null, sessionDetails?: { __typename?: 'SessionDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, browserColorDepth?: string | null, browserScreenHeight?: string | null, browserScreenWidth?: string | null, browserTimezoneOffset?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null } }> } };

export type UserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, email: string, emailVerified?: boolean | null, phoneNumber?: string | null, phoneNumberVerified?: boolean | null, smsMfaEnabled?: boolean | null, status: UserStatus, enabled: boolean, accountId?: string | null, testAccountId?: string | null, referralCode?: string | null, promoCode?: string | null, createdAt: string } | null };

export type UsersQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type UsersQuery = { __typename?: 'Query', users: { __typename?: 'UsersConnection', nextToken?: string | null, items: Array<{ __typename?: 'User', id: string, email: string, emailVerified?: boolean | null, phoneNumber?: string | null, phoneNumberVerified?: boolean | null, smsMfaEnabled?: boolean | null, status: UserStatus, enabled: boolean, accountId?: string | null, testAccountId?: string | null, referralCode?: string | null, promoCode?: string | null, createdAt: string }> } };

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { __typename?: 'Query', countries: { __typename?: 'Countries', currentCountryCode?: string | null, isSupported: boolean, supportedCountries: Array<{ __typename?: 'Country', name: string, phoneCode: string, code: string }>, currentCountry?: { __typename?: 'Country', name: string, phoneCode: string, code: string } | null } };

export type AccountActualFeesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AccountActualFeesQuery = { __typename?: 'Query', accountActualFees?: { __typename?: 'AccountActualFees', highRiskFee: number, dailyPlatformFee: number, dailyExtraSeatsFee: number, weeklyCustomDomainFee: number, extra?: Array<{ __typename?: 'AccountExtraFee', name: string, amount: number, type: AccountExtraFeeType, region?: AccountExtraFeeRegion | null, masterAccountFee?: boolean | null, paymentMethods?: Array<PaymentMethods> | null }> | null, steps: Array<{ __typename?: 'AccountSteps', from: number, trxFee: number, trxFlatFee: number, bizumTrxFlatFee?: number | null, bizumTrxFee?: number | null }> } | null };

export type AccountEventsQueryVariables = Exact<{
  accountId: Scalars['ID'];
  size?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['Int']>;
}>;


export type AccountEventsQuery = { __typename?: 'Query', accountEvents: { __typename?: 'AccountEventsConnection', total: number, items: Array<{ __typename?: 'AccountEvent', id: string, type: string, accountId: string, livemode?: boolean | null, objectId: string, objectType: string, createdAt?: any | null, object: { __typename?: 'AccountEventObject', id: string, refAccountId?: string | null, name?: string | null, status: AccountStatus, note?: string | null, userNote?: string | null, partner?: Partner | null, acquirer?: Acquirer | null, adminEmail?: string | null, defaultCurrency?: Currencies | null, tags?: Array<string> | null, defaultTransactionType?: TransactionTypes | null, referralCode?: string | null, promoCode?: string | null, reviewConfirmed?: boolean | null, billingPlan?: BillingPlans | null, riskScore?: number | null, iban?: string | null, dynamicBilling?: boolean | null, test?: boolean | null, customDomain?: string | null, createdAt?: string | null, updatedAt?: string | null, deletedAt?: string | null, approvedAt?: string | null, rejectedAt?: string | null, activatedAt?: string | null, approvalRequestedAt?: string | null, riskProfile?: RiskProfile | null, riskProfileNote?: string | null, riskIgnoredKeywords?: Array<string> | null, riskUpdatedAt?: string | null, suspendedAt?: string | null, dataUpdatedAt?: string | null, churnReason?: ChurnReason | null, churnReasonOption?: string | null, churnNote?: string | null, statusReason?: StatusReason | null, statusNote?: string | null, accountExecutive?: string | null, tokenizationMethods?: { __typename?: 'AccountTokenizationMethods', googlePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, applePay?: { __typename?: 'AccountTokenizationMethodsItem', enabled?: boolean | null } | null, clickToPay?: { __typename?: 'AccountTokenizationMethodsClickToPayItem', enabled?: boolean | null } | null } | null, notifications?: { __typename?: 'AccountNotifications', emailCustomerOnRefund?: boolean | null, emailCustomerOnSuccess?: boolean | null, emailAdminOnSuccess?: boolean | null } | null, fees?: { __typename?: 'AccountFees', highRiskFee?: number | null, dailyExtraSeatsFee?: number | null, dailyPlatformFee?: number | null, weeklyCustomDomainFee?: number | null, steps?: Array<{ __typename?: 'AccountSteps', trxFee: number, bizumTrxFee?: number | null, bizumTrxFlatFee?: number | null, trxFlatFee: number, from: number }> | null, extra?: Array<{ __typename?: 'AccountExtraFee', name: string, amount: number, type: AccountExtraFeeType, paymentMethods?: Array<PaymentMethods> | null, region?: AccountExtraFeeRegion | null }> | null } | null, business?: { __typename?: 'BusinessData', country?: string | null, legalForm?: LegalForm | null, legalName?: string | null, companyName?: string | null, mcc?: string | null, documentNumber?: string | null, status?: BusinessStatus | null, email?: string | null, phone?: string | null, website?: string | null, monthlyVolume?: number | null, confirmWebsite?: boolean | null, industry?: Industries | null, servicesDescription?: string | null, confirmServicesDescription?: boolean | null, legalAddress?: string | null, legalDescription?: string | null, creationDate?: string | null, lastUpdateDate?: string | null, startActivityDate?: string | null, capital?: any | null, previousNames?: Array<string | null> | null, verificationAttempts?: number | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, registryRecords?: Array<{ __typename?: 'RegistryRecord', name?: string | null, url?: string | null, province?: string | null, date?: string | null }> | null, positions?: Array<{ __typename?: 'BusinessPosition', fromDate?: string | null, role?: string | null, name?: string | null }> | null } | null, representatives?: Array<{ __typename?: 'Representative', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, documentNumber?: string | null, stocksPercentage?: number | null, gender?: Gender | null, citizenship?: string | null, dateOfBirth?: string | null, nationality?: string | null, yearOfBirth?: string | null, placeOfBirth?: string | null, idSession?: string | null, interventionType?: Array<InterventionType> | null, status?: IdVerificationStatus | null, statusCode?: number | null, hasNoPublicActivity?: boolean | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null, document?: { __typename?: 'IdDocument', type?: IdDocumentType | null, number?: string | null, country?: string | null, validFrom?: string | null, validUntil?: string | null } | null, riskLabels?: Array<{ __typename?: 'RiskLabel', label?: string | null, category?: string | null }> | null }> | null, payoutTerms?: { __typename?: 'AccountPayoutTerms', iban?: string | null, period?: number | null, firstPeriod?: number | null, reservePercent?: number | null, suspended?: boolean | null, releaseReserve?: boolean | null } | null, publicBusinessDetails?: { __typename?: 'AccountPublicBusinessDetails', companyName?: string | null, website?: string | null, phone?: string | null, supportWebsite?: string | null, supportPhone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, branding?: { __typename?: 'AccountBranding', accentColor?: string | null, bgColor?: string | null, logoUrl?: string | null, iconUrl?: string | null } | null, contract?: { __typename?: 'AccountContract', envelopeId: string, status: ContractStatus, path?: string | null, signedDate?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null, upsell?: { __typename?: 'Upsell', executive: SalesExecutive, paymentMethods: Array<PaymentMethods>, date: string, note?: string | null } | null } }> } };

export type SettlementsQueryVariables = Exact<{
  filter?: InputMaybe<SearchableSettlementFilterInput>;
  size?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['Int']>;
}>;


export type SettlementsQuery = { __typename?: 'Query', settlements: { __typename?: 'SettlementsConnection', total: number, items: Array<{ __typename?: 'Settlement', accountId: string, acquirer: SettlementAcquirer, acquirerFees: number, grossVolume: number, iban?: string | null, id: string, payMethod?: SettlementPayMethods | null, netVolume: number, periodEndAt: any, periodStartAt: any, releasedAmount?: number | null, reservedAmount?: number | null, scheduledAt: any, status: SettlementStatus, legalName?: string | null, storeId?: string | null, settleGross?: boolean | null }> } };

export type AccountInvoicesQueryVariables = Exact<{
  filter?: InputMaybe<SearchableInvoiceFilterInput>;
  size?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['Int']>;
}>;


export type AccountInvoicesQuery = { __typename?: 'Query', accountInvoices: { __typename?: 'InvoicesConnection', total: number, items: Array<{ __typename?: 'AccountInvoice', id?: string | null, number?: string | null, accountId: string, currency: string, amount: number, tax: number, totalAmount: number, status?: AccountInvoiceStatus | null, paymentMethod?: AccountInvoicePaymentMethod | null, period: { __typename?: 'AccountInvoicePeriod', from?: any | null, to?: any | null }, lineItems: Array<{ __typename?: 'AccountInvoiceLineItem', name: string, quantity: number, unitAmount: number, unitType: InvoiceLineItemUnitType, currency: string, amount: number }>, business?: { __typename?: 'InvoiceBusinessData', iban?: string | null } | null }> } };

export type PreviewPaymentEmailQueryVariables = Exact<{
  paymentId: Scalars['ID'];
  emailType?: InputMaybe<PaymentEmailType>;
  language?: InputMaybe<Scalars['String']>;
  accountId: Scalars['ID'];
}>;


export type PreviewPaymentEmailQuery = { __typename?: 'Query', previewPaymentEmail?: string | null };

export type AccountStatsQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type AccountStatsQuery = { __typename?: 'Query', accountStats: { __typename?: 'AccountStats', stats?: { __typename?: 'Stats', firstTransactionAt?: any | null, activeMonths?: number | null, avgMonthlyTransactions?: number | null, avgMonthlyVolume?: number | null, churned?: boolean | null, totalSucceededCount?: number | null, lastTransactionAt?: any | null, totalSucceededAmount?: number | null } | null } };

export type MasterAccountsQueryVariables = Exact<{
  filter?: InputMaybe<SearchableMasterAccountFilterInput>;
  size?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['Int']>;
}>;


export type MasterAccountsQuery = { __typename?: 'Query', masterAccounts: { __typename?: 'MasterAccountsConnection', total: number, items: Array<{ __typename?: 'MasterAccount', id: string, testAccountId?: string | null, prodAccountId?: string | null, name?: string | null, adminEmail?: string | null, iban?: string | null, apiKey?: string | null, test?: boolean | null, status?: AccountStatus | null, promoCode?: string | null, allowedIPs?: Array<string> | null, createdAt?: string | null, updatedAt?: string | null, webhookEmails?: Array<string> | null, churnedEmails?: Array<string> | null, allowedDomains?: Array<string> | null, accountCallbackUrl?: string | null, requireExternalId?: boolean | null, contractTemplateId?: string | null, autoApprove?: boolean | null, blocked?: boolean | null, allowCreateApiKey?: boolean | null, payoutTerms?: { __typename?: 'AccountPayoutTerms', iban?: string | null, firstPeriod?: number | null, period?: number | null, reservePercent?: number | null, suspended?: boolean | null, releaseReserve?: boolean | null } | null, accountDefaults?: { __typename?: 'AccountDefaults', billingPlan?: BillingPlans | null, language?: string | null, fees?: { __typename?: 'AccountFees', trxFee?: number | null, trxFlatFee?: number | null, highRiskFee?: number | null, dailyPlatformFee?: number | null, dailyExtraSeatsFee?: number | null, steps?: Array<{ __typename?: 'AccountSteps', trxFee: number, bizumTrxFee?: number | null, bizumTrxFlatFee?: number | null, trxFlatFee: number, from: number }> | null, extra?: Array<{ __typename?: 'AccountExtraFee', name: string, amount: number, type: AccountExtraFeeType, region?: AccountExtraFeeRegion | null, masterAccountFee?: boolean | null, paymentMethods?: Array<PaymentMethods> | null }> | null } | null, business?: { __typename?: 'BusinessDefault', mcc?: string | null, website?: string | null, servicesDescription?: string | null } | null } | null, business?: { __typename?: 'BusinessData', mcc?: string | null, legalName?: string | null, website?: string | null, documentNumber?: string | null, servicesDescription?: string | null } | null }> } };

export type StoresQueryVariables = Exact<{
  accountId: Scalars['ID'];
  pageSize?: InputMaybe<Scalars['Int']>;
  token?: InputMaybe<Scalars['String']>;
}>;


export type StoresQuery = { __typename?: 'Query', stores: { __typename?: 'StoresConnection', nextToken?: string | null, items: Array<{ __typename?: 'Store', id: string, accountId: string, name?: string | null, email?: string | null, iban?: string | null, phone?: string | null, website?: string | null, documentNumber?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null }> } };

export type StoreQueryVariables = Exact<{
  id: Scalars['ID'];
  accountId: Scalars['ID'];
}>;


export type StoreQuery = { __typename?: 'Query', store?: { __typename?: 'Store', id: string, name?: string | null } | null };

export type DocumentsQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type DocumentsQuery = { __typename?: 'Query', documents: { __typename?: 'DocumentsConnection', items: Array<{ __typename?: 'Document', id: string, accountId: string, type: DocumentType, status: DocumentStatus, statusMessage?: string | null, statusCode?: string | null, contentType?: string | null, createdAt: string, updatedAt?: string | null, name?: string | null, note?: string | null, internal?: boolean | null, metadata?: Array<{ __typename?: 'DocumentMetadataItem', key: string, value?: Array<string> | null }> | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null }> } };

export type DocumentQueryVariables = Exact<{
  id: Scalars['ID'];
  accountId: Scalars['ID'];
}>;


export type DocumentQuery = { __typename?: 'Query', document?: { __typename?: 'Document', id: string, accountId: string, type: DocumentType, status: DocumentStatus, statusMessage?: string | null, statusCode?: string | null, contentType?: string | null, createdAt: string, updatedAt?: string | null, name?: string | null, note?: string | null, internal?: boolean | null, metadata?: Array<{ __typename?: 'DocumentMetadataItem', key: string, value?: Array<string> | null }> | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null } | null };

export type DocumentEventsQueryVariables = Exact<{
  documentId: Scalars['ID'];
}>;


export type DocumentEventsQuery = { __typename?: 'Query', documentEvents: { __typename?: 'DocumentEventsConnection', total: number, items: Array<{ __typename?: 'DocumentEvent', id: string, type: string, accountId: string, objectId: string, objectType: string, createdAt: any, object: { __typename?: 'DocumentEventObject', id: string, accountId: string, type: DocumentType, status: DocumentStatus, statusCode?: string | null, statusMessage?: string | null, contentType?: string | null, createdAt: any, updatedAt?: any | null, note?: string | null, name?: string | null, internal?: boolean | null, metadata?: Array<{ __typename?: 'DocumentMetadataItem', key: string, value?: Array<string> | null }> | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null } }> } };

export type SubscriptionsQueryVariables = Exact<{
  filter?: InputMaybe<SearchableSubscriptionFilterInput>;
  size?: InputMaybe<Scalars['Int']>;
  from?: InputMaybe<Scalars['Int']>;
}>;


export type SubscriptionsQuery = { __typename?: 'Query', subscriptions: { __typename?: 'SubscriptionsConnection', total: number, items: Array<{ __typename?: 'Subscription', id: string, accountId: string, livemode: boolean, amount: number, currency?: Currencies | null, description?: string | null, planVariantId?: string | null, productId?: string | null, cancelAtPeriodEnd?: boolean | null, pauseIntervalCount?: number | null, pauseAtPeriodEnd?: boolean | null, currentPeriodStart?: number | null, currentPeriodEnd?: number | null, trialPeriodDays?: number | null, trialPeriodEnd?: number | null, customerId?: string | null, defaultTokenId?: string | null, sequenceId?: string | null, lastInvoiceId?: string | null, lastOrderId?: string | null, nextPaymentAt?: number | null, createdAt?: number | null, updatedAt?: number | null, interval: Interval, intervalCount: number, retryCount?: number | null, status: SubscriptionStatus, callbackUrl?: string | null, paymentCallbackUrl?: string | null, storeId?: string | null, masterAccountId?: string | null, customer?: { __typename?: 'Customer', email?: string | null, name?: string | null, phone?: string | null } | null, billingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, shippingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, lastPayment?: { __typename?: 'LastPayment', id: string, status: PaymentStatus, statusMessage?: string | null, statusCode?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', method?: PaymentMethods | null, bizum?: { __typename?: 'PaymentMethodBizum', phoneNumber?: string | null, integrationType?: string | null } | null, card?: { __typename?: 'PaymentMethodCard', brand?: CardBrand | null, country?: string | null, type?: CardType | null, threeDSecure?: boolean | null, threeDSecureVersion?: string | null, threeDSecureFlow?: ThreeDSecureFlow | null, threeDSecureStatus?: ThreeDsStatus | null, last4?: string | null, cardholderName?: string | null, cardholderEmail?: string | null, expiration?: any | null, bank?: string | null, tokenizationMethod?: TokenizationMethods | null, srcCorrelationId?: string | null, srciTransactionId?: string | null, srcDpaId?: string | null } | null, cardPresent?: { __typename?: 'PaymentMethodCardPresent', bin?: string | null, brand?: CardBrand | null, cardholderEmail?: string | null, cardholderName?: string | null, country?: string | null, expiration?: any | null, last4?: string | null, type?: CardType | null } | null, mbway?: { __typename?: 'PaymentMethodMBWay', phoneNumber?: string | null } | null, paypal?: { __typename?: 'PaymentMethodPaypal', orderId?: string | null, payerId?: string | null, email?: string | null, name?: string | null } | null, sepa?: { __typename?: 'PaymentMethodSepa', accountholderEmail?: string | null, accountholderName?: string | null, countryCode?: string | null, bankAddress?: string | null, bankCode?: string | null, bankName?: string | null, bic?: string | null, last4?: string | null, accountholderAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, trustly?: { __typename?: 'PaymentMethodTrustly', customerId?: string | null } | null, klarna?: { __typename?: 'PaymentMethodKlarna', billingCategory?: BillingCategoryKlarna | null, authPaymentMethod?: AuthPaymentMethodKlarna | null } | null } | null, metadata?: Array<{ __typename?: 'KeyValueItem', key: string, value?: string | null }> | null, sessionDetails?: { __typename?: 'SessionDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, browserColorDepth?: string | null, browserScreenHeight?: string | null, browserScreenWidth?: string | null, browserTimezoneOffset?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null }> } };

export type SubscriptionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SubscriptionQuery = { __typename?: 'Query', subscription?: { __typename?: 'Subscription', id: string, accountId: string, livemode: boolean, amount: number, currency?: Currencies | null, description?: string | null, planVariantId?: string | null, productId?: string | null, cancelAtPeriodEnd?: boolean | null, pauseIntervalCount?: number | null, pauseAtPeriodEnd?: boolean | null, currentPeriodStart?: number | null, currentPeriodEnd?: number | null, trialPeriodDays?: number | null, trialPeriodEnd?: number | null, customerId?: string | null, defaultTokenId?: string | null, sequenceId?: string | null, lastInvoiceId?: string | null, lastOrderId?: string | null, nextPaymentAt?: number | null, createdAt?: number | null, updatedAt?: number | null, interval: Interval, intervalCount: number, retryCount?: number | null, status: SubscriptionStatus, callbackUrl?: string | null, paymentCallbackUrl?: string | null, storeId?: string | null, masterAccountId?: string | null, customer?: { __typename?: 'Customer', email?: string | null, name?: string | null, phone?: string | null } | null, billingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, shippingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, lastPayment?: { __typename?: 'LastPayment', id: string, status: PaymentStatus, statusMessage?: string | null, statusCode?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', method?: PaymentMethods | null, bizum?: { __typename?: 'PaymentMethodBizum', phoneNumber?: string | null, integrationType?: string | null } | null, card?: { __typename?: 'PaymentMethodCard', brand?: CardBrand | null, country?: string | null, type?: CardType | null, threeDSecure?: boolean | null, threeDSecureVersion?: string | null, threeDSecureFlow?: ThreeDSecureFlow | null, threeDSecureStatus?: ThreeDsStatus | null, last4?: string | null, cardholderName?: string | null, cardholderEmail?: string | null, expiration?: any | null, bank?: string | null, tokenizationMethod?: TokenizationMethods | null, srcCorrelationId?: string | null, srciTransactionId?: string | null, srcDpaId?: string | null } | null, cardPresent?: { __typename?: 'PaymentMethodCardPresent', bin?: string | null, brand?: CardBrand | null, cardholderEmail?: string | null, cardholderName?: string | null, country?: string | null, expiration?: any | null, last4?: string | null, type?: CardType | null } | null, mbway?: { __typename?: 'PaymentMethodMBWay', phoneNumber?: string | null } | null, paypal?: { __typename?: 'PaymentMethodPaypal', orderId?: string | null, payerId?: string | null, email?: string | null, name?: string | null } | null, sepa?: { __typename?: 'PaymentMethodSepa', accountholderEmail?: string | null, accountholderName?: string | null, countryCode?: string | null, bankAddress?: string | null, bankCode?: string | null, bankName?: string | null, bic?: string | null, last4?: string | null, accountholderAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, trustly?: { __typename?: 'PaymentMethodTrustly', customerId?: string | null } | null, klarna?: { __typename?: 'PaymentMethodKlarna', billingCategory?: BillingCategoryKlarna | null, authPaymentMethod?: AuthPaymentMethodKlarna | null } | null } | null, metadata?: Array<{ __typename?: 'KeyValueItem', key: string, value?: string | null }> | null, sessionDetails?: { __typename?: 'SessionDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, browserColorDepth?: string | null, browserScreenHeight?: string | null, browserScreenWidth?: string | null, browserTimezoneOffset?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null } | null };

export type SubscriptionEventsQueryVariables = Exact<{
  subscriptionId: Scalars['ID'];
}>;


export type SubscriptionEventsQuery = { __typename?: 'Query', subscriptionEvents: { __typename?: 'SubscriptionEventsConnection', total: number, items: Array<{ __typename?: 'SubscriptionEvent', id: string, type: string, accountId: string, objectId: string, objectType: string, createdAt: any, object: { __typename?: 'SubscriptionEventObject', id: string, accountId: string, amount?: number | null, cancelAtPeriodEnd?: boolean | null, createdAt?: any | null, currency: string, currentPeriodEnd?: number | null, currentPeriodStart?: number | null, description?: string | null, interval: Interval, intervalCount: number, lastOrderId?: string | null, livemode?: boolean | null, pauseAtPeriodEnd?: boolean | null, pauseIntervalCount?: number | null, pointOfSaleId?: string | null, retryCount?: number | null, sequenceId?: string | null, status: SubscriptionStatus, storeId?: string | null, trialPeriodDays?: number | null, trialPeriodEnd?: number | null, updatedAt?: any | null, billingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, customer?: { __typename?: 'Customer', email?: string | null, name?: string | null, phone?: string | null } | null, lastPayment?: { __typename?: 'LastPayment', id: string, status: PaymentStatus, statusMessage?: string | null, statusCode?: string | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', method?: PaymentMethods | null, bizum?: { __typename?: 'PaymentMethodBizum', phoneNumber?: string | null, integrationType?: string | null } | null, card?: { __typename?: 'PaymentMethodCard', brand?: CardBrand | null, country?: string | null, type?: CardType | null, threeDSecure?: boolean | null, threeDSecureVersion?: string | null, threeDSecureFlow?: ThreeDSecureFlow | null, threeDSecureStatus?: ThreeDsStatus | null, last4?: string | null, cardholderName?: string | null, cardholderEmail?: string | null, expiration?: any | null, bank?: string | null, tokenizationMethod?: TokenizationMethods | null, srcCorrelationId?: string | null, srciTransactionId?: string | null, srcDpaId?: string | null } | null, cardPresent?: { __typename?: 'PaymentMethodCardPresent', bin?: string | null, brand?: CardBrand | null, cardholderEmail?: string | null, cardholderName?: string | null, country?: string | null, expiration?: any | null, last4?: string | null, type?: CardType | null } | null, mbway?: { __typename?: 'PaymentMethodMBWay', phoneNumber?: string | null } | null, paypal?: { __typename?: 'PaymentMethodPaypal', orderId?: string | null, payerId?: string | null, email?: string | null, name?: string | null } | null, sepa?: { __typename?: 'PaymentMethodSepa', accountholderEmail?: string | null, accountholderName?: string | null, countryCode?: string | null, bankAddress?: string | null, bankCode?: string | null, bankName?: string | null, bic?: string | null, last4?: string | null, accountholderAddress?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, trustly?: { __typename?: 'PaymentMethodTrustly', customerId?: string | null } | null, klarna?: { __typename?: 'PaymentMethodKlarna', billingCategory?: BillingCategoryKlarna | null, authPaymentMethod?: AuthPaymentMethodKlarna | null } | null } | null, shippingDetails?: { __typename?: 'ContactDetails', email?: string | null, name?: string | null, company?: string | null, phone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null } }> } };

export type PreviewSubscriptionEmailQueryVariables = Exact<{
  subscriptionId: Scalars['ID'];
  emailType?: InputMaybe<SubscriptionEmailType>;
  language?: InputMaybe<Scalars['String']>;
  accountId: Scalars['ID'];
}>;


export type PreviewSubscriptionEmailQuery = { __typename?: 'Query', previewSubscriptionEmail?: string | null };

export type ProviderEventsQueryVariables = Exact<{
  providerId?: InputMaybe<Scalars['ID']>;
  accountId: Scalars['ID'];
}>;


export type ProviderEventsQuery = { __typename?: 'Query', providerEvents: { __typename?: 'ProviderEventsConnection', total: number, items: Array<{ __typename?: 'ProviderEvent', id: string, type: string, accountId: string, objectId: string, objectType: string, createdAt: any, object: { __typename?: 'ProviderEventObject', id: string, internalId?: string | null, processor?: Processor | null, enabled?: boolean | null, test?: boolean | null, paymentMethod?: PaymentMethods | null, acquirer?: Acquirer | null, configurable?: boolean | null, nativeHostedPayment?: boolean | null, metadata?: Array<{ __typename?: 'ProviderMetadataItem', key: string, value?: Array<string> | null }> | null, rules?: { __typename?: 'ProviderRules', minAmount?: number | null, maxAmount?: number | null, shopNameLike?: string | null, descriptionLike?: string | null } | null, traceDetails?: { __typename?: 'TraceDetails', ip?: any | null, userAgent?: string | null, countryCode?: string | null, lang?: string | null, deviceType?: DeviceType | null, deviceModel?: string | null, browser?: string | null, browserVersion?: string | null, browserAccept?: string | null, os?: string | null, osVersion?: string | null, source?: string | null, sourceVersion?: string | null, userId?: string | null, userEmail?: string | null, userName?: string | null } | null } }> } };

export type AccountTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountTagsQuery = { __typename?: 'Query', accountTags: Array<string> };

export type ChargeSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type ChargeSourcesQuery = { __typename?: 'Query', chargeSources: Array<string> };

export type MasterAccountQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MasterAccountQuery = { __typename?: 'Query', masterAccount?: { __typename?: 'MasterAccount', id: string, testAccountId?: string | null, prodAccountId?: string | null, name?: string | null, adminEmail?: string | null, iban?: string | null, apiKey?: string | null, test?: boolean | null, status?: AccountStatus | null, promoCode?: string | null, allowedIPs?: Array<string> | null, createdAt?: string | null, updatedAt?: string | null, webhookEmails?: Array<string> | null, churnedEmails?: Array<string> | null, allowedDomains?: Array<string> | null, accountCallbackUrl?: string | null, requireExternalId?: boolean | null, contractTemplateId?: string | null, autoApprove?: boolean | null, blocked?: boolean | null, allowCreateApiKey?: boolean | null, payoutTerms?: { __typename?: 'AccountPayoutTerms', iban?: string | null, firstPeriod?: number | null, period?: number | null, reservePercent?: number | null, suspended?: boolean | null, releaseReserve?: boolean | null } | null, accountDefaults?: { __typename?: 'AccountDefaults', billingPlan?: BillingPlans | null, language?: string | null, fees?: { __typename?: 'AccountFees', trxFee?: number | null, trxFlatFee?: number | null, highRiskFee?: number | null, dailyPlatformFee?: number | null, dailyExtraSeatsFee?: number | null, steps?: Array<{ __typename?: 'AccountSteps', trxFee: number, bizumTrxFee?: number | null, bizumTrxFlatFee?: number | null, trxFlatFee: number, from: number }> | null, extra?: Array<{ __typename?: 'AccountExtraFee', name: string, amount: number, type: AccountExtraFeeType, region?: AccountExtraFeeRegion | null, masterAccountFee?: boolean | null, paymentMethods?: Array<PaymentMethods> | null }> | null } | null, business?: { __typename?: 'BusinessDefault', mcc?: string | null, website?: string | null, servicesDescription?: string | null } | null } | null, business?: { __typename?: 'BusinessData', mcc?: string | null, legalName?: string | null, website?: string | null, documentNumber?: string | null, servicesDescription?: string | null } | null } | null };

export type UserMasterAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type UserMasterAccountQuery = { __typename?: 'Query', userMasterAccount?: { __typename?: 'MasterAccount', id: string, name?: string | null, status?: AccountStatus | null, promoCode?: string | null, allowedIPs?: Array<string> | null, webhookEmails?: Array<string> | null, churnedEmails?: Array<string> | null, allowedDomains?: Array<string> | null, accountCallbackUrl?: string | null, requireExternalId?: boolean | null, apiKey?: string | null, publicBusinessDetails?: { __typename?: 'AccountPublicBusinessDetails', companyName?: string | null, website?: string | null, phone?: string | null, supportWebsite?: string | null, supportPhone?: string | null, address?: { __typename?: 'Address', city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, zip?: string | null, state?: string | null } | null } | null, branding?: { __typename?: 'AccountBranding', accentColor?: string | null, bgColor?: string | null, logoUrl?: string | null, iconUrl?: string | null } | null } | null };

export type NotificationsPortalUrlQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type NotificationsPortalUrlQuery = { __typename?: 'Query', notificationsPortalUrl?: { __typename?: 'Redirect', redirectUrl: string } | null };

export type WebhooksQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  accountId: Scalars['ID'];
}>;


export type WebhooksQuery = { __typename?: 'Query', webhooks: { __typename?: 'WebhooksConnection', nextToken?: string | null, items: Array<{ __typename?: 'Webhook', id: string, url: string, eventTypes: Array<WebhookEventType>, enabled: boolean, updatedAt?: string | null } | null> } };

export type RestrictedKeywordsQueryVariables = Exact<{ [key: string]: never; }>;


export type RestrictedKeywordsQuery = { __typename?: 'Query', restrictedKeywords?: Array<string> | null };

export type WebReportQueryVariables = Exact<{
  baseUrl: Scalars['String'];
}>;


export type WebReportQuery = { __typename?: 'Query', webReport?: { __typename?: 'WebReport', title?: string | null, description?: string | null, summary?: string | null, pageCount?: number | null, failedPageCount?: number | null, uncheckedPageCount?: number | null, legalDetailsUrl?: string | null, status?: WebReportStatus | null, statusCode?: string | null, statusMessage?: string | null, riskCategory?: string | null } | null };

export type WebKeywordsQueryVariables = Exact<{
  baseUrl: Scalars['String'];
  pageSize?: InputMaybe<Scalars['Int']>;
  token?: InputMaybe<Scalars['String']>;
}>;


export type WebKeywordsQuery = { __typename?: 'Query', webKeywords: { __typename?: 'WebKeywordsConnection', nextToken?: string | null, items: Array<{ __typename?: 'WebKeyword', accountId: string, url: string, createdAt?: any | null, expiresAt: any, urlKeyword: string, baseUrl: string, keyword: string, description?: string | null, updatedAt?: any | null, title?: string | null, context?: string | null, confirmed?: boolean | null, explanation?: string | null, incorrect?: boolean | null }> } };

export type AccountBalancesQueryVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type AccountBalancesQuery = { __typename?: 'Query', accountBalances: { __typename?: 'AccountBalancesConnection', items: Array<{ __typename?: 'AccountBalances', accountId?: string | null, currency: string, clearedAmount: number, createdAt: string, outstandingAmount: number, totalAmount: number, updatedAt?: string | null }> } };

export type AdminUsersQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type AdminUsersQuery = { __typename?: 'Query', adminUsers: { __typename?: 'AdminUsersConnection', nextToken?: string | null, items: Array<{ __typename?: 'AdminUser', id: string, email: string, name?: string | null, phoneNumber?: string | null }> } };

export type AffiliatesQueryVariables = Exact<{
  input?: InputMaybe<AffiliateInput>;
}>;


export type AffiliatesQuery = { __typename?: 'Query', affiliates: { __typename?: 'AffiliateConnection', links?: string | null, items: Array<{ __typename?: 'Affiliate', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, affiliate_group_id?: string | null, created_at?: string | null, company?: { __typename?: 'AffiliateCompany', name?: string | null, description?: string | null } | null, address?: { __typename?: 'AffiliateAddress', address?: string | null, postal_code?: string | null, city?: string | null, state?: string | null, country?: { __typename?: 'AffiliateCountry', name?: string | null, code?: string | null } | null } | null, meta_data?: { __typename?: 'AffiliateMetaData', tier?: string | null } | null, referral_link?: { __typename?: 'AffiliateReferralLink', link?: string | null } | null, payout_methods?: Array<{ __typename?: 'AffiliatePayoutMethod', id?: string | null, title?: string | null, details?: { __typename?: 'AffiliatePayoutMethodDetails', iban?: string | null, nif?: string | null } | null }> | null }> } };

export type AffiliateQueryVariables = Exact<{
  affiliateId: Scalars['ID'];
}>;


export type AffiliateQuery = { __typename?: 'Query', affiliate: { __typename?: 'Affiliate', id: string, firstname?: string | null, lastname?: string | null, email?: string | null, affiliate_group_id?: string | null, created_at?: string | null, company?: { __typename?: 'AffiliateCompany', name?: string | null, description?: string | null } | null, address?: { __typename?: 'AffiliateAddress', address?: string | null, postal_code?: string | null, city?: string | null, state?: string | null, country?: { __typename?: 'AffiliateCountry', name?: string | null, code?: string | null } | null } | null, meta_data?: { __typename?: 'AffiliateMetaData', tier?: string | null } | null, referral_link?: { __typename?: 'AffiliateReferralLink', link?: string | null } | null, payout_methods?: Array<{ __typename?: 'AffiliatePayoutMethod', id?: string | null, title?: string | null, details?: { __typename?: 'AffiliatePayoutMethodDetails', iban?: string | null, nif?: string | null } | null }> | null } };

export type AffiliatePayoutMethodsQueryVariables = Exact<{
  affiliateId: Scalars['ID'];
}>;


export type AffiliatePayoutMethodsQuery = { __typename?: 'Query', affiliatePayoutMethods: Array<{ __typename?: 'AffiliatePayoutMethod', id?: string | null, title?: string | null, details?: { __typename?: 'AffiliatePayoutMethodDetails', iban?: string | null, nif?: string | null } | null }> };

export type AffiliateMerchantsQueryVariables = Exact<{
  input?: InputMaybe<AffiliateMerchantInput>;
}>;


export type AffiliateMerchantsQuery = { __typename?: 'Query', affiliateMerchants: { __typename?: 'AffiliateMerchantConnection', links?: string | null, items: Array<{ __typename?: 'AffiliateMerchant', id: string, status?: string | null, created_at?: string | null, meta_data?: { __typename?: 'AffiliateMerchantMetaData', account_id?: string | null, company_name?: string | null, website?: string | null, first_conversion_date?: string | null } | null }> } };

export type AffiliateInvoicesQueryVariables = Exact<{
  taxId: Scalars['String'];
}>;


export type AffiliateInvoicesQuery = { __typename?: 'Query', affiliateInvoices: { __typename?: 'AffiliateInvoiceConnection', total?: number | null, items: Array<{ __typename?: 'AffiliateInvoice', id: string, number?: string | null, amount?: number | null, issuedAt?: string | null, status?: string | null, dueAt?: string | null }> } };

export type OnUpdateAnalyticsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnUpdateAnalyticsSubscription = { __typename?: 'Subscriptions', onUpdateAnalytics?: { __typename?: 'AnalyticsChange', all?: boolean | null } | null };

export type OnUpdateEventsSubscriptionVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type OnUpdateEventsSubscription = { __typename?: 'Subscriptions', onUpdateEvents?: { __typename?: 'AccountLevelUpdate', accountId?: string | null } | null };

export type OnUpdateDocumentsSubscriptionVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type OnUpdateDocumentsSubscription = { __typename?: 'Subscriptions', onUpdateDocuments?: { __typename?: 'AccountLevelUpdate', accountId?: string | null } | null };

export type OnUpdateAccountSubscriptionVariables = Exact<{
  accountId: Scalars['ID'];
}>;


export type OnUpdateAccountSubscription = { __typename?: 'Subscriptions', onUpdateAccount?: { __typename?: 'AccountLevelUpdate', accountId?: string | null } | null };

export const ProviderFieldsFragmentDoc = gql`
    fragment ProviderFields on Provider {
  id
  processor
  enabled
  test
  paymentMethod
  acquirer
  metadata {
    key
    value
    type
    label
    possibleValues
    regex
    example
    secret
  }
  rules {
    minAmount
    maxAmount
    shopNameLike
    descriptionLike
  }
  nativeHostedPayment
}
    `;
export const AddressFieldsFragmentDoc = gql`
    fragment AddressFields on Address {
  city
  country
  line1
  line2
  zip
  state
}
    `;
export const PaymentMethodFieldsFragmentDoc = gql`
    fragment PaymentMethodFields on PaymentMethod {
  method
  bizum {
    phoneNumber
    integrationType
  }
  card {
    brand
    country
    type
    threeDSecure
    threeDSecureVersion
    threeDSecureFlow
    threeDSecureStatus
    last4
    cardholderName
    cardholderEmail
    expiration
    bank
    tokenizationMethod
    srcCorrelationId
    srciTransactionId
    srcDpaId
  }
  cardPresent {
    bin
    brand
    cardholderEmail
    cardholderName
    country
    expiration
    last4
    type
  }
  mbway {
    phoneNumber
  }
  paypal {
    orderId
    payerId
    email
    name
  }
  sepa {
    accountholderAddress {
      city
      country
      line1
      line2
      zip
      state
    }
    accountholderEmail
    accountholderName
    countryCode
    bankAddress
    bankCode
    bankName
    bic
    last4
  }
  trustly {
    customerId
  }
  klarna {
    billingCategory
    authPaymentMethod
  }
}
    `;
export const SessionDetailsFieldsFragmentDoc = gql`
    fragment SessionDetailsFields on SessionDetails {
  ip
  userAgent
  countryCode
  lang
  deviceType
  deviceModel
  browser
  browserVersion
  browserAccept
  browserColorDepth
  browserScreenHeight
  browserScreenWidth
  browserTimezoneOffset
  os
  osVersion
  source
  sourceVersion
}
    `;
export const TraceDetailsFieldsFragmentDoc = gql`
    fragment TraceDetailsFields on TraceDetails {
  ip
  userAgent
  countryCode
  lang
  deviceType
  deviceModel
  browser
  browserVersion
  browserAccept
  os
  osVersion
  source
  sourceVersion
  userId
  userEmail
  userName
}
    `;
export const ChargeFieldsFragmentDoc = gql`
    fragment ChargeFields on Charge {
  id
  accountId
  providerId
  checkoutId
  sequenceId
  processor
  subscriptionId
  pointOfSaleId
  providerReferenceId
  providerInternalId
  masterAccountId
  billingPlan
  createdAt
  updatedAt
  amount
  acquirer
  authorizationCode
  storeId
  billingDetails {
    email
    name
    company
    phone
    taxId
    address {
      ...AddressFields
    }
  }
  currency
  customer {
    email
    name
    phone
  }
  description
  descriptor
  livemode
  orderId
  paymentMethod {
    ...PaymentMethodFields
  }
  refundedAmount
  lastRefundAmount
  lastRefundReason
  cancellationReason
  shippingDetails {
    email
    name
    company
    phone
    taxId
    address {
      ...AddressFields
    }
  }
  shop {
    name
    country
  }
  status
  statusCode
  statusMessage
  providerStatusCode
  providerStatusMessage
  issuerStatusCode
  issuerStatusMessage
  sessionDetails {
    ...SessionDetailsFields
  }
  traceDetails {
    ...TraceDetailsFields
  }
}
    ${AddressFieldsFragmentDoc}
${PaymentMethodFieldsFragmentDoc}
${SessionDetailsFieldsFragmentDoc}
${TraceDetailsFieldsFragmentDoc}`;
export const ChargeEventObjectFieldsFragmentDoc = gql`
    fragment ChargeEventObjectFields on ChargeEventObject {
  id
  accountId
  providerId
  checkoutId
  sequenceId
  billingPlan
  subscriptionId
  providerReferenceId
  providerInternalId
  createdAt
  updatedAt
  amount
  authorizationCode
  billingDetails {
    email
    name
    company
    phone
    taxId
    address {
      ...AddressFields
    }
  }
  currency
  customer {
    email
    name
    phone
  }
  description
  livemode
  orderId
  masterAccountId
  paymentMethod {
    ...PaymentMethodFields
  }
  refundedAmount
  lastRefundAmount
  lastRefundReason
  cancellationReason
  shippingDetails {
    email
    name
    company
    taxId
    phone
    address {
      ...AddressFields
    }
  }
  shop {
    name
    country
  }
  status
  statusCode
  statusMessage
  sessionDetails {
    ...SessionDetailsFields
  }
  traceDetails {
    ...TraceDetailsFields
  }
}
    ${AddressFieldsFragmentDoc}
${PaymentMethodFieldsFragmentDoc}
${SessionDetailsFieldsFragmentDoc}
${TraceDetailsFieldsFragmentDoc}`;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  id
  email
  emailVerified
  phoneNumber
  phoneNumberVerified
  smsMfaEnabled
  status
  enabled
  accountId
  testAccountId
  referralCode
  promoCode
  createdAt
}
    `;
export const PibisiFlagFieldsFragmentDoc = gql`
    fragment PibisiFlagFields on PibisiFlag {
  id
  content {
    action
    charge
    country
    from
    issue
    issuer
    organization
    reason
    scope
    to
    types
    url
  }
}
    `;
export const PibisiFieldsFragmentDoc = gql`
    fragment PibisiFields on Pibisi {
  status
  customerId
  matches {
    id
    status
    adverseInfo {
      ...PibisiFlagFields
    }
    highRisk {
      ...PibisiFlagFields
    }
    media {
      ...PibisiFlagFields
    }
    pep {
      ...PibisiFlagFields
    }
    sanctioned {
      ...PibisiFlagFields
    }
    terrorist {
      ...PibisiFlagFields
    }
    matches {
      ...PibisiFlagFields
    }
  }
  alerts {
    id
    status
    type
    note
  }
}
    ${PibisiFlagFieldsFragmentDoc}`;
export const AccountFieldsFragmentDoc = gql`
    fragment AccountFields on Account {
  id
  refAccountId
  testAccountId
  prodAccountId
  name
  status
  note
  userNote
  partner
  acquirer
  adminEmail
  allowCreateApiKey
  allowRefunds
  defaultCurrency
  defaultTransactionType
  referralCode
  promoCode
  language
  reviewConfirmed
  contactPerson {
    name
    email
    phone
  }
  branding {
    accentColor
    bgColor
    logoUrl
    iconUrl
  }
  tokenizationMethods {
    googlePay {
      enabled
    }
    applePay {
      enabled
    }
    clickToPay {
      enabled
    }
  }
  billingEmail
  notifications {
    emailCustomerOnRefund
    emailCustomerOnSuccess
    emailAdminOnSuccess
    emailCustomerOnSubscription
    emailAdminOnSubscription
    emailOnAccountInvoice
  }
  billingPlan
  fees {
    highRiskFee
    dailyExtraSeatsFee
    dailyPlatformFee
    weeklyCustomDomainFee
    steps {
      trxFee
      bizumTrxFee
      bizumTrxFlatFee
      trxFlatFee
      from
    }
    extra {
      name
      amount
      type
      masterAccountFee
      paymentMethods
    }
  }
  riskScore
  riskProfile
  riskProcessing
  riskProfileNote
  riskIgnoredKeywords
  riskUpdatedAt
  riskLabels {
    label
    category
    riskScore
  }
  business {
    country
    legalForm
    legalName
    companyName
    mcc
    address {
      ...AddressFields
    }
    documentNumber
    status
    email
    phone
    website
    monthlyVolume
    confirmWebsite
    industry
    mcc
    servicesDescription
    confirmServicesDescription
    legalAddress
    legalDescription
    creationDate
    lastUpdateDate
    startActivityDate
    registryRecords {
      name
      url
      province
      date
    }
    positions {
      fromDate
      role
      name
    }
    capital
    previousNames
    verificationAttempts
    pibisi {
      ...PibisiFields
    }
  }
  representatives {
    firstName
    lastName
    address {
      ...AddressFields
    }
    email
    phone
    documentNumber
    stocksPercentage
    gender
    citizenship
    dateOfBirth
    nationality
    citizenship
    yearOfBirth
    placeOfBirth
    document {
      type
      number
      country
      validFrom
      validUntil
    }
    idSession
    interventionType
    status
    statusCode
    hasNoPublicActivity
    riskLabels {
      label
      category
    }
    pibisi {
      ...PibisiFields
    }
  }
  iban
  dynamicBilling
  payoutTerms {
    iban
    period
    firstPeriod
    reservePercent
    suspended
    releaseReserve
    settleGross
    bankTransferConceptPrefix
    settleToStores
  }
  publicBusinessDetails {
    companyName
    website
    phone
    address {
      ...AddressFields
    }
    supportWebsite
    supportPhone
  }
  branding {
    accentColor
    bgColor
    logoUrl
    iconUrl
  }
  test
  secret
  apiKey
  customDomain
  createdAt
  updatedAt
  deletedAt
  approvedAt
  rejectedAt
  activatedAt
  approvalRequestedAt
  suspendedAt
  dataUpdatedAt
  contract {
    envelopeId
    status
    path
    signedDate
  }
  accountExecutive
  upsell {
    executive
    paymentMethods
    date
    note
  }
  billingVatPercent
  churned
  blocked
  statusReason
  statusNote
  churnReason
  churnReasonOption
  churnNote
  previewFeatures
  tags
  masterAccountId
  accountInvoicePaymentMethod
  customAccountInvoiceNotes
  groupInvoicesByStore
}
    ${AddressFieldsFragmentDoc}
${PibisiFieldsFragmentDoc}`;
export const AuthorizedUserFieldsFragmentDoc = gql`
    fragment AuthorizedUserFields on AuthorizedUser {
  id
  accountId
  userEmail
  accessLevel
  storeId
  status
  createdAt
  updatedAt
  lastLoginAt
}
    `;
export const AccountEventObjectFieldsFragmentDoc = gql`
    fragment AccountEventObjectFields on AccountEventObject {
  id
  refAccountId
  name
  status
  note
  userNote
  partner
  acquirer
  adminEmail
  defaultCurrency
  tags
  defaultTransactionType
  referralCode
  promoCode
  reviewConfirmed
  tokenizationMethods {
    googlePay {
      enabled
    }
    applePay {
      enabled
    }
    clickToPay {
      enabled
    }
  }
  notifications {
    emailCustomerOnRefund
    emailCustomerOnSuccess
    emailAdminOnSuccess
  }
  billingPlan
  fees {
    highRiskFee
    dailyExtraSeatsFee
    dailyPlatformFee
    weeklyCustomDomainFee
    steps {
      trxFee
      bizumTrxFee
      bizumTrxFlatFee
      trxFlatFee
      from
    }
    extra {
      name
      amount
      type
      paymentMethods
      region
    }
  }
  riskScore
  business {
    country
    legalForm
    legalName
    companyName
    mcc
    address {
      ...AddressFields
    }
    documentNumber
    status
    email
    phone
    website
    monthlyVolume
    confirmWebsite
    industry
    mcc
    servicesDescription
    confirmServicesDescription
    legalAddress
    legalDescription
    creationDate
    lastUpdateDate
    startActivityDate
    registryRecords {
      name
      url
      province
      date
    }
    positions {
      fromDate
      role
      name
    }
    capital
    previousNames
    verificationAttempts
  }
  representatives {
    firstName
    lastName
    address {
      ...AddressFields
    }
    email
    phone
    documentNumber
    stocksPercentage
    gender
    citizenship
    dateOfBirth
    nationality
    yearOfBirth
    placeOfBirth
    document {
      type
      number
      country
      validFrom
      validUntil
    }
    idSession
    interventionType
    status
    statusCode
    hasNoPublicActivity
    riskLabels {
      label
      category
    }
  }
  iban
  dynamicBilling
  payoutTerms {
    iban
    period
    firstPeriod
    reservePercent
    suspended
    releaseReserve
  }
  publicBusinessDetails {
    companyName
    website
    phone
    address {
      ...AddressFields
    }
    supportWebsite
    supportPhone
  }
  branding {
    accentColor
    bgColor
    logoUrl
    iconUrl
  }
  test
  customDomain
  contract {
    envelopeId
    status
    path
    signedDate
  }
  createdAt
  updatedAt
  deletedAt
  approvedAt
  rejectedAt
  activatedAt
  approvalRequestedAt
  riskScore
  riskProfile
  riskProfileNote
  riskIgnoredKeywords
  riskUpdatedAt
  suspendedAt
  dataUpdatedAt
  traceDetails {
    ...TraceDetailsFields
  }
  churnReason
  churnReasonOption
  churnNote
  statusReason
  statusNote
  accountExecutive
  upsell {
    executive
    paymentMethods
    date
    note
  }
}
    ${AddressFieldsFragmentDoc}
${TraceDetailsFieldsFragmentDoc}`;
export const SettlementFieldsFragmentDoc = gql`
    fragment SettlementFields on Settlement {
  accountId
  acquirer
  acquirerFees
  grossVolume
  iban
  id
  payMethod
  netVolume
  periodEndAt
  periodStartAt
  releasedAmount
  reservedAmount
  scheduledAt
  status
  legalName
  storeId
  settleGross
}
    `;
export const AccountInvoiceFieldsFragmentDoc = gql`
    fragment AccountInvoiceFields on AccountInvoice {
  id
  number
  accountId
  period {
    from
    to
  }
  currency
  amount
  tax
  totalAmount
  status
  lineItems {
    name
    quantity
    unitAmount
    unitType
    currency
    amount
  }
  business {
    iban
  }
  paymentMethod
}
    `;
export const PaymentFieldsFragmentDoc = gql`
    fragment PaymentFields on Payment {
  id
  accountId
  sequenceId
  subscriptionId
  pointOfSaleId
  masterAccountId
  createdAt
  updatedAt
  amount
  authorizationCode
  storeId
  billingDetails {
    email
    name
    company
    phone
    taxId
    address {
      ...AddressFields
    }
  }
  currency
  customer {
    email
    name
    phone
  }
  description
  descriptor
  livemode
  orderId
  paymentMethod {
    ...PaymentMethodFields
  }
  refundedAmount
  lastRefundAmount
  lastRefundReason
  cancellationReason
  shippingDetails {
    email
    name
    company
    phone
    taxId
    address {
      ...AddressFields
    }
  }
  shop {
    name
    country
  }
  status
  statusCode
  statusMessage
  sessionDetails {
    ...SessionDetailsFields
  }
  traceDetails {
    ...TraceDetailsFields
  }
  nextAction {
    type
    redirectUrl
    mustRedirect
  }
}
    ${AddressFieldsFragmentDoc}
${PaymentMethodFieldsFragmentDoc}
${SessionDetailsFieldsFragmentDoc}
${TraceDetailsFieldsFragmentDoc}`;
export const MasterAccountFieldsFragmentDoc = gql`
    fragment MasterAccountFields on MasterAccount {
  id
  testAccountId
  prodAccountId
  name
  adminEmail
  iban
  apiKey
  test
  status
  promoCode
  allowedIPs
  payoutTerms {
    iban
    firstPeriod
    period
    reservePercent
    suspended
    releaseReserve
  }
  accountDefaults {
    billingPlan
    language
    fees {
      trxFee
      trxFlatFee
      highRiskFee
      dailyPlatformFee
      dailyExtraSeatsFee
      steps {
        trxFee
        bizumTrxFee
        bizumTrxFlatFee
        trxFlatFee
        from
      }
      extra {
        name
        amount
        type
        region
        masterAccountFee
        paymentMethods
      }
    }
    business {
      mcc
      website
      servicesDescription
    }
  }
  business {
    mcc
    legalName
    website
    documentNumber
    servicesDescription
  }
  createdAt
  updatedAt
  webhookEmails
  churnedEmails
  allowedDomains
  accountCallbackUrl
  requireExternalId
  contractTemplateId
  autoApprove
  blocked
  allowCreateApiKey
}
    `;
export const UserMasterAccountFieldsFragmentDoc = gql`
    fragment UserMasterAccountFields on MasterAccount {
  id
  name
  status
  promoCode
  allowedIPs
  webhookEmails
  churnedEmails
  allowedDomains
  accountCallbackUrl
  requireExternalId
  apiKey
  publicBusinessDetails {
    companyName
    website
    phone
    address {
      ...AddressFields
    }
    supportWebsite
    supportPhone
  }
  branding {
    accentColor
    bgColor
    logoUrl
    iconUrl
  }
}
    ${AddressFieldsFragmentDoc}`;
export const DocumentFieldsFragmentDoc = gql`
    fragment DocumentFields on Document {
  id
  accountId
  type
  status
  statusMessage
  statusCode
  contentType
  createdAt
  updatedAt
  name
  note
  internal
  metadata {
    key
    value
  }
  traceDetails {
    ...TraceDetailsFields
  }
}
    ${TraceDetailsFieldsFragmentDoc}`;
export const DocumentEventFieldsFragmentDoc = gql`
    fragment DocumentEventFields on DocumentEvent {
  id
  type
  accountId
  objectId
  objectType
  object {
    id
    accountId
    type
    status
    statusCode
    statusMessage
    contentType
    createdAt
    updatedAt
    note
    name
    internal
    metadata {
      key
      value
    }
    traceDetails {
      ...TraceDetailsFields
    }
  }
  createdAt
}
    ${TraceDetailsFieldsFragmentDoc}`;
export const ContactFieldsFragmentDoc = gql`
    fragment ContactFields on ContactDetails {
  email
  name
  company
  phone
  address {
    ...AddressFields
  }
}
    ${AddressFieldsFragmentDoc}`;
export const SubscriptionFieldsFragmentDoc = gql`
    fragment SubscriptionFields on Subscription {
  id
  accountId
  livemode
  amount
  currency
  description
  planVariantId
  productId
  cancelAtPeriodEnd
  pauseIntervalCount
  pauseAtPeriodEnd
  currentPeriodStart
  currentPeriodEnd
  trialPeriodDays
  trialPeriodEnd
  customerId
  customer {
    email
    name
    phone
  }
  billingDetails {
    ...ContactFields
  }
  shippingDetails {
    ...ContactFields
  }
  defaultTokenId
  sequenceId
  lastInvoiceId
  lastOrderId
  lastPayment {
    id
    status
    statusMessage
    statusCode
  }
  paymentMethod {
    ...PaymentMethodFields
  }
  nextPaymentAt
  createdAt
  updatedAt
  interval
  intervalCount
  retryCount
  metadata {
    key
    value
  }
  status
  sessionDetails {
    ...SessionDetailsFields
  }
  traceDetails {
    ...TraceDetailsFields
  }
  sessionDetails {
    ...SessionDetailsFields
  }
  callbackUrl
  paymentCallbackUrl
  storeId
  masterAccountId
}
    ${ContactFieldsFragmentDoc}
${PaymentMethodFieldsFragmentDoc}
${SessionDetailsFieldsFragmentDoc}
${TraceDetailsFieldsFragmentDoc}`;
export const LastPaymentFieldsFragmentDoc = gql`
    fragment LastPaymentFields on LastPayment {
  id
  status
  statusMessage
  statusCode
}
    `;
export const SubscriptionEventObjectFieldsFragmentDoc = gql`
    fragment SubscriptionEventObjectFields on SubscriptionEventObject {
  id
  accountId
  amount
  billingDetails {
    email
    name
    company
    phone
    address {
      ...AddressFields
    }
  }
  cancelAtPeriodEnd
  createdAt
  currency
  currentPeriodEnd
  currentPeriodStart
  customer {
    email
    name
    phone
  }
  description
  interval
  intervalCount
  lastOrderId
  lastPayment {
    ...LastPaymentFields
  }
  livemode
  pauseAtPeriodEnd
  pauseIntervalCount
  paymentMethod {
    ...PaymentMethodFields
  }
  pointOfSaleId
  retryCount
  sequenceId
  shippingDetails {
    email
    name
    company
    phone
    address {
      ...AddressFields
    }
  }
  status
  storeId
  traceDetails {
    ...TraceDetailsFields
  }
  trialPeriodDays
  trialPeriodEnd
  updatedAt
}
    ${AddressFieldsFragmentDoc}
${LastPaymentFieldsFragmentDoc}
${PaymentMethodFieldsFragmentDoc}
${TraceDetailsFieldsFragmentDoc}`;
export const ProviderEventObjectFieldsFragmentDoc = gql`
    fragment ProviderEventObjectFields on ProviderEventObject {
  id
  internalId
  processor
  enabled
  test
  paymentMethod
  acquirer
  configurable
  metadata {
    key
    value
  }
  nativeHostedPayment
  rules {
    minAmount
    maxAmount
    shopNameLike
    descriptionLike
  }
  traceDetails {
    ...TraceDetailsFields
  }
}
    ${TraceDetailsFieldsFragmentDoc}`;
export const WebhookFieldsFragmentDoc = gql`
    fragment WebhookFields on Webhook {
  id
  accountId
  url
  enabled
  eventTypes
  secret
  createdAt
  updatedAt
}
    `;
export const StartExportChargesFieldsFragmentDoc = gql`
    fragment StartExportChargesFields on ChargesExport {
  id
  accountId
  status
}
    `;
export const StoreFieldsFragmentDoc = gql`
    fragment StoreFields on Store {
  id
  accountId
  name
  email
  iban
  phone
  website
  documentNumber
  address {
    ...AddressFields
  }
}
    ${AddressFieldsFragmentDoc}`;
export const AccountBalancesFieldsFragmentDoc = gql`
    fragment AccountBalancesFields on AccountBalances {
  accountId
  currency
  clearedAmount
  createdAt
  outstandingAmount
  totalAmount
  updatedAt
}
    `;
export const AdminUserFieldsFragmentDoc = gql`
    fragment AdminUserFields on AdminUser {
  id
  email
  name
  phoneNumber
}
    `;
export const PayoutMethodsFieldsFragmentDoc = gql`
    fragment PayoutMethodsFields on AffiliatePayoutMethod {
  id
  title
  details {
    iban
    nif
  }
}
    `;
export const AffiliateFieldsFragmentDoc = gql`
    fragment AffiliateFields on Affiliate {
  id
  firstname
  lastname
  email
  company {
    name
    description
  }
  address {
    address
    postal_code
    city
    state
    country {
      name
      code
    }
  }
  meta_data {
    tier
  }
  referral_link {
    link
  }
  affiliate_group_id
  created_at
  payout_methods {
    ...PayoutMethodsFields
  }
}
    ${PayoutMethodsFieldsFragmentDoc}`;
export const AffiliateMerchantFieldsFragmentDoc = gql`
    fragment AffiliateMerchantFields on AffiliateMerchant {
  id
  status
  created_at
  meta_data {
    account_id
    company_name
    website
    first_conversion_date
  }
}
    `;
export const AffiliateInvoiceFieldsFragmentDoc = gql`
    fragment AffiliateInvoiceFields on AffiliateInvoice {
  id
  number
  amount
  issuedAt
  status
  dueAt
}
    `;
export const ExportChargesDocument = gql`
    mutation ExportCharges($filter: SearchableChargeFilterInput, $columns: [String!], $timezone: String) {
  exportCharges(filter: $filter, columns: $columns, timezone: $timezone) {
    downloadUrl
    expiresAt
  }
}
    `;

/**
 * __useExportChargesMutation__
 *
 * To run a mutation, you first call `useExportChargesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportChargesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportChargesMutation, { data, loading, error }] = useExportChargesMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      columns: // value for 'columns'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useExportChargesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ExportChargesMutation, ExportChargesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ExportChargesMutation, ExportChargesMutationVariables>(ExportChargesDocument, options);
      }
export type ExportChargesMutationHookResult = ReturnType<typeof useExportChargesMutation>;
export type ExportChargesMutationResult = Apollo.MutationResult<ExportChargesMutation>;
export type ExportChargesMutationOptions = Apollo.BaseMutationOptions<ExportChargesMutation, ExportChargesMutationVariables>;
export const UpdateAccountDocument = gql`
    mutation UpdateAccount($input: UpdateAccountInput!) {
  updateAccount(input: $input) {
    ...AccountFields
  }
}
    ${AccountFieldsFragmentDoc}`;

/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMutation, { data, loading, error }] = useUpdateAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAccountMutation, UpdateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAccountMutation, UpdateAccountMutationVariables>(UpdateAccountDocument, options);
      }
export type UpdateAccountMutationHookResult = ReturnType<typeof useUpdateAccountMutation>;
export type UpdateAccountMutationResult = Apollo.MutationResult<UpdateAccountMutation>;
export type UpdateAccountMutationOptions = Apollo.BaseMutationOptions<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const UpdateMasterAccountDocument = gql`
    mutation UpdateMasterAccount($input: UpdateMasterAccountInput!) {
  updateMasterAccount(input: $input) {
    ...MasterAccountFields
  }
}
    ${MasterAccountFieldsFragmentDoc}`;

/**
 * __useUpdateMasterAccountMutation__
 *
 * To run a mutation, you first call `useUpdateMasterAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMasterAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMasterAccountMutation, { data, loading, error }] = useUpdateMasterAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMasterAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMasterAccountMutation, UpdateMasterAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateMasterAccountMutation, UpdateMasterAccountMutationVariables>(UpdateMasterAccountDocument, options);
      }
export type UpdateMasterAccountMutationHookResult = ReturnType<typeof useUpdateMasterAccountMutation>;
export type UpdateMasterAccountMutationResult = Apollo.MutationResult<UpdateMasterAccountMutation>;
export type UpdateMasterAccountMutationOptions = Apollo.BaseMutationOptions<UpdateMasterAccountMutation, UpdateMasterAccountMutationVariables>;
export const UpdateUserMasterAccountDocument = gql`
    mutation UpdateUserMasterAccount($input: UpdateUserMasterAccountInput!) {
  updateUserMasterAccount(input: $input) {
    ...UserMasterAccountFields
  }
}
    ${UserMasterAccountFieldsFragmentDoc}`;

/**
 * __useUpdateUserMasterAccountMutation__
 *
 * To run a mutation, you first call `useUpdateUserMasterAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMasterAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMasterAccountMutation, { data, loading, error }] = useUpdateUserMasterAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMasterAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserMasterAccountMutation, UpdateUserMasterAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserMasterAccountMutation, UpdateUserMasterAccountMutationVariables>(UpdateUserMasterAccountDocument, options);
      }
export type UpdateUserMasterAccountMutationHookResult = ReturnType<typeof useUpdateUserMasterAccountMutation>;
export type UpdateUserMasterAccountMutationResult = Apollo.MutationResult<UpdateUserMasterAccountMutation>;
export type UpdateUserMasterAccountMutationOptions = Apollo.BaseMutationOptions<UpdateUserMasterAccountMutation, UpdateUserMasterAccountMutationVariables>;
export const UpdateProviderDocument = gql`
    mutation UpdateProvider($input: UpdateProviderInput!) {
  updateProvider(input: $input) {
    ...ProviderFields
  }
}
    ${ProviderFieldsFragmentDoc}`;

/**
 * __useUpdateProviderMutation__
 *
 * To run a mutation, you first call `useUpdateProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderMutation, { data, loading, error }] = useUpdateProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProviderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProviderMutation, UpdateProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProviderMutation, UpdateProviderMutationVariables>(UpdateProviderDocument, options);
      }
export type UpdateProviderMutationHookResult = ReturnType<typeof useUpdateProviderMutation>;
export type UpdateProviderMutationResult = Apollo.MutationResult<UpdateProviderMutation>;
export type UpdateProviderMutationOptions = Apollo.BaseMutationOptions<UpdateProviderMutation, UpdateProviderMutationVariables>;
export const CreateProviderDocument = gql`
    mutation CreateProvider($input: CreateProviderInput!) {
  createProvider(input: $input) {
    ...ProviderFields
  }
}
    ${ProviderFieldsFragmentDoc}`;

/**
 * __useCreateProviderMutation__
 *
 * To run a mutation, you first call `useCreateProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProviderMutation, { data, loading, error }] = useCreateProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProviderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProviderMutation, CreateProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateProviderMutation, CreateProviderMutationVariables>(CreateProviderDocument, options);
      }
export type CreateProviderMutationHookResult = ReturnType<typeof useCreateProviderMutation>;
export type CreateProviderMutationResult = Apollo.MutationResult<CreateProviderMutation>;
export type CreateProviderMutationOptions = Apollo.BaseMutationOptions<CreateProviderMutation, CreateProviderMutationVariables>;
export const DeleteProviderDocument = gql`
    mutation DeleteProvider($id: ID!) {
  deleteProvider(id: $id) {
    ...ProviderFields
  }
}
    ${ProviderFieldsFragmentDoc}`;

/**
 * __useDeleteProviderMutation__
 *
 * To run a mutation, you first call `useDeleteProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProviderMutation, { data, loading, error }] = useDeleteProviderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProviderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteProviderMutation, DeleteProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteProviderMutation, DeleteProviderMutationVariables>(DeleteProviderDocument, options);
      }
export type DeleteProviderMutationHookResult = ReturnType<typeof useDeleteProviderMutation>;
export type DeleteProviderMutationResult = Apollo.MutationResult<DeleteProviderMutation>;
export type DeleteProviderMutationOptions = Apollo.BaseMutationOptions<DeleteProviderMutation, DeleteProviderMutationVariables>;
export const ImpersonateDocument = gql`
    mutation Impersonate($input: ImpersonateInput!) {
  impersonate(input: $input)
}
    `;

/**
 * __useImpersonateMutation__
 *
 * To run a mutation, you first call `useImpersonateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImpersonateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [impersonateMutation, { data, loading, error }] = useImpersonateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImpersonateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ImpersonateMutation, ImpersonateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ImpersonateMutation, ImpersonateMutationVariables>(ImpersonateDocument, options);
      }
export type ImpersonateMutationHookResult = ReturnType<typeof useImpersonateMutation>;
export type ImpersonateMutationResult = Apollo.MutationResult<ImpersonateMutation>;
export type ImpersonateMutationOptions = Apollo.BaseMutationOptions<ImpersonateMutation, ImpersonateMutationVariables>;
export const ResetUserPasswordDocument = gql`
    mutation ResetUserPassword($userId: ID!, $temporalPassword: String) {
  resetUserPassword(userId: $userId, temporalPassword: $temporalPassword)
}
    `;

/**
 * __useResetUserPasswordMutation__
 *
 * To run a mutation, you first call `useResetUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUserPasswordMutation, { data, loading, error }] = useResetUserPasswordMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      temporalPassword: // value for 'temporalPassword'
 *   },
 * });
 */
export function useResetUserPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>(ResetUserPasswordDocument, options);
      }
export type ResetUserPasswordMutationHookResult = ReturnType<typeof useResetUserPasswordMutation>;
export type ResetUserPasswordMutationResult = Apollo.MutationResult<ResetUserPasswordMutation>;
export type ResetUserPasswordMutationOptions = Apollo.BaseMutationOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;
export const DisableUserDocument = gql`
    mutation DisableUser($id: ID!) {
  disableUser(id: $id) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useDisableUserMutation__
 *
 * To run a mutation, you first call `useDisableUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableUserMutation, { data, loading, error }] = useDisableUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisableUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DisableUserMutation, DisableUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisableUserMutation, DisableUserMutationVariables>(DisableUserDocument, options);
      }
export type DisableUserMutationHookResult = ReturnType<typeof useDisableUserMutation>;
export type DisableUserMutationResult = Apollo.MutationResult<DisableUserMutation>;
export type DisableUserMutationOptions = Apollo.BaseMutationOptions<DisableUserMutation, DisableUserMutationVariables>;
export const EnableUserDocument = gql`
    mutation EnableUser($id: ID!) {
  enableUser(id: $id) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useEnableUserMutation__
 *
 * To run a mutation, you first call `useEnableUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableUserMutation, { data, loading, error }] = useEnableUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnableUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EnableUserMutation, EnableUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EnableUserMutation, EnableUserMutationVariables>(EnableUserDocument, options);
      }
export type EnableUserMutationHookResult = ReturnType<typeof useEnableUserMutation>;
export type EnableUserMutationResult = Apollo.MutationResult<EnableUserMutation>;
export type EnableUserMutationOptions = Apollo.BaseMutationOptions<EnableUserMutation, EnableUserMutationVariables>;
export const DeleteAccountDocument = gql`
    mutation DeleteAccount($id: ID!) {
  deleteAccount(id: $id) {
    ...AccountFields
  }
}
    ${AccountFieldsFragmentDoc}`;

/**
 * __useDeleteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountMutation, { data, loading, error }] = useDeleteAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAccountMutation, DeleteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAccountMutation, DeleteAccountMutationVariables>(DeleteAccountDocument, options);
      }
export type DeleteAccountMutationHookResult = ReturnType<typeof useDeleteAccountMutation>;
export type DeleteAccountMutationResult = Apollo.MutationResult<DeleteAccountMutation>;
export type DeleteAccountMutationOptions = Apollo.BaseMutationOptions<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const RestoreAccountDocument = gql`
    mutation RestoreAccount($id: ID!) {
  restoreAccount(id: $id) {
    ...AccountFields
  }
}
    ${AccountFieldsFragmentDoc}`;

/**
 * __useRestoreAccountMutation__
 *
 * To run a mutation, you first call `useRestoreAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreAccountMutation, { data, loading, error }] = useRestoreAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RestoreAccountMutation, RestoreAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RestoreAccountMutation, RestoreAccountMutationVariables>(RestoreAccountDocument, options);
      }
export type RestoreAccountMutationHookResult = ReturnType<typeof useRestoreAccountMutation>;
export type RestoreAccountMutationResult = Apollo.MutationResult<RestoreAccountMutation>;
export type RestoreAccountMutationOptions = Apollo.BaseMutationOptions<RestoreAccountMutation, RestoreAccountMutationVariables>;
export const GenerateSettlementReportDocument = gql`
    mutation GenerateSettlementReport($input: GenerateSettlementReportInput!) {
  generateSettlementReport(input: $input) {
    downloadUrl
    expiresAt
  }
}
    `;

/**
 * __useGenerateSettlementReportMutation__
 *
 * To run a mutation, you first call `useGenerateSettlementReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSettlementReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSettlementReportMutation, { data, loading, error }] = useGenerateSettlementReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateSettlementReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<GenerateSettlementReportMutation, GenerateSettlementReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<GenerateSettlementReportMutation, GenerateSettlementReportMutationVariables>(GenerateSettlementReportDocument, options);
      }
export type GenerateSettlementReportMutationHookResult = ReturnType<typeof useGenerateSettlementReportMutation>;
export type GenerateSettlementReportMutationResult = Apollo.MutationResult<GenerateSettlementReportMutation>;
export type GenerateSettlementReportMutationOptions = Apollo.BaseMutationOptions<GenerateSettlementReportMutation, GenerateSettlementReportMutationVariables>;
export const CreateAccountInvoiceDocument = gql`
    mutation CreateAccountInvoice($input: AccountInvoiceInput!) {
  createAccountInvoice(input: $input) {
    ...AccountInvoiceFields
  }
}
    ${AccountInvoiceFieldsFragmentDoc}`;

/**
 * __useCreateAccountInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateAccountInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountInvoiceMutation, { data, loading, error }] = useCreateAccountInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccountInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAccountInvoiceMutation, CreateAccountInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAccountInvoiceMutation, CreateAccountInvoiceMutationVariables>(CreateAccountInvoiceDocument, options);
      }
export type CreateAccountInvoiceMutationHookResult = ReturnType<typeof useCreateAccountInvoiceMutation>;
export type CreateAccountInvoiceMutationResult = Apollo.MutationResult<CreateAccountInvoiceMutation>;
export type CreateAccountInvoiceMutationOptions = Apollo.BaseMutationOptions<CreateAccountInvoiceMutation, CreateAccountInvoiceMutationVariables>;
export const DisableTokenizationMethodDocument = gql`
    mutation DisableTokenizationMethod($accountId: ID!, $method: TokenizationMethods!) {
  disableTokenizationMethod(accountId: $accountId, method: $method) {
    ...AccountFields
  }
}
    ${AccountFieldsFragmentDoc}`;

/**
 * __useDisableTokenizationMethodMutation__
 *
 * To run a mutation, you first call `useDisableTokenizationMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableTokenizationMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableTokenizationMethodMutation, { data, loading, error }] = useDisableTokenizationMethodMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      method: // value for 'method'
 *   },
 * });
 */
export function useDisableTokenizationMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DisableTokenizationMethodMutation, DisableTokenizationMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisableTokenizationMethodMutation, DisableTokenizationMethodMutationVariables>(DisableTokenizationMethodDocument, options);
      }
export type DisableTokenizationMethodMutationHookResult = ReturnType<typeof useDisableTokenizationMethodMutation>;
export type DisableTokenizationMethodMutationResult = Apollo.MutationResult<DisableTokenizationMethodMutation>;
export type DisableTokenizationMethodMutationOptions = Apollo.BaseMutationOptions<DisableTokenizationMethodMutation, DisableTokenizationMethodMutationVariables>;
export const EnableTokenizationMethodDocument = gql`
    mutation EnableTokenizationMethod($accountId: ID!, $method: TokenizationMethods!) {
  enableTokenizationMethod(accountId: $accountId, method: $method) {
    ...AccountFields
  }
}
    ${AccountFieldsFragmentDoc}`;

/**
 * __useEnableTokenizationMethodMutation__
 *
 * To run a mutation, you first call `useEnableTokenizationMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableTokenizationMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableTokenizationMethodMutation, { data, loading, error }] = useEnableTokenizationMethodMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      method: // value for 'method'
 *   },
 * });
 */
export function useEnableTokenizationMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EnableTokenizationMethodMutation, EnableTokenizationMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EnableTokenizationMethodMutation, EnableTokenizationMethodMutationVariables>(EnableTokenizationMethodDocument, options);
      }
export type EnableTokenizationMethodMutationHookResult = ReturnType<typeof useEnableTokenizationMethodMutation>;
export type EnableTokenizationMethodMutationResult = Apollo.MutationResult<EnableTokenizationMethodMutation>;
export type EnableTokenizationMethodMutationOptions = Apollo.BaseMutationOptions<EnableTokenizationMethodMutation, EnableTokenizationMethodMutationVariables>;
export const DownloadContractDocument = gql`
    mutation DownloadContract($accountId: ID!) {
  downloadContract(accountId: $accountId) {
    downloadUrl
    expiresAt
  }
}
    `;

/**
 * __useDownloadContractMutation__
 *
 * To run a mutation, you first call `useDownloadContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadContractMutation, { data, loading, error }] = useDownloadContractMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDownloadContractMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DownloadContractMutation, DownloadContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DownloadContractMutation, DownloadContractMutationVariables>(DownloadContractDocument, options);
      }
export type DownloadContractMutationHookResult = ReturnType<typeof useDownloadContractMutation>;
export type DownloadContractMutationResult = Apollo.MutationResult<DownloadContractMutation>;
export type DownloadContractMutationOptions = Apollo.BaseMutationOptions<DownloadContractMutation, DownloadContractMutationVariables>;
export const ApproveAccountDocument = gql`
    mutation ApproveAccount($id: ID!, $processor: Processor) {
  approveAccount(id: $id, processor: $processor) {
    ...AccountFields
  }
}
    ${AccountFieldsFragmentDoc}`;

/**
 * __useApproveAccountMutation__
 *
 * To run a mutation, you first call `useApproveAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveAccountMutation, { data, loading, error }] = useApproveAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      processor: // value for 'processor'
 *   },
 * });
 */
export function useApproveAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ApproveAccountMutation, ApproveAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ApproveAccountMutation, ApproveAccountMutationVariables>(ApproveAccountDocument, options);
      }
export type ApproveAccountMutationHookResult = ReturnType<typeof useApproveAccountMutation>;
export type ApproveAccountMutationResult = Apollo.MutationResult<ApproveAccountMutation>;
export type ApproveAccountMutationOptions = Apollo.BaseMutationOptions<ApproveAccountMutation, ApproveAccountMutationVariables>;
export const RegisterMoneiXMerchantDocument = gql`
    mutation RegisterMoneiXMerchant($id: ID!) {
  registerMoneiXMerchant(id: $id) {
    success
  }
}
    `;

/**
 * __useRegisterMoneiXMerchantMutation__
 *
 * To run a mutation, you first call `useRegisterMoneiXMerchantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMoneiXMerchantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMoneiXMerchantMutation, { data, loading, error }] = useRegisterMoneiXMerchantMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRegisterMoneiXMerchantMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RegisterMoneiXMerchantMutation, RegisterMoneiXMerchantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RegisterMoneiXMerchantMutation, RegisterMoneiXMerchantMutationVariables>(RegisterMoneiXMerchantDocument, options);
      }
export type RegisterMoneiXMerchantMutationHookResult = ReturnType<typeof useRegisterMoneiXMerchantMutation>;
export type RegisterMoneiXMerchantMutationResult = Apollo.MutationResult<RegisterMoneiXMerchantMutation>;
export type RegisterMoneiXMerchantMutationOptions = Apollo.BaseMutationOptions<RegisterMoneiXMerchantMutation, RegisterMoneiXMerchantMutationVariables>;
export const VerifyIdDocument = gql`
    mutation VerifyId($id: Int!, $accountId: ID!) {
  verifyId(id: $id, accountId: $accountId) {
    ...AccountFields
  }
}
    ${AccountFieldsFragmentDoc}`;

/**
 * __useVerifyIdMutation__
 *
 * To run a mutation, you first call `useVerifyIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyIdMutation, { data, loading, error }] = useVerifyIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useVerifyIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VerifyIdMutation, VerifyIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<VerifyIdMutation, VerifyIdMutationVariables>(VerifyIdDocument, options);
      }
export type VerifyIdMutationHookResult = ReturnType<typeof useVerifyIdMutation>;
export type VerifyIdMutationResult = Apollo.MutationResult<VerifyIdMutation>;
export type VerifyIdMutationOptions = Apollo.BaseMutationOptions<VerifyIdMutation, VerifyIdMutationVariables>;
export const CreateAuthorizedUserDocument = gql`
    mutation CreateAuthorizedUser($input: CreateAuthorizedUserInput!) {
  createAuthorizedUser(input: $input) {
    ...AuthorizedUserFields
  }
}
    ${AuthorizedUserFieldsFragmentDoc}`;

/**
 * __useCreateAuthorizedUserMutation__
 *
 * To run a mutation, you first call `useCreateAuthorizedUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAuthorizedUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAuthorizedUserMutation, { data, loading, error }] = useCreateAuthorizedUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAuthorizedUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAuthorizedUserMutation, CreateAuthorizedUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAuthorizedUserMutation, CreateAuthorizedUserMutationVariables>(CreateAuthorizedUserDocument, options);
      }
export type CreateAuthorizedUserMutationHookResult = ReturnType<typeof useCreateAuthorizedUserMutation>;
export type CreateAuthorizedUserMutationResult = Apollo.MutationResult<CreateAuthorizedUserMutation>;
export type CreateAuthorizedUserMutationOptions = Apollo.BaseMutationOptions<CreateAuthorizedUserMutation, CreateAuthorizedUserMutationVariables>;
export const CreateMasterAccountDocument = gql`
    mutation CreateMasterAccount($input: CreateMasterAccountInput!) {
  createMasterAccount(input: $input) {
    ...MasterAccountFields
  }
}
    ${MasterAccountFieldsFragmentDoc}`;

/**
 * __useCreateMasterAccountMutation__
 *
 * To run a mutation, you first call `useCreateMasterAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMasterAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMasterAccountMutation, { data, loading, error }] = useCreateMasterAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMasterAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMasterAccountMutation, CreateMasterAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateMasterAccountMutation, CreateMasterAccountMutationVariables>(CreateMasterAccountDocument, options);
      }
export type CreateMasterAccountMutationHookResult = ReturnType<typeof useCreateMasterAccountMutation>;
export type CreateMasterAccountMutationResult = Apollo.MutationResult<CreateMasterAccountMutation>;
export type CreateMasterAccountMutationOptions = Apollo.BaseMutationOptions<CreateMasterAccountMutation, CreateMasterAccountMutationVariables>;
export const CreateMasterAccountUserDocument = gql`
    mutation CreateMasterAccountUser($input: CreateMasterAccountUserInput!) {
  createMasterAccountUser(input: $input) {
    ...AuthorizedUserFields
  }
}
    ${AuthorizedUserFieldsFragmentDoc}`;

/**
 * __useCreateMasterAccountUserMutation__
 *
 * To run a mutation, you first call `useCreateMasterAccountUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMasterAccountUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMasterAccountUserMutation, { data, loading, error }] = useCreateMasterAccountUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMasterAccountUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMasterAccountUserMutation, CreateMasterAccountUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateMasterAccountUserMutation, CreateMasterAccountUserMutationVariables>(CreateMasterAccountUserDocument, options);
      }
export type CreateMasterAccountUserMutationHookResult = ReturnType<typeof useCreateMasterAccountUserMutation>;
export type CreateMasterAccountUserMutationResult = Apollo.MutationResult<CreateMasterAccountUserMutation>;
export type CreateMasterAccountUserMutationOptions = Apollo.BaseMutationOptions<CreateMasterAccountUserMutation, CreateMasterAccountUserMutationVariables>;
export const DeleteMasterAccountUserDocument = gql`
    mutation DeleteMasterAccountUser($userEmail: String!, $accountId: ID!) {
  deleteMasterAccountUser(userEmail: $userEmail, accountId: $accountId)
}
    `;

/**
 * __useDeleteMasterAccountUserMutation__
 *
 * To run a mutation, you first call `useDeleteMasterAccountUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMasterAccountUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMasterAccountUserMutation, { data, loading, error }] = useDeleteMasterAccountUserMutation({
 *   variables: {
 *      userEmail: // value for 'userEmail'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDeleteMasterAccountUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMasterAccountUserMutation, DeleteMasterAccountUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteMasterAccountUserMutation, DeleteMasterAccountUserMutationVariables>(DeleteMasterAccountUserDocument, options);
      }
export type DeleteMasterAccountUserMutationHookResult = ReturnType<typeof useDeleteMasterAccountUserMutation>;
export type DeleteMasterAccountUserMutationResult = Apollo.MutationResult<DeleteMasterAccountUserMutation>;
export type DeleteMasterAccountUserMutationOptions = Apollo.BaseMutationOptions<DeleteMasterAccountUserMutation, DeleteMasterAccountUserMutationVariables>;
export const DeleteAuthorizedUserDocument = gql`
    mutation DeleteAuthorizedUser($userEmail: String!, $accountId: ID!) {
  deleteAuthorizedUser(userEmail: $userEmail, accountId: $accountId)
}
    `;

/**
 * __useDeleteAuthorizedUserMutation__
 *
 * To run a mutation, you first call `useDeleteAuthorizedUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAuthorizedUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAuthorizedUserMutation, { data, loading, error }] = useDeleteAuthorizedUserMutation({
 *   variables: {
 *      userEmail: // value for 'userEmail'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDeleteAuthorizedUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAuthorizedUserMutation, DeleteAuthorizedUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAuthorizedUserMutation, DeleteAuthorizedUserMutationVariables>(DeleteAuthorizedUserDocument, options);
      }
export type DeleteAuthorizedUserMutationHookResult = ReturnType<typeof useDeleteAuthorizedUserMutation>;
export type DeleteAuthorizedUserMutationResult = Apollo.MutationResult<DeleteAuthorizedUserMutation>;
export type DeleteAuthorizedUserMutationOptions = Apollo.BaseMutationOptions<DeleteAuthorizedUserMutation, DeleteAuthorizedUserMutationVariables>;
export const UpdateAuthorizedUserDocument = gql`
    mutation UpdateAuthorizedUser($input: UpdateAuthorizedUserInput!) {
  updateAuthorizedUser(input: $input) {
    ...AuthorizedUserFields
  }
}
    ${AuthorizedUserFieldsFragmentDoc}`;

/**
 * __useUpdateAuthorizedUserMutation__
 *
 * To run a mutation, you first call `useUpdateAuthorizedUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAuthorizedUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAuthorizedUserMutation, { data, loading, error }] = useUpdateAuthorizedUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAuthorizedUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAuthorizedUserMutation, UpdateAuthorizedUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAuthorizedUserMutation, UpdateAuthorizedUserMutationVariables>(UpdateAuthorizedUserDocument, options);
      }
export type UpdateAuthorizedUserMutationHookResult = ReturnType<typeof useUpdateAuthorizedUserMutation>;
export type UpdateAuthorizedUserMutationResult = Apollo.MutationResult<UpdateAuthorizedUserMutation>;
export type UpdateAuthorizedUserMutationOptions = Apollo.BaseMutationOptions<UpdateAuthorizedUserMutation, UpdateAuthorizedUserMutationVariables>;
export const SendPaymentLinkDocument = gql`
    mutation SendPaymentLink($input: SendPaymentMessageInput!) {
  sendPaymentLink(input: $input) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;

/**
 * __useSendPaymentLinkMutation__
 *
 * To run a mutation, you first call `useSendPaymentLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPaymentLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPaymentLinkMutation, { data, loading, error }] = useSendPaymentLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendPaymentLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendPaymentLinkMutation, SendPaymentLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendPaymentLinkMutation, SendPaymentLinkMutationVariables>(SendPaymentLinkDocument, options);
      }
export type SendPaymentLinkMutationHookResult = ReturnType<typeof useSendPaymentLinkMutation>;
export type SendPaymentLinkMutationResult = Apollo.MutationResult<SendPaymentLinkMutation>;
export type SendPaymentLinkMutationOptions = Apollo.BaseMutationOptions<SendPaymentLinkMutation, SendPaymentLinkMutationVariables>;
export const SendPaymentRequestDocument = gql`
    mutation SendPaymentRequest($input: SendPaymentRequestInput!) {
  sendPaymentRequest(input: $input) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;

/**
 * __useSendPaymentRequestMutation__
 *
 * To run a mutation, you first call `useSendPaymentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPaymentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPaymentRequestMutation, { data, loading, error }] = useSendPaymentRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendPaymentRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendPaymentRequestMutation, SendPaymentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendPaymentRequestMutation, SendPaymentRequestMutationVariables>(SendPaymentRequestDocument, options);
      }
export type SendPaymentRequestMutationHookResult = ReturnType<typeof useSendPaymentRequestMutation>;
export type SendPaymentRequestMutationResult = Apollo.MutationResult<SendPaymentRequestMutation>;
export type SendPaymentRequestMutationOptions = Apollo.BaseMutationOptions<SendPaymentRequestMutation, SendPaymentRequestMutationVariables>;
export const CreatePaymentDocument = gql`
    mutation CreatePayment($input: CreatePaymentInput!) {
  createPayment(input: $input) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;

/**
 * __useCreatePaymentMutation__
 *
 * To run a mutation, you first call `useCreatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentMutation, { data, loading, error }] = useCreatePaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePaymentMutation, CreatePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePaymentMutation, CreatePaymentMutationVariables>(CreatePaymentDocument, options);
      }
export type CreatePaymentMutationHookResult = ReturnType<typeof useCreatePaymentMutation>;
export type CreatePaymentMutationResult = Apollo.MutationResult<CreatePaymentMutation>;
export type CreatePaymentMutationOptions = Apollo.BaseMutationOptions<CreatePaymentMutation, CreatePaymentMutationVariables>;
export const CapturePaymentDocument = gql`
    mutation CapturePayment($input: CapturePaymentInput!) {
  capturePayment(input: $input) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;

/**
 * __useCapturePaymentMutation__
 *
 * To run a mutation, you first call `useCapturePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCapturePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [capturePaymentMutation, { data, loading, error }] = useCapturePaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCapturePaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CapturePaymentMutation, CapturePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CapturePaymentMutation, CapturePaymentMutationVariables>(CapturePaymentDocument, options);
      }
export type CapturePaymentMutationHookResult = ReturnType<typeof useCapturePaymentMutation>;
export type CapturePaymentMutationResult = Apollo.MutationResult<CapturePaymentMutation>;
export type CapturePaymentMutationOptions = Apollo.BaseMutationOptions<CapturePaymentMutation, CapturePaymentMutationVariables>;
export const CancelPaymentDocument = gql`
    mutation CancelPayment($input: CancelPaymentInput!) {
  cancelPayment(input: $input) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;

/**
 * __useCancelPaymentMutation__
 *
 * To run a mutation, you first call `useCancelPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPaymentMutation, { data, loading, error }] = useCancelPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelPaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelPaymentMutation, CancelPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelPaymentMutation, CancelPaymentMutationVariables>(CancelPaymentDocument, options);
      }
export type CancelPaymentMutationHookResult = ReturnType<typeof useCancelPaymentMutation>;
export type CancelPaymentMutationResult = Apollo.MutationResult<CancelPaymentMutation>;
export type CancelPaymentMutationOptions = Apollo.BaseMutationOptions<CancelPaymentMutation, CancelPaymentMutationVariables>;
export const RefundPaymentDocument = gql`
    mutation RefundPayment($input: RefundPaymentInput!) {
  refundPayment(input: $input) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;

/**
 * __useRefundPaymentMutation__
 *
 * To run a mutation, you first call `useRefundPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefundPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refundPaymentMutation, { data, loading, error }] = useRefundPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefundPaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RefundPaymentMutation, RefundPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RefundPaymentMutation, RefundPaymentMutationVariables>(RefundPaymentDocument, options);
      }
export type RefundPaymentMutationHookResult = ReturnType<typeof useRefundPaymentMutation>;
export type RefundPaymentMutationResult = Apollo.MutationResult<RefundPaymentMutation>;
export type RefundPaymentMutationOptions = Apollo.BaseMutationOptions<RefundPaymentMutation, RefundPaymentMutationVariables>;
export const SendPaymentReceiptDocument = gql`
    mutation SendPaymentReceipt($input: SendPaymentMessageInput!) {
  sendPaymentReceipt(input: $input) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;

/**
 * __useSendPaymentReceiptMutation__
 *
 * To run a mutation, you first call `useSendPaymentReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPaymentReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPaymentReceiptMutation, { data, loading, error }] = useSendPaymentReceiptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendPaymentReceiptMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendPaymentReceiptMutation, SendPaymentReceiptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendPaymentReceiptMutation, SendPaymentReceiptMutationVariables>(SendPaymentReceiptDocument, options);
      }
export type SendPaymentReceiptMutationHookResult = ReturnType<typeof useSendPaymentReceiptMutation>;
export type SendPaymentReceiptMutationResult = Apollo.MutationResult<SendPaymentReceiptMutation>;
export type SendPaymentReceiptMutationOptions = Apollo.BaseMutationOptions<SendPaymentReceiptMutation, SendPaymentReceiptMutationVariables>;
export const DeleteDocumentDocument = gql`
    mutation DeleteDocument($id: ID!, $accountId: ID!) {
  deleteDocument(id: $id, accountId: $accountId)
}
    `;

/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentMutation, { data, loading, error }] = useDeleteDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDeleteDocumentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDocumentMutation, DeleteDocumentMutationVariables>(DeleteDocumentDocument, options);
      }
export type DeleteDocumentMutationHookResult = ReturnType<typeof useDeleteDocumentMutation>;
export type DeleteDocumentMutationResult = Apollo.MutationResult<DeleteDocumentMutation>;
export type DeleteDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>;
export const DownloadDocumentDocument = gql`
    mutation DownloadDocument($id: ID!, $accountId: ID!) {
  downloadDocument(id: $id, accountId: $accountId) {
    downloadUrl
    expiresAt
  }
}
    `;

/**
 * __useDownloadDocumentMutation__
 *
 * To run a mutation, you first call `useDownloadDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadDocumentMutation, { data, loading, error }] = useDownloadDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDownloadDocumentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DownloadDocumentMutation, DownloadDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DownloadDocumentMutation, DownloadDocumentMutationVariables>(DownloadDocumentDocument, options);
      }
export type DownloadDocumentMutationHookResult = ReturnType<typeof useDownloadDocumentMutation>;
export type DownloadDocumentMutationResult = Apollo.MutationResult<DownloadDocumentMutation>;
export type DownloadDocumentMutationOptions = Apollo.BaseMutationOptions<DownloadDocumentMutation, DownloadDocumentMutationVariables>;
export const UpdateDocumentDocument = gql`
    mutation UpdateDocument($input: UpdateDocumentInput!) {
  updateDocument(input: $input) {
    ...DocumentFields
  }
}
    ${DocumentFieldsFragmentDoc}`;

/**
 * __useUpdateDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentMutation, { data, loading, error }] = useUpdateDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDocumentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDocumentMutation, UpdateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDocumentMutation, UpdateDocumentMutationVariables>(UpdateDocumentDocument, options);
      }
export type UpdateDocumentMutationHookResult = ReturnType<typeof useUpdateDocumentMutation>;
export type UpdateDocumentMutationResult = Apollo.MutationResult<UpdateDocumentMutation>;
export type UpdateDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentMutation, UpdateDocumentMutationVariables>;
export const UploadDocumentDocument = gql`
    mutation UploadDocument($id: ID!, $contentType: String!, $accountId: ID!) {
  uploadDocument(id: $id, contentType: $contentType, accountId: $accountId) {
    uploadUrl
    expiresAt
  }
}
    `;

/**
 * __useUploadDocumentMutation__
 *
 * To run a mutation, you first call `useUploadDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDocumentMutation, { data, loading, error }] = useUploadDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      contentType: // value for 'contentType'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useUploadDocumentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadDocumentMutation, UploadDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UploadDocumentMutation, UploadDocumentMutationVariables>(UploadDocumentDocument, options);
      }
export type UploadDocumentMutationHookResult = ReturnType<typeof useUploadDocumentMutation>;
export type UploadDocumentMutationResult = Apollo.MutationResult<UploadDocumentMutation>;
export type UploadDocumentMutationOptions = Apollo.BaseMutationOptions<UploadDocumentMutation, UploadDocumentMutationVariables>;
export const CreateDocumentDocument = gql`
    mutation CreateDocument($input: CreateDocumentInput!) {
  createDocument(input: $input) {
    ...DocumentFields
  }
}
    ${DocumentFieldsFragmentDoc}`;

/**
 * __useCreateDocumentMutation__
 *
 * To run a mutation, you first call `useCreateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentMutation, { data, loading, error }] = useCreateDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocumentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDocumentMutation, CreateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateDocumentMutation, CreateDocumentMutationVariables>(CreateDocumentDocument, options);
      }
export type CreateDocumentMutationHookResult = ReturnType<typeof useCreateDocumentMutation>;
export type CreateDocumentMutationResult = Apollo.MutationResult<CreateDocumentMutation>;
export type CreateDocumentMutationOptions = Apollo.BaseMutationOptions<CreateDocumentMutation, CreateDocumentMutationVariables>;
export const CancelSubscriptionDocument = gql`
    mutation CancelSubscription($input: CancelSubscriptionInput!) {
  cancelSubscription(input: $input) {
    ...SubscriptionFields
  }
}
    ${SubscriptionFieldsFragmentDoc}`;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(CancelSubscriptionDocument, options);
      }
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = Apollo.MutationResult<CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;
export const PauseSubscriptionDocument = gql`
    mutation PauseSubscription($input: PauseSubscriptionInput!) {
  pauseSubscription(input: $input) {
    ...SubscriptionFields
  }
}
    ${SubscriptionFieldsFragmentDoc}`;

/**
 * __usePauseSubscriptionMutation__
 *
 * To run a mutation, you first call `usePauseSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseSubscriptionMutation, { data, loading, error }] = usePauseSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePauseSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PauseSubscriptionMutation, PauseSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PauseSubscriptionMutation, PauseSubscriptionMutationVariables>(PauseSubscriptionDocument, options);
      }
export type PauseSubscriptionMutationHookResult = ReturnType<typeof usePauseSubscriptionMutation>;
export type PauseSubscriptionMutationResult = Apollo.MutationResult<PauseSubscriptionMutation>;
export type PauseSubscriptionMutationOptions = Apollo.BaseMutationOptions<PauseSubscriptionMutation, PauseSubscriptionMutationVariables>;
export const ResumeSubscriptionDocument = gql`
    mutation ResumeSubscription($input: ResumeSubscriptionInput!) {
  resumeSubscription(input: $input) {
    ...SubscriptionFields
  }
}
    ${SubscriptionFieldsFragmentDoc}`;

/**
 * __useResumeSubscriptionMutation__
 *
 * To run a mutation, you first call `useResumeSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeSubscriptionMutation, { data, loading, error }] = useResumeSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResumeSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResumeSubscriptionMutation, ResumeSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResumeSubscriptionMutation, ResumeSubscriptionMutationVariables>(ResumeSubscriptionDocument, options);
      }
export type ResumeSubscriptionMutationHookResult = ReturnType<typeof useResumeSubscriptionMutation>;
export type ResumeSubscriptionMutationResult = Apollo.MutationResult<ResumeSubscriptionMutation>;
export type ResumeSubscriptionMutationOptions = Apollo.BaseMutationOptions<ResumeSubscriptionMutation, ResumeSubscriptionMutationVariables>;
export const UpdateSubscriptionDocument = gql`
    mutation UpdateSubscription($input: UpdateSubscriptionInput!) {
  updateSubscription(input: $input) {
    ...SubscriptionFields
  }
}
    ${SubscriptionFieldsFragmentDoc}`;

/**
 * __useUpdateSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionMutation, { data, loading, error }] = useUpdateSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>(UpdateSubscriptionDocument, options);
      }
export type UpdateSubscriptionMutationHookResult = ReturnType<typeof useUpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationResult = Apollo.MutationResult<UpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;
export const ActivateSubscriptionDocument = gql`
    mutation ActivateSubscription($input: ActivateSubscriptionInput!) {
  activateSubscription(input: $input) {
    ...PaymentFields
  }
}
    ${PaymentFieldsFragmentDoc}`;

/**
 * __useActivateSubscriptionMutation__
 *
 * To run a mutation, you first call `useActivateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateSubscriptionMutation, { data, loading, error }] = useActivateSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivateSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ActivateSubscriptionMutation, ActivateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ActivateSubscriptionMutation, ActivateSubscriptionMutationVariables>(ActivateSubscriptionDocument, options);
      }
export type ActivateSubscriptionMutationHookResult = ReturnType<typeof useActivateSubscriptionMutation>;
export type ActivateSubscriptionMutationResult = Apollo.MutationResult<ActivateSubscriptionMutation>;
export type ActivateSubscriptionMutationOptions = Apollo.BaseMutationOptions<ActivateSubscriptionMutation, ActivateSubscriptionMutationVariables>;
export const CreateSubscriptionDocument = gql`
    mutation CreateSubscription($input: CreateSubscriptionInput!) {
  createSubscription(input: $input) {
    ...SubscriptionFields
  }
}
    ${SubscriptionFieldsFragmentDoc}`;

/**
 * __useCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionMutation, { data, loading, error }] = useCreateSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>(CreateSubscriptionDocument, options);
      }
export type CreateSubscriptionMutationHookResult = ReturnType<typeof useCreateSubscriptionMutation>;
export type CreateSubscriptionMutationResult = Apollo.MutationResult<CreateSubscriptionMutation>;
export type CreateSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export const SendSubscriptionLinkDocument = gql`
    mutation SendSubscriptionLink($input: SendSubscriptionMessageInput!) {
  sendSubscriptionLink(input: $input) {
    ...SubscriptionFields
  }
}
    ${SubscriptionFieldsFragmentDoc}`;

/**
 * __useSendSubscriptionLinkMutation__
 *
 * To run a mutation, you first call `useSendSubscriptionLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSubscriptionLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSubscriptionLinkMutation, { data, loading, error }] = useSendSubscriptionLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendSubscriptionLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendSubscriptionLinkMutation, SendSubscriptionLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendSubscriptionLinkMutation, SendSubscriptionLinkMutationVariables>(SendSubscriptionLinkDocument, options);
      }
export type SendSubscriptionLinkMutationHookResult = ReturnType<typeof useSendSubscriptionLinkMutation>;
export type SendSubscriptionLinkMutationResult = Apollo.MutationResult<SendSubscriptionLinkMutation>;
export type SendSubscriptionLinkMutationOptions = Apollo.BaseMutationOptions<SendSubscriptionLinkMutation, SendSubscriptionLinkMutationVariables>;
export const SendSubscriptionStatusDocument = gql`
    mutation SendSubscriptionStatus($input: SendSubscriptionMessageInput!) {
  sendSubscriptionStatus(input: $input) {
    ...SubscriptionFields
  }
}
    ${SubscriptionFieldsFragmentDoc}`;

/**
 * __useSendSubscriptionStatusMutation__
 *
 * To run a mutation, you first call `useSendSubscriptionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSubscriptionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSubscriptionStatusMutation, { data, loading, error }] = useSendSubscriptionStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendSubscriptionStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendSubscriptionStatusMutation, SendSubscriptionStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendSubscriptionStatusMutation, SendSubscriptionStatusMutationVariables>(SendSubscriptionStatusDocument, options);
      }
export type SendSubscriptionStatusMutationHookResult = ReturnType<typeof useSendSubscriptionStatusMutation>;
export type SendSubscriptionStatusMutationResult = Apollo.MutationResult<SendSubscriptionStatusMutation>;
export type SendSubscriptionStatusMutationOptions = Apollo.BaseMutationOptions<SendSubscriptionStatusMutation, SendSubscriptionStatusMutationVariables>;
export const StartCompanyLookupDocument = gql`
    mutation StartCompanyLookup($documentNumber: String!, $accountId: ID!) {
  startCompanyLookup(documentNumber: $documentNumber, accountId: $accountId) {
    ...AccountFields
  }
}
    ${AccountFieldsFragmentDoc}`;

/**
 * __useStartCompanyLookupMutation__
 *
 * To run a mutation, you first call `useStartCompanyLookupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartCompanyLookupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startCompanyLookupMutation, { data, loading, error }] = useStartCompanyLookupMutation({
 *   variables: {
 *      documentNumber: // value for 'documentNumber'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useStartCompanyLookupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartCompanyLookupMutation, StartCompanyLookupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartCompanyLookupMutation, StartCompanyLookupMutationVariables>(StartCompanyLookupDocument, options);
      }
export type StartCompanyLookupMutationHookResult = ReturnType<typeof useStartCompanyLookupMutation>;
export type StartCompanyLookupMutationResult = Apollo.MutationResult<StartCompanyLookupMutation>;
export type StartCompanyLookupMutationOptions = Apollo.BaseMutationOptions<StartCompanyLookupMutation, StartCompanyLookupMutationVariables>;
export const CreatePibisiUserDocument = gql`
    mutation CreatePibisiUser($input: CreatePibisiUserInput) {
  createPibisiUser(input: $input) {
    ...AccountFields
  }
}
    ${AccountFieldsFragmentDoc}`;

/**
 * __useCreatePibisiUserMutation__
 *
 * To run a mutation, you first call `useCreatePibisiUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePibisiUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPibisiUserMutation, { data, loading, error }] = useCreatePibisiUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePibisiUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePibisiUserMutation, CreatePibisiUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreatePibisiUserMutation, CreatePibisiUserMutationVariables>(CreatePibisiUserDocument, options);
      }
export type CreatePibisiUserMutationHookResult = ReturnType<typeof useCreatePibisiUserMutation>;
export type CreatePibisiUserMutationResult = Apollo.MutationResult<CreatePibisiUserMutation>;
export type CreatePibisiUserMutationOptions = Apollo.BaseMutationOptions<CreatePibisiUserMutation, CreatePibisiUserMutationVariables>;
export const RegisterMoneiXpMerchantDocument = gql`
    mutation RegisterMoneiXPMerchant($accountId: ID!, $paymentMethods: [PaymentMethods]) {
  registerMoneiXPMerchant(accountId: $accountId, paymentMethods: $paymentMethods) {
    success
  }
}
    `;

/**
 * __useRegisterMoneiXpMerchantMutation__
 *
 * To run a mutation, you first call `useRegisterMoneiXpMerchantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMoneiXpMerchantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMoneiXpMerchantMutation, { data, loading, error }] = useRegisterMoneiXpMerchantMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      paymentMethods: // value for 'paymentMethods'
 *   },
 * });
 */
export function useRegisterMoneiXpMerchantMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RegisterMoneiXpMerchantMutation, RegisterMoneiXpMerchantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RegisterMoneiXpMerchantMutation, RegisterMoneiXpMerchantMutationVariables>(RegisterMoneiXpMerchantDocument, options);
      }
export type RegisterMoneiXpMerchantMutationHookResult = ReturnType<typeof useRegisterMoneiXpMerchantMutation>;
export type RegisterMoneiXpMerchantMutationResult = Apollo.MutationResult<RegisterMoneiXpMerchantMutation>;
export type RegisterMoneiXpMerchantMutationOptions = Apollo.BaseMutationOptions<RegisterMoneiXpMerchantMutation, RegisterMoneiXpMerchantMutationVariables>;
export const ResolvePibisiAlertDocument = gql`
    mutation ResolvePibisiAlert($input: ResolvePibisiAlertInput) {
  resolvePibisiAlert(input: $input) {
    ...AccountFields
  }
}
    ${AccountFieldsFragmentDoc}`;

/**
 * __useResolvePibisiAlertMutation__
 *
 * To run a mutation, you first call `useResolvePibisiAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolvePibisiAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolvePibisiAlertMutation, { data, loading, error }] = useResolvePibisiAlertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResolvePibisiAlertMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResolvePibisiAlertMutation, ResolvePibisiAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResolvePibisiAlertMutation, ResolvePibisiAlertMutationVariables>(ResolvePibisiAlertDocument, options);
      }
export type ResolvePibisiAlertMutationHookResult = ReturnType<typeof useResolvePibisiAlertMutation>;
export type ResolvePibisiAlertMutationResult = Apollo.MutationResult<ResolvePibisiAlertMutation>;
export type ResolvePibisiAlertMutationOptions = Apollo.BaseMutationOptions<ResolvePibisiAlertMutation, ResolvePibisiAlertMutationVariables>;
export const ResolvePibisiMatchDocument = gql`
    mutation ResolvePibisiMatch($input: ResolvePibisiMatchInput) {
  resolvePibisiMatch(input: $input) {
    ...AccountFields
  }
}
    ${AccountFieldsFragmentDoc}`;

/**
 * __useResolvePibisiMatchMutation__
 *
 * To run a mutation, you first call `useResolvePibisiMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolvePibisiMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolvePibisiMatchMutation, { data, loading, error }] = useResolvePibisiMatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResolvePibisiMatchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResolvePibisiMatchMutation, ResolvePibisiMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResolvePibisiMatchMutation, ResolvePibisiMatchMutationVariables>(ResolvePibisiMatchDocument, options);
      }
export type ResolvePibisiMatchMutationHookResult = ReturnType<typeof useResolvePibisiMatchMutation>;
export type ResolvePibisiMatchMutationResult = Apollo.MutationResult<ResolvePibisiMatchMutation>;
export type ResolvePibisiMatchMutationOptions = Apollo.BaseMutationOptions<ResolvePibisiMatchMutation, ResolvePibisiMatchMutationVariables>;
export const UpdateAccountInvoiceDocument = gql`
    mutation UpdateAccountInvoice($input: UpdateAccountInvoiceInput!) {
  updateAccountInvoice(input: $input) {
    ...AccountInvoiceFields
  }
}
    ${AccountInvoiceFieldsFragmentDoc}`;

/**
 * __useUpdateAccountInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdateAccountInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountInvoiceMutation, { data, loading, error }] = useUpdateAccountInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAccountInvoiceMutation, UpdateAccountInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAccountInvoiceMutation, UpdateAccountInvoiceMutationVariables>(UpdateAccountInvoiceDocument, options);
      }
export type UpdateAccountInvoiceMutationHookResult = ReturnType<typeof useUpdateAccountInvoiceMutation>;
export type UpdateAccountInvoiceMutationResult = Apollo.MutationResult<UpdateAccountInvoiceMutation>;
export type UpdateAccountInvoiceMutationOptions = Apollo.BaseMutationOptions<UpdateAccountInvoiceMutation, UpdateAccountInvoiceMutationVariables>;
export const CalculateRiskScoreDocument = gql`
    mutation CalculateRiskScore($input: CalculateRiskScoreInput!) {
  calculateRiskScore(input: $input) {
    ...AccountFields
  }
}
    ${AccountFieldsFragmentDoc}`;

/**
 * __useCalculateRiskScoreMutation__
 *
 * To run a mutation, you first call `useCalculateRiskScoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateRiskScoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateRiskScoreMutation, { data, loading, error }] = useCalculateRiskScoreMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalculateRiskScoreMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CalculateRiskScoreMutation, CalculateRiskScoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CalculateRiskScoreMutation, CalculateRiskScoreMutationVariables>(CalculateRiskScoreDocument, options);
      }
export type CalculateRiskScoreMutationHookResult = ReturnType<typeof useCalculateRiskScoreMutation>;
export type CalculateRiskScoreMutationResult = Apollo.MutationResult<CalculateRiskScoreMutation>;
export type CalculateRiskScoreMutationOptions = Apollo.BaseMutationOptions<CalculateRiskScoreMutation, CalculateRiskScoreMutationVariables>;
export const DeleteWebhookDocument = gql`
    mutation DeleteWebhook($id: ID!, $accountId: ID!) {
  deleteWebhook(id: $id, accountId: $accountId)
}
    `;

/**
 * __useDeleteWebhookMutation__
 *
 * To run a mutation, you first call `useDeleteWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWebhookMutation, { data, loading, error }] = useDeleteWebhookMutation({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDeleteWebhookMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteWebhookMutation, DeleteWebhookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteWebhookMutation, DeleteWebhookMutationVariables>(DeleteWebhookDocument, options);
      }
export type DeleteWebhookMutationHookResult = ReturnType<typeof useDeleteWebhookMutation>;
export type DeleteWebhookMutationResult = Apollo.MutationResult<DeleteWebhookMutation>;
export type DeleteWebhookMutationOptions = Apollo.BaseMutationOptions<DeleteWebhookMutation, DeleteWebhookMutationVariables>;
export const CreateWebhookDocument = gql`
    mutation CreateWebhook($input: CreateWebhookInput!) {
  createWebhook(input: $input) {
    ...WebhookFields
  }
}
    ${WebhookFieldsFragmentDoc}`;

/**
 * __useCreateWebhookMutation__
 *
 * To run a mutation, you first call `useCreateWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebhookMutation, { data, loading, error }] = useCreateWebhookMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWebhookMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateWebhookMutation, CreateWebhookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateWebhookMutation, CreateWebhookMutationVariables>(CreateWebhookDocument, options);
      }
export type CreateWebhookMutationHookResult = ReturnType<typeof useCreateWebhookMutation>;
export type CreateWebhookMutationResult = Apollo.MutationResult<CreateWebhookMutation>;
export type CreateWebhookMutationOptions = Apollo.BaseMutationOptions<CreateWebhookMutation, CreateWebhookMutationVariables>;
export const UpdateWebhookDocument = gql`
    mutation UpdateWebhook($input: UpdateWebhookInput!) {
  updateWebhook(input: $input) {
    ...WebhookFields
  }
}
    ${WebhookFieldsFragmentDoc}`;

/**
 * __useUpdateWebhookMutation__
 *
 * To run a mutation, you first call `useUpdateWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebhookMutation, { data, loading, error }] = useUpdateWebhookMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWebhookMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWebhookMutation, UpdateWebhookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWebhookMutation, UpdateWebhookMutationVariables>(UpdateWebhookDocument, options);
      }
export type UpdateWebhookMutationHookResult = ReturnType<typeof useUpdateWebhookMutation>;
export type UpdateWebhookMutationResult = Apollo.MutationResult<UpdateWebhookMutation>;
export type UpdateWebhookMutationOptions = Apollo.BaseMutationOptions<UpdateWebhookMutation, UpdateWebhookMutationVariables>;
export const StartExportChargesDocument = gql`
    mutation StartExportCharges($filter: SearchableChargeFilterInput, $columns: [String!], $timezone: String) {
  startExportCharges(filter: $filter, columns: $columns, timezone: $timezone) {
    ...StartExportChargesFields
  }
}
    ${StartExportChargesFieldsFragmentDoc}`;

/**
 * __useStartExportChargesMutation__
 *
 * To run a mutation, you first call `useStartExportChargesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartExportChargesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startExportChargesMutation, { data, loading, error }] = useStartExportChargesMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      columns: // value for 'columns'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useStartExportChargesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartExportChargesMutation, StartExportChargesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<StartExportChargesMutation, StartExportChargesMutationVariables>(StartExportChargesDocument, options);
      }
export type StartExportChargesMutationHookResult = ReturnType<typeof useStartExportChargesMutation>;
export type StartExportChargesMutationResult = Apollo.MutationResult<StartExportChargesMutation>;
export type StartExportChargesMutationOptions = Apollo.BaseMutationOptions<StartExportChargesMutation, StartExportChargesMutationVariables>;
export const DownloadExportDocument = gql`
    mutation DownloadExport($id: ID!) {
  downloadExport(id: $id) {
    downloadUrl
  }
}
    `;

/**
 * __useDownloadExportMutation__
 *
 * To run a mutation, you first call `useDownloadExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadExportMutation, { data, loading, error }] = useDownloadExportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadExportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DownloadExportMutation, DownloadExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DownloadExportMutation, DownloadExportMutationVariables>(DownloadExportDocument, options);
      }
export type DownloadExportMutationHookResult = ReturnType<typeof useDownloadExportMutation>;
export type DownloadExportMutationResult = Apollo.MutationResult<DownloadExportMutation>;
export type DownloadExportMutationOptions = Apollo.BaseMutationOptions<DownloadExportMutation, DownloadExportMutationVariables>;
export const CreateStoreDocument = gql`
    mutation CreateStore($input: CreateStoreInput!) {
  createStore(input: $input) {
    ...StoreFields
  }
}
    ${StoreFieldsFragmentDoc}`;

/**
 * __useCreateStoreMutation__
 *
 * To run a mutation, you first call `useCreateStoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStoreMutation, { data, loading, error }] = useCreateStoreMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStoreMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateStoreMutation, CreateStoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateStoreMutation, CreateStoreMutationVariables>(CreateStoreDocument, options);
      }
export type CreateStoreMutationHookResult = ReturnType<typeof useCreateStoreMutation>;
export type CreateStoreMutationResult = Apollo.MutationResult<CreateStoreMutation>;
export type CreateStoreMutationOptions = Apollo.BaseMutationOptions<CreateStoreMutation, CreateStoreMutationVariables>;
export const UpdateStoreDocument = gql`
    mutation UpdateStore($input: UpdateStoreInput!) {
  updateStore(input: $input) {
    ...StoreFields
  }
}
    ${StoreFieldsFragmentDoc}`;

/**
 * __useUpdateStoreMutation__
 *
 * To run a mutation, you first call `useUpdateStoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStoreMutation, { data, loading, error }] = useUpdateStoreMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStoreMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateStoreMutation, UpdateStoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateStoreMutation, UpdateStoreMutationVariables>(UpdateStoreDocument, options);
      }
export type UpdateStoreMutationHookResult = ReturnType<typeof useUpdateStoreMutation>;
export type UpdateStoreMutationResult = Apollo.MutationResult<UpdateStoreMutation>;
export type UpdateStoreMutationOptions = Apollo.BaseMutationOptions<UpdateStoreMutation, UpdateStoreMutationVariables>;
export const DeleteStoreDocument = gql`
    mutation DeleteStore($id: ID!, $accountId: ID!) {
  deleteStore(id: $id, accountId: $accountId)
}
    `;

/**
 * __useDeleteStoreMutation__
 *
 * To run a mutation, you first call `useDeleteStoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStoreMutation, { data, loading, error }] = useDeleteStoreMutation({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDeleteStoreMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteStoreMutation, DeleteStoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteStoreMutation, DeleteStoreMutationVariables>(DeleteStoreDocument, options);
      }
export type DeleteStoreMutationHookResult = ReturnType<typeof useDeleteStoreMutation>;
export type DeleteStoreMutationResult = Apollo.MutationResult<DeleteStoreMutation>;
export type DeleteStoreMutationOptions = Apollo.BaseMutationOptions<DeleteStoreMutation, DeleteStoreMutationVariables>;
export const UpdateWebKeywordDocument = gql`
    mutation UpdateWebKeyword($input: UpdateWebKeywordInput!) {
  updateWebKeyword(input: $input) {
    incorrect
  }
}
    `;

/**
 * __useUpdateWebKeywordMutation__
 *
 * To run a mutation, you first call `useUpdateWebKeywordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebKeywordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWebKeywordMutation, { data, loading, error }] = useUpdateWebKeywordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWebKeywordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateWebKeywordMutation, UpdateWebKeywordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateWebKeywordMutation, UpdateWebKeywordMutationVariables>(UpdateWebKeywordDocument, options);
      }
export type UpdateWebKeywordMutationHookResult = ReturnType<typeof useUpdateWebKeywordMutation>;
export type UpdateWebKeywordMutationResult = Apollo.MutationResult<UpdateWebKeywordMutation>;
export type UpdateWebKeywordMutationOptions = Apollo.BaseMutationOptions<UpdateWebKeywordMutation, UpdateWebKeywordMutationVariables>;
export const ConnectMasterAccountDocument = gql`
    mutation ConnectMasterAccount($accountId: ID!, $promoCode: String!, $externalId: String, $externalHash: String) {
  connectMasterAccount(
    accountId: $accountId
    promoCode: $promoCode
    externalId: $externalId
    externalHash: $externalHash
  ) {
    ...AccountFields
  }
}
    ${AccountFieldsFragmentDoc}`;

/**
 * __useConnectMasterAccountMutation__
 *
 * To run a mutation, you first call `useConnectMasterAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectMasterAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectMasterAccountMutation, { data, loading, error }] = useConnectMasterAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      promoCode: // value for 'promoCode'
 *      externalId: // value for 'externalId'
 *      externalHash: // value for 'externalHash'
 *   },
 * });
 */
export function useConnectMasterAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConnectMasterAccountMutation, ConnectMasterAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConnectMasterAccountMutation, ConnectMasterAccountMutationVariables>(ConnectMasterAccountDocument, options);
      }
export type ConnectMasterAccountMutationHookResult = ReturnType<typeof useConnectMasterAccountMutation>;
export type ConnectMasterAccountMutationResult = Apollo.MutationResult<ConnectMasterAccountMutation>;
export type ConnectMasterAccountMutationOptions = Apollo.BaseMutationOptions<ConnectMasterAccountMutation, ConnectMasterAccountMutationVariables>;
export const DisconnectMasterAccountDocument = gql`
    mutation DisconnectMasterAccount($accountId: ID!) {
  disconnectMasterAccount(accountId: $accountId) {
    ...AccountFields
  }
}
    ${AccountFieldsFragmentDoc}`;

/**
 * __useDisconnectMasterAccountMutation__
 *
 * To run a mutation, you first call `useDisconnectMasterAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectMasterAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectMasterAccountMutation, { data, loading, error }] = useDisconnectMasterAccountMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDisconnectMasterAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DisconnectMasterAccountMutation, DisconnectMasterAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisconnectMasterAccountMutation, DisconnectMasterAccountMutationVariables>(DisconnectMasterAccountDocument, options);
      }
export type DisconnectMasterAccountMutationHookResult = ReturnType<typeof useDisconnectMasterAccountMutation>;
export type DisconnectMasterAccountMutationResult = Apollo.MutationResult<DisconnectMasterAccountMutation>;
export type DisconnectMasterAccountMutationOptions = Apollo.BaseMutationOptions<DisconnectMasterAccountMutation, DisconnectMasterAccountMutationVariables>;
export const CreateMasterAccountApiKeyDocument = gql`
    mutation CreateMasterAccountApiKey($input: CreateMasterAccountApiKeyInput!) {
  createMasterAccountApiKey(input: $input) {
    ...MasterAccountFields
  }
}
    ${MasterAccountFieldsFragmentDoc}`;

/**
 * __useCreateMasterAccountApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateMasterAccountApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMasterAccountApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMasterAccountApiKeyMutation, { data, loading, error }] = useCreateMasterAccountApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMasterAccountApiKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMasterAccountApiKeyMutation, CreateMasterAccountApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateMasterAccountApiKeyMutation, CreateMasterAccountApiKeyMutationVariables>(CreateMasterAccountApiKeyDocument, options);
      }
export type CreateMasterAccountApiKeyMutationHookResult = ReturnType<typeof useCreateMasterAccountApiKeyMutation>;
export type CreateMasterAccountApiKeyMutationResult = Apollo.MutationResult<CreateMasterAccountApiKeyMutation>;
export type CreateMasterAccountApiKeyMutationOptions = Apollo.BaseMutationOptions<CreateMasterAccountApiKeyMutation, CreateMasterAccountApiKeyMutationVariables>;
export const DeleteMasterAccountApiKeyDocument = gql`
    mutation DeleteMasterAccountApiKey($input: DeleteMasterAccountApiKeyInput!) {
  deleteMasterAccountApiKey(input: $input) {
    ...MasterAccountFields
  }
}
    ${MasterAccountFieldsFragmentDoc}`;

/**
 * __useDeleteMasterAccountApiKeyMutation__
 *
 * To run a mutation, you first call `useDeleteMasterAccountApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMasterAccountApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMasterAccountApiKeyMutation, { data, loading, error }] = useDeleteMasterAccountApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMasterAccountApiKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMasterAccountApiKeyMutation, DeleteMasterAccountApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteMasterAccountApiKeyMutation, DeleteMasterAccountApiKeyMutationVariables>(DeleteMasterAccountApiKeyDocument, options);
      }
export type DeleteMasterAccountApiKeyMutationHookResult = ReturnType<typeof useDeleteMasterAccountApiKeyMutation>;
export type DeleteMasterAccountApiKeyMutationResult = Apollo.MutationResult<DeleteMasterAccountApiKeyMutation>;
export type DeleteMasterAccountApiKeyMutationOptions = Apollo.BaseMutationOptions<DeleteMasterAccountApiKeyMutation, DeleteMasterAccountApiKeyMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UserInput!) {
  updateUser(input: $input) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateAffiliateTierDocument = gql`
    mutation UpdateAffiliateTier($input: UpdateAffiliateTierInput!) {
  updateAffiliateTier(input: $input) {
    id
    meta_data {
      tier
    }
  }
}
    `;

/**
 * __useUpdateAffiliateTierMutation__
 *
 * To run a mutation, you first call `useUpdateAffiliateTierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAffiliateTierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAffiliateTierMutation, { data, loading, error }] = useUpdateAffiliateTierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAffiliateTierMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAffiliateTierMutation, UpdateAffiliateTierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAffiliateTierMutation, UpdateAffiliateTierMutationVariables>(UpdateAffiliateTierDocument, options);
      }
export type UpdateAffiliateTierMutationHookResult = ReturnType<typeof useUpdateAffiliateTierMutation>;
export type UpdateAffiliateTierMutationResult = Apollo.MutationResult<UpdateAffiliateTierMutation>;
export type UpdateAffiliateTierMutationOptions = Apollo.BaseMutationOptions<UpdateAffiliateTierMutation, UpdateAffiliateTierMutationVariables>;
export const EnableAffiliateProcessingDocument = gql`
    mutation EnableAffiliateProcessing($affiliateId: ID!) {
  enableAffiliateProcessing(affiliateId: $affiliateId) {
    id
    affiliate_group_id
  }
}
    `;

/**
 * __useEnableAffiliateProcessingMutation__
 *
 * To run a mutation, you first call `useEnableAffiliateProcessingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableAffiliateProcessingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableAffiliateProcessingMutation, { data, loading, error }] = useEnableAffiliateProcessingMutation({
 *   variables: {
 *      affiliateId: // value for 'affiliateId'
 *   },
 * });
 */
export function useEnableAffiliateProcessingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EnableAffiliateProcessingMutation, EnableAffiliateProcessingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EnableAffiliateProcessingMutation, EnableAffiliateProcessingMutationVariables>(EnableAffiliateProcessingDocument, options);
      }
export type EnableAffiliateProcessingMutationHookResult = ReturnType<typeof useEnableAffiliateProcessingMutation>;
export type EnableAffiliateProcessingMutationResult = Apollo.MutationResult<EnableAffiliateProcessingMutation>;
export type EnableAffiliateProcessingMutationOptions = Apollo.BaseMutationOptions<EnableAffiliateProcessingMutation, EnableAffiliateProcessingMutationVariables>;
export const DisableAffiliateProcessingDocument = gql`
    mutation DisableAffiliateProcessing($affiliateId: ID!) {
  disableAffiliateProcessing(affiliateId: $affiliateId) {
    id
    affiliate_group_id
  }
}
    `;

/**
 * __useDisableAffiliateProcessingMutation__
 *
 * To run a mutation, you first call `useDisableAffiliateProcessingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableAffiliateProcessingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableAffiliateProcessingMutation, { data, loading, error }] = useDisableAffiliateProcessingMutation({
 *   variables: {
 *      affiliateId: // value for 'affiliateId'
 *   },
 * });
 */
export function useDisableAffiliateProcessingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DisableAffiliateProcessingMutation, DisableAffiliateProcessingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DisableAffiliateProcessingMutation, DisableAffiliateProcessingMutationVariables>(DisableAffiliateProcessingDocument, options);
      }
export type DisableAffiliateProcessingMutationHookResult = ReturnType<typeof useDisableAffiliateProcessingMutation>;
export type DisableAffiliateProcessingMutationResult = Apollo.MutationResult<DisableAffiliateProcessingMutation>;
export type DisableAffiliateProcessingMutationOptions = Apollo.BaseMutationOptions<DisableAffiliateProcessingMutation, DisableAffiliateProcessingMutationVariables>;
export const UpdateAffiliatePayoutMethodDocument = gql`
    mutation UpdateAffiliatePayoutMethod($input: UpdateAffiliatePayoutMethodInput!) {
  updateAffiliatePayoutMethod(input: $input) {
    id
    payout_methods {
      ...PayoutMethodsFields
    }
  }
}
    ${PayoutMethodsFieldsFragmentDoc}`;

/**
 * __useUpdateAffiliatePayoutMethodMutation__
 *
 * To run a mutation, you first call `useUpdateAffiliatePayoutMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAffiliatePayoutMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAffiliatePayoutMethodMutation, { data, loading, error }] = useUpdateAffiliatePayoutMethodMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAffiliatePayoutMethodMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAffiliatePayoutMethodMutation, UpdateAffiliatePayoutMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAffiliatePayoutMethodMutation, UpdateAffiliatePayoutMethodMutationVariables>(UpdateAffiliatePayoutMethodDocument, options);
      }
export type UpdateAffiliatePayoutMethodMutationHookResult = ReturnType<typeof useUpdateAffiliatePayoutMethodMutation>;
export type UpdateAffiliatePayoutMethodMutationResult = Apollo.MutationResult<UpdateAffiliatePayoutMethodMutation>;
export type UpdateAffiliatePayoutMethodMutationOptions = Apollo.BaseMutationOptions<UpdateAffiliatePayoutMethodMutation, UpdateAffiliatePayoutMethodMutationVariables>;
export const RetrieveAffiliateHistoryDocument = gql`
    mutation RetrieveAffiliateHistory($affiliateId: ID!, $email: String!) {
  retrieveAffiliateHistory(affiliateId: $affiliateId, email: $email)
}
    `;

/**
 * __useRetrieveAffiliateHistoryMutation__
 *
 * To run a mutation, you first call `useRetrieveAffiliateHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetrieveAffiliateHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retrieveAffiliateHistoryMutation, { data, loading, error }] = useRetrieveAffiliateHistoryMutation({
 *   variables: {
 *      affiliateId: // value for 'affiliateId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRetrieveAffiliateHistoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RetrieveAffiliateHistoryMutation, RetrieveAffiliateHistoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RetrieveAffiliateHistoryMutation, RetrieveAffiliateHistoryMutationVariables>(RetrieveAffiliateHistoryDocument, options);
      }
export type RetrieveAffiliateHistoryMutationHookResult = ReturnType<typeof useRetrieveAffiliateHistoryMutation>;
export type RetrieveAffiliateHistoryMutationResult = Apollo.MutationResult<RetrieveAffiliateHistoryMutation>;
export type RetrieveAffiliateHistoryMutationOptions = Apollo.BaseMutationOptions<RetrieveAffiliateHistoryMutation, RetrieveAffiliateHistoryMutationVariables>;
export const DownloadAffiliateInvoiceDocument = gql`
    mutation DownloadAffiliateInvoice($invoiceNumber: String!, $affiliateId: String!, $year: String!) {
  downloadAffiliateInvoice(
    invoiceNumber: $invoiceNumber
    affiliateId: $affiliateId
    year: $year
  ) {
    downloadUrl
    expiresAt
  }
}
    `;

/**
 * __useDownloadAffiliateInvoiceMutation__
 *
 * To run a mutation, you first call `useDownloadAffiliateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadAffiliateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadAffiliateInvoiceMutation, { data, loading, error }] = useDownloadAffiliateInvoiceMutation({
 *   variables: {
 *      invoiceNumber: // value for 'invoiceNumber'
 *      affiliateId: // value for 'affiliateId'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useDownloadAffiliateInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DownloadAffiliateInvoiceMutation, DownloadAffiliateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DownloadAffiliateInvoiceMutation, DownloadAffiliateInvoiceMutationVariables>(DownloadAffiliateInvoiceDocument, options);
      }
export type DownloadAffiliateInvoiceMutationHookResult = ReturnType<typeof useDownloadAffiliateInvoiceMutation>;
export type DownloadAffiliateInvoiceMutationResult = Apollo.MutationResult<DownloadAffiliateInvoiceMutation>;
export type DownloadAffiliateInvoiceMutationOptions = Apollo.BaseMutationOptions<DownloadAffiliateInvoiceMutation, DownloadAffiliateInvoiceMutationVariables>;
export const AccountDocument = gql`
    query Account($id: ID!) {
  account(id: $id) {
    ...AccountFields
  }
}
    ${AccountFieldsFragmentDoc}`;

/**
 * __useAccountQuery__
 *
 * To run a query within a React component, call `useAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AccountQuery, AccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountQuery, AccountQueryVariables>(AccountDocument, options);
      }
export function useAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountQuery, AccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountQuery, AccountQueryVariables>(AccountDocument, options);
        }
export type AccountQueryHookResult = ReturnType<typeof useAccountQuery>;
export type AccountLazyQueryHookResult = ReturnType<typeof useAccountLazyQuery>;
export type AccountQueryResult = Apollo.QueryResult<AccountQuery, AccountQueryVariables>;
export function refetchAccountQuery(variables: AccountQueryVariables) {
      return { query: AccountDocument, variables: variables }
    }
export const AccountsDocument = gql`
    query Accounts($filter: SearchableAccountFilterInput, $size: Int, $from: Int) {
  accounts(filter: $filter, size: $size, from: $from) {
    items {
      ...AccountFields
    }
    total
  }
}
    ${AccountFieldsFragmentDoc}`;

/**
 * __useAccountsQuery__
 *
 * To run a query within a React component, call `useAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      size: // value for 'size'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useAccountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountsQuery, AccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountsQuery, AccountsQueryVariables>(AccountsDocument, options);
      }
export function useAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountsQuery, AccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountsQuery, AccountsQueryVariables>(AccountsDocument, options);
        }
export type AccountsQueryHookResult = ReturnType<typeof useAccountsQuery>;
export type AccountsLazyQueryHookResult = ReturnType<typeof useAccountsLazyQuery>;
export type AccountsQueryResult = Apollo.QueryResult<AccountsQuery, AccountsQueryVariables>;
export function refetchAccountsQuery(variables?: AccountsQueryVariables) {
      return { query: AccountsDocument, variables: variables }
    }
export const AuthorizedUsersDocument = gql`
    query AuthorizedUsers($accountId: ID!) {
  authorizedUsers(accountId: $accountId) {
    items {
      ...AuthorizedUserFields
    }
  }
}
    ${AuthorizedUserFieldsFragmentDoc}`;

/**
 * __useAuthorizedUsersQuery__
 *
 * To run a query within a React component, call `useAuthorizedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorizedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorizedUsersQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAuthorizedUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AuthorizedUsersQuery, AuthorizedUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AuthorizedUsersQuery, AuthorizedUsersQueryVariables>(AuthorizedUsersDocument, options);
      }
export function useAuthorizedUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AuthorizedUsersQuery, AuthorizedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AuthorizedUsersQuery, AuthorizedUsersQueryVariables>(AuthorizedUsersDocument, options);
        }
export type AuthorizedUsersQueryHookResult = ReturnType<typeof useAuthorizedUsersQuery>;
export type AuthorizedUsersLazyQueryHookResult = ReturnType<typeof useAuthorizedUsersLazyQuery>;
export type AuthorizedUsersQueryResult = Apollo.QueryResult<AuthorizedUsersQuery, AuthorizedUsersQueryVariables>;
export function refetchAuthorizedUsersQuery(variables: AuthorizedUsersQueryVariables) {
      return { query: AuthorizedUsersDocument, variables: variables }
    }
export const AvailablePaymentMethodsDocument = gql`
    query AvailablePaymentMethods($accountId: ID!) {
  availablePaymentMethods(accountId: $accountId) {
    paymentMethod
    configured
    enabled
  }
}
    `;

/**
 * __useAvailablePaymentMethodsQuery__
 *
 * To run a query within a React component, call `useAvailablePaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailablePaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailablePaymentMethodsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAvailablePaymentMethodsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AvailablePaymentMethodsQuery, AvailablePaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AvailablePaymentMethodsQuery, AvailablePaymentMethodsQueryVariables>(AvailablePaymentMethodsDocument, options);
      }
export function useAvailablePaymentMethodsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AvailablePaymentMethodsQuery, AvailablePaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AvailablePaymentMethodsQuery, AvailablePaymentMethodsQueryVariables>(AvailablePaymentMethodsDocument, options);
        }
export type AvailablePaymentMethodsQueryHookResult = ReturnType<typeof useAvailablePaymentMethodsQuery>;
export type AvailablePaymentMethodsLazyQueryHookResult = ReturnType<typeof useAvailablePaymentMethodsLazyQuery>;
export type AvailablePaymentMethodsQueryResult = Apollo.QueryResult<AvailablePaymentMethodsQuery, AvailablePaymentMethodsQueryVariables>;
export function refetchAvailablePaymentMethodsQuery(variables: AvailablePaymentMethodsQueryVariables) {
      return { query: AvailablePaymentMethodsDocument, variables: variables }
    }
export const AvailableProcessorsDocument = gql`
    query AvailableProcessors($accountId: ID!, $paymentMethod: PaymentMethods!) {
  availableProcessors(accountId: $accountId, paymentMethod: $paymentMethod) {
    paymentMethod
    processor
    configured
    enabled
  }
}
    `;

/**
 * __useAvailableProcessorsQuery__
 *
 * To run a query within a React component, call `useAvailableProcessorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableProcessorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableProcessorsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function useAvailableProcessorsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AvailableProcessorsQuery, AvailableProcessorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AvailableProcessorsQuery, AvailableProcessorsQueryVariables>(AvailableProcessorsDocument, options);
      }
export function useAvailableProcessorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AvailableProcessorsQuery, AvailableProcessorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AvailableProcessorsQuery, AvailableProcessorsQueryVariables>(AvailableProcessorsDocument, options);
        }
export type AvailableProcessorsQueryHookResult = ReturnType<typeof useAvailableProcessorsQuery>;
export type AvailableProcessorsLazyQueryHookResult = ReturnType<typeof useAvailableProcessorsLazyQuery>;
export type AvailableProcessorsQueryResult = Apollo.QueryResult<AvailableProcessorsQuery, AvailableProcessorsQueryVariables>;
export function refetchAvailableProcessorsQuery(variables: AvailableProcessorsQueryVariables) {
      return { query: AvailableProcessorsDocument, variables: variables }
    }
export const ProviderConfigDocument = gql`
    query ProviderConfig($paymentMethod: PaymentMethods!, $processor: Processor!) {
  providerConfig(paymentMethod: $paymentMethod, processor: $processor) {
    paymentMethod
    processor
    acquirers
    metadataConfig {
      key
      type
      label
      possibleValues
      default
      regex
      secret
      example
    }
  }
}
    `;

/**
 * __useProviderConfigQuery__
 *
 * To run a query within a React component, call `useProviderConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderConfigQuery({
 *   variables: {
 *      paymentMethod: // value for 'paymentMethod'
 *      processor: // value for 'processor'
 *   },
 * });
 */
export function useProviderConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProviderConfigQuery, ProviderConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProviderConfigQuery, ProviderConfigQueryVariables>(ProviderConfigDocument, options);
      }
export function useProviderConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProviderConfigQuery, ProviderConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProviderConfigQuery, ProviderConfigQueryVariables>(ProviderConfigDocument, options);
        }
export type ProviderConfigQueryHookResult = ReturnType<typeof useProviderConfigQuery>;
export type ProviderConfigLazyQueryHookResult = ReturnType<typeof useProviderConfigLazyQuery>;
export type ProviderConfigQueryResult = Apollo.QueryResult<ProviderConfigQuery, ProviderConfigQueryVariables>;
export function refetchProviderConfigQuery(variables: ProviderConfigQueryVariables) {
      return { query: ProviderConfigDocument, variables: variables }
    }
export const ProviderDocument = gql`
    query Provider($id: ID!) {
  provider(id: $id) {
    ...ProviderFields
  }
}
    ${ProviderFieldsFragmentDoc}`;

/**
 * __useProviderQuery__
 *
 * To run a query within a React component, call `useProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProviderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProviderQuery, ProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProviderQuery, ProviderQueryVariables>(ProviderDocument, options);
      }
export function useProviderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProviderQuery, ProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProviderQuery, ProviderQueryVariables>(ProviderDocument, options);
        }
export type ProviderQueryHookResult = ReturnType<typeof useProviderQuery>;
export type ProviderLazyQueryHookResult = ReturnType<typeof useProviderLazyQuery>;
export type ProviderQueryResult = Apollo.QueryResult<ProviderQuery, ProviderQueryVariables>;
export function refetchProviderQuery(variables: ProviderQueryVariables) {
      return { query: ProviderDocument, variables: variables }
    }
export const ProvidersDocument = gql`
    query Providers($accountId: ID!) {
  providers(accountId: $accountId) {
    ...ProviderFields
  }
}
    ${ProviderFieldsFragmentDoc}`;

/**
 * __useProvidersQuery__
 *
 * To run a query within a React component, call `useProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProvidersQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useProvidersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProvidersQuery, ProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProvidersQuery, ProvidersQueryVariables>(ProvidersDocument, options);
      }
export function useProvidersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProvidersQuery, ProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProvidersQuery, ProvidersQueryVariables>(ProvidersDocument, options);
        }
export type ProvidersQueryHookResult = ReturnType<typeof useProvidersQuery>;
export type ProvidersLazyQueryHookResult = ReturnType<typeof useProvidersLazyQuery>;
export type ProvidersQueryResult = Apollo.QueryResult<ProvidersQuery, ProvidersQueryVariables>;
export function refetchProvidersQuery(variables: ProvidersQueryVariables) {
      return { query: ProvidersDocument, variables: variables }
    }
export const ChargesDocument = gql`
    query Charges($filter: SearchableChargeFilterInput, $size: Int, $from: Int) {
  charges(filter: $filter, size: $size, from: $from) {
    items {
      ...ChargeFields
    }
    total
  }
}
    ${ChargeFieldsFragmentDoc}`;

/**
 * __useChargesQuery__
 *
 * To run a query within a React component, call `useChargesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChargesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChargesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      size: // value for 'size'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useChargesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ChargesQuery, ChargesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChargesQuery, ChargesQueryVariables>(ChargesDocument, options);
      }
export function useChargesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChargesQuery, ChargesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChargesQuery, ChargesQueryVariables>(ChargesDocument, options);
        }
export type ChargesQueryHookResult = ReturnType<typeof useChargesQuery>;
export type ChargesLazyQueryHookResult = ReturnType<typeof useChargesLazyQuery>;
export type ChargesQueryResult = Apollo.QueryResult<ChargesQuery, ChargesQueryVariables>;
export function refetchChargesQuery(variables?: ChargesQueryVariables) {
      return { query: ChargesDocument, variables: variables }
    }
export const ChargesExportDocument = gql`
    query ChargesExport($id: ID!) {
  chargesExport(id: $id) {
    id
    status
    statusCode
    statusMessage
  }
}
    `;

/**
 * __useChargesExportQuery__
 *
 * To run a query within a React component, call `useChargesExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useChargesExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChargesExportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChargesExportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChargesExportQuery, ChargesExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChargesExportQuery, ChargesExportQueryVariables>(ChargesExportDocument, options);
      }
export function useChargesExportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChargesExportQuery, ChargesExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChargesExportQuery, ChargesExportQueryVariables>(ChargesExportDocument, options);
        }
export type ChargesExportQueryHookResult = ReturnType<typeof useChargesExportQuery>;
export type ChargesExportLazyQueryHookResult = ReturnType<typeof useChargesExportLazyQuery>;
export type ChargesExportQueryResult = Apollo.QueryResult<ChargesExportQuery, ChargesExportQueryVariables>;
export function refetchChargesExportQuery(variables: ChargesExportQueryVariables) {
      return { query: ChargesExportDocument, variables: variables }
    }
export const ChargeDocument = gql`
    query Charge($id: ID!) {
  charge(id: $id) {
    ...ChargeFields
  }
}
    ${ChargeFieldsFragmentDoc}`;

/**
 * __useChargeQuery__
 *
 * To run a query within a React component, call `useChargeQuery` and pass it any options that fit your needs.
 * When your component renders, `useChargeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChargeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChargeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChargeQuery, ChargeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChargeQuery, ChargeQueryVariables>(ChargeDocument, options);
      }
export function useChargeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChargeQuery, ChargeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChargeQuery, ChargeQueryVariables>(ChargeDocument, options);
        }
export type ChargeQueryHookResult = ReturnType<typeof useChargeQuery>;
export type ChargeLazyQueryHookResult = ReturnType<typeof useChargeLazyQuery>;
export type ChargeQueryResult = Apollo.QueryResult<ChargeQuery, ChargeQueryVariables>;
export function refetchChargeQuery(variables: ChargeQueryVariables) {
      return { query: ChargeDocument, variables: variables }
    }
export const SucceededDateRangeKpiDocument = gql`
    query SucceededDateRangeKpi($start: Int, $end: Int, $interval: Interval, $accountId: ID, $acquirer: Acquirer, $masterAccountId: ID, $billingPlan: String, $paymentMethod: PaymentMethods, $source: String, $timezone: String, $currency: Currencies) {
  chargesDateRangeKPI(
    start: $start
    end: $end
    interval: $interval
    accountId: $accountId
    acquirer: $acquirer
    masterAccountId: $masterAccountId
    billingPlan: $billingPlan
    paymentMethod: $paymentMethod
    source: $source
    timezone: $timezone
    currency: $currency
  ) {
    currency
    total {
      succeededAmount
      succeededCount
    }
    data {
      timestamp
      cuSucceededAmount
      cuSucceededCount
    }
  }
}
    `;

/**
 * __useSucceededDateRangeKpiQuery__
 *
 * To run a query within a React component, call `useSucceededDateRangeKpiQuery` and pass it any options that fit your needs.
 * When your component renders, `useSucceededDateRangeKpiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSucceededDateRangeKpiQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      interval: // value for 'interval'
 *      accountId: // value for 'accountId'
 *      acquirer: // value for 'acquirer'
 *      masterAccountId: // value for 'masterAccountId'
 *      billingPlan: // value for 'billingPlan'
 *      paymentMethod: // value for 'paymentMethod'
 *      source: // value for 'source'
 *      timezone: // value for 'timezone'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useSucceededDateRangeKpiQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SucceededDateRangeKpiQuery, SucceededDateRangeKpiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SucceededDateRangeKpiQuery, SucceededDateRangeKpiQueryVariables>(SucceededDateRangeKpiDocument, options);
      }
export function useSucceededDateRangeKpiLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SucceededDateRangeKpiQuery, SucceededDateRangeKpiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SucceededDateRangeKpiQuery, SucceededDateRangeKpiQueryVariables>(SucceededDateRangeKpiDocument, options);
        }
export type SucceededDateRangeKpiQueryHookResult = ReturnType<typeof useSucceededDateRangeKpiQuery>;
export type SucceededDateRangeKpiLazyQueryHookResult = ReturnType<typeof useSucceededDateRangeKpiLazyQuery>;
export type SucceededDateRangeKpiQueryResult = Apollo.QueryResult<SucceededDateRangeKpiQuery, SucceededDateRangeKpiQueryVariables>;
export function refetchSucceededDateRangeKpiQuery(variables?: SucceededDateRangeKpiQueryVariables) {
      return { query: SucceededDateRangeKpiDocument, variables: variables }
    }
export const ChargesDateRangeKpiDocument = gql`
    query ChargesDateRangeKpi($start: Int, $end: Int, $interval: Interval, $accountId: ID, $acquirer: Acquirer, $masterAccountId: ID, $billingPlan: String, $paymentMethod: PaymentMethods, $source: String, $timezone: String, $currency: Currencies) {
  chargesDateRangeKPI(
    start: $start
    end: $end
    interval: $interval
    accountId: $accountId
    acquirer: $acquirer
    masterAccountId: $masterAccountId
    billingPlan: $billingPlan
    paymentMethod: $paymentMethod
    source: $source
    timezone: $timezone
    currency: $currency
  ) {
    currency
    total {
      succeededAmount
      succeededCount
      refundedAmount
      refundedCount
      failedCount
    }
    data {
      timestamp
      succeededAmount
      succeededCount
      refundedAmount
      refundedCount
      failedCount
    }
  }
}
    `;

/**
 * __useChargesDateRangeKpiQuery__
 *
 * To run a query within a React component, call `useChargesDateRangeKpiQuery` and pass it any options that fit your needs.
 * When your component renders, `useChargesDateRangeKpiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChargesDateRangeKpiQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      interval: // value for 'interval'
 *      accountId: // value for 'accountId'
 *      acquirer: // value for 'acquirer'
 *      masterAccountId: // value for 'masterAccountId'
 *      billingPlan: // value for 'billingPlan'
 *      paymentMethod: // value for 'paymentMethod'
 *      source: // value for 'source'
 *      timezone: // value for 'timezone'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useChargesDateRangeKpiQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ChargesDateRangeKpiQuery, ChargesDateRangeKpiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChargesDateRangeKpiQuery, ChargesDateRangeKpiQueryVariables>(ChargesDateRangeKpiDocument, options);
      }
export function useChargesDateRangeKpiLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChargesDateRangeKpiQuery, ChargesDateRangeKpiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChargesDateRangeKpiQuery, ChargesDateRangeKpiQueryVariables>(ChargesDateRangeKpiDocument, options);
        }
export type ChargesDateRangeKpiQueryHookResult = ReturnType<typeof useChargesDateRangeKpiQuery>;
export type ChargesDateRangeKpiLazyQueryHookResult = ReturnType<typeof useChargesDateRangeKpiLazyQuery>;
export type ChargesDateRangeKpiQueryResult = Apollo.QueryResult<ChargesDateRangeKpiQuery, ChargesDateRangeKpiQueryVariables>;
export function refetchChargesDateRangeKpiQuery(variables?: ChargesDateRangeKpiQueryVariables) {
      return { query: ChargesDateRangeKpiDocument, variables: variables }
    }
export const ChargeEventsDocument = gql`
    query ChargeEvents($chargeId: ID!, $size: Int, $from: Int) {
  chargeEvents(chargeId: $chargeId, size: $size, from: $from) {
    items {
      id
      type
      accountId
      livemode
      objectId
      objectType
      createdAt
      object {
        ...ChargeEventObjectFields
      }
    }
    total
  }
}
    ${ChargeEventObjectFieldsFragmentDoc}`;

/**
 * __useChargeEventsQuery__
 *
 * To run a query within a React component, call `useChargeEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChargeEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChargeEventsQuery({
 *   variables: {
 *      chargeId: // value for 'chargeId'
 *      size: // value for 'size'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useChargeEventsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChargeEventsQuery, ChargeEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChargeEventsQuery, ChargeEventsQueryVariables>(ChargeEventsDocument, options);
      }
export function useChargeEventsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChargeEventsQuery, ChargeEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChargeEventsQuery, ChargeEventsQueryVariables>(ChargeEventsDocument, options);
        }
export type ChargeEventsQueryHookResult = ReturnType<typeof useChargeEventsQuery>;
export type ChargeEventsLazyQueryHookResult = ReturnType<typeof useChargeEventsLazyQuery>;
export type ChargeEventsQueryResult = Apollo.QueryResult<ChargeEventsQuery, ChargeEventsQueryVariables>;
export function refetchChargeEventsQuery(variables: ChargeEventsQueryVariables) {
      return { query: ChargeEventsDocument, variables: variables }
    }
export const EventsDocument = gql`
    query Events($filter: SearchableEventFilterInput, $size: Int, $from: Int) {
  events(filter: $filter, size: $size, from: $from) {
    items {
      id
      type
      accountId
      livemode
      objectId
      objectType
      createdAt
      object {
        ...ChargeEventObjectFields
      }
    }
    total
  }
}
    ${ChargeEventObjectFieldsFragmentDoc}`;

/**
 * __useEventsQuery__
 *
 * To run a query within a React component, call `useEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      size: // value for 'size'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useEventsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventsQuery, EventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EventsQuery, EventsQueryVariables>(EventsDocument, options);
      }
export function useEventsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventsQuery, EventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EventsQuery, EventsQueryVariables>(EventsDocument, options);
        }
export type EventsQueryHookResult = ReturnType<typeof useEventsQuery>;
export type EventsLazyQueryHookResult = ReturnType<typeof useEventsLazyQuery>;
export type EventsQueryResult = Apollo.QueryResult<EventsQuery, EventsQueryVariables>;
export function refetchEventsQuery(variables?: EventsQueryVariables) {
      return { query: EventsDocument, variables: variables }
    }
export const UserDocument = gql`
    query User($id: ID!) {
  user(id: $id) {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export function refetchUserQuery(variables: UserQueryVariables) {
      return { query: UserDocument, variables: variables }
    }
export const UsersDocument = gql`
    query Users($filter: String, $token: String, $limit: Int) {
  users(filter: $filter, token: $token, limit: $limit) {
    items {
      ...UserFields
    }
    nextToken
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      token: // value for 'token'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UsersQuery, UsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersQueryResult = Apollo.QueryResult<UsersQuery, UsersQueryVariables>;
export function refetchUsersQuery(variables?: UsersQueryVariables) {
      return { query: UsersDocument, variables: variables }
    }
export const CountriesDocument = gql`
    query Countries {
  countries {
    supportedCountries {
      name
      phoneCode
      code
    }
    currentCountry {
      name
      phoneCode
      code
    }
    currentCountryCode
    isSupported
  }
}
    `;

/**
 * __useCountriesQuery__
 *
 * To run a query within a React component, call `useCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
      }
export function useCountriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export type CountriesQueryHookResult = ReturnType<typeof useCountriesQuery>;
export type CountriesLazyQueryHookResult = ReturnType<typeof useCountriesLazyQuery>;
export type CountriesQueryResult = Apollo.QueryResult<CountriesQuery, CountriesQueryVariables>;
export function refetchCountriesQuery(variables?: CountriesQueryVariables) {
      return { query: CountriesDocument, variables: variables }
    }
export const AccountActualFeesDocument = gql`
    query AccountActualFees($id: ID!) {
  accountActualFees(id: $id) {
    highRiskFee
    dailyPlatformFee
    dailyExtraSeatsFee
    weeklyCustomDomainFee
    extra {
      name
      amount
      type
      region
      masterAccountFee
      paymentMethods
    }
    steps {
      from
      trxFee
      trxFlatFee
      bizumTrxFlatFee
      bizumTrxFee
    }
  }
}
    `;

/**
 * __useAccountActualFeesQuery__
 *
 * To run a query within a React component, call `useAccountActualFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountActualFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountActualFeesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAccountActualFeesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AccountActualFeesQuery, AccountActualFeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountActualFeesQuery, AccountActualFeesQueryVariables>(AccountActualFeesDocument, options);
      }
export function useAccountActualFeesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountActualFeesQuery, AccountActualFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountActualFeesQuery, AccountActualFeesQueryVariables>(AccountActualFeesDocument, options);
        }
export type AccountActualFeesQueryHookResult = ReturnType<typeof useAccountActualFeesQuery>;
export type AccountActualFeesLazyQueryHookResult = ReturnType<typeof useAccountActualFeesLazyQuery>;
export type AccountActualFeesQueryResult = Apollo.QueryResult<AccountActualFeesQuery, AccountActualFeesQueryVariables>;
export function refetchAccountActualFeesQuery(variables: AccountActualFeesQueryVariables) {
      return { query: AccountActualFeesDocument, variables: variables }
    }
export const AccountEventsDocument = gql`
    query AccountEvents($accountId: ID!, $size: Int, $from: Int) {
  accountEvents(accountId: $accountId, size: $size, from: $from) {
    items {
      id
      type
      accountId
      livemode
      objectId
      objectType
      object {
        ...AccountEventObjectFields
      }
      createdAt
    }
    total
  }
}
    ${AccountEventObjectFieldsFragmentDoc}`;

/**
 * __useAccountEventsQuery__
 *
 * To run a query within a React component, call `useAccountEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountEventsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      size: // value for 'size'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useAccountEventsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AccountEventsQuery, AccountEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountEventsQuery, AccountEventsQueryVariables>(AccountEventsDocument, options);
      }
export function useAccountEventsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountEventsQuery, AccountEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountEventsQuery, AccountEventsQueryVariables>(AccountEventsDocument, options);
        }
export type AccountEventsQueryHookResult = ReturnType<typeof useAccountEventsQuery>;
export type AccountEventsLazyQueryHookResult = ReturnType<typeof useAccountEventsLazyQuery>;
export type AccountEventsQueryResult = Apollo.QueryResult<AccountEventsQuery, AccountEventsQueryVariables>;
export function refetchAccountEventsQuery(variables: AccountEventsQueryVariables) {
      return { query: AccountEventsDocument, variables: variables }
    }
export const SettlementsDocument = gql`
    query Settlements($filter: SearchableSettlementFilterInput, $size: Int, $from: Int) {
  settlements(filter: $filter, size: $size, from: $from) {
    items {
      ...SettlementFields
    }
    total
  }
}
    ${SettlementFieldsFragmentDoc}`;

/**
 * __useSettlementsQuery__
 *
 * To run a query within a React component, call `useSettlementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettlementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettlementsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      size: // value for 'size'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useSettlementsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SettlementsQuery, SettlementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SettlementsQuery, SettlementsQueryVariables>(SettlementsDocument, options);
      }
export function useSettlementsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SettlementsQuery, SettlementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SettlementsQuery, SettlementsQueryVariables>(SettlementsDocument, options);
        }
export type SettlementsQueryHookResult = ReturnType<typeof useSettlementsQuery>;
export type SettlementsLazyQueryHookResult = ReturnType<typeof useSettlementsLazyQuery>;
export type SettlementsQueryResult = Apollo.QueryResult<SettlementsQuery, SettlementsQueryVariables>;
export function refetchSettlementsQuery(variables?: SettlementsQueryVariables) {
      return { query: SettlementsDocument, variables: variables }
    }
export const AccountInvoicesDocument = gql`
    query AccountInvoices($filter: SearchableInvoiceFilterInput, $size: Int, $from: Int) {
  accountInvoices(filter: $filter, size: $size, from: $from) {
    items {
      ...AccountInvoiceFields
    }
    total
  }
}
    ${AccountInvoiceFieldsFragmentDoc}`;

/**
 * __useAccountInvoicesQuery__
 *
 * To run a query within a React component, call `useAccountInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountInvoicesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      size: // value for 'size'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useAccountInvoicesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountInvoicesQuery, AccountInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountInvoicesQuery, AccountInvoicesQueryVariables>(AccountInvoicesDocument, options);
      }
export function useAccountInvoicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountInvoicesQuery, AccountInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountInvoicesQuery, AccountInvoicesQueryVariables>(AccountInvoicesDocument, options);
        }
export type AccountInvoicesQueryHookResult = ReturnType<typeof useAccountInvoicesQuery>;
export type AccountInvoicesLazyQueryHookResult = ReturnType<typeof useAccountInvoicesLazyQuery>;
export type AccountInvoicesQueryResult = Apollo.QueryResult<AccountInvoicesQuery, AccountInvoicesQueryVariables>;
export function refetchAccountInvoicesQuery(variables?: AccountInvoicesQueryVariables) {
      return { query: AccountInvoicesDocument, variables: variables }
    }
export const PreviewPaymentEmailDocument = gql`
    query PreviewPaymentEmail($paymentId: ID!, $emailType: PaymentEmailType, $language: String, $accountId: ID!) {
  previewPaymentEmail(
    paymentId: $paymentId
    emailType: $emailType
    language: $language
    accountId: $accountId
  )
}
    `;

/**
 * __usePreviewPaymentEmailQuery__
 *
 * To run a query within a React component, call `usePreviewPaymentEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewPaymentEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewPaymentEmailQuery({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *      emailType: // value for 'emailType'
 *      language: // value for 'language'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function usePreviewPaymentEmailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PreviewPaymentEmailQuery, PreviewPaymentEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PreviewPaymentEmailQuery, PreviewPaymentEmailQueryVariables>(PreviewPaymentEmailDocument, options);
      }
export function usePreviewPaymentEmailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PreviewPaymentEmailQuery, PreviewPaymentEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PreviewPaymentEmailQuery, PreviewPaymentEmailQueryVariables>(PreviewPaymentEmailDocument, options);
        }
export type PreviewPaymentEmailQueryHookResult = ReturnType<typeof usePreviewPaymentEmailQuery>;
export type PreviewPaymentEmailLazyQueryHookResult = ReturnType<typeof usePreviewPaymentEmailLazyQuery>;
export type PreviewPaymentEmailQueryResult = Apollo.QueryResult<PreviewPaymentEmailQuery, PreviewPaymentEmailQueryVariables>;
export function refetchPreviewPaymentEmailQuery(variables: PreviewPaymentEmailQueryVariables) {
      return { query: PreviewPaymentEmailDocument, variables: variables }
    }
export const AccountStatsDocument = gql`
    query AccountStats($accountId: ID!) {
  accountStats(accountId: $accountId) {
    stats {
      firstTransactionAt
      activeMonths
      avgMonthlyTransactions
      avgMonthlyVolume
      churned
      totalSucceededCount
      lastTransactionAt
      totalSucceededAmount
    }
  }
}
    `;

/**
 * __useAccountStatsQuery__
 *
 * To run a query within a React component, call `useAccountStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountStatsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountStatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AccountStatsQuery, AccountStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountStatsQuery, AccountStatsQueryVariables>(AccountStatsDocument, options);
      }
export function useAccountStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountStatsQuery, AccountStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountStatsQuery, AccountStatsQueryVariables>(AccountStatsDocument, options);
        }
export type AccountStatsQueryHookResult = ReturnType<typeof useAccountStatsQuery>;
export type AccountStatsLazyQueryHookResult = ReturnType<typeof useAccountStatsLazyQuery>;
export type AccountStatsQueryResult = Apollo.QueryResult<AccountStatsQuery, AccountStatsQueryVariables>;
export function refetchAccountStatsQuery(variables: AccountStatsQueryVariables) {
      return { query: AccountStatsDocument, variables: variables }
    }
export const MasterAccountsDocument = gql`
    query MasterAccounts($filter: SearchableMasterAccountFilterInput, $size: Int, $from: Int) {
  masterAccounts(filter: $filter, size: $size, from: $from) {
    items {
      ...MasterAccountFields
    }
    total
  }
}
    ${MasterAccountFieldsFragmentDoc}`;

/**
 * __useMasterAccountsQuery__
 *
 * To run a query within a React component, call `useMasterAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMasterAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMasterAccountsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      size: // value for 'size'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useMasterAccountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MasterAccountsQuery, MasterAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MasterAccountsQuery, MasterAccountsQueryVariables>(MasterAccountsDocument, options);
      }
export function useMasterAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MasterAccountsQuery, MasterAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MasterAccountsQuery, MasterAccountsQueryVariables>(MasterAccountsDocument, options);
        }
export type MasterAccountsQueryHookResult = ReturnType<typeof useMasterAccountsQuery>;
export type MasterAccountsLazyQueryHookResult = ReturnType<typeof useMasterAccountsLazyQuery>;
export type MasterAccountsQueryResult = Apollo.QueryResult<MasterAccountsQuery, MasterAccountsQueryVariables>;
export function refetchMasterAccountsQuery(variables?: MasterAccountsQueryVariables) {
      return { query: MasterAccountsDocument, variables: variables }
    }
export const StoresDocument = gql`
    query Stores($accountId: ID!, $pageSize: Int, $token: String) {
  stores(accountId: $accountId, pageSize: $pageSize, token: $token) {
    items {
      ...StoreFields
    }
    nextToken
  }
}
    ${StoreFieldsFragmentDoc}`;

/**
 * __useStoresQuery__
 *
 * To run a query within a React component, call `useStoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoresQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      pageSize: // value for 'pageSize'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useStoresQuery(baseOptions: ApolloReactHooks.QueryHookOptions<StoresQuery, StoresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StoresQuery, StoresQueryVariables>(StoresDocument, options);
      }
export function useStoresLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StoresQuery, StoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StoresQuery, StoresQueryVariables>(StoresDocument, options);
        }
export type StoresQueryHookResult = ReturnType<typeof useStoresQuery>;
export type StoresLazyQueryHookResult = ReturnType<typeof useStoresLazyQuery>;
export type StoresQueryResult = Apollo.QueryResult<StoresQuery, StoresQueryVariables>;
export function refetchStoresQuery(variables: StoresQueryVariables) {
      return { query: StoresDocument, variables: variables }
    }
export const StoreDocument = gql`
    query Store($id: ID!, $accountId: ID!) {
  store(id: $id, accountId: $accountId) {
    id
    name
  }
}
    `;

/**
 * __useStoreQuery__
 *
 * To run a query within a React component, call `useStoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreQuery({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useStoreQuery(baseOptions: ApolloReactHooks.QueryHookOptions<StoreQuery, StoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StoreQuery, StoreQueryVariables>(StoreDocument, options);
      }
export function useStoreLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StoreQuery, StoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StoreQuery, StoreQueryVariables>(StoreDocument, options);
        }
export type StoreQueryHookResult = ReturnType<typeof useStoreQuery>;
export type StoreLazyQueryHookResult = ReturnType<typeof useStoreLazyQuery>;
export type StoreQueryResult = Apollo.QueryResult<StoreQuery, StoreQueryVariables>;
export function refetchStoreQuery(variables: StoreQueryVariables) {
      return { query: StoreDocument, variables: variables }
    }
export const DocumentsDocument = gql`
    query Documents($accountId: ID!) {
  documents(accountId: $accountId) {
    items {
      ...DocumentFields
    }
  }
}
    ${DocumentFieldsFragmentDoc}`;

/**
 * __useDocumentsQuery__
 *
 * To run a query within a React component, call `useDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDocumentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DocumentsQuery, DocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DocumentsQuery, DocumentsQueryVariables>(DocumentsDocument, options);
      }
export function useDocumentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DocumentsQuery, DocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DocumentsQuery, DocumentsQueryVariables>(DocumentsDocument, options);
        }
export type DocumentsQueryHookResult = ReturnType<typeof useDocumentsQuery>;
export type DocumentsLazyQueryHookResult = ReturnType<typeof useDocumentsLazyQuery>;
export type DocumentsQueryResult = Apollo.QueryResult<DocumentsQuery, DocumentsQueryVariables>;
export function refetchDocumentsQuery(variables: DocumentsQueryVariables) {
      return { query: DocumentsDocument, variables: variables }
    }
export const DocumentDocument = gql`
    query Document($id: ID!, $accountId: ID!) {
  document(id: $id, accountId: $accountId) {
    ...DocumentFields
  }
}
    ${DocumentFieldsFragmentDoc}`;

/**
 * __useDocumentQuery__
 *
 * To run a query within a React component, call `useDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDocumentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DocumentQuery, DocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DocumentQuery, DocumentQueryVariables>(DocumentDocument, options);
      }
export function useDocumentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DocumentQuery, DocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DocumentQuery, DocumentQueryVariables>(DocumentDocument, options);
        }
export type DocumentQueryHookResult = ReturnType<typeof useDocumentQuery>;
export type DocumentLazyQueryHookResult = ReturnType<typeof useDocumentLazyQuery>;
export type DocumentQueryResult = Apollo.QueryResult<DocumentQuery, DocumentQueryVariables>;
export function refetchDocumentQuery(variables: DocumentQueryVariables) {
      return { query: DocumentDocument, variables: variables }
    }
export const DocumentEventsDocument = gql`
    query DocumentEvents($documentId: ID!) {
  documentEvents(documentId: $documentId) {
    items {
      ...DocumentEventFields
    }
    total
  }
}
    ${DocumentEventFieldsFragmentDoc}`;

/**
 * __useDocumentEventsQuery__
 *
 * To run a query within a React component, call `useDocumentEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentEventsQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useDocumentEventsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DocumentEventsQuery, DocumentEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DocumentEventsQuery, DocumentEventsQueryVariables>(DocumentEventsDocument, options);
      }
export function useDocumentEventsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DocumentEventsQuery, DocumentEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DocumentEventsQuery, DocumentEventsQueryVariables>(DocumentEventsDocument, options);
        }
export type DocumentEventsQueryHookResult = ReturnType<typeof useDocumentEventsQuery>;
export type DocumentEventsLazyQueryHookResult = ReturnType<typeof useDocumentEventsLazyQuery>;
export type DocumentEventsQueryResult = Apollo.QueryResult<DocumentEventsQuery, DocumentEventsQueryVariables>;
export function refetchDocumentEventsQuery(variables: DocumentEventsQueryVariables) {
      return { query: DocumentEventsDocument, variables: variables }
    }
export const SubscriptionsDocument = gql`
    query Subscriptions($filter: SearchableSubscriptionFilterInput, $size: Int, $from: Int) {
  subscriptions(filter: $filter, size: $size, from: $from) {
    items {
      ...SubscriptionFields
    }
    total
  }
}
    ${SubscriptionFieldsFragmentDoc}`;

/**
 * __useSubscriptionsQuery__
 *
 * To run a query within a React component, call `useSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      size: // value for 'size'
 *      from: // value for 'from'
 *   },
 * });
 */
export function useSubscriptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(SubscriptionsDocument, options);
      }
export function useSubscriptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubscriptionsQuery, SubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubscriptionsQuery, SubscriptionsQueryVariables>(SubscriptionsDocument, options);
        }
export type SubscriptionsQueryHookResult = ReturnType<typeof useSubscriptionsQuery>;
export type SubscriptionsLazyQueryHookResult = ReturnType<typeof useSubscriptionsLazyQuery>;
export type SubscriptionsQueryResult = Apollo.QueryResult<SubscriptionsQuery, SubscriptionsQueryVariables>;
export function refetchSubscriptionsQuery(variables?: SubscriptionsQueryVariables) {
      return { query: SubscriptionsDocument, variables: variables }
    }
export const SubscriptionDocument = gql`
    query Subscription($id: ID!) {
  subscription(id: $id) {
    ...SubscriptionFields
  }
}
    ${SubscriptionFieldsFragmentDoc}`;

/**
 * __useSubscriptionQuery__
 *
 * To run a query within a React component, call `useSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubscriptionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SubscriptionQuery, SubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubscriptionQuery, SubscriptionQueryVariables>(SubscriptionDocument, options);
      }
export function useSubscriptionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubscriptionQuery, SubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubscriptionQuery, SubscriptionQueryVariables>(SubscriptionDocument, options);
        }
export type SubscriptionQueryHookResult = ReturnType<typeof useSubscriptionQuery>;
export type SubscriptionLazyQueryHookResult = ReturnType<typeof useSubscriptionLazyQuery>;
export type SubscriptionQueryResult = Apollo.QueryResult<SubscriptionQuery, SubscriptionQueryVariables>;
export function refetchSubscriptionQuery(variables: SubscriptionQueryVariables) {
      return { query: SubscriptionDocument, variables: variables }
    }
export const SubscriptionEventsDocument = gql`
    query SubscriptionEvents($subscriptionId: ID!) {
  subscriptionEvents(subscriptionId: $subscriptionId) {
    items {
      id
      type
      accountId
      objectId
      objectType
      createdAt
      object {
        ...SubscriptionEventObjectFields
      }
    }
    total
  }
}
    ${SubscriptionEventObjectFieldsFragmentDoc}`;

/**
 * __useSubscriptionEventsQuery__
 *
 * To run a query within a React component, call `useSubscriptionEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionEventsQuery({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useSubscriptionEventsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SubscriptionEventsQuery, SubscriptionEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SubscriptionEventsQuery, SubscriptionEventsQueryVariables>(SubscriptionEventsDocument, options);
      }
export function useSubscriptionEventsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubscriptionEventsQuery, SubscriptionEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SubscriptionEventsQuery, SubscriptionEventsQueryVariables>(SubscriptionEventsDocument, options);
        }
export type SubscriptionEventsQueryHookResult = ReturnType<typeof useSubscriptionEventsQuery>;
export type SubscriptionEventsLazyQueryHookResult = ReturnType<typeof useSubscriptionEventsLazyQuery>;
export type SubscriptionEventsQueryResult = Apollo.QueryResult<SubscriptionEventsQuery, SubscriptionEventsQueryVariables>;
export function refetchSubscriptionEventsQuery(variables: SubscriptionEventsQueryVariables) {
      return { query: SubscriptionEventsDocument, variables: variables }
    }
export const PreviewSubscriptionEmailDocument = gql`
    query PreviewSubscriptionEmail($subscriptionId: ID!, $emailType: SubscriptionEmailType, $language: String, $accountId: ID!) {
  previewSubscriptionEmail(
    subscriptionId: $subscriptionId
    emailType: $emailType
    language: $language
    accountId: $accountId
  )
}
    `;

/**
 * __usePreviewSubscriptionEmailQuery__
 *
 * To run a query within a React component, call `usePreviewSubscriptionEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewSubscriptionEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewSubscriptionEmailQuery({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      emailType: // value for 'emailType'
 *      language: // value for 'language'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function usePreviewSubscriptionEmailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PreviewSubscriptionEmailQuery, PreviewSubscriptionEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PreviewSubscriptionEmailQuery, PreviewSubscriptionEmailQueryVariables>(PreviewSubscriptionEmailDocument, options);
      }
export function usePreviewSubscriptionEmailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PreviewSubscriptionEmailQuery, PreviewSubscriptionEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PreviewSubscriptionEmailQuery, PreviewSubscriptionEmailQueryVariables>(PreviewSubscriptionEmailDocument, options);
        }
export type PreviewSubscriptionEmailQueryHookResult = ReturnType<typeof usePreviewSubscriptionEmailQuery>;
export type PreviewSubscriptionEmailLazyQueryHookResult = ReturnType<typeof usePreviewSubscriptionEmailLazyQuery>;
export type PreviewSubscriptionEmailQueryResult = Apollo.QueryResult<PreviewSubscriptionEmailQuery, PreviewSubscriptionEmailQueryVariables>;
export function refetchPreviewSubscriptionEmailQuery(variables: PreviewSubscriptionEmailQueryVariables) {
      return { query: PreviewSubscriptionEmailDocument, variables: variables }
    }
export const ProviderEventsDocument = gql`
    query ProviderEvents($providerId: ID, $accountId: ID!) {
  providerEvents(providerId: $providerId, accountId: $accountId) {
    items {
      id
      type
      accountId
      objectId
      objectType
      createdAt
      object {
        ...ProviderEventObjectFields
      }
    }
    total
  }
}
    ${ProviderEventObjectFieldsFragmentDoc}`;

/**
 * __useProviderEventsQuery__
 *
 * To run a query within a React component, call `useProviderEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderEventsQuery({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useProviderEventsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProviderEventsQuery, ProviderEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProviderEventsQuery, ProviderEventsQueryVariables>(ProviderEventsDocument, options);
      }
export function useProviderEventsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProviderEventsQuery, ProviderEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProviderEventsQuery, ProviderEventsQueryVariables>(ProviderEventsDocument, options);
        }
export type ProviderEventsQueryHookResult = ReturnType<typeof useProviderEventsQuery>;
export type ProviderEventsLazyQueryHookResult = ReturnType<typeof useProviderEventsLazyQuery>;
export type ProviderEventsQueryResult = Apollo.QueryResult<ProviderEventsQuery, ProviderEventsQueryVariables>;
export function refetchProviderEventsQuery(variables: ProviderEventsQueryVariables) {
      return { query: ProviderEventsDocument, variables: variables }
    }
export const AccountTagsDocument = gql`
    query AccountTags {
  accountTags
}
    `;

/**
 * __useAccountTagsQuery__
 *
 * To run a query within a React component, call `useAccountTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountTagsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountTagsQuery, AccountTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountTagsQuery, AccountTagsQueryVariables>(AccountTagsDocument, options);
      }
export function useAccountTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountTagsQuery, AccountTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountTagsQuery, AccountTagsQueryVariables>(AccountTagsDocument, options);
        }
export type AccountTagsQueryHookResult = ReturnType<typeof useAccountTagsQuery>;
export type AccountTagsLazyQueryHookResult = ReturnType<typeof useAccountTagsLazyQuery>;
export type AccountTagsQueryResult = Apollo.QueryResult<AccountTagsQuery, AccountTagsQueryVariables>;
export function refetchAccountTagsQuery(variables?: AccountTagsQueryVariables) {
      return { query: AccountTagsDocument, variables: variables }
    }
export const ChargeSourcesDocument = gql`
    query ChargeSources {
  chargeSources
}
    `;

/**
 * __useChargeSourcesQuery__
 *
 * To run a query within a React component, call `useChargeSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChargeSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChargeSourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useChargeSourcesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ChargeSourcesQuery, ChargeSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChargeSourcesQuery, ChargeSourcesQueryVariables>(ChargeSourcesDocument, options);
      }
export function useChargeSourcesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChargeSourcesQuery, ChargeSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChargeSourcesQuery, ChargeSourcesQueryVariables>(ChargeSourcesDocument, options);
        }
export type ChargeSourcesQueryHookResult = ReturnType<typeof useChargeSourcesQuery>;
export type ChargeSourcesLazyQueryHookResult = ReturnType<typeof useChargeSourcesLazyQuery>;
export type ChargeSourcesQueryResult = Apollo.QueryResult<ChargeSourcesQuery, ChargeSourcesQueryVariables>;
export function refetchChargeSourcesQuery(variables?: ChargeSourcesQueryVariables) {
      return { query: ChargeSourcesDocument, variables: variables }
    }
export const MasterAccountDocument = gql`
    query MasterAccount($id: ID!) {
  masterAccount(id: $id) {
    ...MasterAccountFields
  }
}
    ${MasterAccountFieldsFragmentDoc}`;

/**
 * __useMasterAccountQuery__
 *
 * To run a query within a React component, call `useMasterAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMasterAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMasterAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMasterAccountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MasterAccountQuery, MasterAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MasterAccountQuery, MasterAccountQueryVariables>(MasterAccountDocument, options);
      }
export function useMasterAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MasterAccountQuery, MasterAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MasterAccountQuery, MasterAccountQueryVariables>(MasterAccountDocument, options);
        }
export type MasterAccountQueryHookResult = ReturnType<typeof useMasterAccountQuery>;
export type MasterAccountLazyQueryHookResult = ReturnType<typeof useMasterAccountLazyQuery>;
export type MasterAccountQueryResult = Apollo.QueryResult<MasterAccountQuery, MasterAccountQueryVariables>;
export function refetchMasterAccountQuery(variables: MasterAccountQueryVariables) {
      return { query: MasterAccountDocument, variables: variables }
    }
export const UserMasterAccountDocument = gql`
    query UserMasterAccount {
  userMasterAccount {
    ...UserMasterAccountFields
  }
}
    ${UserMasterAccountFieldsFragmentDoc}`;

/**
 * __useUserMasterAccountQuery__
 *
 * To run a query within a React component, call `useUserMasterAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserMasterAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserMasterAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserMasterAccountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UserMasterAccountQuery, UserMasterAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserMasterAccountQuery, UserMasterAccountQueryVariables>(UserMasterAccountDocument, options);
      }
export function useUserMasterAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserMasterAccountQuery, UserMasterAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserMasterAccountQuery, UserMasterAccountQueryVariables>(UserMasterAccountDocument, options);
        }
export type UserMasterAccountQueryHookResult = ReturnType<typeof useUserMasterAccountQuery>;
export type UserMasterAccountLazyQueryHookResult = ReturnType<typeof useUserMasterAccountLazyQuery>;
export type UserMasterAccountQueryResult = Apollo.QueryResult<UserMasterAccountQuery, UserMasterAccountQueryVariables>;
export function refetchUserMasterAccountQuery(variables?: UserMasterAccountQueryVariables) {
      return { query: UserMasterAccountDocument, variables: variables }
    }
export const NotificationsPortalUrlDocument = gql`
    query NotificationsPortalUrl($accountId: ID!) {
  notificationsPortalUrl(accountId: $accountId) {
    redirectUrl
  }
}
    `;

/**
 * __useNotificationsPortalUrlQuery__
 *
 * To run a query within a React component, call `useNotificationsPortalUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsPortalUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsPortalUrlQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useNotificationsPortalUrlQuery(baseOptions: ApolloReactHooks.QueryHookOptions<NotificationsPortalUrlQuery, NotificationsPortalUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NotificationsPortalUrlQuery, NotificationsPortalUrlQueryVariables>(NotificationsPortalUrlDocument, options);
      }
export function useNotificationsPortalUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NotificationsPortalUrlQuery, NotificationsPortalUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NotificationsPortalUrlQuery, NotificationsPortalUrlQueryVariables>(NotificationsPortalUrlDocument, options);
        }
export type NotificationsPortalUrlQueryHookResult = ReturnType<typeof useNotificationsPortalUrlQuery>;
export type NotificationsPortalUrlLazyQueryHookResult = ReturnType<typeof useNotificationsPortalUrlLazyQuery>;
export type NotificationsPortalUrlQueryResult = Apollo.QueryResult<NotificationsPortalUrlQuery, NotificationsPortalUrlQueryVariables>;
export function refetchNotificationsPortalUrlQuery(variables: NotificationsPortalUrlQueryVariables) {
      return { query: NotificationsPortalUrlDocument, variables: variables }
    }
export const WebhooksDocument = gql`
    query Webhooks($token: String, $pageSize: Int, $accountId: ID!) {
  webhooks(token: $token, pageSize: $pageSize, accountId: $accountId) {
    items {
      id
      url
      eventTypes
      enabled
      updatedAt
    }
    nextToken
  }
}
    `;

/**
 * __useWebhooksQuery__
 *
 * To run a query within a React component, call `useWebhooksQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebhooksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebhooksQuery({
 *   variables: {
 *      token: // value for 'token'
 *      pageSize: // value for 'pageSize'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useWebhooksQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WebhooksQuery, WebhooksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WebhooksQuery, WebhooksQueryVariables>(WebhooksDocument, options);
      }
export function useWebhooksLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebhooksQuery, WebhooksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WebhooksQuery, WebhooksQueryVariables>(WebhooksDocument, options);
        }
export type WebhooksQueryHookResult = ReturnType<typeof useWebhooksQuery>;
export type WebhooksLazyQueryHookResult = ReturnType<typeof useWebhooksLazyQuery>;
export type WebhooksQueryResult = Apollo.QueryResult<WebhooksQuery, WebhooksQueryVariables>;
export function refetchWebhooksQuery(variables: WebhooksQueryVariables) {
      return { query: WebhooksDocument, variables: variables }
    }
export const RestrictedKeywordsDocument = gql`
    query RestrictedKeywords {
  restrictedKeywords
}
    `;

/**
 * __useRestrictedKeywordsQuery__
 *
 * To run a query within a React component, call `useRestrictedKeywordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRestrictedKeywordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestrictedKeywordsQuery({
 *   variables: {
 *   },
 * });
 */
export function useRestrictedKeywordsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RestrictedKeywordsQuery, RestrictedKeywordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RestrictedKeywordsQuery, RestrictedKeywordsQueryVariables>(RestrictedKeywordsDocument, options);
      }
export function useRestrictedKeywordsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RestrictedKeywordsQuery, RestrictedKeywordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RestrictedKeywordsQuery, RestrictedKeywordsQueryVariables>(RestrictedKeywordsDocument, options);
        }
export type RestrictedKeywordsQueryHookResult = ReturnType<typeof useRestrictedKeywordsQuery>;
export type RestrictedKeywordsLazyQueryHookResult = ReturnType<typeof useRestrictedKeywordsLazyQuery>;
export type RestrictedKeywordsQueryResult = Apollo.QueryResult<RestrictedKeywordsQuery, RestrictedKeywordsQueryVariables>;
export function refetchRestrictedKeywordsQuery(variables?: RestrictedKeywordsQueryVariables) {
      return { query: RestrictedKeywordsDocument, variables: variables }
    }
export const WebReportDocument = gql`
    query WebReport($baseUrl: String!) {
  webReport(baseUrl: $baseUrl) {
    title
    description
    summary
    pageCount
    failedPageCount
    uncheckedPageCount
    legalDetailsUrl
    status
    statusCode
    statusMessage
    riskCategory
  }
}
    `;

/**
 * __useWebReportQuery__
 *
 * To run a query within a React component, call `useWebReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebReportQuery({
 *   variables: {
 *      baseUrl: // value for 'baseUrl'
 *   },
 * });
 */
export function useWebReportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WebReportQuery, WebReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WebReportQuery, WebReportQueryVariables>(WebReportDocument, options);
      }
export function useWebReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebReportQuery, WebReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WebReportQuery, WebReportQueryVariables>(WebReportDocument, options);
        }
export type WebReportQueryHookResult = ReturnType<typeof useWebReportQuery>;
export type WebReportLazyQueryHookResult = ReturnType<typeof useWebReportLazyQuery>;
export type WebReportQueryResult = Apollo.QueryResult<WebReportQuery, WebReportQueryVariables>;
export function refetchWebReportQuery(variables: WebReportQueryVariables) {
      return { query: WebReportDocument, variables: variables }
    }
export const WebKeywordsDocument = gql`
    query WebKeywords($baseUrl: String!, $pageSize: Int, $token: String) {
  webKeywords(baseUrl: $baseUrl, pageSize: $pageSize, token: $token) {
    items {
      accountId
      url
      createdAt
      expiresAt
      urlKeyword
      baseUrl
      keyword
      description
      updatedAt
      title
      context
      confirmed
      explanation
      incorrect
    }
    nextToken
  }
}
    `;

/**
 * __useWebKeywordsQuery__
 *
 * To run a query within a React component, call `useWebKeywordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebKeywordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebKeywordsQuery({
 *   variables: {
 *      baseUrl: // value for 'baseUrl'
 *      pageSize: // value for 'pageSize'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useWebKeywordsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WebKeywordsQuery, WebKeywordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WebKeywordsQuery, WebKeywordsQueryVariables>(WebKeywordsDocument, options);
      }
export function useWebKeywordsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebKeywordsQuery, WebKeywordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WebKeywordsQuery, WebKeywordsQueryVariables>(WebKeywordsDocument, options);
        }
export type WebKeywordsQueryHookResult = ReturnType<typeof useWebKeywordsQuery>;
export type WebKeywordsLazyQueryHookResult = ReturnType<typeof useWebKeywordsLazyQuery>;
export type WebKeywordsQueryResult = Apollo.QueryResult<WebKeywordsQuery, WebKeywordsQueryVariables>;
export function refetchWebKeywordsQuery(variables: WebKeywordsQueryVariables) {
      return { query: WebKeywordsDocument, variables: variables }
    }
export const AccountBalancesDocument = gql`
    query AccountBalances($accountId: ID!) {
  accountBalances(accountId: $accountId) {
    items {
      ...AccountBalancesFields
    }
  }
}
    ${AccountBalancesFieldsFragmentDoc}`;

/**
 * __useAccountBalancesQuery__
 *
 * To run a query within a React component, call `useAccountBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountBalancesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useAccountBalancesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AccountBalancesQuery, AccountBalancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountBalancesQuery, AccountBalancesQueryVariables>(AccountBalancesDocument, options);
      }
export function useAccountBalancesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountBalancesQuery, AccountBalancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountBalancesQuery, AccountBalancesQueryVariables>(AccountBalancesDocument, options);
        }
export type AccountBalancesQueryHookResult = ReturnType<typeof useAccountBalancesQuery>;
export type AccountBalancesLazyQueryHookResult = ReturnType<typeof useAccountBalancesLazyQuery>;
export type AccountBalancesQueryResult = Apollo.QueryResult<AccountBalancesQuery, AccountBalancesQueryVariables>;
export function refetchAccountBalancesQuery(variables: AccountBalancesQueryVariables) {
      return { query: AccountBalancesDocument, variables: variables }
    }
export const AdminUsersDocument = gql`
    query AdminUsers($token: String, $limit: Int) {
  adminUsers(token: $token, limit: $limit) {
    items {
      ...AdminUserFields
    }
    nextToken
  }
}
    ${AdminUserFieldsFragmentDoc}`;

/**
 * __useAdminUsersQuery__
 *
 * To run a query within a React component, call `useAdminUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUsersQuery({
 *   variables: {
 *      token: // value for 'token'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAdminUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AdminUsersQuery, AdminUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AdminUsersQuery, AdminUsersQueryVariables>(AdminUsersDocument, options);
      }
export function useAdminUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AdminUsersQuery, AdminUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AdminUsersQuery, AdminUsersQueryVariables>(AdminUsersDocument, options);
        }
export type AdminUsersQueryHookResult = ReturnType<typeof useAdminUsersQuery>;
export type AdminUsersLazyQueryHookResult = ReturnType<typeof useAdminUsersLazyQuery>;
export type AdminUsersQueryResult = Apollo.QueryResult<AdminUsersQuery, AdminUsersQueryVariables>;
export function refetchAdminUsersQuery(variables?: AdminUsersQueryVariables) {
      return { query: AdminUsersDocument, variables: variables }
    }
export const AffiliatesDocument = gql`
    query Affiliates($input: AffiliateInput) {
  affiliates(input: $input) {
    items {
      ...AffiliateFields
    }
    links
  }
}
    ${AffiliateFieldsFragmentDoc}`;

/**
 * __useAffiliatesQuery__
 *
 * To run a query within a React component, call `useAffiliatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAffiliatesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AffiliatesQuery, AffiliatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AffiliatesQuery, AffiliatesQueryVariables>(AffiliatesDocument, options);
      }
export function useAffiliatesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AffiliatesQuery, AffiliatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AffiliatesQuery, AffiliatesQueryVariables>(AffiliatesDocument, options);
        }
export type AffiliatesQueryHookResult = ReturnType<typeof useAffiliatesQuery>;
export type AffiliatesLazyQueryHookResult = ReturnType<typeof useAffiliatesLazyQuery>;
export type AffiliatesQueryResult = Apollo.QueryResult<AffiliatesQuery, AffiliatesQueryVariables>;
export function refetchAffiliatesQuery(variables?: AffiliatesQueryVariables) {
      return { query: AffiliatesDocument, variables: variables }
    }
export const AffiliateDocument = gql`
    query Affiliate($affiliateId: ID!) {
  affiliate(affiliateId: $affiliateId) {
    ...AffiliateFields
  }
}
    ${AffiliateFieldsFragmentDoc}`;

/**
 * __useAffiliateQuery__
 *
 * To run a query within a React component, call `useAffiliateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliateQuery({
 *   variables: {
 *      affiliateId: // value for 'affiliateId'
 *   },
 * });
 */
export function useAffiliateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AffiliateQuery, AffiliateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AffiliateQuery, AffiliateQueryVariables>(AffiliateDocument, options);
      }
export function useAffiliateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AffiliateQuery, AffiliateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AffiliateQuery, AffiliateQueryVariables>(AffiliateDocument, options);
        }
export type AffiliateQueryHookResult = ReturnType<typeof useAffiliateQuery>;
export type AffiliateLazyQueryHookResult = ReturnType<typeof useAffiliateLazyQuery>;
export type AffiliateQueryResult = Apollo.QueryResult<AffiliateQuery, AffiliateQueryVariables>;
export function refetchAffiliateQuery(variables: AffiliateQueryVariables) {
      return { query: AffiliateDocument, variables: variables }
    }
export const AffiliatePayoutMethodsDocument = gql`
    query AffiliatePayoutMethods($affiliateId: ID!) {
  affiliatePayoutMethods(affiliateId: $affiliateId) {
    ...PayoutMethodsFields
  }
}
    ${PayoutMethodsFieldsFragmentDoc}`;

/**
 * __useAffiliatePayoutMethodsQuery__
 *
 * To run a query within a React component, call `useAffiliatePayoutMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliatePayoutMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliatePayoutMethodsQuery({
 *   variables: {
 *      affiliateId: // value for 'affiliateId'
 *   },
 * });
 */
export function useAffiliatePayoutMethodsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AffiliatePayoutMethodsQuery, AffiliatePayoutMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AffiliatePayoutMethodsQuery, AffiliatePayoutMethodsQueryVariables>(AffiliatePayoutMethodsDocument, options);
      }
export function useAffiliatePayoutMethodsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AffiliatePayoutMethodsQuery, AffiliatePayoutMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AffiliatePayoutMethodsQuery, AffiliatePayoutMethodsQueryVariables>(AffiliatePayoutMethodsDocument, options);
        }
export type AffiliatePayoutMethodsQueryHookResult = ReturnType<typeof useAffiliatePayoutMethodsQuery>;
export type AffiliatePayoutMethodsLazyQueryHookResult = ReturnType<typeof useAffiliatePayoutMethodsLazyQuery>;
export type AffiliatePayoutMethodsQueryResult = Apollo.QueryResult<AffiliatePayoutMethodsQuery, AffiliatePayoutMethodsQueryVariables>;
export function refetchAffiliatePayoutMethodsQuery(variables: AffiliatePayoutMethodsQueryVariables) {
      return { query: AffiliatePayoutMethodsDocument, variables: variables }
    }
export const AffiliateMerchantsDocument = gql`
    query AffiliateMerchants($input: AffiliateMerchantInput) {
  affiliateMerchants(input: $input) {
    items {
      ...AffiliateMerchantFields
    }
    links
  }
}
    ${AffiliateMerchantFieldsFragmentDoc}`;

/**
 * __useAffiliateMerchantsQuery__
 *
 * To run a query within a React component, call `useAffiliateMerchantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliateMerchantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliateMerchantsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAffiliateMerchantsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AffiliateMerchantsQuery, AffiliateMerchantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AffiliateMerchantsQuery, AffiliateMerchantsQueryVariables>(AffiliateMerchantsDocument, options);
      }
export function useAffiliateMerchantsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AffiliateMerchantsQuery, AffiliateMerchantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AffiliateMerchantsQuery, AffiliateMerchantsQueryVariables>(AffiliateMerchantsDocument, options);
        }
export type AffiliateMerchantsQueryHookResult = ReturnType<typeof useAffiliateMerchantsQuery>;
export type AffiliateMerchantsLazyQueryHookResult = ReturnType<typeof useAffiliateMerchantsLazyQuery>;
export type AffiliateMerchantsQueryResult = Apollo.QueryResult<AffiliateMerchantsQuery, AffiliateMerchantsQueryVariables>;
export function refetchAffiliateMerchantsQuery(variables?: AffiliateMerchantsQueryVariables) {
      return { query: AffiliateMerchantsDocument, variables: variables }
    }
export const AffiliateInvoicesDocument = gql`
    query AffiliateInvoices($taxId: String!) {
  affiliateInvoices(taxId: $taxId) {
    items {
      ...AffiliateInvoiceFields
    }
    total
  }
}
    ${AffiliateInvoiceFieldsFragmentDoc}`;

/**
 * __useAffiliateInvoicesQuery__
 *
 * To run a query within a React component, call `useAffiliateInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliateInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliateInvoicesQuery({
 *   variables: {
 *      taxId: // value for 'taxId'
 *   },
 * });
 */
export function useAffiliateInvoicesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AffiliateInvoicesQuery, AffiliateInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AffiliateInvoicesQuery, AffiliateInvoicesQueryVariables>(AffiliateInvoicesDocument, options);
      }
export function useAffiliateInvoicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AffiliateInvoicesQuery, AffiliateInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AffiliateInvoicesQuery, AffiliateInvoicesQueryVariables>(AffiliateInvoicesDocument, options);
        }
export type AffiliateInvoicesQueryHookResult = ReturnType<typeof useAffiliateInvoicesQuery>;
export type AffiliateInvoicesLazyQueryHookResult = ReturnType<typeof useAffiliateInvoicesLazyQuery>;
export type AffiliateInvoicesQueryResult = Apollo.QueryResult<AffiliateInvoicesQuery, AffiliateInvoicesQueryVariables>;
export function refetchAffiliateInvoicesQuery(variables: AffiliateInvoicesQueryVariables) {
      return { query: AffiliateInvoicesDocument, variables: variables }
    }
export const OnUpdateAnalyticsDocument = gql`
    subscription OnUpdateAnalytics {
  onUpdateAnalytics(all: true) {
    all
  }
}
    `;

/**
 * __useOnUpdateAnalyticsSubscription__
 *
 * To run a query within a React component, call `useOnUpdateAnalyticsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateAnalyticsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateAnalyticsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnUpdateAnalyticsSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<OnUpdateAnalyticsSubscription, OnUpdateAnalyticsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<OnUpdateAnalyticsSubscription, OnUpdateAnalyticsSubscriptionVariables>(OnUpdateAnalyticsDocument, options);
      }
export type OnUpdateAnalyticsSubscriptionHookResult = ReturnType<typeof useOnUpdateAnalyticsSubscription>;
export type OnUpdateAnalyticsSubscriptionResult = Apollo.SubscriptionResult<OnUpdateAnalyticsSubscription>;
export const OnUpdateEventsDocument = gql`
    subscription OnUpdateEvents($accountId: ID!) {
  onUpdateEvents(accountId: $accountId) {
    accountId
  }
}
    `;

/**
 * __useOnUpdateEventsSubscription__
 *
 * To run a query within a React component, call `useOnUpdateEventsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateEventsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateEventsSubscription({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useOnUpdateEventsSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<OnUpdateEventsSubscription, OnUpdateEventsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<OnUpdateEventsSubscription, OnUpdateEventsSubscriptionVariables>(OnUpdateEventsDocument, options);
      }
export type OnUpdateEventsSubscriptionHookResult = ReturnType<typeof useOnUpdateEventsSubscription>;
export type OnUpdateEventsSubscriptionResult = Apollo.SubscriptionResult<OnUpdateEventsSubscription>;
export const OnUpdateDocumentsDocument = gql`
    subscription OnUpdateDocuments($accountId: ID!) {
  onUpdateDocuments(accountId: $accountId) {
    accountId
  }
}
    `;

/**
 * __useOnUpdateDocumentsSubscription__
 *
 * To run a query within a React component, call `useOnUpdateDocumentsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateDocumentsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateDocumentsSubscription({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useOnUpdateDocumentsSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<OnUpdateDocumentsSubscription, OnUpdateDocumentsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<OnUpdateDocumentsSubscription, OnUpdateDocumentsSubscriptionVariables>(OnUpdateDocumentsDocument, options);
      }
export type OnUpdateDocumentsSubscriptionHookResult = ReturnType<typeof useOnUpdateDocumentsSubscription>;
export type OnUpdateDocumentsSubscriptionResult = Apollo.SubscriptionResult<OnUpdateDocumentsSubscription>;
export const OnUpdateAccountDocument = gql`
    subscription OnUpdateAccount($accountId: ID!) {
  onUpdateAccount(accountId: $accountId) {
    accountId
  }
}
    `;

/**
 * __useOnUpdateAccountSubscription__
 *
 * To run a query within a React component, call `useOnUpdateAccountSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnUpdateAccountSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnUpdateAccountSubscription({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useOnUpdateAccountSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<OnUpdateAccountSubscription, OnUpdateAccountSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<OnUpdateAccountSubscription, OnUpdateAccountSubscriptionVariables>(OnUpdateAccountDocument, options);
      }
export type OnUpdateAccountSubscriptionHookResult = ReturnType<typeof useOnUpdateAccountSubscription>;
export type OnUpdateAccountSubscriptionResult = Apollo.SubscriptionResult<OnUpdateAccountSubscription>;